var Tf = Object.defineProperty;
var Cf = (e, n, t) => n in e ? Tf(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var xe = (e, n, t) => Cf(e, typeof n != "symbol" ? n + "" : n, t);
import { defineComponent as ke, computed as S, openBlock as b, createElementBlock as T, normalizeStyle as Fe, normalizeClass as j, createCommentVNode as P, toDisplayString as le, ref as J, shallowRef as Et, onMounted as et, watch as Ne, onUnmounted as Jt, h as St, nextTick as Ke, createBlock as ce, unref as v, useSlots as Ht, inject as bn, resolveDynamicComponent as mt, mergeProps as lt, withCtx as ue, renderSlot as U, provide as ea, createTextVNode as He, createElementVNode as E, withModifiers as Ve, createVNode as se, readonly as ri, getCurrentScope as Eu, onScopeDispose as Al, toValue as Qe, getCurrentInstance as ii, hasInjectionContext as Iu, watchEffect as jt, toRaw as Au, Teleport as Pn, Transition as ht, useId as Ca, withDirectives as Gt, vModelCheckbox as Mf, reactive as ka, shallowReadonly as Aa, useTemplateRef as Ge, createSlots as dt, renderList as Oe, normalizeProps as Mt, guardReactiveProps as zt, mergeDefaults as Pu, toRef as kl, Fragment as $e, onBeforeUpdate as Df, vShow as Bn, withKeys as Pt, useModel as rn, useAttrs as Pl, mergeModels as Ft, TransitionGroup as Er, vModelText as oi, onBeforeUnmount as ss, onUpdated as _f, onDeactivated as Ru, onActivated as Vu, isVNode as ms, triggerRef as Ir, isRef as Fu, markRaw as Ui, resolveComponent as Lu, isMemoSame as Of, defineAsyncComponent as Ef } from "vue";
import { RouterLink as If, useRouter as Nu, onBeforeRouteLeave as Af, useRoute as ui } from "vue-router";
import { defineStore as Pf } from "pinia";
const Rf = ["alt", "src"], Vf = {
  key: 1,
  class: "select-none"
}, Ff = /* @__PURE__ */ ke({
  __name: "VAvatar",
  props: {
    name: { default: "" },
    avatar: { default: void 0 },
    size: { default: "md" },
    customSize: { default: void 0 },
    shape: { default: "circle" },
    online: { type: Boolean, default: !1 },
    alt: { default: "User avatar" },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = S(() => n.modern ? `user-avatar--${n.size}` : {
      xs: "w-6 h-6 text-xs",
      sm: "w-8 h-8 text-sm",
      md: "w-10 h-10 text-base",
      lg: "w-12 h-12 text-lg",
      xl: "w-16 h-16 text-xl"
    }[n.size]), a = S(
      () => n.shape === "square" ? "rounded-md" : "rounded-full"
    ), s = S(() => n.customSize ? {
      width: `${n.customSize}px`,
      height: `${n.customSize}px`,
      fontSize: `${n.customSize * 0.4}px`
    } : {}), l = S(() => {
      if (!n.name) return "?";
      const c = n.name.trim().split(/\s+/);
      return c.length >= 2 ? `${c[0][0]}${c[1][0]}`.toUpperCase() : n.name.substring(0, 2).toUpperCase();
    }), r = S(() => {
      if (!n.name) return "bg-base-200 text-secondaryText";
      let c = 0;
      for (let p = 0; p < n.name.length; p++)
        c = n.name.charCodeAt(p) + ((c << 5) - c);
      const d = [
        "bg-blue-500 text-white",
        "bg-purple-500 text-white",
        "bg-pink-500 text-white",
        "bg-green-500 text-white",
        "bg-orange-500 text-white",
        "bg-primary text-white",
        "bg-indigo-500 text-white",
        "bg-cyan-500 text-white"
      ];
      return d[Math.abs(c) % d.length];
    }), i = S(() => {
      if (!n.name) return null;
      let c = 0;
      for (let d = 0; d < n.name.length; d++)
        c = n.name.charCodeAt(d) + ((c << 5) - c);
      return Math.abs(c) % 8;
    }), o = S(
      () => i.value === null ? "bg-base-200 text-secondaryText" : `user-avatar--tone-${i.value}`
    ), u = S(() => !!n.avatar);
    return (c, d) => (b(), T("div", {
      class: j([[t.value, a.value, !u.value && (n.modern ? o.value : r.value), { "user-avatar--modern": n.modern }], "user-avatar relative inline-flex items-center justify-center overflow-hidden flex-shrink-0 font-medium transition-all duration-200"]),
      style: Fe(s.value)
    }, [
      u.value ? (b(), T("img", {
        key: 0,
        alt: e.alt,
        src: e.avatar,
        class: "w-full h-full object-cover",
        onError: d[0] || (d[0] = (p) => p.target.style.display = "none")
      }, null, 40, Rf)) : P("", !0),
      u.value ? P("", !0) : (b(), T("span", Vf, le(l.value), 1)),
      e.online ? (b(), T("span", {
        key: 2,
        class: j([n.modern ? "user-avatar__status" : {
          "w-1.5 h-1.5": e.size === "xs",
          "w-2 h-2": e.size === "sm",
          "w-2.5 h-2.5": e.size === "md",
          "w-3 h-3": e.size === "lg",
          "w-4 h-4": e.size === "xl"
        }, "absolute bottom-0 right-0 block rounded-full bg-success ring-2 ring-base-100 transition-all"]),
        "aria-label": "Online"
      }, null, 2)) : P("", !0)
    ], 6));
  }
}), Le = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n)
    t[a] = s;
  return t;
}, qi = /* @__PURE__ */ Le(Ff, [["__scopeId", "data-v-cfe90801"]]), zu = Symbol("buttonGroup"), Bu = /^[a-z0-9]+(-[a-z0-9]+)*$/, Rl = (e, n, t, a = "") => {
  const s = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (s.length < 2 || s.length > 3)
      return null;
    a = s.shift().slice(1);
  }
  if (s.length > 3 || !s.length)
    return null;
  if (s.length > 1) {
    const i = s.pop(), o = s.pop(), u = {
      // Allow provider without '@': "provider:prefix:name"
      provider: s.length > 0 ? s[0] : a,
      prefix: o,
      name: i
    };
    return n && !ml(u) ? null : u;
  }
  const l = s[0], r = l.split("-");
  if (r.length > 1) {
    const i = {
      provider: a,
      prefix: r.shift(),
      name: r.join("-")
    };
    return n && !ml(i) ? null : i;
  }
  if (t && a === "") {
    const i = {
      provider: a,
      prefix: "",
      name: l
    };
    return n && !ml(i, t) ? null : i;
  }
  return null;
}, ml = (e, n) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((n && e.prefix === "" || e.prefix) && e.name) : !1, Wu = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), xl = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Vl = Object.freeze({
  ...Wu,
  ...xl
}), Ar = Object.freeze({
  ...Vl,
  body: "",
  hidden: !1
});
function Lf(e, n) {
  const t = {};
  !e.hFlip != !n.hFlip && (t.hFlip = !0), !e.vFlip != !n.vFlip && (t.vFlip = !0);
  const a = ((e.rotate || 0) + (n.rotate || 0)) % 4;
  return a && (t.rotate = a), t;
}
function ji(e, n) {
  const t = Lf(e, n);
  for (const a in Ar)
    a in xl ? a in e && !(a in t) && (t[a] = xl[a]) : a in n ? t[a] = n[a] : a in e && (t[a] = e[a]);
  return t;
}
function Nf(e, n) {
  const t = e.icons, a = e.aliases || /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  function l(r) {
    if (t[r])
      return s[r] = [];
    if (!(r in s)) {
      s[r] = null;
      const i = a[r] && a[r].parent, o = i && l(i);
      o && (s[r] = [i].concat(o));
    }
    return s[r];
  }
  return Object.keys(t).concat(Object.keys(a)).forEach(l), s;
}
function zf(e, n, t) {
  const a = e.icons, s = e.aliases || /* @__PURE__ */ Object.create(null);
  let l = {};
  function r(i) {
    l = ji(
      a[i] || s[i],
      l
    );
  }
  return r(n), t.forEach(r), ji(e, l);
}
function Yu(e, n) {
  const t = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return t;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    n(s, null), t.push(s);
  });
  const a = Nf(e);
  for (const s in a) {
    const l = a[s];
    l && (n(s, zf(e, s, l)), t.push(s));
  }
  return t;
}
const Bf = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Wu
};
function lr(e, n) {
  for (const t in n)
    if (t in e && typeof e[t] != typeof n[t])
      return !1;
  return !0;
}
function Hu(e) {
  if (typeof e != "object" || e === null)
    return null;
  const n = e;
  if (typeof n.prefix != "string" || !e.icons || typeof e.icons != "object" || !lr(e, Bf))
    return null;
  const t = n.icons;
  for (const s in t) {
    const l = t[s];
    if (
      // Name cannot be empty
      !s || // Must have body
      typeof l.body != "string" || // Check other props
      !lr(
        l,
        Ar
      )
    )
      return null;
  }
  const a = n.aliases || /* @__PURE__ */ Object.create(null);
  for (const s in a) {
    const l = a[s], r = l.parent;
    if (
      // Name cannot be empty
      !s || // Parent must be set and point to existing icon
      typeof r != "string" || !t[r] && !a[r] || // Check other props
      !lr(
        l,
        Ar
      )
    )
      return null;
  }
  return n;
}
const Gi = /* @__PURE__ */ Object.create(null);
function Wf(e, n) {
  return {
    provider: e,
    prefix: n,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function Xa(e, n) {
  const t = Gi[e] || (Gi[e] = /* @__PURE__ */ Object.create(null));
  return t[n] || (t[n] = Wf(e, n));
}
function Uu(e, n) {
  return Hu(n) ? Yu(n, (t, a) => {
    a ? e.icons[t] = a : e.missing.add(t);
  }) : [];
}
function Yf(e, n, t) {
  try {
    if (typeof t.body == "string")
      return e.icons[n] = { ...t }, !0;
  } catch {
  }
  return !1;
}
let As = !1;
function qu(e) {
  return typeof e == "boolean" && (As = e), As;
}
function Hf(e) {
  const n = typeof e == "string" ? Rl(e, !0, As) : e;
  if (n) {
    const t = Xa(n.provider, n.prefix), a = n.name;
    return t.icons[a] || (t.missing.has(a) ? null : void 0);
  }
}
function Uf(e, n) {
  const t = Rl(e, !0, As);
  if (!t)
    return !1;
  const a = Xa(t.provider, t.prefix);
  return n ? Yf(a, t.name, n) : (a.missing.add(t.name), !0);
}
function qf(e, n) {
  if (typeof e != "object")
    return !1;
  if (typeof n != "string" && (n = e.provider || ""), As && !n && !e.prefix) {
    let s = !1;
    return Hu(e) && (e.prefix = "", Yu(e, (l, r) => {
      Uf(l, r) && (s = !0);
    })), s;
  }
  const t = e.prefix;
  if (!ml({
    prefix: t,
    name: "a"
  }))
    return !1;
  const a = Xa(n, t);
  return !!Uu(a, e);
}
const ju = Object.freeze({
  width: null,
  height: null
}), Gu = Object.freeze({
  // Dimensions
  ...ju,
  // Transformations
  ...xl
}), jf = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Gf = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Ki(e, n, t) {
  if (n === 1)
    return e;
  if (t = t || 100, typeof e == "number")
    return Math.ceil(e * n * t) / t;
  if (typeof e != "string")
    return e;
  const a = e.split(jf);
  if (a === null || !a.length)
    return e;
  const s = [];
  let l = a.shift(), r = Gf.test(l);
  for (; ; ) {
    if (r) {
      const i = parseFloat(l);
      isNaN(i) ? s.push(l) : s.push(Math.ceil(i * n * t) / t);
    } else
      s.push(l);
    if (l = a.shift(), l === void 0)
      return s.join("");
    r = !r;
  }
}
function Kf(e, n = "defs") {
  let t = "";
  const a = e.indexOf("<" + n);
  for (; a >= 0; ) {
    const s = e.indexOf(">", a), l = e.indexOf("</" + n);
    if (s === -1 || l === -1)
      break;
    const r = e.indexOf(">", l);
    if (r === -1)
      break;
    t += e.slice(s + 1, l).trim(), e = e.slice(0, a).trim() + e.slice(r + 1);
  }
  return {
    defs: t,
    content: e
  };
}
function Zf(e, n) {
  return e ? "<defs>" + e + "</defs>" + n : n;
}
function Xf(e, n, t) {
  const a = Kf(e);
  return Zf(a.defs, n + a.content + t);
}
const Jf = (e) => e === "unset" || e === "undefined" || e === "none";
function Qf(e, n) {
  const t = {
    ...Vl,
    ...e
  }, a = {
    ...Gu,
    ...n
  }, s = {
    left: t.left,
    top: t.top,
    width: t.width,
    height: t.height
  };
  let l = t.body;
  [t, a].forEach((m) => {
    const k = [], y = m.hFlip, h = m.vFlip;
    let g = m.rotate;
    y ? h ? g += 2 : (k.push(
      "translate(" + (s.width + s.left).toString() + " " + (0 - s.top).toString() + ")"
    ), k.push("scale(-1 1)"), s.top = s.left = 0) : h && (k.push(
      "translate(" + (0 - s.left).toString() + " " + (s.height + s.top).toString() + ")"
    ), k.push("scale(1 -1)"), s.top = s.left = 0);
    let x;
    switch (g < 0 && (g -= Math.floor(g / 4) * 4), g = g % 4, g) {
      case 1:
        x = s.height / 2 + s.top, k.unshift(
          "rotate(90 " + x.toString() + " " + x.toString() + ")"
        );
        break;
      case 2:
        k.unshift(
          "rotate(180 " + (s.width / 2 + s.left).toString() + " " + (s.height / 2 + s.top).toString() + ")"
        );
        break;
      case 3:
        x = s.width / 2 + s.left, k.unshift(
          "rotate(-90 " + x.toString() + " " + x.toString() + ")"
        );
        break;
    }
    g % 2 === 1 && (s.left !== s.top && (x = s.left, s.left = s.top, s.top = x), s.width !== s.height && (x = s.width, s.width = s.height, s.height = x)), k.length && (l = Xf(
      l,
      '<g transform="' + k.join(" ") + '">',
      "</g>"
    ));
  });
  const r = a.width, i = a.height, o = s.width, u = s.height;
  let c, d;
  r === null ? (d = i === null ? "1em" : i === "auto" ? u : i, c = Ki(d, o / u)) : (c = r === "auto" ? o : r, d = i === null ? Ki(c, u / o) : i === "auto" ? u : i);
  const p = {}, f = (m, k) => {
    Jf(k) || (p[m] = k.toString());
  };
  f("width", c), f("height", d);
  const w = [s.left, s.top, o, u];
  return p.viewBox = w.join(" "), {
    attributes: p,
    viewBox: w,
    body: l
  };
}
const eh = /\sid="(\S+)"/g, th = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let nh = 0;
function ah(e, n = th) {
  const t = [];
  let a;
  for (; a = eh.exec(e); )
    t.push(a[1]);
  if (!t.length)
    return e;
  const s = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return t.forEach((l) => {
    const r = typeof n == "function" ? n(l) : n + (nh++).toString(), i = l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + i + ')([")]|\\.[a-z])', "g"),
      "$1" + r + s + "$3"
    );
  }), e = e.replace(new RegExp(s, "g"), ""), e;
}
const Pr = /* @__PURE__ */ Object.create(null);
function sh(e, n) {
  Pr[e] = n;
}
function Rr(e) {
  return Pr[e] || Pr[""];
}
function ci(e) {
  let n;
  if (typeof e.resources == "string")
    n = [e.resources];
  else if (n = e.resources, !(n instanceof Array) || !n.length)
    return null;
  return {
    // API hosts
    resources: n,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const di = /* @__PURE__ */ Object.create(null), vs = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], vl = [];
for (; vs.length > 0; )
  vs.length === 1 || Math.random() > 0.5 ? vl.push(vs.shift()) : vl.push(vs.pop());
di[""] = ci({
  resources: ["https://api.iconify.design"].concat(vl)
});
function lh(e, n) {
  const t = ci(n);
  return t === null ? !1 : (di[e] = t, !0);
}
function fi(e) {
  return di[e];
}
const rh = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Zi = rh();
function ih(e, n) {
  const t = fi(e);
  if (!t)
    return 0;
  let a;
  if (!t.maxURL)
    a = 0;
  else {
    let s = 0;
    t.resources.forEach((r) => {
      s = Math.max(s, r.length);
    });
    const l = n + ".json?icons=";
    a = t.maxURL - s - t.path.length - l.length;
  }
  return a;
}
function oh(e) {
  return e === 404;
}
const uh = (e, n, t) => {
  const a = [], s = ih(e, n), l = "icons";
  let r = {
    type: l,
    provider: e,
    prefix: n,
    icons: []
  }, i = 0;
  return t.forEach((o, u) => {
    i += o.length + 1, i >= s && u > 0 && (a.push(r), r = {
      type: l,
      provider: e,
      prefix: n,
      icons: []
    }, i = o.length), r.icons.push(o);
  }), a.push(r), a;
};
function ch(e) {
  if (typeof e == "string") {
    const n = fi(e);
    if (n)
      return n.path;
  }
  return "/";
}
const dh = (e, n, t) => {
  if (!Zi) {
    t("abort", 424);
    return;
  }
  let a = ch(n.provider);
  switch (n.type) {
    case "icons": {
      const l = n.prefix, i = n.icons.join(","), o = new URLSearchParams({
        icons: i
      });
      a += l + ".json?" + o.toString();
      break;
    }
    case "custom": {
      const l = n.uri;
      a += l.slice(0, 1) === "/" ? l.slice(1) : l;
      break;
    }
    default:
      t("abort", 400);
      return;
  }
  let s = 503;
  Zi(e + a).then((l) => {
    const r = l.status;
    if (r !== 200) {
      setTimeout(() => {
        t(oh(r) ? "abort" : "next", r);
      });
      return;
    }
    return s = 501, l.json();
  }).then((l) => {
    if (typeof l != "object" || l === null) {
      setTimeout(() => {
        l === 404 ? t("abort", l) : t("next", s);
      });
      return;
    }
    setTimeout(() => {
      t("success", l);
    });
  }).catch(() => {
    t("next", s);
  });
}, fh = {
  prepare: uh,
  send: dh
};
function hh(e) {
  const n = {
    loaded: [],
    missing: [],
    pending: []
  }, t = /* @__PURE__ */ Object.create(null);
  e.sort((s, l) => s.provider !== l.provider ? s.provider.localeCompare(l.provider) : s.prefix !== l.prefix ? s.prefix.localeCompare(l.prefix) : s.name.localeCompare(l.name));
  let a = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((s) => {
    if (a.name === s.name && a.prefix === s.prefix && a.provider === s.provider)
      return;
    a = s;
    const l = s.provider, r = s.prefix, i = s.name, o = t[l] || (t[l] = /* @__PURE__ */ Object.create(null)), u = o[r] || (o[r] = Xa(l, r));
    let c;
    i in u.icons ? c = n.loaded : r === "" || u.missing.has(i) ? c = n.missing : c = n.pending;
    const d = {
      provider: l,
      prefix: r,
      name: i
    };
    c.push(d);
  }), n;
}
function Ku(e, n) {
  e.forEach((t) => {
    const a = t.loaderCallbacks;
    a && (t.loaderCallbacks = a.filter((s) => s.id !== n));
  });
}
function mh(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const n = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!n.length)
      return;
    let t = !1;
    const a = e.provider, s = e.prefix;
    n.forEach((l) => {
      const r = l.icons, i = r.pending.length;
      r.pending = r.pending.filter((o) => {
        if (o.prefix !== s)
          return !0;
        const u = o.name;
        if (e.icons[u])
          r.loaded.push({
            provider: a,
            prefix: s,
            name: u
          });
        else if (e.missing.has(u))
          r.missing.push({
            provider: a,
            prefix: s,
            name: u
          });
        else
          return t = !0, !0;
        return !1;
      }), r.pending.length !== i && (t || Ku([e], l.id), l.callback(
        r.loaded.slice(0),
        r.missing.slice(0),
        r.pending.slice(0),
        l.abort
      ));
    });
  }));
}
let vh = 0;
function ph(e, n, t) {
  const a = vh++, s = Ku.bind(null, t, a);
  if (!n.pending.length)
    return s;
  const l = {
    id: a,
    icons: n,
    callback: e,
    abort: s
  };
  return t.forEach((r) => {
    (r.loaderCallbacks || (r.loaderCallbacks = [])).push(l);
  }), s;
}
function gh(e, n = !0, t = !1) {
  const a = [];
  return e.forEach((s) => {
    const l = typeof s == "string" ? Rl(s, n, t) : s;
    l && a.push(l);
  }), a;
}
var yh = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function bh(e, n, t, a) {
  const s = e.resources.length, l = e.random ? Math.floor(Math.random() * s) : e.index;
  let r;
  if (e.random) {
    let C = e.resources.slice(0);
    for (r = []; C.length > 1; ) {
      const O = Math.floor(Math.random() * C.length);
      r.push(C[O]), C = C.slice(0, O).concat(C.slice(O + 1));
    }
    r = r.concat(C);
  } else
    r = e.resources.slice(l).concat(e.resources.slice(0, l));
  const i = Date.now();
  let o = "pending", u = 0, c, d = null, p = [], f = [];
  typeof a == "function" && f.push(a);
  function w() {
    d && (clearTimeout(d), d = null);
  }
  function m() {
    o === "pending" && (o = "aborted"), w(), p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function k(C, O) {
    O && (f = []), typeof C == "function" && f.push(C);
  }
  function y() {
    return {
      startTime: i,
      payload: n,
      status: o,
      queriesSent: u,
      queriesPending: p.length,
      subscribe: k,
      abort: m
    };
  }
  function h() {
    o = "failed", f.forEach((C) => {
      C(void 0, c);
    });
  }
  function g() {
    p.forEach((C) => {
      C.status === "pending" && (C.status = "aborted");
    }), p = [];
  }
  function x(C, O, _) {
    const I = O !== "success";
    switch (p = p.filter((D) => D !== C), o) {
      case "pending":
        break;
      case "failed":
        if (I || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (O === "abort") {
      c = _, h();
      return;
    }
    if (I) {
      c = _, p.length || (r.length ? $() : h());
      return;
    }
    if (w(), g(), !e.random) {
      const D = e.resources.indexOf(C.resource);
      D !== -1 && D !== e.index && (e.index = D);
    }
    o = "completed", f.forEach((D) => {
      D(_);
    });
  }
  function $() {
    if (o !== "pending")
      return;
    w();
    const C = r.shift();
    if (C === void 0) {
      if (p.length) {
        d = setTimeout(() => {
          w(), o === "pending" && (g(), h());
        }, e.timeout);
        return;
      }
      h();
      return;
    }
    const O = {
      status: "pending",
      resource: C,
      callback: (_, I) => {
        x(O, _, I);
      }
    };
    p.push(O), u++, d = setTimeout($, e.rotate), t(C, n, O.callback);
  }
  return setTimeout($), y;
}
function Zu(e) {
  const n = {
    ...yh,
    ...e
  };
  let t = [];
  function a() {
    t = t.filter((i) => i().status === "pending");
  }
  function s(i, o, u) {
    const c = bh(
      n,
      i,
      o,
      (d, p) => {
        a(), u && u(d, p);
      }
    );
    return t.push(c), c;
  }
  function l(i) {
    return t.find((o) => i(o)) || null;
  }
  return {
    query: s,
    find: l,
    setIndex: (i) => {
      n.index = i;
    },
    getIndex: () => n.index,
    cleanup: a
  };
}
function Xi() {
}
const rr = /* @__PURE__ */ Object.create(null);
function wh(e) {
  if (!rr[e]) {
    const n = fi(e);
    if (!n)
      return;
    const t = Zu(n), a = {
      config: n,
      redundancy: t
    };
    rr[e] = a;
  }
  return rr[e];
}
function kh(e, n, t) {
  let a, s;
  if (typeof e == "string") {
    const l = Rr(e);
    if (!l)
      return t(void 0, 424), Xi;
    s = l.send;
    const r = wh(e);
    r && (a = r.redundancy);
  } else {
    const l = ci(e);
    if (l) {
      a = Zu(l);
      const r = e.resources ? e.resources[0] : "", i = Rr(r);
      i && (s = i.send);
    }
  }
  return !a || !s ? (t(void 0, 424), Xi) : a.query(n, s, t)().abort;
}
function Ji() {
}
function xh(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, mh(e);
  }));
}
function Sh(e) {
  const n = [], t = [];
  return e.forEach((a) => {
    (a.match(Bu) ? n : t).push(a);
  }), {
    valid: n,
    invalid: t
  };
}
function ps(e, n, t) {
  function a() {
    const s = e.pendingIcons;
    n.forEach((l) => {
      s && s.delete(l), e.icons[l] || e.missing.add(l);
    });
  }
  if (t && typeof t == "object")
    try {
      if (!Uu(e, t).length) {
        a();
        return;
      }
    } catch (s) {
      console.error(s);
    }
  a(), xh(e);
}
function Qi(e, n) {
  e instanceof Promise ? e.then((t) => {
    n(t);
  }).catch(() => {
    n(null);
  }) : n(e);
}
function $h(e, n) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(n).sort() : e.iconsToLoad = n, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: t, prefix: a } = e, s = e.iconsToLoad;
    if (delete e.iconsToLoad, !s || !s.length)
      return;
    const l = e.loadIcon;
    if (e.loadIcons && (s.length > 1 || !l)) {
      Qi(
        e.loadIcons(s, a, t),
        (c) => {
          ps(e, s, c);
        }
      );
      return;
    }
    if (l) {
      s.forEach((c) => {
        const d = l(c, a, t);
        Qi(d, (p) => {
          const f = p ? {
            prefix: a,
            icons: {
              [c]: p
            }
          } : null;
          ps(e, [c], f);
        });
      });
      return;
    }
    const { valid: r, invalid: i } = Sh(s);
    if (i.length && ps(e, i, null), !r.length)
      return;
    const o = a.match(Bu) ? Rr(t) : null;
    if (!o) {
      ps(e, r, null);
      return;
    }
    o.prepare(t, a, r).forEach((c) => {
      kh(t, c, (d) => {
        ps(e, c.icons, d);
      });
    });
  }));
}
const Th = (e, n) => {
  const t = gh(e, !0, qu()), a = hh(t);
  if (!a.pending.length) {
    let o = !0;
    return n && setTimeout(() => {
      o && n(
        a.loaded,
        a.missing,
        a.pending,
        Ji
      );
    }), () => {
      o = !1;
    };
  }
  const s = /* @__PURE__ */ Object.create(null), l = [];
  let r, i;
  return a.pending.forEach((o) => {
    const { provider: u, prefix: c } = o;
    if (c === i && u === r)
      return;
    r = u, i = c, l.push(Xa(u, c));
    const d = s[u] || (s[u] = /* @__PURE__ */ Object.create(null));
    d[c] || (d[c] = []);
  }), a.pending.forEach((o) => {
    const { provider: u, prefix: c, name: d } = o, p = Xa(u, c), f = p.pendingIcons || (p.pendingIcons = /* @__PURE__ */ new Set());
    f.has(d) || (f.add(d), s[u][c].push(d));
  }), l.forEach((o) => {
    const u = s[o.provider][o.prefix];
    u.length && $h(o, u);
  }), n ? ph(n, a, l) : Ji;
};
function Ch(e, n) {
  const t = {
    ...e
  };
  for (const a in n) {
    const s = n[a], l = typeof s;
    a in ju ? (s === null || s && (l === "string" || l === "number")) && (t[a] = s) : l === typeof t[a] && (t[a] = a === "rotate" ? s % 4 : s);
  }
  return t;
}
const Mh = /[\s,]+/;
function Dh(e, n) {
  n.split(Mh).forEach((t) => {
    switch (t.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function _h(e, n = 0) {
  const t = e.replace(/^-?[0-9.]*/, "");
  function a(s) {
    for (; s < 0; )
      s += 4;
    return s % 4;
  }
  if (t === "") {
    const s = parseInt(e);
    return isNaN(s) ? 0 : a(s);
  } else if (t !== e) {
    let s = 0;
    switch (t) {
      case "%":
        s = 25;
        break;
      case "deg":
        s = 90;
    }
    if (s) {
      let l = parseFloat(e.slice(0, e.length - t.length));
      return isNaN(l) ? 0 : (l = l / s, l % 1 === 0 ? a(l) : 0);
    }
  }
  return n;
}
function Oh(e, n) {
  let t = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const a in n)
    t += " " + a + '="' + n[a] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + t + ">" + e + "</svg>";
}
function Eh(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Ih(e) {
  return "data:image/svg+xml," + Eh(e);
}
function Ah(e) {
  return 'url("' + Ih(e) + '")';
}
const eo = {
  ...Gu,
  inline: !1
}, Ph = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Rh = {
  display: "inline-block"
}, Vr = {
  backgroundColor: "currentColor"
}, Xu = {
  backgroundColor: "transparent"
}, to = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, no = {
  webkitMask: Vr,
  mask: Vr,
  background: Xu
};
for (const e in no) {
  const n = no[e];
  for (const t in to)
    n[e + t] = to[t];
}
const pl = {};
["horizontal", "vertical"].forEach((e) => {
  const n = e.slice(0, 1) + "Flip";
  pl[e + "-flip"] = n, pl[e.slice(0, 1) + "-flip"] = n, pl[e + "Flip"] = n;
});
function ao(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const so = (e, n) => {
  const t = Ch(eo, n), a = { ...Ph }, s = n.mode || "svg", l = {}, r = n.style, i = typeof r == "object" && !(r instanceof Array) ? r : {};
  for (let m in n) {
    const k = n[m];
    if (k !== void 0)
      switch (m) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          t[m] = k === !0 || k === "true" || k === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof k == "string" && Dh(t, k);
          break;
        // Color: override style
        case "color":
          l.color = k;
          break;
        // Rotation as string
        case "rotate":
          typeof k == "string" ? t[m] = _h(k) : typeof k == "number" && (t[m] = k);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          k !== !0 && k !== "true" && delete a["aria-hidden"];
          break;
        default: {
          const y = pl[m];
          y ? (k === !0 || k === "true" || k === 1) && (t[y] = !0) : eo[m] === void 0 && (a[m] = k);
        }
      }
  }
  const o = Qf(e, t), u = o.attributes;
  if (t.inline && (l.verticalAlign = "-0.125em"), s === "svg") {
    a.style = {
      ...l,
      ...i
    }, Object.assign(a, u);
    let m = 0, k = n.id;
    return typeof k == "string" && (k = k.replace(/-/g, "_")), a.innerHTML = ah(o.body, k ? () => k + "ID" + m++ : "iconifyVue"), St("svg", a);
  }
  const { body: c, width: d, height: p } = e, f = s === "mask" || (s === "bg" ? !1 : c.indexOf("currentColor") !== -1), w = Oh(c, {
    ...u,
    width: d + "",
    height: p + ""
  });
  return a.style = {
    ...l,
    "--svg": Ah(w),
    width: ao(u.width),
    height: ao(u.height),
    ...Rh,
    ...f ? Vr : Xu,
    ...i
  }, St("span", a);
};
qu(!0);
sh("", fh);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const n = e.IconifyPreload, t = "Invalid IconifyPreload syntax.";
    typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((a) => {
      try {
        // Check if item is an object and not null/array
        (typeof a != "object" || a === null || a instanceof Array || // Check for 'icons' and 'prefix'
        typeof a.icons != "object" || typeof a.prefix != "string" || // Add icon set
        !qf(a)) && console.error(t);
      } catch {
        console.error(t);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const n = e.IconifyProviders;
    if (typeof n == "object" && n !== null)
      for (let t in n) {
        const a = "IconifyProviders[" + t + "] is invalid.";
        try {
          const s = n[t];
          if (typeof s != "object" || !s || s.resources === void 0)
            continue;
          lh(t, s) || console.error(a);
        } catch {
          console.error(a);
        }
      }
  }
}
const Vh = {
  ...Vl,
  body: ""
}, Fh = ke((e, { emit: n }) => {
  const t = J(null);
  function a() {
    var u, c;
    t.value && ((c = (u = t.value).abort) == null || c.call(u), t.value = null);
  }
  const s = J(!!e.ssr), l = J(""), r = Et(null);
  function i() {
    const u = e.icon;
    if (typeof u == "object" && u !== null && typeof u.body == "string")
      return l.value = "", {
        data: u
      };
    let c;
    if (typeof u != "string" || (c = Rl(u, !1, !0)) === null)
      return null;
    let d = Hf(c);
    if (!d) {
      const w = t.value;
      return (!w || w.name !== u) && (d === null ? t.value = {
        name: u
      } : t.value = {
        name: u,
        abort: Th([c], o)
      }), null;
    }
    a(), l.value !== u && (l.value = u, Ke(() => {
      n("load", u);
    }));
    const p = e.customise;
    if (p) {
      d = Object.assign({}, d);
      const w = p(d.body, c.name, c.prefix, c.provider);
      typeof w == "string" && (d.body = w);
    }
    const f = ["iconify"];
    return c.prefix !== "" && f.push("iconify--" + c.prefix), c.provider !== "" && f.push("iconify--" + c.provider), { data: d, classes: f };
  }
  function o() {
    var c;
    const u = i();
    u ? u.data !== ((c = r.value) == null ? void 0 : c.data) && (r.value = u) : r.value = null;
  }
  return s.value ? o() : et(() => {
    s.value = !0, o();
  }), Ne(() => e.icon, o), Jt(a), () => {
    const u = r.value;
    if (!u)
      return so(Vh, e);
    let c = e;
    return u.classes && (c = {
      ...e,
      class: u.classes.join(" ")
    }), so({
      ...Vl,
      ...u.data
    }, c);
  };
}, {
  props: [
    // Icon and render mode
    "icon",
    "mode",
    "ssr",
    // Layout and style
    "width",
    "height",
    "style",
    "color",
    "inline",
    // Transformations
    "rotate",
    "hFlip",
    "horizontalFlip",
    "vFlip",
    "verticalFlip",
    "flip",
    // Misc
    "id",
    "ariaHidden",
    "customise",
    "title"
  ],
  emits: ["load"]
}), Lh = /* @__PURE__ */ ke({
  __name: "VIcon",
  props: {
    icon: {},
    size: { default: 24 },
    color: { default: "currentColor" },
    class: { default: "" },
    loading: { type: Boolean }
  },
  setup(e) {
    const n = S(() => e.color.startsWith("text-")), t = S(() => e.loading ? "lucide:loader-2" : e.icon), a = S(() => typeof e.size == "number" ? `${e.size}px` : e.size), s = S(() => n.value ? e.color : ""), l = S(() => n.value ? void 0 : { color: e.color });
    return (r, i) => (b(), ce(v(Fh), {
      class: j([[{ "v-icon--spin": e.loading }, s.value, e.class], "v-icon"]),
      height: a.value,
      icon: t.value,
      style: Fe(l.value),
      width: a.value,
      "aria-hidden": "true",
      focusable: "false"
    }, null, 8, ["class", "height", "icon", "style", "width"]));
  }
}), ye = /* @__PURE__ */ Le(Lh, [["__scopeId", "data-v-68f452e3"]]), Nh = {
  key: 0,
  class: "v-button__icon"
}, zh = {
  key: 1,
  class: "v-button__content"
}, Bh = { key: 0 }, Wh = {
  key: 2,
  class: "v-button__icon"
}, Yh = /* @__PURE__ */ ke({
  __name: "VButton",
  props: {
    text: { default: "" },
    type: { default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { default: void 0 },
    variant: { default: "default" },
    to: { default: void 0 },
    replace: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 },
    size: { default: void 0 }
  },
  setup(e) {
    const n = Ht(), t = bn(zu, !1), a = e, s = S(() => !a.text && !!a.icon && !n.default), l = S(() => {
      switch (a.variant) {
        case "primary":
          return "v-button--primary";
        case "positive":
          return "v-button--positive";
        case "negative":
          return "v-button--negative";
        case "warning":
          return "v-button--warning";
        case "link":
          return "v-button--link";
        case "secondary":
          return "v-button--secondary";
        case "neutral":
          return "v-button--neutral";
        case "info":
          return "v-button--info";
        default:
          return "v-button--primary";
      }
    }), r = S(() => a.modern ? 15 : 24), i = S(() => !!a.to), o = S(() => a.modern ? a.disabled : a.disabled || a.loading), u = S(() => a.modern && a.loading && !a.disabled);
    return (c, d) => (b(), ce(mt(i.value ? v(If) : "button"), lt(
      {
        class: [
          "v-button",
          l.value,
          a.size ? `v-button--${a.size}` : "",
          {
            "v-button--modern": a.modern,
            "v-button--grouped": v(t),
            "v-button--icon-only": s.value,
            "v-button--disabled cursor-not-allowed": o.value,
            "v-button--loading": u.value
          }
        ]
      },
      i.value ? {
        to: a.disabled || a.loading ? void 0 : a.to,
        replace: a.replace,
        ...c.$attrs
      } : { type: a.type, disabled: a.disabled || a.loading, ...c.$attrs }
    ), {
      default: ue(() => [
        c.$slots.iconLeft || a.loading || a.icon ? (b(), T("span", Nh, [
          a.loading ? (b(), ce(ye, {
            key: 0,
            loading: a.loading,
            size: r.value,
            icon: "lucide:loader-2"
          }, null, 8, ["loading", "size"])) : U(c.$slots, "iconLeft", { key: 1 }, () => [
            a.icon ? (b(), ce(ye, {
              key: 0,
              icon: a.icon,
              size: r.value
            }, null, 8, ["icon", "size"])) : P("", !0)
          ], !0)
        ])) : P("", !0),
        s.value ? P("", !0) : (b(), T("span", zh, [
          a.text ? (b(), T("span", Bh, le(a.text), 1)) : P("", !0),
          U(c.$slots, "default", {}, void 0, !0)
        ])),
        c.$slots.iconRight ? (b(), T("span", Wh, [
          U(c.$slots, "iconRight", {}, void 0, !0)
        ])) : P("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), vt = /* @__PURE__ */ Le(Yh, [["__scopeId", "data-v-bf5152fe"]]), Hh = {
  class: "v-button-group",
  role: "group"
}, Uh = /* @__PURE__ */ ke({
  __name: "VButtonGroup",
  setup(e) {
    return ea(zu, !0), (n, t) => (b(), T("div", Hh, [
      U(n.$slots, "default", {}, void 0, !0)
    ]));
  }
}), zD = /* @__PURE__ */ Le(Uh, [["__scopeId", "data-v-b6af72a2"]]), qh = { key: 1 }, jh = /* @__PURE__ */ ke({
  __name: "VTag",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "primary" },
    size: { default: "sm" },
    icon: { default: void 0 },
    iconPosition: { default: "left" },
    rounded: { type: Boolean, default: !1 },
    class: { default: "" },
    customColor: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = S(() => ({
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18
    })[n.size]), a = S(() => `vtag--${n.size}`), s = S(
      () => n.customColor ? { "--_tag-color": `var(${n.customColor})` } : void 0
    ), l = S(
      () => n.customColor ? `vtag--custom-${n.variant}` : `vtag--${n.variant}-${n.color}`
    ), r = S(() => n.rounded ? "vtag--rounded" : "vtag--square");
    return (i, o) => (b(), T("span", {
      style: Fe(s.value),
      class: j([[a.value, l.value, r.value, n.class, { "vtag--modern": n.modern }], "vtag"])
    }, [
      e.icon && e.iconPosition === "left" ? (b(), ce(ye, {
        key: 0,
        icon: e.icon,
        size: t.value
      }, null, 8, ["icon", "size"])) : P("", !0),
      e.label || i.$slots.default ? (b(), T("span", qh, [
        U(i.$slots, "default", {}, () => [
          He(le(e.label), 1)
        ], !0)
      ])) : P("", !0),
      U(i.$slots, "icon-right", {}, () => [
        e.icon && e.iconPosition === "right" ? (b(), ce(ye, {
          key: 0,
          icon: e.icon,
          size: t.value
        }, null, 8, ["icon", "size"])) : P("", !0)
      ], !0)
    ], 6));
  }
}), Ju = /* @__PURE__ */ Le(jh, [["__scopeId", "data-v-2c5fd8f6"]]), Gh = { class: "vchip__content" }, Kh = {
  key: 1,
  class: "vchip__label"
}, Zh = ["disabled"], Xh = /* @__PURE__ */ ke({
  __name: "VChip",
  props: {
    label: { default: "" },
    variant: { default: "soft" },
    color: { default: "default" },
    selectedColor: { default: "primary" },
    size: { default: "md" },
    icon: { default: void 0 },
    closable: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    badge: { default: void 0 },
    badgeColor: { default: "primary" },
    class: { default: "" },
    value: { type: [String, Number, Boolean, Object, null], default: void 0 },
    modelValue: { default: void 0 },
    multiple: { type: Boolean, default: !1 },
    valueComparator: { type: Function, default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["click", "close", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (p, f) => {
      if (t.valueComparator)
        return t.valueComparator(p, f);
      if (p === f) return !0;
      if (p == null || f == null) return !1;
      if (typeof p == "object" && typeof f == "object")
        try {
          return JSON.stringify(p) === JSON.stringify(f);
        } catch {
          return !1;
        }
      return p === f;
    }, l = S(() => t.modelValue !== void 0 && t.value !== void 0 ? t.multiple ? Array.isArray(t.modelValue) && t.modelValue.some((p) => s(p, t.value)) : s(t.modelValue, t.value) : t.active), r = S(() => (t.modern ? { sm: 13, md: 15, lg: 16 } : { sm: 14, md: 16, lg: 18 })[t.size]), i = S(() => `vchip--${t.size}`), o = S(() => {
      if (t.color === "default" && l.value)
        return `vchip--${t.variant}-${t.selectedColor}-selected`;
      const p = `vchip--${t.variant}-${t.color}`;
      return l.value ? `${p}-selected` : p;
    }), u = S(() => t.disabled ? "vchip--disabled" : "vchip--interactive"), c = (p) => {
      if (!t.disabled) {
        if (t.value !== void 0 && t.modelValue !== void 0)
          if (t.multiple) {
            const f = Array.isArray(t.modelValue) ? t.modelValue : [];
            if (f.findIndex((m) => s(m, t.value)) > -1) {
              const m = f.filter((k) => !s(k, t.value));
              a("update:modelValue", m);
            } else
              a("update:modelValue", [...f, t.value]);
          } else
            s(t.modelValue, t.value) ? a("update:modelValue", null) : a("update:modelValue", t.value);
        a("click", p);
      }
    }, d = (p) => {
      t.disabled || a("close", p);
    };
    return (p, f) => (b(), T("span", {
      class: j([[i.value, o.value, u.value, t.class, { "vchip--modern": t.modern }], "vchip"]),
      onClick: c
    }, [
      E("span", Gh, [
        e.icon ? (b(), ce(ye, {
          key: 0,
          icon: e.icon,
          size: r.value,
          class: "vchip__icon"
        }, null, 8, ["icon", "size"])) : P("", !0),
        e.label || p.$slots.default ? (b(), T("span", Kh, [
          U(p.$slots, "default", {}, () => [
            He(le(e.label), 1)
          ], !0)
        ])) : P("", !0),
        U(p.$slots, "badge", {}, () => [
          e.badge ? (b(), ce(Ju, {
            key: 0,
            color: e.badgeColor,
            label: e.badge,
            size: "sm",
            variant: "outline"
          }, null, 8, ["color", "label"])) : P("", !0)
        ], !0)
      ]),
      e.closable ? (b(), T("button", {
        key: 0,
        disabled: e.disabled,
        class: "vchip__close",
        type: "button",
        onClick: Ve(d, ["stop"])
      }, [
        se(ye, {
          size: r.value - 2,
          icon: "lucide:x"
        }, null, 8, ["size"])
      ], 8, Zh)) : P("", !0)
    ], 2));
  }
}), Qu = /* @__PURE__ */ Le(Xh, [["__scopeId", "data-v-68700419"]]);
function ec(e) {
  return Eu() ? (Al(e), !0) : !1;
}
const ir = /* @__PURE__ */ new WeakMap(), Jh = (...e) => {
  var n;
  const t = e[0], a = (n = ii()) == null ? void 0 : n.proxy;
  if (a == null && !Iu())
    throw new Error("injectLocal must be called in setup");
  return a && ir.has(a) && t in ir.get(a) ? ir.get(a)[t] : bn(...e);
}, hi = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Qh = Object.prototype.toString, em = (e) => Qh.call(e) === "[object Object]", lo = () => {
};
function tm(e, n) {
  function t(...a) {
    return new Promise((s, l) => {
      Promise.resolve(e(() => n.apply(this, a), { fn: n, thisArg: this, args: a })).then(s).catch(l);
    });
  }
  return t;
}
function nm(e, n = {}) {
  let t, a, s = lo;
  const l = (o) => {
    clearTimeout(o), s(), s = lo;
  };
  let r;
  return (o) => {
    const u = Qe(e), c = Qe(n.maxWait);
    return t && l(t), u <= 0 || c !== void 0 && c <= 0 ? (a && (l(a), a = null), Promise.resolve(o())) : new Promise((d, p) => {
      s = n.rejectOnCancel ? p : d, r = o, c && !a && (a = setTimeout(() => {
        t && l(t), a = null, d(r());
      }, c)), t = setTimeout(() => {
        a && l(a), a = null, d(o());
      }, u);
    });
  };
}
function am(e) {
  let n;
  function t() {
    return n || (n = e()), n;
  }
  return t.reset = async () => {
    const a = n;
    n = void 0, a && await a;
  }, t;
}
function ro(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function sm(e) {
  return ii();
}
function or(e) {
  return Array.isArray(e) ? e : [e];
}
function lm(e, n = 200, t = {}) {
  return tm(
    nm(n, t),
    e
  );
}
function rm(e, n = !0, t) {
  sm() ? et(e, t) : n ? e() : Ke(e);
}
function Fr(e, n, t = {}) {
  const {
    immediate: a = !0,
    immediateCallback: s = !1
  } = t, l = Et(!1);
  let r = null;
  function i() {
    r && (clearTimeout(r), r = null);
  }
  function o() {
    l.value = !1, i();
  }
  function u(...c) {
    s && e(), i(), l.value = !0, r = setTimeout(() => {
      l.value = !1, r = null, e(...c);
    }, Qe(n));
  }
  return a && (l.value = !0, hi && u()), ec(o), {
    isPending: ri(l),
    start: u,
    stop: o
  };
}
function im(e, n, t) {
  return Ne(
    e,
    n,
    {
      ...t,
      immediate: !0
    }
  );
}
const mi = hi ? window : void 0, tc = hi ? window.navigator : void 0;
function om(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
function Ps(...e) {
  const n = [], t = () => {
    n.forEach((i) => i()), n.length = 0;
  }, a = (i, o, u, c) => (i.addEventListener(o, u, c), () => i.removeEventListener(o, u, c)), s = S(() => {
    const i = or(Qe(e[0])).filter((o) => o != null);
    return i.every((o) => typeof o != "string") ? i : void 0;
  }), l = im(
    () => {
      var i, o;
      return [
        (o = (i = s.value) == null ? void 0 : i.map((u) => om(u))) != null ? o : [mi].filter((u) => u != null),
        or(Qe(s.value ? e[1] : e[0])),
        or(v(s.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Qe(s.value ? e[3] : e[2])
      ];
    },
    ([i, o, u, c]) => {
      if (t(), !(i != null && i.length) || !(o != null && o.length) || !(u != null && u.length))
        return;
      const d = em(c) ? { ...c } : c;
      n.push(
        ...i.flatMap(
          (p) => o.flatMap(
            (f) => u.map((w) => a(p, f, w, d))
          )
        )
      );
    },
    { flush: "post" }
  ), r = () => {
    l(), t();
  };
  return ec(t), r;
}
function um() {
  const e = Et(!1), n = ii();
  return n && et(() => {
    e.value = !0;
  }, n), e;
}
function vi(e) {
  const n = um();
  return S(() => (n.value, !!e()));
}
const cm = Symbol("vueuse-ssr-width");
function dm() {
  const e = Iu() ? Jh(cm, null) : null;
  return typeof e == "number" ? e : void 0;
}
function fm(e, n = {}) {
  const { window: t = mi, ssrWidth: a = dm() } = n, s = vi(() => t && "matchMedia" in t && typeof t.matchMedia == "function"), l = Et(typeof a == "number"), r = Et(), i = Et(!1), o = (u) => {
    i.value = u.matches;
  };
  return jt(() => {
    if (l.value) {
      l.value = !s.value;
      const u = Qe(e).split(",");
      i.value = u.some((c) => {
        const d = c.includes("not all"), p = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), f = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let w = !!(p || f);
        return p && w && (w = a >= ro(p[1])), f && w && (w = a <= ro(f[1])), d ? !w : w;
      });
      return;
    }
    s.value && (r.value = t.matchMedia(Qe(e)), i.value = r.value.matches);
  }), Ps(r, "change", o, { passive: !0 }), S(() => i.value);
}
function io(e, n = {}) {
  const {
    controls: t = !1,
    navigator: a = tc
  } = n, s = vi(() => a && "permissions" in a), l = Et(), r = typeof e == "string" ? { name: e } : e, i = Et(), o = () => {
    var c, d;
    i.value = (d = (c = l.value) == null ? void 0 : c.state) != null ? d : "prompt";
  };
  Ps(l, "change", o, { passive: !0 });
  const u = am(async () => {
    if (s.value) {
      if (!l.value)
        try {
          l.value = await a.permissions.query(r);
        } catch {
          l.value = void 0;
        } finally {
          o();
        }
      if (t)
        return Au(l.value);
    }
  });
  return u(), t ? {
    state: i,
    isSupported: s,
    query: u
  } : i;
}
function pi(e = {}) {
  const {
    navigator: n = tc,
    read: t = !1,
    source: a,
    copiedDuring: s = 1500,
    legacy: l = !1
  } = e, r = vi(() => n && "clipboard" in n), i = io("clipboard-read"), o = io("clipboard-write"), u = S(() => r.value || l), c = Et(""), d = Et(!1), p = Fr(() => d.value = !1, s, { immediate: !1 });
  async function f() {
    let h = !(r.value && y(i.value));
    if (!h)
      try {
        c.value = await n.clipboard.readText();
      } catch {
        h = !0;
      }
    h && (c.value = k());
  }
  u.value && t && Ps(["copy", "cut"], f, { passive: !0 });
  async function w(h = Qe(a)) {
    if (u.value && h != null) {
      let g = !(r.value && y(o.value));
      if (!g)
        try {
          await n.clipboard.writeText(h);
        } catch {
          g = !0;
        }
      g && m(h), c.value = h, d.value = !0, p.start();
    }
  }
  function m(h) {
    const g = document.createElement("textarea");
    g.value = h ?? "", g.style.position = "absolute", g.style.opacity = "0", document.body.appendChild(g), g.select(), document.execCommand("copy"), g.remove();
  }
  function k() {
    var h, g, x;
    return (x = (g = (h = document == null ? void 0 : document.getSelection) == null ? void 0 : h.call(document)) == null ? void 0 : g.toString()) != null ? x : "";
  }
  function y(h) {
    return h === "granted" || h === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: d,
    copy: w
  };
}
function hm(e = {}) {
  const {
    window: n = mi,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: l = !0,
    type: r = "inner"
  } = e, i = Et(t), o = Et(a), u = () => {
    if (n)
      if (r === "outer")
        i.value = n.outerWidth, o.value = n.outerHeight;
      else if (r === "visual" && n.visualViewport) {
        const { width: d, height: p, scale: f } = n.visualViewport;
        i.value = Math.round(d * f), o.value = Math.round(p * f);
      } else l ? (i.value = n.innerWidth, o.value = n.innerHeight) : (i.value = n.document.documentElement.clientWidth, o.value = n.document.documentElement.clientHeight);
  };
  u(), rm(u);
  const c = { passive: !0 };
  if (Ps("resize", u, c), n && r === "visual" && n.visualViewport && Ps(n.visualViewport, "resize", u, c), s) {
    const d = fm("(orientation: portrait)");
    Ne(d, () => u());
  }
  return { width: i, height: o };
}
const mm = ["innerHTML"], vm = { key: 1 }, Nn = 12, Gn = 8, pm = 200, gm = /* @__PURE__ */ ke({
  __name: "VTooltip",
  props: {
    text: {},
    allowHtml: { type: Boolean, default: !1 },
    placement: { default: "right" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    tooltipClass: { default: "" },
    wrapperClass: { default: "" },
    maxWidth: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = J(!1), a = J(null), s = J(null), l = J(null), r = J({ top: 0, left: 0 }), i = J(n.placement), o = J(null), u = (m, k, y, h, g, x) => {
      const $ = m.top, C = g - m.bottom, O = m.left, _ = h - m.right, I = $ >= y + Gn + Nn, D = C >= y + Gn + Nn, z = O >= k + Gn + Nn, H = _ >= k + Gn + Nn;
      if (x === "top" && I) return "top";
      if (x === "bottom" && D) return "bottom";
      if (x === "left" && z) return "left";
      if (x === "right" && H) return "right";
      const ne = [
        { placement: "right", fits: H, space: _ },
        { placement: "left", fits: z, space: O },
        { placement: "bottom", fits: D, space: C },
        { placement: "top", fits: I, space: $ }
      ], te = ne.find((q) => q.fits);
      return te ? te.placement : (ne.sort((q, ie) => ie.space - q.space), ne[0].placement);
    }, c = async () => {
      if (!s.value) return;
      const m = s.value.getBoundingClientRect(), k = window.innerWidth, y = window.innerHeight;
      if (o.value = null, r.value = { top: -9999, left: -9999 }, i.value = n.placement, await Ke(), !l.value) return;
      const h = l.value.getBoundingClientRect(), g = n.modern ? h.width : Math.max(h.width, pm), x = h.height, $ = u(
        m,
        g,
        x,
        k,
        y,
        n.placement
      );
      let C, O;
      switch ($) {
        case "top":
          C = m.top - Gn - x, O = m.left + m.width / 2 - g / 2;
          break;
        case "bottom":
          C = m.bottom + Gn, O = m.left + m.width / 2 - g / 2;
          break;
        case "left":
          C = m.top + m.height / 2 - x / 2, O = m.left - Gn - g;
          break;
        case "right":
        default:
          C = m.top + m.height / 2 - x / 2, O = m.right + Gn;
          break;
      }
      const _ = k - g - Nn;
      O = Math.max(Nn, Math.min(O, _));
      const I = y - x - Nn;
      C = Math.max(Nn, Math.min(C, I));
      const D = k - Nn * 2;
      g > D && (o.value = `${D}px`), r.value = { top: C, left: O }, $ && (i.value = $);
    }, d = () => {
      n.disabled || !n.text || (a.value = setTimeout(async () => {
        t.value = !0, await Ke(), c();
      }, n.delay));
    }, p = () => {
      a.value && (clearTimeout(a.value), a.value = null), t.value = !1, i.value = n.placement;
    }, f = S(() => ({
      top: `${r.value.top}px`,
      left: `${r.value.left}px`,
      maxWidth: o.value ?? n.maxWidth ?? (n.modern ? "20rem" : "800px")
    })), w = S(
      () => n.modern ? "v-tooltip__body--modern bg-base-100/100 text-mainText rounded-lg shadow-lg break-words w-fit card" : "bg-base-100/100 text-mainText text-sm font-medium px-3 py-1.5 rounded-lg shadow-lg break-words w-fit min-w-[200px] card"
    );
    return (m, k) => (b(), T("div", {
      ref_key: "triggerRef",
      ref: s,
      class: j(["relative inline-block cursor-pointer", e.wrapperClass]),
      onBlur: p,
      onFocus: d,
      onMouseenter: d,
      onMouseleave: p
    }, [
      U(m.$slots, "default", {}, void 0, !0),
      (b(), ce(Pn, { to: "body" }, [
        se(ht, {
          "enter-active-class": "transition-opacity duration-200 ease-out",
          "enter-from-class": "opacity-0",
          "enter-to-class": "opacity-100",
          "leave-active-class": "transition-opacity duration-150 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: ue(() => [
            t.value && e.text ? (b(), T("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: l,
              style: Fe(f.value),
              class: "fixed z-[10001] pointer-events-none"
            }, [
              E("div", {
                class: j([w.value, e.tooltipClass])
              }, [
                n.allowHtml ? (b(), T("span", {
                  key: 0,
                  innerHTML: e.text
                }, null, 8, mm)) : (b(), T("span", vm, le(e.text), 1))
              ], 2)
            ], 4)) : P("", !0)
          ]),
          _: 1
        })
      ]))
    ], 34));
  }
}), xa = /* @__PURE__ */ Le(gm, [["__scopeId", "data-v-11931e94"]]), ym = ["aria-label"], bm = /* @__PURE__ */ ke({
  __name: "VCopyButton",
  props: {
    value: {},
    label: { default: "value" },
    size: { default: 16 }
  },
  setup(e) {
    const { copy: n, copied: t, isSupported: a } = pi({ source: () => e.value, copiedDuring: 1500 });
    return (s, l) => v(a) ? (b(), ce(xa, {
      key: 0,
      text: v(t) ? "Copied!" : `Copy ${e.label}`,
      placement: "top"
    }, {
      default: ue(() => [
        E("button", {
          "aria-label": `Copy ${e.label}`,
          class: "v-copy-button flex-shrink-0 flex items-center justify-center p-1 rounded-md text-secondaryText hover:text-mainText hover:bg-base-200",
          type: "button",
          onClick: l[0] || (l[0] = Ve((r) => v(n)(), ["stop"]))
        }, [
          se(ye, {
            class: j(v(t) ? "text-success" : ""),
            icon: v(t) ? "lucide:check" : "lucide:copy",
            size: e.size
          }, null, 8, ["class", "icon", "size"])
        ], 8, ym)
      ]),
      _: 1
    }, 8, ["text"])) : P("", !0);
  }
}), BD = /* @__PURE__ */ Le(bm, [["__scopeId", "data-v-1863029c"]]);
class Ma extends Error {
}
class wm extends Ma {
  constructor(n) {
    super(`Invalid DateTime: ${n.toMessage()}`);
  }
}
class km extends Ma {
  constructor(n) {
    super(`Invalid Interval: ${n.toMessage()}`);
  }
}
class xm extends Ma {
  constructor(n) {
    super(`Invalid Duration: ${n.toMessage()}`);
  }
}
class Wa extends Ma {
}
class nc extends Ma {
  constructor(n) {
    super(`Invalid unit ${n}`);
  }
}
class Rt extends Ma {
}
class Kn extends Ma {
  constructor() {
    super("Zone is an abstract class");
  }
}
const _e = "numeric", wn = "short", Zt = "long", Sl = {
  year: _e,
  month: _e,
  day: _e
}, ac = {
  year: _e,
  month: wn,
  day: _e
}, Sm = {
  year: _e,
  month: wn,
  day: _e,
  weekday: wn
}, sc = {
  year: _e,
  month: Zt,
  day: _e
}, lc = {
  year: _e,
  month: Zt,
  day: _e,
  weekday: Zt
}, rc = {
  hour: _e,
  minute: _e
}, ic = {
  hour: _e,
  minute: _e,
  second: _e
}, oc = {
  hour: _e,
  minute: _e,
  second: _e,
  timeZoneName: wn
}, uc = {
  hour: _e,
  minute: _e,
  second: _e,
  timeZoneName: Zt
}, cc = {
  hour: _e,
  minute: _e,
  hourCycle: "h23"
}, dc = {
  hour: _e,
  minute: _e,
  second: _e,
  hourCycle: "h23"
}, fc = {
  hour: _e,
  minute: _e,
  second: _e,
  hourCycle: "h23",
  timeZoneName: wn
}, hc = {
  hour: _e,
  minute: _e,
  second: _e,
  hourCycle: "h23",
  timeZoneName: Zt
}, mc = {
  year: _e,
  month: _e,
  day: _e,
  hour: _e,
  minute: _e
}, vc = {
  year: _e,
  month: _e,
  day: _e,
  hour: _e,
  minute: _e,
  second: _e
}, pc = {
  year: _e,
  month: wn,
  day: _e,
  hour: _e,
  minute: _e
}, gc = {
  year: _e,
  month: wn,
  day: _e,
  hour: _e,
  minute: _e,
  second: _e
}, $m = {
  year: _e,
  month: wn,
  day: _e,
  weekday: wn,
  hour: _e,
  minute: _e
}, yc = {
  year: _e,
  month: Zt,
  day: _e,
  hour: _e,
  minute: _e,
  timeZoneName: wn
}, bc = {
  year: _e,
  month: Zt,
  day: _e,
  hour: _e,
  minute: _e,
  second: _e,
  timeZoneName: wn
}, wc = {
  year: _e,
  month: Zt,
  day: _e,
  weekday: Zt,
  hour: _e,
  minute: _e,
  timeZoneName: Zt
}, kc = {
  year: _e,
  month: Zt,
  day: _e,
  weekday: Zt,
  hour: _e,
  minute: _e,
  second: _e,
  timeZoneName: Zt
};
class Ls {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new Kn();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new Kn();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new Kn();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, t) {
    throw new Kn();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    throw new Kn();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    throw new Kn();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    throw new Kn();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new Kn();
  }
}
let ur = null;
class Fl extends Ls {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return ur === null && (ur = new Fl()), ur;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(n, { format: t, locale: a }) {
    return Ic(n, t, a);
  }
  /** @override **/
  formatOffset(n, t) {
    return Ds(this.offset(n), t);
  }
  /** @override **/
  offset(n) {
    return -new Date(n).getTimezoneOffset();
  }
  /** @override **/
  equals(n) {
    return n.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
const Lr = /* @__PURE__ */ new Map();
function Tm(e) {
  let n = Lr.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  }), Lr.set(e, n)), n;
}
const Cm = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function Mm(e, n) {
  const t = e.format(n).replace(/\u200E/g, ""), a = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(t), [, s, l, r, i, o, u, c] = a;
  return [r, s, l, i, o, u, c];
}
function Dm(e, n) {
  const t = e.formatToParts(n), a = [];
  for (let s = 0; s < t.length; s++) {
    const { type: l, value: r } = t[s], i = Cm[l];
    l === "era" ? a[i] = r : Be(i) || (a[i] = parseInt(r, 10));
  }
  return a;
}
const cr = /* @__PURE__ */ new Map();
class Yn extends Ls {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(n) {
    let t = cr.get(n);
    return t === void 0 && cr.set(n, t = new Yn(n)), t;
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    cr.clear(), Lr.clear();
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(n) {
    return this.isValidZone(n);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(n) {
    if (!n)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: n }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(n) {
    super(), this.zoneName = n, this.valid = Yn.isValidZone(n);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(n, { format: t, locale: a }) {
    return Ic(n, t, a, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ds(this.offset(n), t);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(n) {
    if (!this.valid) return NaN;
    const t = new Date(n);
    if (isNaN(t)) return NaN;
    const a = Tm(this.name);
    let [s, l, r, i, o, u, c] = a.formatToParts ? Dm(a, t) : Mm(a, t);
    i === "BC" && (s = -Math.abs(s) + 1);
    const p = Nl({
      year: s,
      month: l,
      day: r,
      hour: o === 24 ? 0 : o,
      minute: u,
      second: c,
      millisecond: 0
    });
    let f = +t;
    const w = f % 1e3;
    return f -= w >= 0 ? w : 1e3 + w, (p - f) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "iana" && n.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let oo = {};
function _m(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = oo[t];
  return a || (a = new Intl.ListFormat(e, n), oo[t] = a), a;
}
const Nr = /* @__PURE__ */ new Map();
function zr(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Nr.get(t);
  return a === void 0 && (a = new Intl.DateTimeFormat(e, n), Nr.set(t, a)), a;
}
const Br = /* @__PURE__ */ new Map();
function Om(e, n = {}) {
  const t = JSON.stringify([e, n]);
  let a = Br.get(t);
  return a === void 0 && (a = new Intl.NumberFormat(e, n), Br.set(t, a)), a;
}
const Wr = /* @__PURE__ */ new Map();
function Em(e, n = {}) {
  const { base: t, ...a } = n, s = JSON.stringify([e, a]);
  let l = Wr.get(s);
  return l === void 0 && (l = new Intl.RelativeTimeFormat(e, n), Wr.set(s, l)), l;
}
let $s = null;
function Im() {
  return $s || ($s = new Intl.DateTimeFormat().resolvedOptions().locale, $s);
}
const Yr = /* @__PURE__ */ new Map();
function xc(e) {
  let n = Yr.get(e);
  return n === void 0 && (n = new Intl.DateTimeFormat(e).resolvedOptions(), Yr.set(e, n)), n;
}
const Hr = /* @__PURE__ */ new Map();
function Am(e) {
  let n = Hr.get(e);
  if (!n) {
    const t = new Intl.Locale(e);
    n = "getWeekInfo" in t ? t.getWeekInfo() : t.weekInfo, "minimalDays" in n || (n = { ...Sc, ...n }), Hr.set(e, n);
  }
  return n;
}
function Pm(e) {
  const n = e.indexOf("-x-");
  n !== -1 && (e = e.substring(0, n));
  const t = e.indexOf("-u-");
  if (t === -1)
    return [e];
  {
    let a, s;
    try {
      a = zr(e).resolvedOptions(), s = e;
    } catch {
      const o = e.substring(0, t);
      a = zr(o).resolvedOptions(), s = o;
    }
    const { numberingSystem: l, calendar: r } = a;
    return [s, l, r];
  }
}
function Rm(e, n, t) {
  return (t || n) && (e.includes("-u-") || (e += "-u"), t && (e += `-ca-${t}`), n && (e += `-nu-${n}`)), e;
}
function Vm(e) {
  const n = [];
  for (let t = 1; t <= 12; t++) {
    const a = Ie.utc(2009, t, 1);
    n.push(e(a));
  }
  return n;
}
function Fm(e) {
  const n = [];
  for (let t = 1; t <= 7; t++) {
    const a = Ie.utc(2016, 11, 13 + t);
    n.push(e(a));
  }
  return n;
}
function al(e, n, t, a) {
  const s = e.listingMode();
  return s === "error" ? null : s === "en" ? t(n) : a(n);
}
function Lm(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || xc(e.locale).numberingSystem === "latn";
}
class Nm {
  constructor(n, t, a) {
    this.padTo = a.padTo || 0, this.floor = a.floor || !1;
    const { padTo: s, floor: l, ...r } = a;
    if (!t || Object.keys(r).length > 0) {
      const i = { useGrouping: !1, ...a };
      a.padTo > 0 && (i.minimumIntegerDigits = a.padTo), this.inf = Om(n, i);
    }
  }
  format(n) {
    if (this.inf) {
      const t = this.floor ? Math.floor(n) : n;
      return this.inf.format(t);
    } else {
      const t = this.floor ? Math.floor(n) : ki(n, 3);
      return Ct(t, this.padTo);
    }
  }
}
class zm {
  constructor(n, t, a) {
    this.opts = a, this.originalZone = void 0;
    let s;
    if (this.opts.timeZone)
      this.dt = n;
    else if (n.zone.type === "fixed") {
      const r = -1 * (n.offset / 60), i = r >= 0 ? `Etc/GMT+${r}` : `Etc/GMT${r}`;
      n.offset !== 0 && Yn.create(i).valid ? (s = i, this.dt = n) : (s = "UTC", this.dt = n.offset === 0 ? n : n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    } else n.zone.type === "system" ? this.dt = n : n.zone.type === "iana" ? (this.dt = n, s = n.zone.name) : (s = "UTC", this.dt = n.setZone("UTC").plus({ minutes: n.offset }), this.originalZone = n.zone);
    const l = { ...this.opts };
    l.timeZone = l.timeZone || s, this.dtf = zr(t, l);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: n }) => n).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const n = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? n.map((t) => {
      if (t.type === "timeZoneName") {
        const a = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...t,
          value: a
        };
      } else
        return t;
    }) : n;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class Bm {
  constructor(n, t, a) {
    this.opts = { style: "long", ...a }, !t && Oc() && (this.rtf = Em(n, a));
  }
  format(n, t) {
    return this.rtf ? this.rtf.format(n, t) : uv(t, n, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(n, t) {
    return this.rtf ? this.rtf.formatToParts(n, t) : [];
  }
}
const Sc = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class st {
  static fromOpts(n) {
    return st.create(
      n.locale,
      n.numberingSystem,
      n.outputCalendar,
      n.weekSettings,
      n.defaultToEN
    );
  }
  static create(n, t, a, s, l = !1) {
    const r = n || yt.defaultLocale, i = r || (l ? "en-US" : Im()), o = t || yt.defaultNumberingSystem, u = a || yt.defaultOutputCalendar, c = qr(s) || yt.defaultWeekSettings;
    return new st(i, o, u, c, r);
  }
  static resetCache() {
    $s = null, Nr.clear(), Br.clear(), Wr.clear(), Yr.clear(), Hr.clear();
  }
  static fromObject({ locale: n, numberingSystem: t, outputCalendar: a, weekSettings: s } = {}) {
    return st.create(n, t, a, s);
  }
  constructor(n, t, a, s, l) {
    const [r, i, o] = Pm(n);
    this.locale = r, this.numberingSystem = t || i || null, this.outputCalendar = a || o || null, this.weekSettings = s, this.intl = Rm(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = l, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = Lm(this)), this.fastNumbersCached;
  }
  listingMode() {
    const n = this.isEnglish(), t = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return n && t ? "en" : "intl";
  }
  clone(n) {
    return !n || Object.getOwnPropertyNames(n).length === 0 ? this : st.create(
      n.locale || this.specifiedLocale,
      n.numberingSystem || this.numberingSystem,
      n.outputCalendar || this.outputCalendar,
      qr(n.weekSettings) || this.weekSettings,
      n.defaultToEN || !1
    );
  }
  redefaultToEN(n = {}) {
    return this.clone({ ...n, defaultToEN: !0 });
  }
  redefaultToSystem(n = {}) {
    return this.clone({ ...n, defaultToEN: !1 });
  }
  months(n, t = !1) {
    return al(this, n, Rc, () => {
      const a = this.intl === "ja" || this.intl.startsWith("ja-");
      t &= !a;
      const s = t ? { month: n, day: "numeric" } : { month: n }, l = t ? "format" : "standalone";
      if (!this.monthsCache[l][n]) {
        const r = a ? (i) => this.dtFormatter(i, s).format() : (i) => this.extract(i, s, "month");
        this.monthsCache[l][n] = Vm(r);
      }
      return this.monthsCache[l][n];
    });
  }
  weekdays(n, t = !1) {
    return al(this, n, Lc, () => {
      const a = t ? { weekday: n, year: "numeric", month: "long", day: "numeric" } : { weekday: n }, s = t ? "format" : "standalone";
      return this.weekdaysCache[s][n] || (this.weekdaysCache[s][n] = Fm(
        (l) => this.extract(l, a, "weekday")
      )), this.weekdaysCache[s][n];
    });
  }
  meridiems() {
    return al(
      this,
      void 0,
      () => Nc,
      () => {
        if (!this.meridiemCache) {
          const n = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Ie.utc(2016, 11, 13, 9), Ie.utc(2016, 11, 13, 19)].map(
            (t) => this.extract(t, n, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(n) {
    return al(this, n, zc, () => {
      const t = { era: n };
      return this.eraCache[n] || (this.eraCache[n] = [Ie.utc(-40, 1, 1), Ie.utc(2017, 1, 1)].map(
        (a) => this.extract(a, t, "era")
      )), this.eraCache[n];
    });
  }
  extract(n, t, a) {
    const s = this.dtFormatter(n, t), l = s.formatToParts(), r = l.find((i) => i.type.toLowerCase() === a);
    return r ? r.value : null;
  }
  numberFormatter(n = {}) {
    return new Nm(this.intl, n.forceSimple || this.fastNumbers, n);
  }
  dtFormatter(n, t = {}) {
    return new zm(n, this.intl, t);
  }
  relFormatter(n = {}) {
    return new Bm(this.intl, this.isEnglish(), n);
  }
  listFormatter(n = {}) {
    return _m(this.intl, n);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || xc(this.intl).locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : Ec() ? Am(this.locale) : Sc;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(n) {
    return this.locale === n.locale && this.numberingSystem === n.numberingSystem && this.outputCalendar === n.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let dr = null;
class Bt extends Ls {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return dr === null && (dr = new Bt(0)), dr;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(n) {
    return n === 0 ? Bt.utcInstance : new Bt(n);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(n) {
    if (n) {
      const t = n.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (t)
        return new Bt(zl(t[1], t[2]));
    }
    return null;
  }
  constructor(n) {
    super(), this.fixed = n;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Ds(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Ds(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(n, t) {
    return Ds(this.fixed, t);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(n) {
    return n.type === "fixed" && n.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class Wm extends Ls {
  constructor(n) {
    super(), this.zoneName = n;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function Qn(e, n) {
  if (Be(e) || e === null)
    return n;
  if (e instanceof Ls)
    return e;
  if (Gm(e)) {
    const t = e.toLowerCase();
    return t === "default" ? n : t === "local" || t === "system" ? Fl.instance : t === "utc" || t === "gmt" ? Bt.utcInstance : Bt.parseSpecifier(t) || Yn.create(e);
  } else return na(e) ? Bt.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new Wm(e);
}
const gi = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, uo = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, Ym = gi.hanidec.replace(/[\[|\]]/g, "").split("");
function Hm(e) {
  let n = parseInt(e, 10);
  if (isNaN(n)) {
    n = "";
    for (let t = 0; t < e.length; t++) {
      const a = e.charCodeAt(t);
      if (e[t].search(gi.hanidec) !== -1)
        n += Ym.indexOf(e[t]);
      else
        for (const s in uo) {
          const [l, r] = uo[s];
          a >= l && a <= r && (n += a - l);
        }
    }
    return parseInt(n, 10);
  } else
    return n;
}
const Ur = /* @__PURE__ */ new Map();
function Um() {
  Ur.clear();
}
function dn({ numberingSystem: e }, n = "") {
  const t = e || "latn";
  let a = Ur.get(t);
  a === void 0 && (a = /* @__PURE__ */ new Map(), Ur.set(t, a));
  let s = a.get(n);
  return s === void 0 && (s = new RegExp(`${gi[t]}${n}`), a.set(n, s)), s;
}
let co = () => Date.now(), fo = "system", ho = null, mo = null, vo = null, po = 60, go, yo = null;
class yt {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return co;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    co = n;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(n) {
    fo = n;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return Qn(fo, Fl.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return ho;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(n) {
    ho = n;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return mo;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(n) {
    mo = n;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return vo;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(n) {
    vo = n;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return yo;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(n) {
    yo = qr(n);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return po;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(n) {
    po = n % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return go;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(n) {
    go = n;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    st.resetCache(), Yn.resetCache(), Ie.resetCache(), Um();
  }
}
class pn {
  constructor(n, t) {
    this.reason = n, this.explanation = t;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const $c = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], Tc = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function sn(e, n) {
  return new pn(
    "unit out of range",
    `you specified ${n} (of type ${typeof n}) as a ${e}, which is invalid`
  );
}
function yi(e, n, t) {
  const a = new Date(Date.UTC(e, n - 1, t));
  e < 100 && e >= 0 && a.setUTCFullYear(a.getUTCFullYear() - 1900);
  const s = a.getUTCDay();
  return s === 0 ? 7 : s;
}
function Cc(e, n, t) {
  return t + (Ns(e) ? Tc : $c)[n - 1];
}
function Mc(e, n) {
  const t = Ns(e) ? Tc : $c, a = t.findIndex((l) => l < n), s = n - t[a];
  return { month: a + 1, day: s };
}
function bi(e, n) {
  return (e - n + 7) % 7 + 1;
}
function $l(e, n = 4, t = 1) {
  const { year: a, month: s, day: l } = e, r = Cc(a, s, l), i = bi(yi(a, s, l), t);
  let o = Math.floor((r - i + 14 - n) / 7), u;
  return o < 1 ? (u = a - 1, o = Rs(u, n, t)) : o > Rs(a, n, t) ? (u = a + 1, o = 1) : u = a, { weekYear: u, weekNumber: o, weekday: i, ...Bl(e) };
}
function bo(e, n = 4, t = 1) {
  const { weekYear: a, weekNumber: s, weekday: l } = e, r = bi(yi(a, 1, n), t), i = qa(a);
  let o = s * 7 + l - r - 7 + n, u;
  o < 1 ? (u = a - 1, o += qa(u)) : o > i ? (u = a + 1, o -= qa(a)) : u = a;
  const { month: c, day: d } = Mc(u, o);
  return { year: u, month: c, day: d, ...Bl(e) };
}
function fr(e) {
  const { year: n, month: t, day: a } = e, s = Cc(n, t, a);
  return { year: n, ordinal: s, ...Bl(e) };
}
function wo(e) {
  const { year: n, ordinal: t } = e, { month: a, day: s } = Mc(n, t);
  return { year: n, month: a, day: s, ...Bl(e) };
}
function ko(e, n) {
  if (!Be(e.localWeekday) || !Be(e.localWeekNumber) || !Be(e.localWeekYear)) {
    if (!Be(e.weekday) || !Be(e.weekNumber) || !Be(e.weekYear))
      throw new Wa(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Be(e.localWeekday) || (e.weekday = e.localWeekday), Be(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Be(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: n.getMinDaysInFirstWeek(),
      startOfWeek: n.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function qm(e, n = 4, t = 1) {
  const a = Ll(e.weekYear), s = ln(
    e.weekNumber,
    1,
    Rs(e.weekYear, n, t)
  ), l = ln(e.weekday, 1, 7);
  return a ? s ? l ? !1 : sn("weekday", e.weekday) : sn("week", e.weekNumber) : sn("weekYear", e.weekYear);
}
function jm(e) {
  const n = Ll(e.year), t = ln(e.ordinal, 1, qa(e.year));
  return n ? t ? !1 : sn("ordinal", e.ordinal) : sn("year", e.year);
}
function Dc(e) {
  const n = Ll(e.year), t = ln(e.month, 1, 12), a = ln(e.day, 1, Tl(e.year, e.month));
  return n ? t ? a ? !1 : sn("day", e.day) : sn("month", e.month) : sn("year", e.year);
}
function _c(e) {
  const { hour: n, minute: t, second: a, millisecond: s } = e, l = ln(n, 0, 23) || n === 24 && t === 0 && a === 0 && s === 0, r = ln(t, 0, 59), i = ln(a, 0, 59), o = ln(s, 0, 999);
  return l ? r ? i ? o ? !1 : sn("millisecond", s) : sn("second", a) : sn("minute", t) : sn("hour", n);
}
function Be(e) {
  return typeof e > "u";
}
function na(e) {
  return typeof e == "number";
}
function Ll(e) {
  return typeof e == "number" && e % 1 === 0;
}
function Gm(e) {
  return typeof e == "string";
}
function Km(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function Oc() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function Ec() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function Zm(e) {
  return Array.isArray(e) ? e : [e];
}
function xo(e, n, t) {
  if (e.length !== 0)
    return e.reduce((a, s) => {
      const l = [n(s), s];
      return a && t(a[0], l[0]) === a[0] ? a : l;
    }, null)[1];
}
function Xm(e, n) {
  return n.reduce((t, a) => (t[a] = e[a], t), {});
}
function Ja(e, n) {
  return Object.prototype.hasOwnProperty.call(e, n);
}
function qr(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Rt("Week settings must be an object");
  if (!ln(e.firstDay, 1, 7) || !ln(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((n) => !ln(n, 1, 7)))
    throw new Rt("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function ln(e, n, t) {
  return Ll(e) && e >= n && e <= t;
}
function Jm(e, n) {
  return e - n * Math.floor(e / n);
}
function Ct(e, n = 2) {
  const t = e < 0;
  let a;
  return t ? a = "-" + ("" + -e).padStart(n, "0") : a = ("" + e).padStart(n, "0"), a;
}
function Jn(e) {
  if (!(Be(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function ca(e) {
  if (!(Be(e) || e === null || e === ""))
    return parseFloat(e);
}
function wi(e) {
  if (!(Be(e) || e === null || e === "")) {
    const n = parseFloat("0." + e) * 1e3;
    return Math.floor(n);
  }
}
function ki(e, n, t = "round") {
  const a = 10 ** n;
  switch (t) {
    case "expand":
      return e > 0 ? Math.ceil(e * a) / a : Math.floor(e * a) / a;
    case "trunc":
      return Math.trunc(e * a) / a;
    case "round":
      return Math.round(e * a) / a;
    case "floor":
      return Math.floor(e * a) / a;
    case "ceil":
      return Math.ceil(e * a) / a;
    default:
      throw new RangeError(`Value rounding ${t} is out of range`);
  }
}
function Ns(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function qa(e) {
  return Ns(e) ? 366 : 365;
}
function Tl(e, n) {
  const t = Jm(n - 1, 12) + 1, a = e + (n - t) / 12;
  return t === 2 ? Ns(a) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][t - 1];
}
function Nl(e) {
  let n = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (n = new Date(n), n.setUTCFullYear(e.year, e.month - 1, e.day)), +n;
}
function So(e, n, t) {
  return -bi(yi(e, 1, n), t) + n - 1;
}
function Rs(e, n = 4, t = 1) {
  const a = So(e, n, t), s = So(e + 1, n, t);
  return (qa(e) - a + s) / 7;
}
function jr(e) {
  return e > 99 ? e : e > yt.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function Ic(e, n, t, a = null) {
  const s = new Date(e), l = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  a && (l.timeZone = a);
  const r = { timeZoneName: n, ...l }, i = new Intl.DateTimeFormat(t, r).formatToParts(s).find((o) => o.type.toLowerCase() === "timezonename");
  return i ? i.value : null;
}
function zl(e, n) {
  let t = parseInt(e, 10);
  Number.isNaN(t) && (t = 0);
  const a = parseInt(n, 10) || 0, s = t < 0 || Object.is(t, -0) ? -a : a;
  return t * 60 + s;
}
function Ac(e) {
  const n = Number(e);
  if (typeof e == "boolean" || e === "" || !Number.isFinite(n))
    throw new Rt(`Invalid unit value ${e}`);
  return n;
}
function Cl(e, n) {
  const t = {};
  for (const a in e)
    if (Ja(e, a)) {
      const s = e[a];
      if (s == null) continue;
      t[n(a)] = Ac(s);
    }
  return t;
}
function Ds(e, n) {
  const t = Math.trunc(Math.abs(e / 60)), a = Math.trunc(Math.abs(e % 60)), s = e >= 0 ? "+" : "-";
  switch (n) {
    case "short":
      return `${s}${Ct(t, 2)}:${Ct(a, 2)}`;
    case "narrow":
      return `${s}${t}${a > 0 ? `:${a}` : ""}`;
    case "techie":
      return `${s}${Ct(t, 2)}${Ct(a, 2)}`;
    default:
      throw new RangeError(`Value format ${n} is out of range for property format`);
  }
}
function Bl(e) {
  return Xm(e, ["hour", "minute", "second", "millisecond"]);
}
const Qm = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Pc = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], ev = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Rc(e) {
  switch (e) {
    case "narrow":
      return [...ev];
    case "short":
      return [...Pc];
    case "long":
      return [...Qm];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Vc = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Fc = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], tv = ["M", "T", "W", "T", "F", "S", "S"];
function Lc(e) {
  switch (e) {
    case "narrow":
      return [...tv];
    case "short":
      return [...Fc];
    case "long":
      return [...Vc];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const Nc = ["AM", "PM"], nv = ["Before Christ", "Anno Domini"], av = ["BC", "AD"], sv = ["B", "A"];
function zc(e) {
  switch (e) {
    case "narrow":
      return [...sv];
    case "short":
      return [...av];
    case "long":
      return [...nv];
    default:
      return null;
  }
}
function lv(e) {
  return Nc[e.hour < 12 ? 0 : 1];
}
function rv(e, n) {
  return Lc(n)[e.weekday - 1];
}
function iv(e, n) {
  return Rc(n)[e.month - 1];
}
function ov(e, n) {
  return zc(n)[e.year < 0 ? 0 : 1];
}
function uv(e, n, t = "always", a = !1) {
  const s = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, l = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (t === "auto" && l) {
    const d = e === "days";
    switch (n) {
      case 1:
        return d ? "tomorrow" : `next ${s[e][0]}`;
      case -1:
        return d ? "yesterday" : `last ${s[e][0]}`;
      case 0:
        return d ? "today" : `this ${s[e][0]}`;
    }
  }
  const r = Object.is(n, -0) || n < 0, i = Math.abs(n), o = i === 1, u = s[e], c = a ? o ? u[1] : u[2] || u[1] : o ? s[e][0] : e;
  return r ? `${i} ${c} ago` : `in ${i} ${c}`;
}
function $o(e, n) {
  let t = "";
  for (const a of e)
    a.literal ? t += a.val : t += n(a.val);
  return t;
}
const cv = {
  D: Sl,
  DD: ac,
  DDD: sc,
  DDDD: lc,
  t: rc,
  tt: ic,
  ttt: oc,
  tttt: uc,
  T: cc,
  TT: dc,
  TTT: fc,
  TTTT: hc,
  f: mc,
  ff: pc,
  fff: yc,
  ffff: wc,
  F: vc,
  FF: gc,
  FFF: bc,
  FFFF: kc
};
class Vt {
  static create(n, t = {}) {
    return new Vt(n, t);
  }
  static parseFormat(n) {
    let t = null, a = "", s = !1;
    const l = [];
    for (let r = 0; r < n.length; r++) {
      const i = n.charAt(r);
      i === "'" ? ((a.length > 0 || s) && l.push({
        literal: s || /^\s+$/.test(a),
        val: a === "" ? "'" : a
      }), t = null, a = "", s = !s) : s || i === t ? a += i : (a.length > 0 && l.push({ literal: /^\s+$/.test(a), val: a }), a = i, t = i);
    }
    return a.length > 0 && l.push({ literal: s || /^\s+$/.test(a), val: a }), l;
  }
  static macroTokenToFormatOpts(n) {
    return cv[n];
  }
  constructor(n, t) {
    this.opts = t, this.loc = n, this.systemLoc = null;
  }
  formatWithSystemDefault(n, t) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(n, { ...this.opts, ...t }).format();
  }
  dtFormatter(n, t = {}) {
    return this.loc.dtFormatter(n, { ...this.opts, ...t });
  }
  formatDateTime(n, t) {
    return this.dtFormatter(n, t).format();
  }
  formatDateTimeParts(n, t) {
    return this.dtFormatter(n, t).formatToParts();
  }
  formatInterval(n, t) {
    return this.dtFormatter(n.start, t).dtf.formatRange(n.start.toJSDate(), n.end.toJSDate());
  }
  resolvedOptions(n, t) {
    return this.dtFormatter(n, t).resolvedOptions();
  }
  num(n, t = 0, a = void 0) {
    if (this.opts.forceSimple)
      return Ct(n, t);
    const s = { ...this.opts };
    return t > 0 && (s.padTo = t), a && (s.signDisplay = a), this.loc.numberFormatter(s).format(n);
  }
  formatDateTimeFromString(n, t) {
    const a = this.loc.listingMode() === "en", s = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", l = (f, w) => this.loc.extract(n, f, w), r = (f) => n.isOffsetFixed && n.offset === 0 && f.allowZ ? "Z" : n.isValid ? n.zone.formatOffset(n.ts, f.format) : "", i = () => a ? lv(n) : l({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), o = (f, w) => a ? iv(n, f) : l(w ? { month: f } : { month: f, day: "numeric" }, "month"), u = (f, w) => a ? rv(n, f) : l(
      w ? { weekday: f } : { weekday: f, month: "long", day: "numeric" },
      "weekday"
    ), c = (f) => {
      const w = Vt.macroTokenToFormatOpts(f);
      return w ? this.formatWithSystemDefault(n, w) : f;
    }, d = (f) => a ? ov(n, f) : l({ era: f }, "era"), p = (f) => {
      switch (f) {
        // ms
        case "S":
          return this.num(n.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(n.millisecond, 3);
        // seconds
        case "s":
          return this.num(n.second);
        case "ss":
          return this.num(n.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(n.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(n.millisecond / 100));
        // minutes
        case "m":
          return this.num(n.minute);
        case "mm":
          return this.num(n.minute, 2);
        // hours
        case "h":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12);
        case "hh":
          return this.num(n.hour % 12 === 0 ? 12 : n.hour % 12, 2);
        case "H":
          return this.num(n.hour);
        case "HH":
          return this.num(n.hour, 2);
        // offset
        case "Z":
          return r({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return r({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return r({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return n.zone.offsetName(n.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return n.zone.offsetName(n.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return n.zoneName;
        // meridiems
        case "a":
          return i();
        // dates
        case "d":
          return s ? l({ day: "numeric" }, "day") : this.num(n.day);
        case "dd":
          return s ? l({ day: "2-digit" }, "day") : this.num(n.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(n.weekday);
        case "ccc":
          return u("short", !0);
        case "cccc":
          return u("long", !0);
        case "ccccc":
          return u("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(n.weekday);
        case "EEE":
          return u("short", !1);
        case "EEEE":
          return u("long", !1);
        case "EEEEE":
          return u("narrow", !1);
        // months - standalone
        case "L":
          return s ? l({ month: "numeric", day: "numeric" }, "month") : this.num(n.month);
        case "LL":
          return s ? l({ month: "2-digit", day: "numeric" }, "month") : this.num(n.month, 2);
        case "LLL":
          return o("short", !0);
        case "LLLL":
          return o("long", !0);
        case "LLLLL":
          return o("narrow", !0);
        // months - format
        case "M":
          return s ? l({ month: "numeric" }, "month") : this.num(n.month);
        case "MM":
          return s ? l({ month: "2-digit" }, "month") : this.num(n.month, 2);
        case "MMM":
          return o("short", !1);
        case "MMMM":
          return o("long", !1);
        case "MMMMM":
          return o("narrow", !1);
        // years
        case "y":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year);
        case "yy":
          return s ? l({ year: "2-digit" }, "year") : this.num(n.year.toString().slice(-2), 2);
        case "yyyy":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year, 4);
        case "yyyyyy":
          return s ? l({ year: "numeric" }, "year") : this.num(n.year, 6);
        // eras
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(n.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(n.weekYear, 4);
        case "W":
          return this.num(n.weekNumber);
        case "WW":
          return this.num(n.weekNumber, 2);
        case "n":
          return this.num(n.localWeekNumber);
        case "nn":
          return this.num(n.localWeekNumber, 2);
        case "ii":
          return this.num(n.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(n.localWeekYear, 4);
        case "o":
          return this.num(n.ordinal);
        case "ooo":
          return this.num(n.ordinal, 3);
        case "q":
          return this.num(n.quarter);
        case "qq":
          return this.num(n.quarter, 2);
        case "X":
          return this.num(Math.floor(n.ts / 1e3));
        case "x":
          return this.num(n.ts);
        default:
          return c(f);
      }
    };
    return $o(Vt.parseFormat(t), p);
  }
  formatDurationFromString(n, t) {
    const a = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, s = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, l = (c, d) => (p) => {
      const f = s(p);
      if (f) {
        const w = d.isNegativeDuration && f !== d.largestUnit ? a : 1;
        let m;
        return this.opts.signMode === "negativeLargestOnly" && f !== d.largestUnit ? m = "never" : this.opts.signMode === "all" ? m = "always" : m = "auto", this.num(c.get(f) * w, p.length, m);
      } else
        return p;
    }, r = Vt.parseFormat(t), i = r.reduce(
      (c, { literal: d, val: p }) => d ? c : c.concat(p),
      []
    ), o = n.shiftTo(...i.map(s).filter((c) => c)), u = {
      isNegativeDuration: o < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(o.values)[0]
    };
    return $o(r, l(o, u));
  }
}
const Bc = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function ls(...e) {
  const n = e.reduce((t, a) => t + a.source, "");
  return RegExp(`^${n}$`);
}
function rs(...e) {
  return (n) => e.reduce(
    ([t, a, s], l) => {
      const [r, i, o] = l(n, s);
      return [{ ...t, ...r }, i || a, o];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function is(e, ...n) {
  if (e == null)
    return [null, null];
  for (const [t, a] of n) {
    const s = t.exec(e);
    if (s)
      return a(s);
  }
  return [null, null];
}
function Wc(...e) {
  return (n, t) => {
    const a = {};
    let s;
    for (s = 0; s < e.length; s++)
      a[e[s]] = Jn(n[t + s]);
    return [a, null, t + s];
  };
}
const Yc = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/, dv = `(?:${Yc.source}?(?:\\[(${Bc.source})\\])?)?`, xi = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Hc = RegExp(`${xi.source}${dv}`), Si = RegExp(`(?:[Tt]${Hc.source})?`), fv = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, hv = /(\d{4})-?W(\d\d)(?:-?(\d))?/, mv = /(\d{4})-?(\d{3})/, vv = Wc("weekYear", "weekNumber", "weekDay"), pv = Wc("year", "ordinal"), gv = /(\d{4})-(\d\d)-(\d\d)/, Uc = RegExp(
  `${xi.source} ?(?:${Yc.source}|(${Bc.source}))?`
), yv = RegExp(`(?: ${Uc.source})?`);
function ja(e, n, t) {
  const a = e[n];
  return Be(a) ? t : Jn(a);
}
function bv(e, n) {
  return [{
    year: ja(e, n),
    month: ja(e, n + 1, 1),
    day: ja(e, n + 2, 1)
  }, null, n + 3];
}
function os(e, n) {
  return [{
    hours: ja(e, n, 0),
    minutes: ja(e, n + 1, 0),
    seconds: ja(e, n + 2, 0),
    milliseconds: wi(e[n + 3])
  }, null, n + 4];
}
function zs(e, n) {
  const t = !e[n] && !e[n + 1], a = zl(e[n + 1], e[n + 2]), s = t ? null : Bt.instance(a);
  return [{}, s, n + 3];
}
function Bs(e, n) {
  const t = e[n] ? Yn.create(e[n]) : null;
  return [{}, t, n + 1];
}
const wv = RegExp(`^T?${xi.source}$`), kv = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function xv(e) {
  const [n, t, a, s, l, r, i, o, u] = e, c = n[0] === "-", d = o && o[0] === "-", p = (f, w = !1) => f !== void 0 && (w || f && c) ? -f : f;
  return [
    {
      years: p(ca(t)),
      months: p(ca(a)),
      weeks: p(ca(s)),
      days: p(ca(l)),
      hours: p(ca(r)),
      minutes: p(ca(i)),
      seconds: p(ca(o), o === "-0"),
      milliseconds: p(wi(u), d)
    }
  ];
}
const Sv = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function $i(e, n, t, a, s, l, r) {
  const i = {
    year: n.length === 2 ? jr(Jn(n)) : Jn(n),
    month: Pc.indexOf(t) + 1,
    day: Jn(a),
    hour: Jn(s),
    minute: Jn(l)
  };
  return r && (i.second = Jn(r)), e && (i.weekday = e.length > 3 ? Vc.indexOf(e) + 1 : Fc.indexOf(e) + 1), i;
}
const $v = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function Tv(e) {
  const [
    ,
    n,
    t,
    a,
    s,
    l,
    r,
    i,
    o,
    u,
    c,
    d
  ] = e, p = $i(n, s, a, t, l, r, i);
  let f;
  return o ? f = Sv[o] : u ? f = 0 : f = zl(c, d), [p, new Bt(f)];
}
function Cv(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const Mv = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, Dv = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, _v = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function To(e) {
  const [, n, t, a, s, l, r, i] = e;
  return [$i(n, s, a, t, l, r, i), Bt.utcInstance];
}
function Ov(e) {
  const [, n, t, a, s, l, r, i] = e;
  return [$i(n, i, t, a, s, l, r), Bt.utcInstance];
}
const Ev = ls(fv, Si), Iv = ls(hv, Si), Av = ls(mv, Si), Pv = ls(Hc), qc = rs(
  bv,
  os,
  zs,
  Bs
), Rv = rs(
  vv,
  os,
  zs,
  Bs
), Vv = rs(
  pv,
  os,
  zs,
  Bs
), Fv = rs(
  os,
  zs,
  Bs
);
function Lv(e) {
  return is(
    e,
    [Ev, qc],
    [Iv, Rv],
    [Av, Vv],
    [Pv, Fv]
  );
}
function Nv(e) {
  return is(Cv(e), [$v, Tv]);
}
function zv(e) {
  return is(
    e,
    [Mv, To],
    [Dv, To],
    [_v, Ov]
  );
}
function Bv(e) {
  return is(e, [kv, xv]);
}
const Wv = rs(os);
function Yv(e) {
  return is(e, [wv, Wv]);
}
const Hv = ls(gv, yv), Uv = ls(Uc), qv = rs(
  os,
  zs,
  Bs
);
function jv(e) {
  return is(
    e,
    [Hv, qc],
    [Uv, qv]
  );
}
const Co = "Invalid Duration", jc = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Gv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...jc
}, en = 146097 / 400, Pa = 146097 / 4800, Kv = {
  years: {
    quarters: 4,
    months: 12,
    weeks: en / 7,
    days: en,
    hours: en * 24,
    minutes: en * 24 * 60,
    seconds: en * 24 * 60 * 60,
    milliseconds: en * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: en / 28,
    days: en / 4,
    hours: en * 24 / 4,
    minutes: en * 24 * 60 / 4,
    seconds: en * 24 * 60 * 60 / 4,
    milliseconds: en * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Pa / 7,
    days: Pa,
    hours: Pa * 24,
    minutes: Pa * 24 * 60,
    seconds: Pa * 24 * 60 * 60,
    milliseconds: Pa * 24 * 60 * 60 * 1e3
  },
  ...jc
}, pa = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Zv = pa.slice(0).reverse();
function zn(e, n, t = !1) {
  const a = {
    values: t ? n.values : { ...e.values, ...n.values || {} },
    loc: e.loc.clone(n.loc),
    conversionAccuracy: n.conversionAccuracy || e.conversionAccuracy,
    matrix: n.matrix || e.matrix
  };
  return new Je(a);
}
function Gc(e, n) {
  let t = n.milliseconds ?? 0;
  for (const a of Zv.slice(1))
    n[a] && (t += n[a] * e[a].milliseconds);
  return t;
}
function Mo(e, n) {
  const t = Gc(e, n) < 0 ? -1 : 1;
  pa.reduceRight((a, s) => {
    if (Be(n[s]))
      return a;
    if (a) {
      const l = n[a] * t, r = e[s][a], i = Math.floor(l / r);
      n[s] += i * t, n[a] -= i * r * t;
    }
    return s;
  }, null), pa.reduce((a, s) => {
    if (Be(n[s]))
      return a;
    if (a) {
      const l = n[a] % 1;
      n[a] -= l, n[s] += l * e[a][s];
    }
    return s;
  }, null);
}
function Do(e) {
  const n = {};
  for (const [t, a] of Object.entries(e))
    a !== 0 && (n[t] = a);
  return n;
}
class Je {
  /**
   * @private
   */
  constructor(n) {
    const t = n.conversionAccuracy === "longterm" || !1;
    let a = t ? Kv : Gv;
    n.matrix && (a = n.matrix), this.values = n.values, this.loc = n.loc || st.create(), this.conversionAccuracy = t ? "longterm" : "casual", this.invalid = n.invalid || null, this.matrix = a, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(n, t) {
    return Je.fromObject({ milliseconds: n }, t);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(n, t = {}) {
    if (n == null || typeof n != "object")
      throw new Rt(
        `Duration.fromObject: argument expected to be an object, got ${n === null ? "null" : typeof n}`
      );
    return new Je({
      values: Cl(n, Je.normalizeUnit),
      loc: st.fromObject(t),
      conversionAccuracy: t.conversionAccuracy,
      matrix: t.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(n) {
    if (na(n))
      return Je.fromMillis(n);
    if (Je.isDuration(n))
      return n;
    if (typeof n == "object")
      return Je.fromObject(n);
    throw new Rt(
      `Unknown duration argument ${n} of type ${typeof n}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(n, t) {
    const [a] = Bv(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(n, t) {
    const [a] = Yv(n);
    return a ? Je.fromObject(a, t) : Je.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Rt("need to specify a reason the Duration is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (yt.throwOnInvalid)
      throw new xm(a);
    return new Je({ invalid: a });
  }
  /**
   * @private
   */
  static normalizeUnit(n) {
    const t = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[n && n.toLowerCase()];
    if (!t) throw new nc(n);
    return t;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(n) {
    return n && n.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */
  toFormat(n, t = {}) {
    const a = {
      ...t,
      floor: t.round !== !1 && t.floor !== !1
    };
    return this.isValid ? Vt.create(this.loc, a).formatDurationFromString(this, n) : Co;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */
  toHuman(n = {}) {
    if (!this.isValid) return Co;
    const t = n.showZeros !== !1, a = pa.map((s) => {
      const l = this.values[s];
      return Be(l) || l === 0 && !t ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...n, unit: s.slice(0, -1) }).format(l);
    }).filter((s) => s);
    return this.loc.listFormatter({ type: "conjunction", style: n.listStyle || "narrow", ...n }).format(a);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let n = "P";
    return this.years !== 0 && (n += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (n += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (n += this.weeks + "W"), this.days !== 0 && (n += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (n += "T"), this.hours !== 0 && (n += this.hours + "H"), this.minutes !== 0 && (n += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (n += ki(this.seconds + this.milliseconds / 1e3, 3) + "S"), n === "P" && (n += "T0S"), n;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(n = {}) {
    if (!this.isValid) return null;
    const t = this.toMillis();
    return t < 0 || t >= 864e5 ? null : (n = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...n,
      includeOffset: !1
    }, Ie.fromMillis(t, { zone: "UTC" }).toISOTime(n));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Gc(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n), a = {};
    for (const s of pa)
      (Ja(t.values, s) || Ja(this.values, s)) && (a[s] = t.get(s) + this.get(s));
    return zn(this, { values: a }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return this.plus(t.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(n) {
    if (!this.isValid) return this;
    const t = {};
    for (const a of Object.keys(this.values))
      t[a] = Ac(n(this.values[a], a));
    return zn(this, { values: t }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(n) {
    return this[Je.normalizeUnit(n)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = { ...this.values, ...Cl(n, Je.normalizeUnit) };
    return zn(this, { values: t });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: n, numberingSystem: t, conversionAccuracy: a, matrix: s } = {}) {
    const r = { loc: this.loc.clone({ locale: n, numberingSystem: t }), matrix: s, conversionAccuracy: a };
    return zn(this, r);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(n) {
    return this.isValid ? this.shiftTo(n).get(n) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const n = this.toObject();
    return Mo(this.matrix, n), zn(this, { values: n }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const n = Do(this.normalize().shiftToAll().toObject());
    return zn(this, { values: n }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...n) {
    if (!this.isValid) return this;
    if (n.length === 0)
      return this;
    n = n.map((r) => Je.normalizeUnit(r));
    const t = {}, a = {}, s = this.toObject();
    let l;
    for (const r of pa)
      if (n.indexOf(r) >= 0) {
        l = r;
        let i = 0;
        for (const u in a)
          i += this.matrix[u][r] * a[u], a[u] = 0;
        na(s[r]) && (i += s[r]);
        const o = Math.trunc(i);
        t[r] = o, a[r] = (i * 1e3 - o * 1e3) / 1e3;
      } else na(s[r]) && (a[r] = s[r]);
    for (const r in a)
      a[r] !== 0 && (t[l] += r === l ? a[r] : a[r] / this.matrix[l][r]);
    return Mo(this.matrix, t), zn(this, { values: t }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const n = {};
    for (const t of Object.keys(this.values))
      n[t] = this.values[t] === 0 ? 0 : -this.values[t];
    return zn(this, { values: n }, !0);
  }
  /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */
  removeZeros() {
    if (!this.isValid) return this;
    const n = Do(this.values);
    return zn(this, { values: n }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(n) {
    if (!this.isValid || !n.isValid || !this.loc.equals(n.loc))
      return !1;
    function t(a, s) {
      return a === void 0 || a === 0 ? s === void 0 || s === 0 : a === s;
    }
    for (const a of pa)
      if (!t(this.values[a], n.values[a]))
        return !1;
    return !0;
  }
}
const Ra = "Invalid Interval";
function Xv(e, n) {
  return !e || !e.isValid ? gt.invalid("missing or invalid start") : !n || !n.isValid ? gt.invalid("missing or invalid end") : n < e ? gt.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${n.toISO()}`
  ) : null;
}
class gt {
  /**
   * @private
   */
  constructor(n) {
    this.s = n.start, this.e = n.end, this.invalid = n.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Rt("need to specify a reason the Interval is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (yt.throwOnInvalid)
      throw new km(a);
    return new gt({ invalid: a });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(n, t) {
    const a = gs(n), s = gs(t), l = Xv(a, s);
    return l ?? new gt({
      start: a,
      end: s
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(n, t) {
    const a = Je.fromDurationLike(t), s = gs(n);
    return gt.fromDateTimes(s, s.plus(a));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(n, t) {
    const a = Je.fromDurationLike(t), s = gs(n);
    return gt.fromDateTimes(s.minus(a), s);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(n, t) {
    const [a, s] = (n || "").split("/", 2);
    if (a && s) {
      let l, r;
      try {
        l = Ie.fromISO(a, t), r = l.isValid;
      } catch {
        r = !1;
      }
      let i, o;
      try {
        i = Ie.fromISO(s, t), o = i.isValid;
      } catch {
        o = !1;
      }
      if (r && o)
        return gt.fromDateTimes(l, i);
      if (r) {
        const u = Je.fromISO(s, t);
        if (u.isValid)
          return gt.after(l, u);
      } else if (o) {
        const u = Je.fromISO(a, t);
        if (u.isValid)
          return gt.before(i, u);
      }
    }
    return gt.invalid("unparsable", `the input "${n}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(n) {
    return n && n.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */
  get lastDateTime() {
    return this.isValid && this.e ? this.e.minus(1) : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(n = "milliseconds") {
    return this.isValid ? this.toDuration(n).get(n) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(n = "milliseconds", t) {
    if (!this.isValid) return NaN;
    const a = this.start.startOf(n, t);
    let s;
    return t != null && t.useLocaleWeeks ? s = this.end.reconfigure({ locale: a.locale }) : s = this.end, s = s.startOf(n, t), Math.floor(s.diff(a, n).get(n)) + (s.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(n) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, n) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(n) {
    return this.isValid ? this.s > n : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(n) {
    return this.isValid ? this.e <= n : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(n) {
    return this.isValid ? this.s <= n && this.e > n : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: n, end: t } = {}) {
    return this.isValid ? gt.fromDateTimes(n || this.s, t || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...n) {
    if (!this.isValid) return [];
    const t = n.map(gs).filter((r) => this.contains(r)).sort((r, i) => r.toMillis() - i.toMillis()), a = [];
    let { s } = this, l = 0;
    for (; s < this.e; ) {
      const r = t[l] || this.e, i = +r > +this.e ? this.e : r;
      a.push(gt.fromDateTimes(s, i)), s = i, l += 1;
    }
    return a;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(n) {
    const t = Je.fromDurationLike(n);
    if (!this.isValid || !t.isValid || t.as("milliseconds") === 0)
      return [];
    let { s: a } = this, s = 1, l;
    const r = [];
    for (; a < this.e; ) {
      const i = this.start.plus(t.mapUnits((o) => o * s));
      l = +i > +this.e ? this.e : i, r.push(gt.fromDateTimes(a, l)), a = l, s += 1;
    }
    return r;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(n) {
    return this.isValid ? this.splitBy(this.length() / n).slice(0, n) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(n) {
    return this.e > n.s && this.s < n.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(n) {
    return this.isValid ? +this.e == +n.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(n) {
    return this.isValid ? +n.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(n) {
    return this.isValid ? this.s <= n.s && this.e >= n.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(n) {
    return !this.isValid || !n.isValid ? !1 : this.s.equals(n.s) && this.e.equals(n.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(n) {
    if (!this.isValid) return this;
    const t = this.s > n.s ? this.s : n.s, a = this.e < n.e ? this.e : n.e;
    return t >= a ? null : gt.fromDateTimes(t, a);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(n) {
    if (!this.isValid) return this;
    const t = this.s < n.s ? this.s : n.s, a = this.e > n.e ? this.e : n.e;
    return gt.fromDateTimes(t, a);
  }
  /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(n) {
    const [t, a] = n.sort((s, l) => s.s - l.s).reduce(
      ([s, l], r) => l ? l.overlaps(r) || l.abutsStart(r) ? [s, l.union(r)] : [s.concat([l]), r] : [s, r],
      [[], null]
    );
    return a && t.push(a), t;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(n) {
    let t = null, a = 0;
    const s = [], l = n.map((o) => [
      { time: o.s, type: "s" },
      { time: o.e, type: "e" }
    ]), r = Array.prototype.concat(...l), i = r.sort((o, u) => o.time - u.time);
    for (const o of i)
      a += o.type === "s" ? 1 : -1, a === 1 ? t = o.time : (t && +t != +o.time && s.push(gt.fromDateTimes(t, o.time)), t = null);
    return gt.merge(s);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...n) {
    return gt.xor([this].concat(n)).map((t) => this.intersection(t)).filter((t) => t && !t.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Ra;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(n = Sl, t = {}) {
    return this.isValid ? Vt.create(this.s.loc.clone(t), n).formatInterval(this) : Ra;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(n) {
    return this.isValid ? `${this.s.toISO(n)}/${this.e.toISO(n)}` : Ra;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Ra;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(n) {
    return this.isValid ? `${this.s.toISOTime(n)}/${this.e.toISOTime(n)}` : Ra;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(n, { separator: t = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(n)}${t}${this.e.toFormat(n)}` : Ra;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(n, t) {
    return this.isValid ? this.e.diff(this.s, n, t) : Je.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(n) {
    return gt.fromDateTimes(n(this.s), n(this.e));
  }
}
class sl {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(n = yt.defaultZone) {
    const t = Ie.now().setZone(n).set({ month: 12 });
    return !n.isUniversal && t.offset !== t.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(n) {
    return Yn.isValidZone(n);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(n) {
    return Qn(n, yt.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: n = null, locObj: t = null } = {}) {
    return (t || st.create(n)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: l = "gregory" } = {}) {
    return (s || st.create(t, a, l)).months(n);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null, outputCalendar: l = "gregory" } = {}) {
    return (s || st.create(t, a, l)).months(n, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(n = "long", { locale: t = null, numberingSystem: a = null, locObj: s = null } = {}) {
    return (s || st.create(t, a, null)).weekdays(n, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: n = null } = {}) {
    return st.create(n).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(n = "short", { locale: t = null } = {}) {
    return st.create(t, null, "gregory").eras(n);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Oc(), localeWeek: Ec() };
  }
}
function _o(e, n) {
  const t = (s) => s.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), a = t(n) - t(e);
  return Math.floor(Je.fromMillis(a).as("days"));
}
function Jv(e, n, t) {
  const a = [
    ["years", (o, u) => u.year - o.year],
    ["quarters", (o, u) => u.quarter - o.quarter + (u.year - o.year) * 4],
    ["months", (o, u) => u.month - o.month + (u.year - o.year) * 12],
    [
      "weeks",
      (o, u) => {
        const c = _o(o, u);
        return (c - c % 7) / 7;
      }
    ],
    ["days", _o]
  ], s = {}, l = e;
  let r, i;
  for (const [o, u] of a)
    t.indexOf(o) >= 0 && (r = o, s[o] = u(e, n), i = l.plus(s), i > n ? (s[o]--, e = l.plus(s), e > n && (i = e, s[o]--, e = l.plus(s))) : e = i);
  return [e, s, i, r];
}
function Qv(e, n, t, a) {
  let [s, l, r, i] = Jv(e, n, t);
  const o = n - s, u = t.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  u.length === 0 && (r < n && (r = s.plus({ [i]: 1 })), r !== s && (l[i] = (l[i] || 0) + o / (r - s)));
  const c = Je.fromObject(l, a);
  return u.length > 0 ? Je.fromMillis(o, a).shiftTo(...u).plus(c) : c;
}
const ep = "missing Intl.DateTimeFormat.formatToParts support";
function nt(e, n = (t) => t) {
  return { regex: e, deser: ([t]) => n(Hm(t)) };
}
const tp = " ", Kc = `[ ${tp}]`, Zc = new RegExp(Kc, "g");
function np(e) {
  return e.replace(/\./g, "\\.?").replace(Zc, Kc);
}
function Oo(e) {
  return e.replace(/\./g, "").replace(Zc, " ").toLowerCase();
}
function fn(e, n) {
  return e === null ? null : {
    regex: RegExp(e.map(np).join("|")),
    deser: ([t]) => e.findIndex((a) => Oo(t) === Oo(a)) + n
  };
}
function Eo(e, n) {
  return { regex: e, deser: ([, t, a]) => zl(t, a), groups: n };
}
function ll(e) {
  return { regex: e, deser: ([n]) => n };
}
function ap(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function sp(e, n) {
  const t = dn(n), a = dn(n, "{2}"), s = dn(n, "{3}"), l = dn(n, "{4}"), r = dn(n, "{6}"), i = dn(n, "{1,2}"), o = dn(n, "{1,3}"), u = dn(n, "{1,6}"), c = dn(n, "{1,9}"), d = dn(n, "{2,4}"), p = dn(n, "{4,6}"), f = (k) => ({ regex: RegExp(ap(k.val)), deser: ([y]) => y, literal: !0 }), m = ((k) => {
    if (e.literal)
      return f(k);
    switch (k.val) {
      // era
      case "G":
        return fn(n.eras("short"), 0);
      case "GG":
        return fn(n.eras("long"), 0);
      // years
      case "y":
        return nt(u);
      case "yy":
        return nt(d, jr);
      case "yyyy":
        return nt(l);
      case "yyyyy":
        return nt(p);
      case "yyyyyy":
        return nt(r);
      // months
      case "M":
        return nt(i);
      case "MM":
        return nt(a);
      case "MMM":
        return fn(n.months("short", !0), 1);
      case "MMMM":
        return fn(n.months("long", !0), 1);
      case "L":
        return nt(i);
      case "LL":
        return nt(a);
      case "LLL":
        return fn(n.months("short", !1), 1);
      case "LLLL":
        return fn(n.months("long", !1), 1);
      // dates
      case "d":
        return nt(i);
      case "dd":
        return nt(a);
      // ordinals
      case "o":
        return nt(o);
      case "ooo":
        return nt(s);
      // time
      case "HH":
        return nt(a);
      case "H":
        return nt(i);
      case "hh":
        return nt(a);
      case "h":
        return nt(i);
      case "mm":
        return nt(a);
      case "m":
        return nt(i);
      case "q":
        return nt(i);
      case "qq":
        return nt(a);
      case "s":
        return nt(i);
      case "ss":
        return nt(a);
      case "S":
        return nt(o);
      case "SSS":
        return nt(s);
      case "u":
        return ll(c);
      case "uu":
        return ll(i);
      case "uuu":
        return nt(t);
      // meridiem
      case "a":
        return fn(n.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return nt(l);
      case "kk":
        return nt(d, jr);
      // weekNumber (W)
      case "W":
        return nt(i);
      case "WW":
        return nt(a);
      // weekdays
      case "E":
      case "c":
        return nt(t);
      case "EEE":
        return fn(n.weekdays("short", !1), 1);
      case "EEEE":
        return fn(n.weekdays("long", !1), 1);
      case "ccc":
        return fn(n.weekdays("short", !0), 1);
      case "cccc":
        return fn(n.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return Eo(new RegExp(`([+-]${i.source})(?::(${a.source}))?`), 2);
      case "ZZZ":
        return Eo(new RegExp(`([+-]${i.source})(${a.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return ll(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return ll(/[^\S\n\r]/);
      default:
        return f(k);
    }
  })(e) || {
    invalidReason: ep
  };
  return m.token = e, m;
}
const lp = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function rp(e, n, t) {
  const { type: a, value: s } = e;
  if (a === "literal") {
    const o = /^\s+$/.test(s);
    return {
      literal: !o,
      val: o ? " " : s
    };
  }
  const l = n[a];
  let r = a;
  a === "hour" && (n.hour12 != null ? r = n.hour12 ? "hour12" : "hour24" : n.hourCycle != null ? n.hourCycle === "h11" || n.hourCycle === "h12" ? r = "hour12" : r = "hour24" : r = t.hour12 ? "hour12" : "hour24");
  let i = lp[r];
  if (typeof i == "object" && (i = i[l]), i)
    return {
      literal: !1,
      val: i
    };
}
function ip(e) {
  return [`^${e.map((t) => t.regex).reduce((t, a) => `${t}(${a.source})`, "")}$`, e];
}
function op(e, n, t) {
  const a = e.match(n);
  if (a) {
    const s = {};
    let l = 1;
    for (const r in t)
      if (Ja(t, r)) {
        const i = t[r], o = i.groups ? i.groups + 1 : 1;
        !i.literal && i.token && (s[i.token.val[0]] = i.deser(a.slice(l, l + o))), l += o;
      }
    return [a, s];
  } else
    return [a, {}];
}
function up(e) {
  const n = (l) => {
    switch (l) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let t = null, a;
  return Be(e.z) || (t = Yn.create(e.z)), Be(e.Z) || (t || (t = new Bt(e.Z)), a = e.Z), Be(e.q) || (e.M = (e.q - 1) * 3 + 1), Be(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Be(e.u) || (e.S = wi(e.u)), [Object.keys(e).reduce((l, r) => {
    const i = n(r);
    return i && (l[i] = e[r]), l;
  }, {}), t, a];
}
let hr = null;
function cp() {
  return hr || (hr = Ie.fromMillis(1555555555555)), hr;
}
function dp(e, n) {
  if (e.literal)
    return e;
  const t = Vt.macroTokenToFormatOpts(e.val), a = ed(t, n);
  return a == null || a.includes(void 0) ? e : a;
}
function Xc(e, n) {
  return Array.prototype.concat(...e.map((t) => dp(t, n)));
}
class Jc {
  constructor(n, t) {
    if (this.locale = n, this.format = t, this.tokens = Xc(Vt.parseFormat(t), n), this.units = this.tokens.map((a) => sp(a, n)), this.disqualifyingUnit = this.units.find((a) => a.invalidReason), !this.disqualifyingUnit) {
      const [a, s] = ip(this.units);
      this.regex = RegExp(a, "i"), this.handlers = s;
    }
  }
  explainFromTokens(n) {
    if (this.isValid) {
      const [t, a] = op(n, this.regex, this.handlers), [s, l, r] = a ? up(a) : [null, null, void 0];
      if (Ja(a, "a") && Ja(a, "H"))
        throw new Wa(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: n,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: t,
        matches: a,
        result: s,
        zone: l,
        specificOffset: r
      };
    } else
      return { input: n, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function Qc(e, n, t) {
  return new Jc(e, t).explainFromTokens(n);
}
function fp(e, n, t) {
  const { result: a, zone: s, specificOffset: l, invalidReason: r } = Qc(e, n, t);
  return [a, s, l, r];
}
function ed(e, n) {
  if (!e)
    return null;
  const a = Vt.create(n, e).dtFormatter(cp()), s = a.formatToParts(), l = a.resolvedOptions();
  return s.map((r) => rp(r, e, l));
}
const mr = "Invalid DateTime", Io = 864e13;
function Ts(e) {
  return new pn("unsupported zone", `the zone "${e.name}" is not supported`);
}
function vr(e) {
  return e.weekData === null && (e.weekData = $l(e.c)), e.weekData;
}
function pr(e) {
  return e.localWeekData === null && (e.localWeekData = $l(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function da(e, n) {
  const t = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Ie({ ...t, ...n, old: t });
}
function td(e, n, t) {
  let a = e - n * 60 * 1e3;
  const s = t.offset(a);
  if (n === s)
    return [a, n];
  a -= (s - n) * 60 * 1e3;
  const l = t.offset(a);
  return s === l ? [a, s] : [e - Math.min(s, l) * 60 * 1e3, Math.max(s, l)];
}
function rl(e, n) {
  e += n * 60 * 1e3;
  const t = new Date(e);
  return {
    year: t.getUTCFullYear(),
    month: t.getUTCMonth() + 1,
    day: t.getUTCDate(),
    hour: t.getUTCHours(),
    minute: t.getUTCMinutes(),
    second: t.getUTCSeconds(),
    millisecond: t.getUTCMilliseconds()
  };
}
function gl(e, n, t) {
  return td(Nl(e), n, t);
}
function Ao(e, n) {
  const t = e.o, a = e.c.year + Math.trunc(n.years), s = e.c.month + Math.trunc(n.months) + Math.trunc(n.quarters) * 3, l = {
    ...e.c,
    year: a,
    month: s,
    day: Math.min(e.c.day, Tl(a, s)) + Math.trunc(n.days) + Math.trunc(n.weeks) * 7
  }, r = Je.fromObject({
    years: n.years - Math.trunc(n.years),
    quarters: n.quarters - Math.trunc(n.quarters),
    months: n.months - Math.trunc(n.months),
    weeks: n.weeks - Math.trunc(n.weeks),
    days: n.days - Math.trunc(n.days),
    hours: n.hours,
    minutes: n.minutes,
    seconds: n.seconds,
    milliseconds: n.milliseconds
  }).as("milliseconds"), i = Nl(l);
  let [o, u] = td(i, t, e.zone);
  return r !== 0 && (o += r, u = e.zone.offset(o)), { ts: o, o: u };
}
function Va(e, n, t, a, s, l) {
  const { setZone: r, zone: i } = t;
  if (e && Object.keys(e).length !== 0 || n) {
    const o = n || i, u = Ie.fromObject(e, {
      ...t,
      zone: o,
      specificOffset: l
    });
    return r ? u : u.setZone(i);
  } else
    return Ie.invalid(
      new pn("unparsable", `the input "${s}" can't be parsed as ${a}`)
    );
}
function il(e, n, t = !0) {
  return e.isValid ? Vt.create(st.create("en-US"), {
    allowZ: t,
    forceSimple: !0
  }).formatDateTimeFromString(e, n) : null;
}
function gr(e, n, t) {
  const a = e.c.year > 9999 || e.c.year < 0;
  let s = "";
  if (a && e.c.year >= 0 && (s += "+"), s += Ct(e.c.year, a ? 6 : 4), t === "year") return s;
  if (n) {
    if (s += "-", s += Ct(e.c.month), t === "month") return s;
    s += "-";
  } else if (s += Ct(e.c.month), t === "month") return s;
  return s += Ct(e.c.day), s;
}
function Po(e, n, t, a, s, l, r) {
  let i = !t || e.c.millisecond !== 0 || e.c.second !== 0, o = "";
  switch (r) {
    case "day":
    case "month":
    case "year":
      break;
    default:
      if (o += Ct(e.c.hour), r === "hour") break;
      if (n) {
        if (o += ":", o += Ct(e.c.minute), r === "minute") break;
        i && (o += ":", o += Ct(e.c.second));
      } else {
        if (o += Ct(e.c.minute), r === "minute") break;
        i && (o += Ct(e.c.second));
      }
      if (r === "second") break;
      i && (!a || e.c.millisecond !== 0) && (o += ".", o += Ct(e.c.millisecond, 3));
  }
  return s && (e.isOffsetFixed && e.offset === 0 && !l ? o += "Z" : e.o < 0 ? (o += "-", o += Ct(Math.trunc(-e.o / 60)), o += ":", o += Ct(Math.trunc(-e.o % 60))) : (o += "+", o += Ct(Math.trunc(e.o / 60)), o += ":", o += Ct(Math.trunc(e.o % 60)))), l && (o += "[" + e.zone.ianaName + "]"), o;
}
const nd = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, hp = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, mp = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, yl = ["year", "month", "day", "hour", "minute", "second", "millisecond"], vp = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], pp = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function bl(e) {
  const n = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!n) throw new nc(e);
  return n;
}
function Ro(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return bl(e);
  }
}
function gp(e) {
  if (Cs === void 0 && (Cs = yt.now()), e.type !== "iana")
    return e.offset(Cs);
  const n = e.name;
  let t = Gr.get(n);
  return t === void 0 && (t = e.offset(Cs), Gr.set(n, t)), t;
}
function Vo(e, n) {
  const t = Qn(n.zone, yt.defaultZone);
  if (!t.isValid)
    return Ie.invalid(Ts(t));
  const a = st.fromObject(n);
  let s, l;
  if (Be(e.year))
    s = yt.now();
  else {
    for (const o of yl)
      Be(e[o]) && (e[o] = nd[o]);
    const r = Dc(e) || _c(e);
    if (r)
      return Ie.invalid(r);
    const i = gp(t);
    [s, l] = gl(e, i, t);
  }
  return new Ie({ ts: s, zone: t, loc: a, o: l });
}
function Fo(e, n, t) {
  const a = Be(t.round) ? !0 : t.round, s = Be(t.rounding) ? "trunc" : t.rounding, l = (i, o) => (i = ki(i, a || t.calendary ? 0 : 2, t.calendary ? "round" : s), n.loc.clone(t).relFormatter(t).format(i, o)), r = (i) => t.calendary ? n.hasSame(e, i) ? 0 : n.startOf(i).diff(e.startOf(i), i).get(i) : n.diff(e, i).get(i);
  if (t.unit)
    return l(r(t.unit), t.unit);
  for (const i of t.units) {
    const o = r(i);
    if (Math.abs(o) >= 1)
      return l(o, i);
  }
  return l(e > n ? -0 : 0, t.units[t.units.length - 1]);
}
function Lo(e) {
  let n = {}, t;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (n = e[e.length - 1], t = Array.from(e).slice(0, e.length - 1)) : t = Array.from(e), [n, t];
}
let Cs;
const Gr = /* @__PURE__ */ new Map();
class Ie {
  /**
   * @access private
   */
  constructor(n) {
    const t = n.zone || yt.defaultZone;
    let a = n.invalid || (Number.isNaN(n.ts) ? new pn("invalid input") : null) || (t.isValid ? null : Ts(t));
    this.ts = Be(n.ts) ? yt.now() : n.ts;
    let s = null, l = null;
    if (!a)
      if (n.old && n.old.ts === this.ts && n.old.zone.equals(t))
        [s, l] = [n.old.c, n.old.o];
      else {
        const i = na(n.o) && !n.old ? n.o : t.offset(this.ts);
        s = rl(this.ts, i), a = Number.isNaN(s.year) ? new pn("invalid input") : null, s = a ? null : s, l = a ? null : i;
      }
    this._zone = t, this.loc = n.loc || st.create(), this.invalid = a, this.weekData = null, this.localWeekData = null, this.c = s, this.o = l, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Ie({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [n, t] = Lo(arguments), [a, s, l, r, i, o, u] = t;
    return Vo({ year: a, month: s, day: l, hour: r, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [n, t] = Lo(arguments), [a, s, l, r, i, o, u] = t;
    return n.zone = Bt.utcInstance, Vo({ year: a, month: s, day: l, hour: r, minute: i, second: o, millisecond: u }, n);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(n, t = {}) {
    const a = Km(n) ? n.valueOf() : NaN;
    if (Number.isNaN(a))
      return Ie.invalid("invalid input");
    const s = Qn(t.zone, yt.defaultZone);
    return s.isValid ? new Ie({
      ts: a,
      zone: s,
      loc: st.fromObject(t)
    }) : Ie.invalid(Ts(s));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(n, t = {}) {
    if (na(n))
      return n < -Io || n > Io ? Ie.invalid("Timestamp out of range") : new Ie({
        ts: n,
        zone: Qn(t.zone, yt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Rt(
      `fromMillis requires a numerical input, but received a ${typeof n} with value ${n}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(n, t = {}) {
    if (na(n))
      return new Ie({
        ts: n * 1e3,
        zone: Qn(t.zone, yt.defaultZone),
        loc: st.fromObject(t)
      });
    throw new Rt("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(n, t = {}) {
    n = n || {};
    const a = Qn(t.zone, yt.defaultZone);
    if (!a.isValid)
      return Ie.invalid(Ts(a));
    const s = st.fromObject(t), l = Cl(n, Ro), { minDaysInFirstWeek: r, startOfWeek: i } = ko(l, s), o = yt.now(), u = Be(t.specificOffset) ? a.offset(o) : t.specificOffset, c = !Be(l.ordinal), d = !Be(l.year), p = !Be(l.month) || !Be(l.day), f = d || p, w = l.weekYear || l.weekNumber;
    if ((f || c) && w)
      throw new Wa(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (p && c)
      throw new Wa("Can't mix ordinal dates with month/day");
    const m = w || l.weekday && !f;
    let k, y, h = rl(o, u);
    m ? (k = vp, y = hp, h = $l(h, r, i)) : c ? (k = pp, y = mp, h = fr(h)) : (k = yl, y = nd);
    let g = !1;
    for (const D of k) {
      const z = l[D];
      Be(z) ? g ? l[D] = y[D] : l[D] = h[D] : g = !0;
    }
    const x = m ? qm(l, r, i) : c ? jm(l) : Dc(l), $ = x || _c(l);
    if ($)
      return Ie.invalid($);
    const C = m ? bo(l, r, i) : c ? wo(l) : l, [O, _] = gl(C, u, a), I = new Ie({
      ts: O,
      zone: a,
      o: _,
      loc: s
    });
    return l.weekday && f && n.weekday !== I.weekday ? Ie.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${l.weekday} and a date of ${I.toISO()}`
    ) : I.isValid ? I : Ie.invalid(I.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(n, t = {}) {
    const [a, s] = Lv(n);
    return Va(a, s, t, "ISO 8601", n);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(n, t = {}) {
    const [a, s] = Nv(n);
    return Va(a, s, t, "RFC 2822", n);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(n, t = {}) {
    const [a, s] = zv(n);
    return Va(a, s, t, "HTTP", t);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(n, t, a = {}) {
    if (Be(n) || Be(t))
      throw new Rt("fromFormat requires an input string and a format");
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    }), [i, o, u, c] = fp(r, n, t);
    return c ? Ie.invalid(c) : Va(i, o, a, `format ${t}`, n, u);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(n, t, a = {}) {
    return Ie.fromFormat(n, t, a);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(n, t = {}) {
    const [a, s] = jv(n);
    return Va(a, s, t, "SQL", n);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(n, t = null) {
    if (!n)
      throw new Rt("need to specify a reason the DateTime is invalid");
    const a = n instanceof pn ? n : new pn(n, t);
    if (yt.throwOnInvalid)
      throw new wm(a);
    return new Ie({ invalid: a });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(n) {
    return n && n.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(n, t = {}) {
    const a = ed(n, st.fromObject(t));
    return a ? a.map((s) => s ? s.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(n, t = {}) {
    return Xc(Vt.parseFormat(n), st.fromObject(t)).map((s) => s.val).join("");
  }
  static resetCache() {
    Cs = void 0, Gr.clear();
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(n) {
    return this[n];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? vr(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? vr(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? vr(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? pr(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? pr(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? pr(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? fr(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? sl.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? sl.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? sl.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? sl.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const n = 864e5, t = 6e4, a = Nl(this.c), s = this.zone.offset(a - n), l = this.zone.offset(a + n), r = this.zone.offset(a - s * t), i = this.zone.offset(a - l * t);
    if (r === i)
      return [this];
    const o = a - r * t, u = a - i * t, c = rl(o, r), d = rl(u, i);
    return c.hour === d.hour && c.minute === d.minute && c.second === d.second && c.millisecond === d.millisecond ? [da(this, { ts: o }), da(this, { ts: u })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Ns(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return Tl(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? qa(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Rs(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? Rs(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(n = {}) {
    const { locale: t, numberingSystem: a, calendar: s } = Vt.create(
      this.loc.clone(n),
      n
    ).resolvedOptions(this);
    return { locale: t, numberingSystem: a, outputCalendar: s };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(n = 0, t = {}) {
    return this.setZone(Bt.instance(n), t);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(yt.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(n, { keepLocalTime: t = !1, keepCalendarTime: a = !1 } = {}) {
    if (n = Qn(n, yt.defaultZone), n.equals(this.zone))
      return this;
    if (n.isValid) {
      let s = this.ts;
      if (t || a) {
        const l = n.offset(this.ts), r = this.toObject();
        [s] = gl(r, l, n);
      }
      return da(this, { ts: s, zone: n });
    } else
      return Ie.invalid(Ts(n));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: n, numberingSystem: t, outputCalendar: a } = {}) {
    const s = this.loc.clone({ locale: n, numberingSystem: t, outputCalendar: a });
    return da(this, { loc: s });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(n) {
    return this.reconfigure({ locale: n });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(n) {
    if (!this.isValid) return this;
    const t = Cl(n, Ro), { minDaysInFirstWeek: a, startOfWeek: s } = ko(t, this.loc), l = !Be(t.weekYear) || !Be(t.weekNumber) || !Be(t.weekday), r = !Be(t.ordinal), i = !Be(t.year), o = !Be(t.month) || !Be(t.day), u = i || o, c = t.weekYear || t.weekNumber;
    if ((u || r) && c)
      throw new Wa(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (o && r)
      throw new Wa("Can't mix ordinal dates with month/day");
    let d;
    l ? d = bo(
      { ...$l(this.c, a, s), ...t },
      a,
      s
    ) : Be(t.ordinal) ? (d = { ...this.toObject(), ...t }, Be(t.day) && (d.day = Math.min(Tl(d.year, d.month), d.day))) : d = wo({ ...fr(this.c), ...t });
    const [p, f] = gl(d, this.o, this.zone);
    return da(this, { ts: p, o: f });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n);
    return da(this, Ao(this, t));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(n) {
    if (!this.isValid) return this;
    const t = Je.fromDurationLike(n).negate();
    return da(this, Ao(this, t));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(n, { useLocaleWeeks: t = !1 } = {}) {
    if (!this.isValid) return this;
    const a = {}, s = Je.normalizeUnit(n);
    switch (s) {
      case "years":
        a.month = 1;
      // falls through
      case "quarters":
      case "months":
        a.day = 1;
      // falls through
      case "weeks":
      case "days":
        a.hour = 0;
      // falls through
      case "hours":
        a.minute = 0;
      // falls through
      case "minutes":
        a.second = 0;
      // falls through
      case "seconds":
        a.millisecond = 0;
        break;
    }
    if (s === "weeks")
      if (t) {
        const l = this.loc.getStartOfWeek(), { weekday: r } = this;
        r < l && (a.weekNumber = this.weekNumber - 1), a.weekday = l;
      } else
        a.weekday = 1;
    if (s === "quarters") {
      const l = Math.ceil(this.month / 3);
      a.month = (l - 1) * 3 + 1;
    }
    return this.set(a);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(n, t) {
    return this.isValid ? this.plus({ [n]: 1 }).startOf(n, t).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(n, t = {}) {
    return this.isValid ? Vt.create(this.loc.redefaultToEN(t)).formatDateTimeFromString(this, n) : mr;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(n = Sl, t = {}) {
    return this.isValid ? Vt.create(this.loc.clone(t), n).formatDateTime(this) : mr;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(n = {}) {
    return this.isValid ? Vt.create(this.loc.clone(n), n).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */
  toISO({
    format: n = "extended",
    suppressSeconds: t = !1,
    suppressMilliseconds: a = !1,
    includeOffset: s = !0,
    extendedZone: l = !1,
    precision: r = "milliseconds"
  } = {}) {
    if (!this.isValid)
      return null;
    r = bl(r);
    const i = n === "extended";
    let o = gr(this, i, r);
    return yl.indexOf(r) >= 3 && (o += "T"), o += Po(
      this,
      i,
      t,
      a,
      s,
      l,
      r
    ), o;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */
  toISODate({ format: n = "extended", precision: t = "day" } = {}) {
    return this.isValid ? gr(this, n === "extended", bl(t)) : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return il(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: n = !1,
    suppressSeconds: t = !1,
    includeOffset: a = !0,
    includePrefix: s = !1,
    extendedZone: l = !1,
    format: r = "extended",
    precision: i = "milliseconds"
  } = {}) {
    return this.isValid ? (i = bl(i), (s && yl.indexOf(i) >= 3 ? "T" : "") + Po(
      this,
      r === "extended",
      t,
      n,
      a,
      l,
      i
    )) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return il(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return il(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */
  toSQLDate() {
    return this.isValid ? gr(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: n = !0, includeZone: t = !1, includeOffsetSpace: a = !0 } = {}) {
    let s = "HH:mm:ss.SSS";
    return (t || n) && (a && (s += " "), t ? s += "z" : n && (s += "ZZ")), il(this, s, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(n = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(n)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : mr;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(n = {}) {
    if (!this.isValid) return {};
    const t = { ...this.c };
    return n.includeConfig && (t.outputCalendar = this.outputCalendar, t.numberingSystem = this.loc.numberingSystem, t.locale = this.loc.locale), t;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(n, t = "milliseconds", a = {}) {
    if (!this.isValid || !n.isValid)
      return Je.invalid("created by diffing an invalid DateTime");
    const s = { locale: this.locale, numberingSystem: this.numberingSystem, ...a }, l = Zm(t).map(Je.normalizeUnit), r = n.valueOf() > this.valueOf(), i = r ? this : n, o = r ? n : this, u = Qv(i, o, l, s);
    return r ? u.negate() : u;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(n = "milliseconds", t = {}) {
    return this.diff(Ie.now(), n, t);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */
  until(n) {
    return this.isValid ? gt.fromDateTimes(this, n) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(n, t, a) {
    if (!this.isValid) return !1;
    const s = n.valueOf(), l = this.setZone(n.zone, { keepLocalTime: !0 });
    return l.startOf(t, a) <= s && s <= l.endOf(t, a);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(n) {
    return this.isValid && n.isValid && this.valueOf() === n.valueOf() && this.zone.equals(n.zone) && this.loc.equals(n.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(n = {}) {
    if (!this.isValid) return null;
    const t = n.base || Ie.fromObject({}, { zone: this.zone }), a = n.padding ? this < t ? -n.padding : n.padding : 0;
    let s = ["years", "months", "days", "hours", "minutes", "seconds"], l = n.unit;
    return Array.isArray(n.unit) && (s = n.unit, l = void 0), Fo(t, this.plus(a), {
      ...n,
      numeric: "always",
      units: s,
      unit: l
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(n = {}) {
    return this.isValid ? Fo(n.base || Ie.fromObject({}, { zone: this.zone }), this, {
      ...n,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...n) {
    if (!n.every(Ie.isDateTime))
      throw new Rt("min requires all arguments be DateTimes");
    return xo(n, (t) => t.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...n) {
    if (!n.every(Ie.isDateTime))
      throw new Rt("max requires all arguments be DateTimes");
    return xo(n, (t) => t.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(n, t, a = {}) {
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    });
    return Qc(r, n, t);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(n, t, a = {}) {
    return Ie.fromFormatExplain(n, t, a);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(n, t = {}) {
    const { locale: a = null, numberingSystem: s = null } = t, l = st.fromOpts({
      locale: a,
      numberingSystem: s,
      defaultToEN: !0
    });
    return new Jc(l, n);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(n, t, a = {}) {
    if (Be(n) || Be(t))
      throw new Rt(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: s = null, numberingSystem: l = null } = a, r = st.fromOpts({
      locale: s,
      numberingSystem: l,
      defaultToEN: !0
    });
    if (!r.equals(t.locale))
      throw new Rt(
        `fromFormatParser called with a locale of ${r}, but the format parser was created for ${t.locale}`
      );
    const { result: i, zone: o, specificOffset: u, invalidReason: c } = t.explainFromTokens(n);
    return c ? Ie.invalid(c) : Va(
      i,
      o,
      a,
      `format ${t.format}`,
      n,
      u
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Sl;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return ac;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return Sm;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return sc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return lc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return rc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return ic;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return oc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return uc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return cc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return dc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return fc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return hc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return mc;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return vc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return pc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return gc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return $m;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return yc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return bc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return wc;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return kc;
  }
}
function gs(e) {
  if (Ie.isDateTime(e))
    return e;
  if (e && e.valueOf && na(e.valueOf()))
    return Ie.fromJSDate(e);
  if (e && typeof e == "object")
    return Ie.fromObject(e);
  throw new Rt(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const yp = ["datetime", "title"], bp = {
  key: 1,
  class: "text-secondaryText"
}, wp = /* @__PURE__ */ ke({
  __name: "VDate",
  props: {
    value: { default: null },
    format: { default: "MM/dd/yyyy, h:mm a" },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = S(() => {
      if (!e.value) return null;
      const s = Ie.fromISO(e.value).toLocal();
      return s.isValid ? s : null;
    }), t = S(() => {
      var s;
      return ((s = n.value) == null ? void 0 : s.toFormat(e.format)) ?? "—";
    }), a = S(() => {
      if (!e.value) return;
      const s = Ie.fromISO(e.value, { zone: "utc" });
      return s.isValid ? `${s.toFormat("yyyy-MM-dd HH:mm:ss")} UTC` : e.value;
    });
    return (s, l) => e.value ? (b(), T("time", {
      key: 0,
      datetime: e.value,
      title: a.value,
      class: j({ "v-date--modern": e.modern })
    }, le(t.value), 11, yp)) : (b(), T("span", bp, "—"));
  }
}), WD = /* @__PURE__ */ Le(wp, [["__scopeId", "data-v-dd18eb20"]]), kp = ["id", "disabled", "value"], xp = ["for"], Sp = /* @__PURE__ */ ke({
  __name: "VCheckbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    id: {},
    label: {},
    value: { type: [String, Number, Boolean] },
    disabled: { type: Boolean },
    indeterminate: { type: Boolean },
    modern: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Ca(), l = S(() => t.id || s), r = S({
      get() {
        return t.modelValue;
      },
      set(o) {
        o !== void 0 && a("update:modelValue", o);
      }
    }), i = J(null);
    return jt(() => {
      i.value && (i.value.indeterminate = !!t.indeterminate);
    }), (o, u) => (b(), T("div", {
      class: j(["v-checkbox", { "v-checkbox--modern": t.modern }])
    }, [
      Gt(E("input", lt({
        id: l.value,
        ref_key: "inputRef",
        ref: i,
        "onUpdate:modelValue": u[0] || (u[0] = (c) => r.value = c),
        disabled: t.disabled,
        value: e.value,
        class: "v-checkbox__input",
        type: "checkbox"
      }, o.$attrs), null, 16, kp), [
        [Mf, r.value]
      ]),
      e.label || o.$slots.label ? (b(), T("label", {
        key: 0,
        class: j([
          "v-checkbox__label",
          { "v-checkbox__label--disabled": t.disabled }
        ]),
        for: t.disabled ? void 0 : l.value
      }, [
        U(o.$slots, "label", {}, () => [
          He(le(e.label), 1)
        ], !0)
      ], 10, xp)) : P("", !0)
    ], 2));
  }
}), ad = /* @__PURE__ */ Le(Sp, [["__scopeId", "data-v-e0e44db6"]]), $p = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Tp = Object.prototype.toString, Cp = (e) => Tp.call(e) === "[object Object]", ol = () => {
};
function yr(e) {
  return Array.isArray(e) ? e : [e];
}
function Mp(e, n, t) {
  return Ne(e, n, {
    ...t,
    immediate: !0
  });
}
const sd = $p ? window : void 0;
function Kt(e) {
  var n;
  const t = Qe(e);
  return (n = t == null ? void 0 : t.$el) !== null && n !== void 0 ? n : t;
}
function Ga(...e) {
  const n = (a, s, l, r) => (a.addEventListener(s, l, r), () => a.removeEventListener(s, l, r)), t = S(() => {
    const a = yr(Qe(e[0])).filter((s) => s != null);
    return a.every((s) => typeof s != "string") ? a : void 0;
  });
  return Mp(() => {
    var a, s;
    return [
      (a = (s = t.value) === null || s === void 0 ? void 0 : s.map((l) => Kt(l))) !== null && a !== void 0 ? a : [sd].filter((l) => l != null),
      yr(Qe(t.value ? e[1] : e[0])),
      yr(v(t.value ? e[2] : e[1])),
      Qe(t.value ? e[3] : e[2])
    ];
  }, ([a, s, l, r], i, o) => {
    if (!(a != null && a.length) || !(s != null && s.length) || !(l != null && l.length)) return;
    const u = Cp(r) ? { ...r } : r, c = a.flatMap((d) => s.flatMap((p) => l.map((f) => n(d, p, f, u))));
    o(() => {
      c.forEach((d) => d());
    });
  }, { flush: "post" });
}
function Dp(e, n, t = {}) {
  const { window: a = sd, ignore: s = [], capture: l = !0, detectIframe: r = !1, controls: i = !1 } = t;
  if (!a) return i ? {
    stop: ol,
    cancel: ol,
    trigger: ol
  } : ol;
  let o = !0;
  const u = (k) => Qe(s).some((y) => {
    if (typeof y == "string") return Array.from(a.document.querySelectorAll(y)).some((h) => h === k.target || k.composedPath().includes(h));
    {
      const h = Kt(y);
      return h && (k.target === h || k.composedPath().includes(h));
    }
  });
  function c(k) {
    const y = Qe(k);
    return y && y.$.subTree.shapeFlag === 16;
  }
  function d(k, y) {
    const h = Qe(k), g = h.$.subTree && h.$.subTree.children;
    return g == null || !Array.isArray(g) ? !1 : g.some((x) => x.el === y.target || y.composedPath().includes(x.el));
  }
  const p = (k) => {
    const y = Kt(e);
    if (k.target != null && !(!(y instanceof Element) && c(e) && d(e, k)) && !(!y || y === k.target || k.composedPath().includes(y))) {
      if ("detail" in k && k.detail === 0 && (o = !u(k)), !o) {
        o = !0;
        return;
      }
      n(k);
    }
  };
  let f = !1;
  const w = [
    Ga(a, "click", (k) => {
      f || (f = !0, setTimeout(() => {
        f = !1;
      }, 0), p(k));
    }, {
      passive: !0,
      capture: l
    }),
    Ga(a, "pointerdown", (k) => {
      const y = Kt(e);
      o = !u(k) && !!(y && !k.composedPath().includes(y));
    }, { passive: !0 }),
    r && Ga(a, "blur", (k) => {
      setTimeout(() => {
        var y;
        const h = Kt(e);
        ((y = a.document.activeElement) === null || y === void 0 ? void 0 : y.tagName) === "IFRAME" && !(h != null && h.contains(a.document.activeElement)) && n(k);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), m = () => w.forEach((k) => k());
  return i ? {
    stop: m,
    cancel: () => {
      o = !1;
    },
    trigger: (k) => {
      o = !0, p(k), o = !1;
    }
  } : m;
}
function _p(e, n = {}) {
  const { threshold: t = 50, onSwipe: a, onSwipeEnd: s, onSwipeStart: l, passive: r = !0 } = n, i = ka({
    x: 0,
    y: 0
  }), o = ka({
    x: 0,
    y: 0
  }), u = S(() => i.x - o.x), c = S(() => i.y - o.y), { max: d, abs: p } = Math, f = S(() => d(p(u.value), p(c.value)) >= t), w = Et(!1), m = S(() => f.value ? p(u.value) > p(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), k = (O) => [O.touches[0].clientX, O.touches[0].clientY], y = (O, _) => {
    i.x = O, i.y = _;
  }, h = (O, _) => {
    o.x = O, o.y = _;
  }, g = {
    passive: r,
    capture: !r
  }, x = (O) => {
    w.value && (s == null || s(O, m.value)), w.value = !1;
  }, $ = [
    Ga(e, "touchstart", (O) => {
      if (O.touches.length !== 1) return;
      const [_, I] = k(O);
      y(_, I), h(_, I), l == null || l(O);
    }, g),
    Ga(e, "touchmove", (O) => {
      if (O.touches.length !== 1) return;
      const [_, I] = k(O);
      h(_, I), g.capture && !g.passive && Math.abs(u.value) > Math.abs(c.value) && O.preventDefault(), !w.value && f.value && (w.value = !0), w.value && (a == null || a(O));
    }, g),
    Ga(e, ["touchend", "touchcancel"], x, g)
  ];
  return {
    isSwiping: w,
    direction: m,
    coordsStart: i,
    coordsEnd: o,
    lengthX: u,
    lengthY: c,
    stop: () => $.forEach((O) => O())
  };
}
const Qa = Math.min, ba = Math.max, Ml = Math.round, ul = Math.floor, On = (e) => ({
  x: e,
  y: e
}), Op = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ep = {
  start: "end",
  end: "start"
};
function Kr(e, n, t) {
  return ba(e, Qa(n, t));
}
function Ws(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Sa(e) {
  return e.split("-")[0];
}
function Ys(e) {
  return e.split("-")[1];
}
function ld(e) {
  return e === "x" ? "y" : "x";
}
function Ti(e) {
  return e === "y" ? "height" : "width";
}
const Ip = /* @__PURE__ */ new Set(["top", "bottom"]);
function ta(e) {
  return Ip.has(Sa(e)) ? "y" : "x";
}
function Ci(e) {
  return ld(ta(e));
}
function Ap(e, n, t) {
  t === void 0 && (t = !1);
  const a = Ys(e), s = Ci(e), l = Ti(s);
  let r = s === "x" ? a === (t ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return n.reference[l] > n.floating[l] && (r = Dl(r)), [r, Dl(r)];
}
function Pp(e) {
  const n = Dl(e);
  return [Zr(e), n, Zr(n)];
}
function Zr(e) {
  return e.replace(/start|end/g, (n) => Ep[n]);
}
const No = ["left", "right"], zo = ["right", "left"], Rp = ["top", "bottom"], Vp = ["bottom", "top"];
function Fp(e, n, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? zo : No : n ? No : zo;
    case "left":
    case "right":
      return n ? Rp : Vp;
    default:
      return [];
  }
}
function Lp(e, n, t, a) {
  const s = Ys(e);
  let l = Fp(Sa(e), t === "start", a);
  return s && (l = l.map((r) => r + "-" + s), n && (l = l.concat(l.map(Zr)))), l;
}
function Dl(e) {
  return e.replace(/left|right|bottom|top/g, (n) => Op[n]);
}
function Np(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function rd(e) {
  return typeof e != "number" ? Np(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function _l(e) {
  const {
    x: n,
    y: t,
    width: a,
    height: s
  } = e;
  return {
    width: a,
    height: s,
    top: t,
    left: n,
    right: n + a,
    bottom: t + s,
    x: n,
    y: t
  };
}
function Bo(e, n, t) {
  let {
    reference: a,
    floating: s
  } = e;
  const l = ta(n), r = Ci(n), i = Ti(r), o = Sa(n), u = l === "y", c = a.x + a.width / 2 - s.width / 2, d = a.y + a.height / 2 - s.height / 2, p = a[i] / 2 - s[i] / 2;
  let f;
  switch (o) {
    case "top":
      f = {
        x: c,
        y: a.y - s.height
      };
      break;
    case "bottom":
      f = {
        x: c,
        y: a.y + a.height
      };
      break;
    case "right":
      f = {
        x: a.x + a.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: a.x - s.width,
        y: d
      };
      break;
    default:
      f = {
        x: a.x,
        y: a.y
      };
  }
  switch (Ys(n)) {
    case "start":
      f[r] -= p * (t && u ? -1 : 1);
      break;
    case "end":
      f[r] += p * (t && u ? -1 : 1);
      break;
  }
  return f;
}
async function zp(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: a,
    y: s,
    platform: l,
    rects: r,
    elements: i,
    strategy: o
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = Ws(n, e), w = rd(f), k = i[p ? d === "floating" ? "reference" : "floating" : d], y = _l(await l.getClippingRect({
    element: (t = await (l.isElement == null ? void 0 : l.isElement(k))) == null || t ? k : k.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: o
  })), h = d === "floating" ? {
    x: a,
    y: s,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, g = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(i.floating)), x = await (l.isElement == null ? void 0 : l.isElement(g)) ? await (l.getScale == null ? void 0 : l.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = _l(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: h,
    offsetParent: g,
    strategy: o
  }) : h);
  return {
    top: (y.top - $.top + w.top) / x.y,
    bottom: ($.bottom - y.bottom + w.bottom) / x.y,
    left: (y.left - $.left + w.left) / x.x,
    right: ($.right - y.right + w.right) / x.x
  };
}
const Bp = async (e, n, t) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: l = [],
    platform: r
  } = t, i = l.filter(Boolean), o = await (r.isRTL == null ? void 0 : r.isRTL(n));
  let u = await r.getElementRects({
    reference: e,
    floating: n,
    strategy: s
  }), {
    x: c,
    y: d
  } = Bo(u, a, o), p = a, f = {}, w = 0;
  for (let k = 0; k < i.length; k++) {
    var m;
    const {
      name: y,
      fn: h
    } = i[k], {
      x: g,
      y: x,
      data: $,
      reset: C
    } = await h({
      x: c,
      y: d,
      initialPlacement: a,
      placement: p,
      strategy: s,
      middlewareData: f,
      rects: u,
      platform: {
        ...r,
        detectOverflow: (m = r.detectOverflow) != null ? m : zp
      },
      elements: {
        reference: e,
        floating: n
      }
    });
    c = g ?? c, d = x ?? d, f = {
      ...f,
      [y]: {
        ...f[y],
        ...$
      }
    }, C && w <= 50 && (w++, typeof C == "object" && (C.placement && (p = C.placement), C.rects && (u = C.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: n,
      strategy: s
    }) : C.rects), {
      x: c,
      y: d
    } = Bo(u, p, o)), k = -1);
  }
  return {
    x: c,
    y: d,
    placement: p,
    strategy: s,
    middlewareData: f
  };
}, Wp = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: a,
      placement: s,
      rects: l,
      platform: r,
      elements: i,
      middlewareData: o
    } = n, {
      element: u,
      padding: c = 0
    } = Ws(e, n) || {};
    if (u == null)
      return {};
    const d = rd(c), p = {
      x: t,
      y: a
    }, f = Ci(s), w = Ti(f), m = await r.getDimensions(u), k = f === "y", y = k ? "top" : "left", h = k ? "bottom" : "right", g = k ? "clientHeight" : "clientWidth", x = l.reference[w] + l.reference[f] - p[f] - l.floating[w], $ = p[f] - l.reference[f], C = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(u));
    let O = C ? C[g] : 0;
    (!O || !await (r.isElement == null ? void 0 : r.isElement(C))) && (O = i.floating[g] || l.floating[w]);
    const _ = x / 2 - $ / 2, I = O / 2 - m[w] / 2 - 1, D = Qa(d[y], I), z = Qa(d[h], I), H = D, ne = O - m[w] - z, te = O / 2 - m[w] / 2 + _, q = Kr(H, te, ne), ie = !o.arrow && Ys(s) != null && te !== q && l.reference[w] / 2 - (te < H ? D : z) - m[w] / 2 < 0, L = ie ? te < H ? te - H : te - ne : 0;
    return {
      [f]: p[f] + L,
      data: {
        [f]: q,
        centerOffset: te - q - L,
        ...ie && {
          alignmentOffset: L
        }
      },
      reset: ie
    };
  }
}), Yp = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, a;
      const {
        placement: s,
        middlewareData: l,
        rects: r,
        initialPlacement: i,
        platform: o,
        elements: u
      } = n, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: m = !0,
        ...k
      } = Ws(e, n);
      if ((t = l.arrow) != null && t.alignmentOffset)
        return {};
      const y = Sa(s), h = ta(i), g = Sa(i) === i, x = await (o.isRTL == null ? void 0 : o.isRTL(u.floating)), $ = p || (g || !m ? [Dl(i)] : Pp(i)), C = w !== "none";
      !p && C && $.push(...Lp(i, m, w, x));
      const O = [i, ...$], _ = await o.detectOverflow(n, k), I = [];
      let D = ((a = l.flip) == null ? void 0 : a.overflows) || [];
      if (c && I.push(_[y]), d) {
        const te = Ap(s, r, x);
        I.push(_[te[0]], _[te[1]]);
      }
      if (D = [...D, {
        placement: s,
        overflows: I
      }], !I.every((te) => te <= 0)) {
        var z, H;
        const te = (((z = l.flip) == null ? void 0 : z.index) || 0) + 1, q = O[te];
        if (q && (!(d === "alignment" ? h !== ta(q) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        D.every((ae) => ta(ae.placement) === h ? ae.overflows[0] > 0 : !0)))
          return {
            data: {
              index: te,
              overflows: D
            },
            reset: {
              placement: q
            }
          };
        let ie = (H = D.filter((L) => L.overflows[0] <= 0).sort((L, ae) => L.overflows[1] - ae.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!ie)
          switch (f) {
            case "bestFit": {
              var ne;
              const L = (ne = D.filter((ae) => {
                if (C) {
                  const Y = ta(ae.placement);
                  return Y === h || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Y === "y";
                }
                return !0;
              }).map((ae) => [ae.placement, ae.overflows.filter((Y) => Y > 0).reduce((Y, W) => Y + W, 0)]).sort((ae, Y) => ae[1] - Y[1])[0]) == null ? void 0 : ne[0];
              L && (ie = L);
              break;
            }
            case "initialPlacement":
              ie = i;
              break;
          }
        if (s !== ie)
          return {
            reset: {
              placement: ie
            }
          };
      }
      return {};
    }
  };
}, Hp = /* @__PURE__ */ new Set(["left", "top"]);
async function Up(e, n) {
  const {
    placement: t,
    platform: a,
    elements: s
  } = e, l = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), r = Sa(t), i = Ys(t), o = ta(t) === "y", u = Hp.has(r) ? -1 : 1, c = l && o ? -1 : 1, d = Ws(n, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: w
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return i && typeof w == "number" && (f = i === "end" ? w * -1 : w), o ? {
    x: f * c,
    y: p * u
  } : {
    x: p * u,
    y: f * c
  };
}
const qp = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, a;
      const {
        x: s,
        y: l,
        placement: r,
        middlewareData: i
      } = n, o = await Up(n, e);
      return r === ((t = i.offset) == null ? void 0 : t.placement) && (a = i.arrow) != null && a.alignmentOffset ? {} : {
        x: s + o.x,
        y: l + o.y,
        data: {
          ...o,
          placement: r
        }
      };
    }
  };
}, jp = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: a,
        placement: s,
        platform: l
      } = n, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: o = {
          fn: (y) => {
            let {
              x: h,
              y: g
            } = y;
            return {
              x: h,
              y: g
            };
          }
        },
        ...u
      } = Ws(e, n), c = {
        x: t,
        y: a
      }, d = await l.detectOverflow(n, u), p = ta(Sa(s)), f = ld(p);
      let w = c[f], m = c[p];
      if (r) {
        const y = f === "y" ? "top" : "left", h = f === "y" ? "bottom" : "right", g = w + d[y], x = w - d[h];
        w = Kr(g, w, x);
      }
      if (i) {
        const y = p === "y" ? "top" : "left", h = p === "y" ? "bottom" : "right", g = m + d[y], x = m - d[h];
        m = Kr(g, m, x);
      }
      const k = o.fn({
        ...n,
        [f]: w,
        [p]: m
      });
      return {
        ...k,
        data: {
          x: k.x - t,
          y: k.y - a,
          enabled: {
            [f]: r,
            [p]: i
          }
        }
      };
    }
  };
};
function Wl() {
  return typeof window < "u";
}
function Da(e) {
  return Mi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Xt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Rn(e) {
  var n;
  return (n = (Mi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function Mi(e) {
  return Wl() ? e instanceof Node || e instanceof Xt(e).Node : !1;
}
function kn(e) {
  return Wl() ? e instanceof Element || e instanceof Xt(e).Element : !1;
}
function In(e) {
  return Wl() ? e instanceof HTMLElement || e instanceof Xt(e).HTMLElement : !1;
}
function Wo(e) {
  return !Wl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Xt(e).ShadowRoot;
}
const Gp = /* @__PURE__ */ new Set(["inline", "contents"]);
function Hs(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: a,
    display: s
  } = xn(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + a + t) && !Gp.has(s);
}
const Kp = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Zp(e) {
  return Kp.has(Da(e));
}
const Xp = [":popover-open", ":modal"];
function Yl(e) {
  return Xp.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
const Jp = ["transform", "translate", "scale", "rotate", "perspective"], Qp = ["transform", "translate", "scale", "rotate", "perspective", "filter"], eg = ["paint", "layout", "strict", "content"];
function Di(e) {
  const n = _i(), t = kn(e) ? xn(e) : e;
  return Jp.some((a) => t[a] ? t[a] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || Qp.some((a) => (t.willChange || "").includes(a)) || eg.some((a) => (t.contain || "").includes(a));
}
function tg(e) {
  let n = sa(e);
  for (; In(n) && !es(n); ) {
    if (Di(n))
      return n;
    if (Yl(n))
      return null;
    n = sa(n);
  }
  return null;
}
function _i() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ng = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function es(e) {
  return ng.has(Da(e));
}
function xn(e) {
  return Xt(e).getComputedStyle(e);
}
function Hl(e) {
  return kn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function sa(e) {
  if (Da(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Wo(e) && e.host || // Fallback.
    Rn(e)
  );
  return Wo(n) ? n.host : n;
}
function id(e) {
  const n = sa(e);
  return es(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : In(n) && Hs(n) ? n : id(n);
}
function Vs(e, n, t) {
  var a;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const s = id(e), l = s === ((a = e.ownerDocument) == null ? void 0 : a.body), r = Xt(s);
  if (l) {
    const i = Xr(r);
    return n.concat(r, r.visualViewport || [], Hs(s) ? s : [], i && t ? Vs(i) : []);
  }
  return n.concat(s, Vs(s, [], t));
}
function Xr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function od(e) {
  const n = xn(e);
  let t = parseFloat(n.width) || 0, a = parseFloat(n.height) || 0;
  const s = In(e), l = s ? e.offsetWidth : t, r = s ? e.offsetHeight : a, i = Ml(t) !== l || Ml(a) !== r;
  return i && (t = l, a = r), {
    width: t,
    height: a,
    $: i
  };
}
function Oi(e) {
  return kn(e) ? e : e.contextElement;
}
function Ka(e) {
  const n = Oi(e);
  if (!In(n))
    return On(1);
  const t = n.getBoundingClientRect(), {
    width: a,
    height: s,
    $: l
  } = od(n);
  let r = (l ? Ml(t.width) : t.width) / a, i = (l ? Ml(t.height) : t.height) / s;
  return (!r || !Number.isFinite(r)) && (r = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: r,
    y: i
  };
}
const ag = /* @__PURE__ */ On(0);
function ud(e) {
  const n = Xt(e);
  return !_i() || !n.visualViewport ? ag : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function sg(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Xt(e) ? !1 : n;
}
function $a(e, n, t, a) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const s = e.getBoundingClientRect(), l = Oi(e);
  let r = On(1);
  n && (a ? kn(a) && (r = Ka(a)) : r = Ka(e));
  const i = sg(l, t, a) ? ud(l) : On(0);
  let o = (s.left + i.x) / r.x, u = (s.top + i.y) / r.y, c = s.width / r.x, d = s.height / r.y;
  if (l) {
    const p = Xt(l), f = a && kn(a) ? Xt(a) : a;
    let w = p, m = Xr(w);
    for (; m && a && f !== w; ) {
      const k = Ka(m), y = m.getBoundingClientRect(), h = xn(m), g = y.left + (m.clientLeft + parseFloat(h.paddingLeft)) * k.x, x = y.top + (m.clientTop + parseFloat(h.paddingTop)) * k.y;
      o *= k.x, u *= k.y, c *= k.x, d *= k.y, o += g, u += x, w = Xt(m), m = Xr(w);
    }
  }
  return _l({
    width: c,
    height: d,
    x: o,
    y: u
  });
}
function Ul(e, n) {
  const t = Hl(e).scrollLeft;
  return n ? n.left + t : $a(Rn(e)).left + t;
}
function cd(e, n) {
  const t = e.getBoundingClientRect(), a = t.left + n.scrollLeft - Ul(e, t), s = t.top + n.scrollTop;
  return {
    x: a,
    y: s
  };
}
function lg(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: a,
    strategy: s
  } = e;
  const l = s === "fixed", r = Rn(a), i = n ? Yl(n.floating) : !1;
  if (a === r || i && l)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = On(1);
  const c = On(0), d = In(a);
  if ((d || !d && !l) && ((Da(a) !== "body" || Hs(r)) && (o = Hl(a)), In(a))) {
    const f = $a(a);
    u = Ka(a), c.x = f.x + a.clientLeft, c.y = f.y + a.clientTop;
  }
  const p = r && !d && !l ? cd(r, o) : On(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - o.scrollLeft * u.x + c.x + p.x,
    y: t.y * u.y - o.scrollTop * u.y + c.y + p.y
  };
}
function rg(e) {
  return Array.from(e.getClientRects());
}
function ig(e) {
  const n = Rn(e), t = Hl(e), a = e.ownerDocument.body, s = ba(n.scrollWidth, n.clientWidth, a.scrollWidth, a.clientWidth), l = ba(n.scrollHeight, n.clientHeight, a.scrollHeight, a.clientHeight);
  let r = -t.scrollLeft + Ul(e);
  const i = -t.scrollTop;
  return xn(a).direction === "rtl" && (r += ba(n.clientWidth, a.clientWidth) - s), {
    width: s,
    height: l,
    x: r,
    y: i
  };
}
const Yo = 25;
function og(e, n) {
  const t = Xt(e), a = Rn(e), s = t.visualViewport;
  let l = a.clientWidth, r = a.clientHeight, i = 0, o = 0;
  if (s) {
    l = s.width, r = s.height;
    const c = _i();
    (!c || c && n === "fixed") && (i = s.offsetLeft, o = s.offsetTop);
  }
  const u = Ul(a);
  if (u <= 0) {
    const c = a.ownerDocument, d = c.body, p = getComputedStyle(d), f = c.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, w = Math.abs(a.clientWidth - d.clientWidth - f);
    w <= Yo && (l -= w);
  } else u <= Yo && (l += u);
  return {
    width: l,
    height: r,
    x: i,
    y: o
  };
}
const ug = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function cg(e, n) {
  const t = $a(e, !0, n === "fixed"), a = t.top + e.clientTop, s = t.left + e.clientLeft, l = In(e) ? Ka(e) : On(1), r = e.clientWidth * l.x, i = e.clientHeight * l.y, o = s * l.x, u = a * l.y;
  return {
    width: r,
    height: i,
    x: o,
    y: u
  };
}
function Ho(e, n, t) {
  let a;
  if (n === "viewport")
    a = og(e, t);
  else if (n === "document")
    a = ig(Rn(e));
  else if (kn(n))
    a = cg(n, t);
  else {
    const s = ud(e);
    a = {
      x: n.x - s.x,
      y: n.y - s.y,
      width: n.width,
      height: n.height
    };
  }
  return _l(a);
}
function dd(e, n) {
  const t = sa(e);
  return t === n || !kn(t) || es(t) ? !1 : xn(t).position === "fixed" || dd(t, n);
}
function dg(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let a = Vs(e, [], !1).filter((i) => kn(i) && Da(i) !== "body"), s = null;
  const l = xn(e).position === "fixed";
  let r = l ? sa(e) : e;
  for (; kn(r) && !es(r); ) {
    const i = xn(r), o = Di(r);
    !o && i.position === "fixed" && (s = null), (l ? !o && !s : !o && i.position === "static" && !!s && ug.has(s.position) || Hs(r) && !o && dd(e, r)) ? a = a.filter((c) => c !== r) : s = i, r = sa(r);
  }
  return n.set(e, a), a;
}
function fg(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: a,
    strategy: s
  } = e;
  const r = [...t === "clippingAncestors" ? Yl(n) ? [] : dg(n, this._c) : [].concat(t), a], i = r[0], o = r.reduce((u, c) => {
    const d = Ho(n, c, s);
    return u.top = ba(d.top, u.top), u.right = Qa(d.right, u.right), u.bottom = Qa(d.bottom, u.bottom), u.left = ba(d.left, u.left), u;
  }, Ho(n, i, s));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function hg(e) {
  const {
    width: n,
    height: t
  } = od(e);
  return {
    width: n,
    height: t
  };
}
function mg(e, n, t) {
  const a = In(n), s = Rn(n), l = t === "fixed", r = $a(e, !0, l, n);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = On(0);
  function u() {
    o.x = Ul(s);
  }
  if (a || !a && !l)
    if ((Da(n) !== "body" || Hs(s)) && (i = Hl(n)), a) {
      const f = $a(n, !0, l, n);
      o.x = f.x + n.clientLeft, o.y = f.y + n.clientTop;
    } else s && u();
  l && !a && s && u();
  const c = s && !a && !l ? cd(s, i) : On(0), d = r.left + i.scrollLeft - o.x - c.x, p = r.top + i.scrollTop - o.y - c.y;
  return {
    x: d,
    y: p,
    width: r.width,
    height: r.height
  };
}
function br(e) {
  return xn(e).position === "static";
}
function Uo(e, n) {
  if (!In(e) || xn(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return Rn(e) === t && (t = t.ownerDocument.body), t;
}
function fd(e, n) {
  const t = Xt(e);
  if (Yl(e))
    return t;
  if (!In(e)) {
    let s = sa(e);
    for (; s && !es(s); ) {
      if (kn(s) && !br(s))
        return s;
      s = sa(s);
    }
    return t;
  }
  let a = Uo(e, n);
  for (; a && Zp(a) && br(a); )
    a = Uo(a, n);
  return a && es(a) && br(a) && !Di(a) ? t : a || tg(e) || t;
}
const vg = async function(e) {
  const n = this.getOffsetParent || fd, t = this.getDimensions, a = await t(e.floating);
  return {
    reference: mg(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function pg(e) {
  return xn(e).direction === "rtl";
}
const gg = {
  convertOffsetParentRelativeRectToViewportRelativeRect: lg,
  getDocumentElement: Rn,
  getClippingRect: fg,
  getOffsetParent: fd,
  getElementRects: vg,
  getClientRects: rg,
  getDimensions: hg,
  getScale: Ka,
  isElement: kn,
  isRTL: pg
};
function hd(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function yg(e, n) {
  let t = null, a;
  const s = Rn(e);
  function l() {
    var i;
    clearTimeout(a), (i = t) == null || i.disconnect(), t = null;
  }
  function r(i, o) {
    i === void 0 && (i = !1), o === void 0 && (o = 1), l();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: d,
      width: p,
      height: f
    } = u;
    if (i || n(), !p || !f)
      return;
    const w = ul(d), m = ul(s.clientWidth - (c + p)), k = ul(s.clientHeight - (d + f)), y = ul(c), g = {
      rootMargin: -w + "px " + -m + "px " + -k + "px " + -y + "px",
      threshold: ba(0, Qa(1, o)) || 1
    };
    let x = !0;
    function $(C) {
      const O = C[0].intersectionRatio;
      if (O !== o) {
        if (!x)
          return r();
        O ? r(!1, O) : a = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !hd(u, e.getBoundingClientRect()) && r(), x = !1;
    }
    try {
      t = new IntersectionObserver($, {
        ...g,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      t = new IntersectionObserver($, g);
    }
    t.observe(e);
  }
  return r(!0), l;
}
function bg(e, n, t, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: l = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = a, u = Oi(e), c = s || l ? [...u ? Vs(u) : [], ...Vs(n)] : [];
  c.forEach((y) => {
    s && y.addEventListener("scroll", t, {
      passive: !0
    }), l && y.addEventListener("resize", t);
  });
  const d = u && i ? yg(u, t) : null;
  let p = -1, f = null;
  r && (f = new ResizeObserver((y) => {
    let [h] = y;
    h && h.target === u && f && (f.unobserve(n), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var g;
      (g = f) == null || g.observe(n);
    })), t();
  }), u && !o && f.observe(u), f.observe(n));
  let w, m = o ? $a(e) : null;
  o && k();
  function k() {
    const y = $a(e);
    m && !hd(m, y) && t(), m = y, w = requestAnimationFrame(k);
  }
  return t(), () => {
    var y;
    c.forEach((h) => {
      s && h.removeEventListener("scroll", t), l && h.removeEventListener("resize", t);
    }), d == null || d(), (y = f) == null || y.disconnect(), f = null, o && cancelAnimationFrame(w);
  };
}
const wg = qp, kg = jp, xg = Yp, Sg = Wp, $g = (e, n, t) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform: gg,
    ...t
  }, l = {
    ...s.platform,
    _c: a
  };
  return Bp(e, n, {
    ...s,
    platform: l
  });
};
function Tg(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Jr(e) {
  if (Tg(e)) {
    const n = e.$el;
    return Mi(n) && Da(n) === "#comment" ? null : n;
  }
  return e;
}
function Ba(e) {
  return typeof e == "function" ? e() : v(e);
}
function Cg(e) {
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const t = Jr(Ba(e.element));
      return t == null ? {} : Sg({
        element: t,
        padding: e.padding
      }).fn(n);
    }
  };
}
function md(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function qo(e, n) {
  const t = md(e);
  return Math.round(n * t) / t;
}
function Mg(e, n, t) {
  t === void 0 && (t = {});
  const a = t.whileElementsMounted, s = S(() => {
    var O;
    return (O = Ba(t.open)) != null ? O : !0;
  }), l = S(() => Ba(t.middleware)), r = S(() => {
    var O;
    return (O = Ba(t.placement)) != null ? O : "bottom";
  }), i = S(() => {
    var O;
    return (O = Ba(t.strategy)) != null ? O : "absolute";
  }), o = S(() => {
    var O;
    return (O = Ba(t.transform)) != null ? O : !0;
  }), u = S(() => Jr(e.value)), c = S(() => Jr(n.value)), d = J(0), p = J(0), f = J(i.value), w = J(r.value), m = Et({}), k = J(!1), y = S(() => {
    const O = {
      position: f.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return O;
    const _ = qo(c.value, d.value), I = qo(c.value, p.value);
    return o.value ? {
      ...O,
      transform: "translate(" + _ + "px, " + I + "px)",
      ...md(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: f.value,
      left: _ + "px",
      top: I + "px"
    };
  });
  let h;
  function g() {
    if (u.value == null || c.value == null)
      return;
    const O = s.value;
    $g(u.value, c.value, {
      middleware: l.value,
      placement: r.value,
      strategy: i.value
    }).then((_) => {
      d.value = _.x, p.value = _.y, f.value = _.strategy, w.value = _.placement, m.value = _.middlewareData, k.value = O !== !1;
    });
  }
  function x() {
    typeof h == "function" && (h(), h = void 0);
  }
  function $() {
    if (x(), a === void 0) {
      g();
      return;
    }
    if (u.value != null && c.value != null) {
      h = a(u.value, c.value, g);
      return;
    }
  }
  function C() {
    s.value || (k.value = !1);
  }
  return Ne([l, r, i, s], g, {
    flush: "sync"
  }), Ne([u, c], $, {
    flush: "sync"
  }), Ne(s, C, {
    flush: "sync"
  }), Eu() && Al(x), {
    x: Aa(d),
    y: Aa(p),
    strategy: Aa(f),
    placement: Aa(w),
    middlewareData: Aa(m),
    isPositioned: Aa(k),
    floatingStyles: y,
    update: g
  };
}
const vd = 6048e5, Dg = 864e5, _g = 6e4, Og = 36e5, Eg = 1e3, jo = Symbol.for("constructDateFrom");
function ot(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && jo in e ? e[jo](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function ze(e, n) {
  return ot(n || e, e);
}
function an(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in);
  return isNaN(n) ? ot((t == null ? void 0 : t.in) || e, NaN) : (n && a.setDate(a.getDate() + n), a);
}
function gn(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return ot(e, NaN);
  if (!n)
    return a;
  const s = a.getDate(), l = ot(e, a.getTime());
  l.setMonth(a.getMonth() + n + 1, 0);
  const r = l.getDate();
  return s >= r ? l : (a.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    s
  ), a);
}
function pd(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: l = 0,
    days: r = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = ze(e, t == null ? void 0 : t.in), d = s || a ? gn(c, s + a * 12) : c, p = r || l ? an(d, r + l * 7) : d, f = o + i * 60, m = (u + f * 60) * 1e3;
  return ot(e, +p + m);
}
let Ig = {};
function _a() {
  return Ig;
}
function on(e, n) {
  var i, o, u, c;
  const t = _a(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = ze(e, n == null ? void 0 : n.in), l = s.getDay(), r = (l < a ? 7 : 0) + l - a;
  return s.setDate(s.getDate() - r), s.setHours(0, 0, 0, 0), s;
}
function ts(e, n) {
  return on(e, { ...n, weekStartsOn: 1 });
}
function gd(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = ot(t, 0);
  s.setFullYear(a + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const l = ts(s), r = ot(t, 0);
  r.setFullYear(a, 0, 4), r.setHours(0, 0, 0, 0);
  const i = ts(r);
  return t.getTime() >= l.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function Ol(e) {
  const n = ze(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Us(e, ...n) {
  const t = ot.bind(
    null,
    n.find((a) => typeof a == "object")
  );
  return n.map(t);
}
function Go(e, n) {
  const t = ze(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function yd(e, n, t) {
  const [a, s] = Us(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = Go(a), r = Go(s), i = +l - Ol(l), o = +r - Ol(r);
  return Math.round((i - o) / Dg);
}
function Ag(e, n) {
  const t = gd(e, n), a = ot(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), ts(a);
}
function Pg(e, n, t) {
  return gn(e, n * 3, t);
}
function Ei(e, n, t) {
  return gn(e, n * 12, t);
}
function Ko(e, n) {
  const t = +ze(e) - +ze(n);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function bd(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function _s(e) {
  return !(!bd(e) && typeof e != "number" || isNaN(+ze(e)));
}
function Zo(e, n) {
  const t = ze(e, n == null ? void 0 : n.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function Rg(e, n, t) {
  const [a, s] = Us(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return a.getFullYear() - s.getFullYear();
}
function Vg(e) {
  return (n) => {
    const a = (e ? Math[e] : Math.trunc)(n);
    return a === 0 ? 0 : a;
  };
}
function Fg(e, n, t) {
  const [a, s] = Us(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = Ko(a, s), r = Math.abs(Rg(a, s));
  a.setFullYear(1584), s.setFullYear(1584);
  const i = Ko(a, s) === -l, o = l * (r - +i);
  return o === 0 ? 0 : o;
}
function wd(e, n) {
  const [t, a] = Us(e, n.start, n.end);
  return { start: t, end: a };
}
function Ii(e, n) {
  const { start: t, end: a } = wd(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const l = s ? +t : +a, r = s ? a : t;
  r.setHours(0, 0, 0, 0);
  let i = 1;
  const o = [];
  for (; +r <= l; )
    o.push(ot(t, r)), r.setDate(r.getDate() + i), r.setHours(0, 0, 0, 0);
  return s ? o.reverse() : o;
}
function ga(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function Lg(e, n) {
  const { start: t, end: a } = wd(n == null ? void 0 : n.in, e);
  let s = +t > +a;
  const l = s ? +ga(t) : +ga(a);
  let r = ga(s ? a : t), i = 1;
  const o = [];
  for (; +r <= l; )
    o.push(ot(t, r)), r = Pg(r, i);
  return s ? o.reverse() : o;
}
function Ng(e, n) {
  const t = ze(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function kd(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Za(e, n) {
  const t = ze(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Ai(e, n) {
  var i, o, u, c;
  const t = _a(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = ze(e, n == null ? void 0 : n.in), l = s.getDay(), r = (l < a ? -7 : 0) + 6 - (l - a);
  return s.setDate(s.getDate() + r), s.setHours(23, 59, 59, 999), s;
}
function Xo(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = t.getMonth(), s = a - a % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
const zg = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Bg = (e, n, t) => {
  let a;
  const s = zg[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function wr(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Wg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Yg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Hg = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ug = {
  date: wr({
    formats: Wg,
    defaultWidth: "full"
  }),
  time: wr({
    formats: Yg,
    defaultWidth: "full"
  }),
  dateTime: wr({
    formats: Hg,
    defaultWidth: "full"
  })
}, qg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, jg = (e, n, t, a) => qg[e];
function ys(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : r;
      s = e.formattingValues[i] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[l];
  };
}
const Gg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Kg = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Zg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Xg = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Jg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Qg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ey = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, ty = {
  ordinalNumber: ey,
  era: ys({
    values: Gg,
    defaultWidth: "wide"
  }),
  quarter: ys({
    values: Kg,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ys({
    values: Zg,
    defaultWidth: "wide"
  }),
  day: ys({
    values: Xg,
    defaultWidth: "wide"
  }),
  dayPeriod: ys({
    values: Jg,
    defaultWidth: "wide",
    formattingValues: Qg,
    defaultFormattingWidth: "wide"
  })
};
function bs(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(s);
    if (!l)
      return null;
    const r = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? ay(i, (d) => d.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      ny(i, (d) => d.test(r))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(r.length);
    return { value: u, rest: c };
  };
}
function ny(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function ay(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function sy(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = t.valueCallback ? t.valueCallback(r) : r;
    const i = n.slice(s.length);
    return { value: r, rest: i };
  };
}
const ly = /^(\d+)(th|st|nd|rd)?/i, ry = /\d+/i, iy = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, oy = {
  any: [/^b/i, /^(a|c)/i]
}, uy = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, cy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dy = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, fy = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, hy = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, my = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vy = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, py = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, gy = {
  ordinalNumber: sy({
    matchPattern: ly,
    parsePattern: ry,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: bs({
    matchPatterns: iy,
    defaultMatchWidth: "wide",
    parsePatterns: oy,
    defaultParseWidth: "any"
  }),
  quarter: bs({
    matchPatterns: uy,
    defaultMatchWidth: "wide",
    parsePatterns: cy,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: bs({
    matchPatterns: dy,
    defaultMatchWidth: "wide",
    parsePatterns: fy,
    defaultParseWidth: "any"
  }),
  day: bs({
    matchPatterns: hy,
    defaultMatchWidth: "wide",
    parsePatterns: my,
    defaultParseWidth: "any"
  }),
  dayPeriod: bs({
    matchPatterns: vy,
    defaultMatchWidth: "any",
    parsePatterns: py,
    defaultParseWidth: "any"
  })
}, xd = {
  code: "en-US",
  formatDistance: Bg,
  formatLong: Ug,
  formatRelative: jg,
  localize: ty,
  match: gy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function yy(e, n) {
  const t = ze(e, n == null ? void 0 : n.in);
  return yd(t, Za(t)) + 1;
}
function Pi(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = +ts(t) - +Ag(t);
  return Math.round(a / vd) + 1;
}
function Ri(e, n) {
  var c, d, p, f;
  const t = ze(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = _a(), l = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((f = (p = s.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, r = ot((n == null ? void 0 : n.in) || e, 0);
  r.setFullYear(a + 1, 0, l), r.setHours(0, 0, 0, 0);
  const i = on(r, n), o = ot((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(a, 0, l), o.setHours(0, 0, 0, 0);
  const u = on(o, n);
  return +t >= +i ? a + 1 : +t >= +u ? a : a - 1;
}
function by(e, n) {
  var i, o, u, c;
  const t = _a(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((o = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : o.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = Ri(e, n), l = ot((n == null ? void 0 : n.in) || e, 0);
  return l.setFullYear(s, 0, a), l.setHours(0, 0, 0, 0), on(l, n);
}
function Vi(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = +on(t, n) - +by(t, n);
  return Math.round(a / vd) + 1;
}
function it(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const Zn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return it(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : it(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return it(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return it(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return it(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return it(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return it(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), s = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return it(s, n.length);
  }
}, Fa = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Jo = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), s = a > 0 ? a : 1 - a;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return Zn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const s = Ri(e, a), l = s > 0 ? s : 1 - s;
    if (n === "YY") {
      const r = l % 100;
      return it(r, 2);
    }
    return n === "Yo" ? t.ordinalNumber(l, { unit: "year" }) : it(l, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = gd(e);
    return it(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return it(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return it(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Zn.M(e, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return it(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const s = Vi(e, a);
    return n === "wo" ? t.ordinalNumber(s, { unit: "week" }) : it(s, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = Pi(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : it(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Zn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = yy(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : it(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const s = e.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(l);
      // Padded numerical value
      case "ee":
        return it(l, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(l, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const s = e.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(l);
      // Padded numerical value
      case "cc":
        return it(l, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), s = a === 0 ? 7 : a;
    switch (n) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return it(s, n.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a === 12 ? s = Fa.noon : a === 0 ? s = Fa.midnight : s = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let s;
    switch (a >= 17 ? s = Fa.evening : a >= 12 ? s = Fa.afternoon : a >= 4 ? s = Fa.morning : s = Fa.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return Zn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Zn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : it(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Zn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Zn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Zn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return eu(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return ma(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return ma(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return eu(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return ma(a);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return ma(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Qo(a, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + ma(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Qo(a, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + ma(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(+e / 1e3);
    return it(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return it(+e, n.length);
  }
};
function Qo(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? t + String(s) : t + String(s) + n + it(l, 2);
}
function eu(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + it(Math.abs(e) / 60, 2) : ma(e, n);
}
function ma(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), s = it(Math.trunc(a / 60), 2), l = it(a % 60, 2);
  return t + s + n + l;
}
const tu = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, Sd = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, wy = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], s = t[2];
  if (!s)
    return tu(e, n);
  let l;
  switch (a) {
    case "P":
      l = n.dateTime({ width: "short" });
      break;
    case "PP":
      l = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = n.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", tu(a, n)).replace("{{time}}", Sd(s, n));
}, Qr = {
  p: Sd,
  P: wy
}, ky = /^D+$/, xy = /^Y+$/, Sy = ["D", "DD", "YY", "YYYY"];
function $d(e) {
  return ky.test(e);
}
function Td(e) {
  return xy.test(e);
}
function ei(e, n, t) {
  const a = $y(e, n, t);
  if (console.warn(a), Sy.includes(e)) throw new RangeError(a);
}
function $y(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ty = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Cy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, My = /^'([^]*?)'?$/, Dy = /''/g, _y = /[a-zA-Z]/;
function nn(e, n, t) {
  var c, d, p, f, w, m, k, y;
  const a = _a(), s = (t == null ? void 0 : t.locale) ?? a.locale ?? xd, l = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((f = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, r = (t == null ? void 0 : t.weekStartsOn) ?? ((m = (w = t == null ? void 0 : t.locale) == null ? void 0 : w.options) == null ? void 0 : m.weekStartsOn) ?? a.weekStartsOn ?? ((y = (k = a.locale) == null ? void 0 : k.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = ze(e, t == null ? void 0 : t.in);
  if (!_s(i))
    throw new RangeError("Invalid time value");
  let o = n.match(Cy).map((h) => {
    const g = h[0];
    if (g === "p" || g === "P") {
      const x = Qr[g];
      return x(h, s.formatLong);
    }
    return h;
  }).join("").match(Ty).map((h) => {
    if (h === "''")
      return { isToken: !1, value: "'" };
    const g = h[0];
    if (g === "'")
      return { isToken: !1, value: Oy(h) };
    if (Jo[g])
      return { isToken: !0, value: h };
    if (g.match(_y))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: h };
  });
  s.localize.preprocessor && (o = s.localize.preprocessor(i, o));
  const u = {
    firstWeekContainsDate: l,
    weekStartsOn: r,
    locale: s
  };
  return o.map((h) => {
    if (!h.isToken) return h.value;
    const g = h.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Td(g) || !(t != null && t.useAdditionalDayOfYearTokens) && $d(g)) && ei(g, n, String(e));
    const x = Jo[g[0]];
    return x(i, g, s.localize, u);
  }).join("");
}
function Oy(e) {
  const n = e.match(My);
  return n ? n[1].replace(Dy, "'") : e;
}
function Ey(e, n) {
  return ze(e, n == null ? void 0 : n.in).getDay();
}
function Iy(e, n) {
  const t = ze(e, n == null ? void 0 : n.in), a = t.getFullYear(), s = t.getMonth(), l = ot(t, 0);
  return l.setFullYear(a, s + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function Ay() {
  return Object.assign({}, _a());
}
function An(e, n) {
  return ze(e, n == null ? void 0 : n.in).getHours();
}
function Py(e, n) {
  const t = ze(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Hn(e, n) {
  return ze(e, n == null ? void 0 : n.in).getMinutes();
}
function Xe(e, n) {
  return ze(e, n == null ? void 0 : n.in).getMonth();
}
function la(e) {
  return ze(e).getSeconds();
}
function We(e, n) {
  return ze(e, n == null ? void 0 : n.in).getFullYear();
}
function Dn(e, n) {
  return +ze(e) > +ze(n);
}
function Wn(e, n) {
  return +ze(e) < +ze(n);
}
function Ya(e, n) {
  return +ze(e) == +ze(n);
}
function Ry(e, n) {
  const t = Vy(n) ? new n(0) : ot(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function Vy(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const Fy = 10;
class Cd {
  constructor() {
    xe(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class Ly extends Cd {
  constructor(n, t, a, s, l) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = s, l && (this.subPriority = l);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class Ny extends Cd {
  constructor(t, a) {
    super();
    xe(this, "priority", Fy);
    xe(this, "subPriority", -1);
    this.context = t || ((s) => ot(a, s));
  }
  set(t, a) {
    return a.timestampIsSet ? t : ot(t, Ry(t, this.context));
  }
}
class at {
  run(n, t, a, s) {
    const l = this.parse(n, t, a, s);
    return l ? {
      setter: new Ly(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class zy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 140);
    xe(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, a, s) {
    return a.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const $t = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Cn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Tt(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function pt(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Mn(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, l = t[3] ? parseInt(t[3], 10) : 0, r = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (s * Og + l * _g + r * Eg),
    rest: n.slice(t[0].length)
  };
}
function Md(e) {
  return pt($t.anyDigitsSigned, e);
}
function bt(e, n) {
  switch (e) {
    case 1:
      return pt($t.singleDigit, n);
    case 2:
      return pt($t.twoDigits, n);
    case 3:
      return pt($t.threeDigits, n);
    case 4:
      return pt($t.fourDigits, n);
    default:
      return pt(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function El(e, n) {
  switch (e) {
    case 1:
      return pt($t.singleDigitSigned, n);
    case 2:
      return pt($t.twoDigitsSigned, n);
    case 3:
      return pt($t.threeDigitsSigned, n);
    case 4:
      return pt($t.fourDigitsSigned, n);
    default:
      return pt(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Fi(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Dd(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let s;
  if (a <= 50)
    s = e || 100;
  else {
    const l = a + 50, r = Math.trunc(l / 100) * 100, i = e >= l % 100;
    s = e + r - (i ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function _d(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class By extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    const l = (r) => ({
      year: r,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return Tt(bt(4, t), l);
      case "yo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return Tt(bt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s) {
    const l = t.getFullYear();
    if (s.isTwoDigitYear) {
      const i = Dd(
        s.year,
        l
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const r = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Wy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => ({
      year: r,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return Tt(bt(4, t), l);
      case "Yo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return Tt(bt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, s, l) {
    const r = Ri(t, l);
    if (s.isTwoDigitYear) {
      const o = Dd(
        s.year,
        r
      );
      return t.setFullYear(
        o,
        0,
        l.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), on(t, l);
    }
    const i = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(i, 0, l.firstWeekContainsDate), t.setHours(0, 0, 0, 0), on(t, l);
  }
}
class Yy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return El(a === "R" ? 4 : a.length, t);
  }
  set(t, a, s) {
    const l = ot(t, 0);
    return l.setFullYear(s, 0, 4), l.setHours(0, 0, 0, 0), ts(l);
  }
}
class Hy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 130);
    xe(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return El(a === "u" ? 4 : a.length, t);
  }
  set(t, a, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Uy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 120);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return bt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class qy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 120);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return bt(a.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class jy extends at {
  constructor() {
    super(...arguments);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    xe(this, "priority", 110);
  }
  parse(t, a, s) {
    const l = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "M":
        return Tt(
          pt($t.month, t),
          l
        );
      // 01, 02, ..., 12
      case "MM":
        return Tt(bt(2, t), l);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Gy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 110);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => r - 1;
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return Tt(
          pt($t.month, t),
          l
        );
      // 01, 02, ..., 12
      case "LL":
        return Tt(bt(2, t), l);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Ky(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in), s = Vi(a, t) - n;
  return a.setDate(a.getDate() - s * 7), ze(a, t == null ? void 0 : t.in);
}
class Zy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 100);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "w":
        return pt($t.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s, l) {
    return on(Ky(t, s, l), l);
  }
}
function Xy(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in), s = Pi(a, t) - n;
  return a.setDate(a.getDate() - s * 7), a;
}
class Jy extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 100);
    xe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "I":
        return pt($t.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, s) {
    return ts(Xy(t, s));
  }
}
const Qy = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], eb = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class tb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "subPriority", 1);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "d":
        return pt($t.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear(), l = _d(s), r = t.getMonth();
    return l ? a >= 1 && a <= eb[r] : a >= 1 && a <= Qy[r];
  }
  set(t, a, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class nb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "subpriority", 1);
    xe(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    switch (a) {
      case "D":
      case "DD":
        return pt($t.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    const s = t.getFullYear();
    return _d(s) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function Li(e, n, t) {
  var d, p, f, w;
  const a = _a(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? a.weekStartsOn ?? ((w = (f = a.locale) == null ? void 0 : f.options) == null ? void 0 : w.weekStartsOn) ?? 0, l = ze(e, t == null ? void 0 : t.in), r = l.getDay(), o = (n % 7 + 7) % 7, u = 7 - s, c = n < 0 || n > 6 ? n - (r + u) % 7 : (o + u) % 7 - (r + u) % 7;
  return an(l, c, t);
}
class ab extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Li(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
class sb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, l) {
    const r = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "e":
      case "ee":
        return Tt(bt(a.length, t), r);
      // 3rd
      case "eo":
        return Tt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Li(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
class lb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, s, l) {
    const r = (i) => {
      const o = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + o;
    };
    switch (a) {
      // 3
      case "c":
      case "cc":
        return Tt(bt(a.length, t), r);
      // 3rd
      case "co":
        return Tt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          r
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, s, l) {
    return t = Li(t, s, l), t.setHours(0, 0, 0, 0), t;
  }
}
function rb(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in), s = Py(a, t), l = n - s;
  return an(a, l, t);
}
class ib extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 90);
    xe(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, s) {
    const l = (r) => r === 0 ? 7 : r;
    switch (a) {
      // 2
      case "i":
      case "ii":
        return bt(a.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return Tt(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // T
      case "iiiii":
        return Tt(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tu
      case "iiiiii":
        return Tt(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      // Tuesday
      case "iiii":
      default:
        return Tt(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, s) {
    return t = rb(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class ob extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Fi(s), 0, 0, 0), t;
  }
}
class ub extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Fi(s), 0, 0, 0), t;
  }
}
class cb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 80);
    xe(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, s) {
    return t.setHours(Fi(s), 0, 0, 0), t;
  }
}
class db extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "h":
        return pt($t.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, s) {
    const l = t.getHours() >= 12;
    return l && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !l && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class fb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "H":
        return pt($t.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class hb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "K":
        return pt($t.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class mb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 70);
    xe(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "k":
        return pt($t.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, s) {
    const l = s <= 24 ? s % 24 : s;
    return t.setHours(l, 0, 0, 0), t;
  }
}
class vb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 60);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "m":
        return pt($t.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class pb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 50);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, s) {
    switch (a) {
      case "s":
        return pt($t.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return bt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, s) {
    return t.setSeconds(s, 0), t;
  }
}
class gb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 30);
    xe(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const s = (l) => Math.trunc(l * Math.pow(10, -a.length + 3));
    return Tt(bt(a.length, t), s);
  }
  set(t, a, s) {
    return t.setMilliseconds(s), t;
  }
}
class yb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 10);
    xe(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return Mn(
          Cn.basicOptionalMinutes,
          t
        );
      case "XX":
        return Mn(Cn.basic, t);
      case "XXXX":
        return Mn(
          Cn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Mn(
          Cn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Mn(Cn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - Ol(t) - s
    );
  }
}
class bb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 10);
    xe(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return Mn(
          Cn.basicOptionalMinutes,
          t
        );
      case "xx":
        return Mn(Cn.basic, t);
      case "xxxx":
        return Mn(
          Cn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Mn(
          Cn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Mn(Cn.extended, t);
    }
  }
  set(t, a, s) {
    return a.timestampIsSet ? t : ot(
      t,
      t.getTime() - Ol(t) - s
    );
  }
}
class wb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 40);
    xe(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Md(t);
  }
  set(t, a, s) {
    return [ot(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class kb extends at {
  constructor() {
    super(...arguments);
    xe(this, "priority", 20);
    xe(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Md(t);
  }
  set(t, a, s) {
    return [ot(t, s), { timestampIsSet: !0 }];
  }
}
const xb = {
  G: new zy(),
  y: new By(),
  Y: new Wy(),
  R: new Yy(),
  u: new Hy(),
  Q: new Uy(),
  q: new qy(),
  M: new jy(),
  L: new Gy(),
  w: new Zy(),
  I: new Jy(),
  d: new tb(),
  D: new nb(),
  E: new ab(),
  e: new sb(),
  c: new lb(),
  i: new ib(),
  a: new ob(),
  b: new ub(),
  B: new cb(),
  h: new db(),
  H: new fb(),
  K: new hb(),
  k: new mb(),
  m: new vb(),
  s: new pb(),
  S: new gb(),
  X: new yb(),
  x: new bb(),
  t: new wb(),
  T: new kb()
}, Sb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $b = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Tb = /^'([^]*?)'?$/, Cb = /''/g, Mb = /\S/, Db = /[a-zA-Z]/;
function ti(e, n, t, a) {
  var k, y, h, g, x, $, C, O;
  const s = () => ot((a == null ? void 0 : a.in) || t, NaN), l = Ay(), r = (a == null ? void 0 : a.locale) ?? l.locale ?? xd, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((y = (k = a == null ? void 0 : a.locale) == null ? void 0 : k.options) == null ? void 0 : y.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((g = (h = l.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, o = (a == null ? void 0 : a.weekStartsOn) ?? (($ = (x = a == null ? void 0 : a.locale) == null ? void 0 : x.options) == null ? void 0 : $.weekStartsOn) ?? l.weekStartsOn ?? ((O = (C = l.locale) == null ? void 0 : C.options) == null ? void 0 : O.weekStartsOn) ?? 0;
  if (!n)
    return e ? s() : ze(t, a == null ? void 0 : a.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: r
  }, c = [new Ny(a == null ? void 0 : a.in, t)], d = n.match($b).map((_) => {
    const I = _[0];
    if (I in Qr) {
      const D = Qr[I];
      return D(_, r.formatLong);
    }
    return _;
  }).join("").match(Sb), p = [];
  for (let _ of d) {
    !(a != null && a.useAdditionalWeekYearTokens) && Td(_) && ei(_, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && $d(_) && ei(_, n, e);
    const I = _[0], D = xb[I];
    if (D) {
      const { incompatibleTokens: z } = D;
      if (Array.isArray(z)) {
        const ne = p.find(
          (te) => z.includes(te.token) || te.token === I
        );
        if (ne)
          throw new RangeError(
            `The format string mustn't contain \`${ne.fullToken}\` and \`${_}\` at the same time`
          );
      } else if (D.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${_}\` and any other token at the same time`
        );
      p.push({ token: I, fullToken: _ });
      const H = D.run(
        e,
        _,
        r.match,
        u
      );
      if (!H)
        return s();
      c.push(H.setter), e = H.rest;
    } else {
      if (I.match(Db))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + I + "`"
        );
      if (_ === "''" ? _ = "'" : I === "'" && (_ = _b(_)), e.indexOf(_) === 0)
        e = e.slice(_.length);
      else
        return s();
    }
  }
  if (e.length > 0 && Mb.test(e))
    return s();
  const f = c.map((_) => _.priority).sort((_, I) => I - _).filter((_, I, D) => D.indexOf(_) === I).map(
    (_) => c.filter((I) => I.priority === _).sort((I, D) => D.subPriority - I.subPriority)
  ).map((_) => _[0]);
  let w = ze(t, a == null ? void 0 : a.in);
  if (isNaN(+w)) return s();
  const m = {};
  for (const _ of f) {
    if (!_.validate(w, u))
      return s();
    const I = _.set(w, m, u);
    Array.isArray(I) ? (w = I[0], Object.assign(m, I[1])) : w = I;
  }
  return w;
}
function _b(e) {
  return e.match(Tb)[1].replace(Cb, "'");
}
function nu(e, n, t) {
  const [a, s] = Us(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +ga(a) == +ga(s);
}
function Od(e, n, t) {
  return an(e, -n, t);
}
function Ob(e, n) {
  const t = (n == null ? void 0 : n.nearestTo) ?? 1;
  if (t < 1 || t > 30) return ot(e, NaN);
  const a = ze(e, n == null ? void 0 : n.in), s = a.getSeconds() / 60, l = a.getMilliseconds() / 1e3 / 60, r = a.getMinutes() + s + l, i = (n == null ? void 0 : n.roundingMethod) ?? "round", u = Vg(i)(r / t) * t;
  return a.setMinutes(u, 0, 0), a;
}
function Ed(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in), s = a.getFullYear(), l = a.getDate(), r = ot(e, 0);
  r.setFullYear(s, n, 15), r.setHours(0, 0, 0, 0);
  const i = Iy(r);
  return a.setMonth(n, Math.min(l, i)), a;
}
function je(e, n, t) {
  let a = ze(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (n.year != null && a.setFullYear(n.year), n.month != null && (a = Ed(a, n.month)), n.date != null && a.setDate(n.date), n.hours != null && a.setHours(n.hours), n.minutes != null && a.setMinutes(n.minutes), n.seconds != null && a.setSeconds(n.seconds), n.milliseconds != null && a.setMilliseconds(n.milliseconds), a);
}
function Eb(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in);
  return a.setMilliseconds(n), a;
}
function Ib(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in);
  return a.setSeconds(n), a;
}
function vn(e, n, t) {
  const a = ze(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? ot(e, NaN) : (a.setFullYear(n), a);
}
function ns(e, n, t) {
  return gn(e, -n, t);
}
function Ab(e, n, t) {
  const {
    years: a = 0,
    months: s = 0,
    weeks: l = 0,
    days: r = 0,
    hours: i = 0,
    minutes: o = 0,
    seconds: u = 0
  } = n, c = ns(e, s + a * 12, t), d = Od(c, r + l * 7, t), p = o + i * 60, w = (u + p * 60) * 1e3;
  return ot(e, +d - w);
}
function Id(e, n, t) {
  return Ei(e, -n, t);
}
function Pb(e, n, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: t
  }).format(n).split(/\s/g).slice(2).join(" ");
}
const kr = {}, Ms = {};
function ya(e, n) {
  try {
    const a = (kr[e] || (kr[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(n).split("GMT")[1];
    return a in Ms ? Ms[a] : au(a, a.split(":"));
  } catch {
    if (e in Ms) return Ms[e];
    const t = e == null ? void 0 : e.match(Rb);
    return t ? au(e, t.slice(1)) : NaN;
  }
}
const Rb = /([+-]\d\d):?(\d\d)?/;
function au(e, n) {
  const t = +(n[0] || 0), a = +(n[1] || 0), s = +(n[2] || 0) / 60;
  return Ms[e] = t * 60 + a > 0 ? t * 60 + a + s : t * 60 - a - s;
}
class _n extends Date {
  //#region static
  constructor(...n) {
    super(), n.length > 1 && typeof n[n.length - 1] == "string" && (this.timeZone = n.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(ya(this.timeZone, this)) ? this.setTime(NaN) : n.length ? typeof n[0] == "number" && (n.length === 1 || n.length === 2 && typeof n[1] != "number") ? this.setTime(n[0]) : typeof n[0] == "string" ? this.setTime(+new Date(n[0])) : n[0] instanceof Date ? this.setTime(+n[0]) : (this.setTime(+new Date(...n)), Ad(this), ni(this)) : this.setTime(Date.now());
  }
  static tz(n, ...t) {
    return t.length ? new _n(...t, n) : new _n(Date.now(), n);
  }
  //#endregion
  //#region time zone
  withTimeZone(n) {
    return new _n(+this, n);
  }
  getTimezoneOffset() {
    const n = -ya(this.timeZone, this);
    return n > 0 ? Math.floor(n) : Math.ceil(n);
  }
  //#endregion
  //#region time
  setTime(n) {
    return Date.prototype.setTime.apply(this, arguments), ni(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new _n(+new Date(n), this.timeZone);
  }
  //#endregion
}
const su = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!su.test(e)) return;
  const n = e.replace(su, "$1UTC");
  _n.prototype[n] && (e.startsWith("get") ? _n.prototype[e] = function() {
    return this.internal[n]();
  } : (_n.prototype[e] = function() {
    return Date.prototype[n].apply(this.internal, arguments), Vb(this), +this;
  }, _n.prototype[n] = function() {
    return Date.prototype[n].apply(this, arguments), ni(this), +this;
  }));
});
function ni(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-ya(e.timeZone, e) * 60));
}
function Vb(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Ad(e);
}
function Ad(e) {
  const n = ya(e.timeZone, e), t = n > 0 ? Math.floor(n) : Math.ceil(n), a = /* @__PURE__ */ new Date(+e);
  a.setUTCHours(a.getUTCHours() - 1);
  const s = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), l = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), r = s - l, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  r && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + r);
  const o = s - t;
  o && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + o);
  const u = /* @__PURE__ */ new Date(+e);
  u.setUTCSeconds(0);
  const c = s > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, d = Math.round(-(ya(e.timeZone, e) * 60)) % 60;
  (d || c) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + d + c));
  const p = ya(e.timeZone, e), f = p > 0 ? Math.floor(p) : Math.ceil(p), m = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - f, k = f !== t, y = m - o;
  if (k && y) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y);
    const h = ya(e.timeZone, e), g = h > 0 ? Math.floor(h) : Math.ceil(h), x = f - g;
    x && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + x), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x));
  }
}
class Ha extends _n {
  //#region static
  static tz(n, ...t) {
    return t.length ? new Ha(...t, n) : new Ha(Date.now(), n);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [n, t, a] = this.tzComponents(), s = `${n}${t}:${a}`;
    return this.internal.toISOString().slice(0, -1) + s;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [n, t, a, s] = this.internal.toUTCString().split(" ");
    return `${n == null ? void 0 : n.slice(0, -1)} ${a} ${t} ${s}`;
  }
  toTimeString() {
    const n = this.internal.toUTCString().split(" ")[4], [t, a, s] = this.tzComponents();
    return `${n} GMT${t}${a}${s} (${Pb(this.timeZone, this)})`;
  }
  toLocaleString(n, t) {
    return Date.prototype.toLocaleString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(n, t) {
    return Date.prototype.toLocaleDateString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(n, t) {
    return Date.prototype.toLocaleTimeString.call(this, n, {
      ...t,
      timeZone: (t == null ? void 0 : t.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const n = this.getTimezoneOffset(), t = n > 0 ? "-" : "+", a = String(Math.floor(Math.abs(n) / 60)).padStart(2, "0"), s = String(Math.abs(n) % 60).padStart(2, "0");
    return [t, a, s];
  }
  //#endregion
  withTimeZone(n) {
    return new Ha(+this, n);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](n) {
    return new Ha(+new Date(n), this.timeZone);
  }
  //#endregion
}
function qs() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      St("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      St("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      St("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
function Fb() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      St("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
function Pd() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Rd() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
function Vd() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      St("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
function Fd() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
function Ld() {
  return St(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      St("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
const Nd = Symbol("ContextKey"), Lb = (e, n) => {
  const { setTimeModelValue: t } = _t(), a = E0(e), s = J(null), l = ka({
    menuFocused: !1,
    shiftKeyInMenu: !1,
    isInputFocused: !1,
    isTextInputDate: !1,
    arrowNavigationLevel: 0
  }), r = a.getDate(/* @__PURE__ */ new Date()), i = J(""), o = J([{ month: Xe(r), year: We(r) }]), u = ka({ hours: 0, minutes: 0, seconds: 0 });
  t(u, null, r, a.range.value.enabled);
  const c = S({
    get: () => s.value,
    set: (m) => {
      s.value = m;
    }
  }), d = S(
    () => (m) => o.value[m] ? o.value[m].month : 0
  ), p = S(
    () => (m) => o.value[m] ? o.value[m].year : 0
  ), f = (m, k) => {
    l[m] = k;
  }, w = () => {
    t(u, c.value, r, a.range.value.enabled);
  };
  ea(Nd, {
    rootProps: e,
    defaults: a,
    modelValue: c,
    state: ri(l),
    rootEmit: n,
    calendars: o,
    month: d,
    year: p,
    time: u,
    today: r,
    inputValue: i,
    setState: f,
    updateTime: w,
    getDate: a.getDate
  });
}, Ze = () => {
  const e = bn(Nd);
  if (!e)
    throw new Error("Can't use context");
  return e;
};
var hn = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(hn || {}), wa = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(wa || {}), Nt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Nt || {});
const Nb = ["timestamp", "date", "iso"];
var mn = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(mn || {}), ct = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(ct || {}), Ua = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(Ua || {}), zd = /* @__PURE__ */ ((e) => (e[e.Sunday = 0] = "Sunday", e[e.Monday = 1] = "Monday", e[e.Tuesday = 2] = "Tuesday", e[e.Wednesday = 3] = "Wednesday", e[e.Thursday = 4] = "Thursday", e[e.Friday = 5] = "Friday", e[e.Saturday = 6] = "Saturday", e))(zd || {});
const zb = () => {
  const { rootProps: e, state: n } = Ze(), t = S(() => n.arrowNavigationLevel), a = J(-1), s = J(-1);
  Ne(t, (h, g) => {
    y(h === 0 && g > 0);
  });
  const l = J([]), r = J(/* @__PURE__ */ new Map()), i = () => {
    const h = Array.from(
      document.querySelectorAll(`[data-dp-action-element="${t.value}"]`)
    ), g = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Map();
    for (const $ of h) {
      const C = $.getBoundingClientRect(), O = C.top, _ = C.left;
      g.has(O) || g.set(O, []), g.get(O).push($), x.set($, { row: O, col: _ });
    }
    l.value = Array.from(g.entries()).sort(($, C) => $[0] - C[0]).map(([$, C]) => o(C, x)), r.value = x;
  }, o = (h, g) => h.sort((x, $) => {
    const C = g.get(x), O = g.get($);
    return C.col - O.col;
  }), u = (h, g) => {
    t.value === 0 && (a.value = h, s.value = g);
  }, c = (h) => {
    if (![ct.arrowUp, ct.arrowDown, ct.arrowLeft, ct.arrowRight].includes(h.key))
      return;
    i(), h.preventDefault();
    const g = document.activeElement;
    if (!(g != null && g.hasAttribute("data-dp-action-element")))
      return;
    let x = -1, $ = -1;
    for (let C = 0; C < l.value.length; C++) {
      const O = l.value[C].indexOf(g);
      if (O !== -1) {
        x = C, $ = O;
        break;
      }
    }
    if (x !== -1)
      switch (h.key) {
        case ct.arrowLeft:
          return d(x, $);
        case ct.arrowRight:
          return p(x, $);
        case ct.arrowUp:
          return f(x, $);
        case ct.arrowDown:
          return w(x, $);
        default:
          return;
      }
  }, d = (h, g) => {
    if (g > 0) {
      const x = l.value[h][g - 1];
      u(h, g - 1), x && x.focus();
    }
  }, p = (h, g) => {
    if (g < l.value[h].length - 1) {
      const x = l.value[h][g + 1];
      u(h, g + 1), x && x.focus();
    }
  }, f = (h, g) => {
    if (h > 0) {
      const x = l.value[h - 1], $ = Math.min(g, x.length - 1), C = x[$];
      u(h - 1, $), C && C.focus();
    }
  }, w = (h, g) => {
    if (h < l.value.length - 1) {
      const x = l.value[h + 1], $ = Math.min(g, x.length - 1), C = x[$];
      u(h + 1, $), C && C.focus();
    }
  }, m = () => {
    Ke().then(() => {
      var g;
      i();
      const h = (g = l.value[a.value]) == null ? void 0 : g[s.value];
      h && k(h);
    });
  }, k = (h) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        h.focus({ preventScroll: !0 });
      });
    });
  }, y = (h) => {
    if (h)
      return m();
    const g = document.querySelector(`[data-dp-element-active="${t.value}"]`);
    if (g && !h)
      k(g);
    else {
      const x = document.querySelector(`[data-dp-action-element="${t.value}"]`);
      x && k(x);
    }
  };
  et(() => {
    e.arrowNavigation && (y(!1), document.addEventListener("keydown", c));
  }), Jt(() => {
    e.arrowNavigation && document.removeEventListener("keydown", c);
  });
}, Bb = () => {
  const { checkPartialRangeValue: e, checkRangeEnabled: n, isValidDate: t } = un(), { convertType: a, errorMapper: s } = _t(), {
    getDate: l,
    rootEmit: r,
    state: i,
    rootProps: o,
    inputValue: u,
    defaults: { textInput: c, range: d, multiDates: p, timeConfig: f, formats: w },
    modelValue: m,
    updateTime: k
  } = Ze(), { setTime: y, getWeekFromDate: h } = Lt(), { formatSelectedDate: g, formatForTextInput: x } = ra();
  Ne(
    m,
    (F, Z) => {
      r("internal-model-change", m.value), JSON.stringify(Z ?? {}) !== JSON.stringify(F ?? {}) && k();
    },
    { deep: !0 }
  ), Ne(d, (F, Z) => {
    F.enabled !== Z.enabled && (m.value = null);
  }), Ne(
    () => w.value.input,
    () => {
      de();
    }
  );
  const $ = (F) => F ? o.modelType ? me(F) : {
    hours: An(F),
    minutes: Hn(F),
    seconds: f.value.enableSeconds ? la(F) : 0
  } : null, C = (F) => o.modelType ? me(F) : { month: Xe(F), year: We(F) }, O = (F) => Array.isArray(F) ? p.value.enabled ? F.map((Z) => _(Z, vn(l(), Z))) : n(
    () => [
      vn(l(), F[0]),
      F[1] ? vn(l(), F[1]) : e(d.value.partialRange)
    ],
    d.value.enabled
  ) : vn(l(), +F), _ = (F, Z) => (typeof F == "string" || typeof F == "number") && o.modelType ? he(F) : Z, I = (F) => Array.isArray(F) ? [
    _(F[0], y(F[0])),
    _(F[1], y(F[1]))
  ] : _(F, y(F)), D = (F) => {
    const Z = je(l(), { date: 1 });
    return Array.isArray(F) ? p.value.enabled ? F.map(
      (ve) => _(ve, je(Z, { month: +ve.month, year: +ve.year }))
    ) : n(
      () => [
        _(F[0], je(Z, { month: +F[0].month, year: +F[0].year })),
        _(
          F[1],
          F[1] ? je(Z, { month: +F[1].month, year: +F[1].year }) : e(d.value.partialRange)
        )
      ],
      d.value.enabled
    ) : _(F, je(Z, { month: +F.month, year: +F.year }));
  }, z = (F) => {
    if (Array.isArray(F))
      return F.map((Z) => he(Z));
    throw new Error(s.dateArr("multi-dates"));
  }, H = (F) => {
    if (Array.isArray(F) && d.value.enabled) {
      const Z = F[0], ve = F[1];
      return [
        l(Array.isArray(Z) ? Z[0] : null),
        Array.isArray(ve) && ve.length ? l(ve[0]) : null
      ];
    }
    return l(F[0]);
  }, ne = (F) => o.modelAuto ? Array.isArray(F) ? [he(F[0]), he(F[1])] : o.autoApply ? [he(F)] : [he(F), null] : Array.isArray(F) ? n(
    () => F[1] ? [
      he(F[0]),
      F[1] ? he(F[1]) : e(d.value.partialRange)
    ] : [he(F[0])],
    d.value.enabled
  ) : he(F), te = () => {
    Array.isArray(m.value) && d.value.enabled && m.value.length === 1 && m.value.push(e(d.value.partialRange));
  }, q = () => {
    const F = m.value;
    return [
      me(F[0]),
      F[1] ? me(F[1]) : e(d.value.partialRange)
    ];
  }, ie = () => Array.isArray(m.value) ? m.value[1] ? q() : me(a(m.value[0])) : [], L = () => (m.value || []).map((F) => me(F)), ae = (F = !1) => (F || te(), o.modelAuto ? ie() : p.value.enabled ? L() : Array.isArray(m.value) ? n(() => q(), d.value.enabled) : me(a(m.value))), Y = (F) => !F || Array.isArray(F) && !F.length ? null : o.timePicker ? I(a(F)) : o.monthPicker ? D(a(F)) : o.yearPicker ? O(a(F)) : p.value.enabled ? z(a(F)) : o.weekPicker ? H(a(F)) : ne(a(F)), W = (F) => {
    if (i.isTextInputDate) return;
    const Z = Y(F);
    t(a(Z)) ? (m.value = a(Z), de()) : (m.value = null, u.value = "");
  }, K = () => m.value ? p.value.enabled ? m.value.map((F) => g(F)).join("; ") : c.value.enabled ? x() : g(m.value) : "", de = () => {
    u.value = K();
  }, he = (F) => o.modelType ? Nb.includes(o.modelType) ? l(F) : o.modelType === "format" && typeof w.value.input == "string" ? ti(F, w.value.input, l(), { locale: o.locale }) : ti(F, o.modelType, l(), { locale: o.locale }) : l(F), me = (F) => F ? o.modelType ? o.modelType === "timestamp" ? +F : o.modelType === "iso" ? F.toISOString() : o.modelType === "format" && typeof w.value.input == "string" ? g(F) : g(F, o.modelType) : F : null, Te = (F) => {
    r("update:model-value", F);
  }, we = (F) => Array.isArray(m.value) ? p.value.enabled ? m.value.map((Z) => F(Z)) : [F(m.value[0]), m.value[1] ? F(m.value[1]) : null] : F(a(m.value)), X = () => {
    if (Array.isArray(m.value)) {
      const F = h(m.value[0], o.weekStart), Z = m.value[1] ? h(m.value[1], o.weekStart) : [];
      return [F.map((ve) => l(ve)), Z.map((ve) => l(ve))];
    }
    return h(m.value, o.weekStart).map((F) => l(F));
  }, pe = (F) => Te(a(we(F))), Me = () => r("update:model-value", X());
  return {
    checkBeforeEmit: () => m.value ? d.value.enabled ? d.value.partialRange ? m.value.length >= 1 : m.value.length === 2 : !!m.value : !1,
    parseExternalModelValue: W,
    formatInputValue: de,
    emitModelValue: () => (de(), o.monthPicker ? pe(C) : o.timePicker ? pe($) : o.yearPicker ? pe(We) : o.weekPicker ? Me() : Te(ae()))
  };
}, js = () => {
  const {
    defaults: { transitions: e }
  } = Ze(), n = S(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), t = S(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: n, showTransition: !!e.value, menuTransition: t };
}, Gs = (e) => {
  const {
    today: n,
    time: t,
    modelValue: a,
    defaults: { range: s }
  } = Ze(), { setTimeModelValue: l } = _t();
  Ne(
    s,
    (r, i) => {
      r.enabled !== i.enabled && l(t, a.value, n, s.value.enabled);
    },
    { deep: !0 }
  ), Ne(
    a,
    (r, i) => {
      e && JSON.stringify(r ?? {}) !== JSON.stringify(i ?? {}) && e();
    },
    { deep: !0 }
  );
}, un = () => {
  const {
    defaults: { safeDates: e, range: n, multiDates: t, filters: a, timeConfig: s },
    rootProps: l,
    getDate: r
  } = Ze(), { getMapKeyType: i, getMapDate: o, errorMapper: u, convertType: c } = _t(), { isDateBefore: d, isDateAfter: p, isDateEqual: f, resetDate: w, getDaysInBetween: m, setTimeValue: k, getTimeObj: y, setTime: h } = Lt(), g = (G) => e.value.disabledDates ? typeof e.value.disabledDates == "function" ? e.value.disabledDates(r(G)) : !!o(G, e.value.disabledDates) : !1, x = (G) => e.value.maxDate ? l.yearPicker ? We(G) > We(e.value.maxDate) : p(G, e.value.maxDate) : !1, $ = (G) => e.value.minDate ? l.yearPicker ? We(G) < We(e.value.minDate) : d(G, e.value.minDate) : !1, C = (G) => {
    var N;
    if (!G) return !1;
    const oe = x(G), be = $(G), A = g(G), B = a.value.months.map((fe) => +fe).includes(Xe(G)), M = (N = a.value.weekDays) != null && N.length ? a.value.weekDays.some((fe) => +fe === Ey(G)) : !1, V = z(G), R = We(G), Q = R < +l.yearRange[0] || R > +l.yearRange[1];
    return !(oe || be || A || B || Q || M || V);
  }, O = (G, oe) => d(...Me(e.value.minDate, G, oe)) || f(...Me(e.value.minDate, G, oe)), _ = (G, oe) => p(...Me(e.value.maxDate, G, oe)) || f(...Me(e.value.maxDate, G, oe)), I = (G, oe, be) => {
    let A = !1;
    return e.value.maxDate && be && _(G, oe) && (A = !0), e.value.minDate && !be && O(G, oe) && (A = !0), A;
  }, D = (G, oe, be, A) => {
    let B = !1;
    return A && (e.value.minDate || e.value.maxDate) ? e.value.minDate && e.value.maxDate ? B = I(G, oe, be) : (e.value.minDate && O(G, oe) || e.value.maxDate && _(G, oe)) && (B = !0) : B = !0, B;
  }, z = (G) => Array.isArray(e.value.allowedDates) && !e.value.allowedDates.length ? !0 : e.value.allowedDates ? !o(
    G,
    e.value.allowedDates,
    i(l.monthPicker, l.yearPicker)
  ) : !1, H = (G) => !C(G), ne = (G) => n.value.noDisabledRange ? !Ii({ start: G[0], end: G[1] }).some((oe) => H(oe)) : !0, te = (G) => {
    if (G) {
      const oe = We(G);
      return oe >= +l.yearRange[0] && oe <= l.yearRange[1];
    }
    return !0;
  }, q = (G, oe) => !!(Array.isArray(G) && G[oe] && (n.value.maxRange || n.value.minRange) && te(G[oe])), ie = (G, oe, be = 0) => {
    if (q(oe, be) && te(G)) {
      const A = yd(G, oe[be]), B = m(oe[be], G), M = B.length === 1 ? 0 : B.filter((R) => H(R)).length, V = Math.abs(A) - (n.value.minMaxRawRange ? 0 : M);
      if (n.value.minRange && n.value.maxRange)
        return V >= +n.value.minRange && V <= +n.value.maxRange;
      if (n.value.minRange) return V >= +n.value.minRange;
      if (n.value.maxRange) return V <= +n.value.maxRange;
    }
    return !0;
  }, L = () => !s.value.enableTimePicker || l.monthPicker || l.yearPicker || s.value.ignoreTimeValidation, ae = (G) => Array.isArray(G) ? [G[0] ? k(G[0]) : null, G[1] ? k(G[1]) : null] : k(G), Y = (G, oe, be) => oe ? G.find(
    (A) => +A.hours === An(oe) && A.minutes === "*" ? !0 : +A.minutes === Hn(oe) && +A.hours === An(oe)
  ) && be : !1, W = (G, oe, be) => {
    const [A, B] = G, [M, V] = oe;
    return !Y(A, M, be) && !Y(B, V, be) && be;
  }, K = (G, oe) => {
    const be = Array.isArray(oe) ? oe : [oe];
    return Array.isArray(l.disabledTimes) ? Array.isArray(l.disabledTimes[0]) ? W(l.disabledTimes, be, G) : !be.some((A) => Y(l.disabledTimes, A, G)) : G;
  }, de = (G, oe) => {
    const be = Array.isArray(oe) ? [y(oe[0]), oe[1] ? y(oe[1]) : void 0] : y(oe), A = !l.disabledTimes(be);
    return G && A;
  }, he = (G, oe) => l.disabledTimes ? Array.isArray(l.disabledTimes) ? K(oe, G) : de(oe, G) : oe, me = (G) => {
    let oe = !0;
    if (!G || L()) return !0;
    const be = !e.value.minDate && !e.value.maxDate ? ae(G) : G;
    return (l.maxTime || e.value.maxDate) && (oe = Z(
      l.maxTime,
      e.value.maxDate,
      "max",
      c(be),
      oe
    )), (l.minTime || e.value.minDate) && (oe = Z(
      l.minTime,
      e.value.minDate,
      "min",
      c(be),
      oe
    )), he(G, oe);
  }, Te = (G) => {
    if (!l.monthPicker) return !0;
    let oe = !0;
    const be = r(w(G));
    if (e.value.minDate && e.value.maxDate) {
      const A = r(w(e.value.minDate)), B = r(w(e.value.maxDate));
      return p(be, A) && d(be, B) || f(be, A) || f(be, B);
    }
    if (e.value.minDate) {
      const A = r(w(e.value.minDate));
      oe = p(be, A) || f(be, A);
    }
    if (e.value.maxDate) {
      const A = r(w(e.value.maxDate));
      oe = d(be, A) || f(be, A);
    }
    return oe;
  }, we = S(() => (G) => !s.value.enableTimePicker || s.value.ignoreTimeValidation ? !0 : me(G)), X = S(() => (G) => l.monthPicker ? Array.isArray(G) && (n.value.enabled || t.value.enabled) ? !G.filter((oe) => !Te(oe)).length : Te(G) : !0), pe = (G, oe, be) => {
    if (!oe || be && !e.value.maxDate || !be && !e.value.minDate) return !1;
    const A = be ? gn(G, 1) : ns(G, 1), B = [Xe(A), We(A)];
    return be ? !_(...B) : !O(...B);
  }, Me = (G, oe, be) => [je(r(G), { date: 1 }), je(r(), { month: oe, year: be, date: 1 })], F = (G, oe, be, A) => {
    if (!G) return !0;
    if (A) {
      const B = be === "max" ? Wn(G, oe) : Dn(G, oe), M = { seconds: 0, milliseconds: 0 };
      return B || Ya(je(G, M), je(oe, M));
    }
    return be === "max" ? G.getTime() <= oe.getTime() : G.getTime() >= oe.getTime();
  }, Z = (G, oe, be, A, B) => {
    if (Array.isArray(A)) {
      const V = ve(G, A[0], oe), R = ve(G, A[1], oe);
      return F(A[0], V, be, !!oe) && F(A[1], R, be, !!oe) && B;
    }
    const M = ve(G, A, oe);
    return F(A, M, be, !!oe) && B;
  }, ve = (G, oe, be) => G ? h(G, oe) : r(be ?? oe);
  return {
    isDisabled: H,
    validateDate: C,
    validateMonthYearInRange: D,
    isDateRangeAllowed: ne,
    checkMinMaxRange: ie,
    isValidTime: me,
    validateMonthYear: pe,
    validateMinDate: O,
    validateMaxDate: _,
    isValidDate: (G) => Array.isArray(G) ? _s(G[0]) && (G[1] ? _s(G[1]) : !0) : G ? _s(G) : !1,
    checkPartialRangeValue: (G) => {
      if (G) return null;
      throw new Error(u.prop("partial-range"));
    },
    checkRangeEnabled: (G, oe) => {
      if (oe) return G();
      throw new Error(u.prop("range"));
    },
    checkMinMaxValue: (G, oe, be) => {
      const A = be != null, B = oe != null;
      if (!A && !B) return !1;
      const M = +be, V = +oe;
      return A && B ? +G > M || +G < V : A ? +G > M : B ? +G < V : !1;
    },
    isTimeValid: we,
    isMonthValid: X
  };
}, Wb = (e) => {
  const {
    rootEmit: n,
    rootProps: t,
    defaults: { timeConfig: a, flow: s }
  } = Ze(), l = J(0), r = ka({
    [wa.timePicker]: !a.value.enableTimePicker || t.timePicker || t.monthPicker,
    [wa.calendar]: !1,
    [wa.header]: !1
  }), i = S(() => t.monthPicker || t.timePicker), o = (f) => {
    var w, m;
    if ((m = (w = s.value) == null ? void 0 : w.steps) != null && m.length) {
      if (!f && i.value) return p();
      r[f] = !0, Object.keys(r).filter((k) => !r[k]).length || p();
    }
  }, u = () => {
    var f, w, m, k;
    (w = (f = s.value) == null ? void 0 : f.steps) != null && w.length && l.value !== -1 && (l.value += 1, n("flow-step", l.value), p()), ((k = (m = s.value) == null ? void 0 : m.steps) == null ? void 0 : k.length) === l.value && Ke().then(() => c());
  }, c = () => {
    l.value = -1;
  }, d = (f, w, ...m) => {
    var k, y, h;
    ((k = s.value) == null ? void 0 : k.steps[l.value]) === f && e.value && ((h = (y = e.value)[w]) == null || h.call(y, ...m));
  }, p = (f = 0) => {
    var m;
    f && (l.value += f), d(Nt.month, "toggleMonthPicker", !0), d(Nt.year, "toggleYearPicker", !0), d(Nt.calendar, "toggleTimePicker", !1, !0), d(Nt.time, "toggleTimePicker", !0, !0);
    const w = (m = s.value) == null ? void 0 : m.steps[l.value];
    (w === Nt.hours || w === Nt.minutes || w === Nt.seconds) && d(w, "toggleTimePicker", !0, !0, w);
  };
  return { childMount: o, updateFlowStep: u, resetFlow: c, handleFlow: p, flowStep: l };
};
function xr(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
function ws(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : r;
      s = e.formattingValues[i] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      s = e.values[i] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return s[l];
  };
}
function ks(e) {
  return (n, t = {}) => {
    const a = t.width, s = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(s);
    if (!l)
      return null;
    const r = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(i) ? Hb(i, (d) => d.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      Yb(i, (d) => d.test(r))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(r.length);
    return { value: u, rest: c };
  };
}
function Yb(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Hb(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Ub(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const s = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = t.valueCallback ? t.valueCallback(r) : r;
    const i = n.slice(s.length);
    return { value: r, rest: i };
  };
}
const qb = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, jb = (e, n, t) => {
  let a;
  const s = qb[e];
  return typeof s == "string" ? a = s : n === 1 ? a = s.one : a = s.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
}, Gb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Kb = (e, n, t, a) => Gb[e], Zb = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Xb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Jb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Qb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, e0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, t0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, n0 = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, a0 = {
  ordinalNumber: n0,
  era: ws({
    values: Zb,
    defaultWidth: "wide"
  }),
  quarter: ws({
    values: Xb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ws({
    values: Jb,
    defaultWidth: "wide"
  }),
  day: ws({
    values: Qb,
    defaultWidth: "wide"
  }),
  dayPeriod: ws({
    values: e0,
    defaultWidth: "wide",
    formattingValues: t0,
    defaultFormattingWidth: "wide"
  })
}, s0 = /^(\d+)(th|st|nd|rd)?/i, l0 = /\d+/i, r0 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, i0 = {
  any: [/^b/i, /^(a|c)/i]
}, o0 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, u0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c0 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, d0 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, f0 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, h0 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, m0 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, v0 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, p0 = {
  ordinalNumber: Ub({
    matchPattern: s0,
    parsePattern: l0,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: ks({
    matchPatterns: r0,
    defaultMatchWidth: "wide",
    parsePatterns: i0,
    defaultParseWidth: "any"
  }),
  quarter: ks({
    matchPatterns: o0,
    defaultMatchWidth: "wide",
    parsePatterns: u0,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: ks({
    matchPatterns: c0,
    defaultMatchWidth: "wide",
    parsePatterns: d0,
    defaultParseWidth: "any"
  }),
  day: ks({
    matchPatterns: f0,
    defaultMatchWidth: "wide",
    parsePatterns: h0,
    defaultParseWidth: "any"
  }),
  dayPeriod: ks({
    matchPatterns: m0,
    defaultMatchWidth: "any",
    parsePatterns: v0,
    defaultParseWidth: "any"
  })
}, g0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, y0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, b0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, w0 = {
  date: xr({
    formats: g0,
    defaultWidth: "full"
  }),
  time: xr({
    formats: y0,
    defaultWidth: "full"
  }),
  dateTime: xr({
    formats: b0,
    defaultWidth: "full"
  })
}, k0 = {
  code: "en-US",
  formatDistance: jb,
  formatLong: w0,
  formatRelative: Kb,
  localize: a0,
  match: p0,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, lu = {
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1,
  autoSwitchStartEnd: !0
}, x0 = {
  allowStopPropagation: !0,
  closeOnScroll: !1,
  modeHeight: 255,
  allowPreventDefault: !1,
  closeOnClearValue: !0,
  closeOnAutoApply: !0,
  noSwipe: !1,
  keepActionRow: !1,
  onClickOutside: void 0,
  tabOutClosesMenu: !0,
  arrowLeft: void 0,
  keepViewOnOffsetClick: !1,
  timeArrowHoldThreshold: 0,
  shadowDom: !1,
  mobileBreakpoint: 600,
  setDateOnMenuClose: !1,
  escClose: !0,
  spaceConfirm: !0,
  monthChangeOnArrows: !0,
  monthChangeOnScroll: !0
}, ru = {
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: "open",
  selectOnFocus: !1,
  rangeSeparator: " - ",
  escClose: !0,
  format: void 0,
  maskFormat: void 0,
  applyOnBlur: !1,
  separators: void 0
}, S0 = {
  dates: [],
  years: [],
  months: [],
  quarters: [],
  weeks: [],
  weekdays: [],
  options: { highlightDisabled: !1 }
}, $0 = {
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  selectBtnLabel: "Select",
  cancelBtnLabel: "Cancel",
  nowBtnLabel: "Now",
  nowBtnRound: void 0
}, T0 = {
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`
}, iu = {
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down"
}, C0 = {
  weekDays: [],
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] }
}, M0 = {
  month: "LLL",
  year: "yyyy",
  weekDay: "EEEEEE",
  quarter: "MMMM",
  day: "d",
  input: void 0,
  preview: void 0
}, D0 = {
  enableTimePicker: !0,
  ignoreTimeValidation: !1,
  enableSeconds: !1,
  enableMinutes: !0,
  is24: !0,
  noHoursOverlay: !1,
  noMinutesOverlay: !1,
  noSecondsOverlay: !1,
  hoursGridIncrement: 1,
  minutesGridIncrement: 5,
  secondsGridIncrement: 5,
  hoursIncrement: 1,
  minutesIncrement: 1,
  secondsIncrement: 1,
  timePickerInline: !1,
  startTime: void 0
}, _0 = {
  flowStep: 0,
  menuWrapRef: null,
  collapse: !1
}, O0 = {
  weekStart: zd.Monday,
  yearRange: () => [1900, 2100],
  ui: () => ({}),
  locale: () => k0,
  dark: !1,
  transitions: !0,
  hideNavigation: () => [],
  vertical: !1,
  hideMonthYearSelect: !1,
  disableYearSelect: !1,
  autoApply: !1,
  disabledDates: () => [],
  hideOffsetDates: !1,
  noToday: !1,
  markers: () => [],
  presetDates: () => [],
  preventMinMaxNavigation: !1,
  reverseYears: !1,
  weekPicker: !1,
  arrowNavigation: !1,
  monthPicker: !1,
  yearPicker: !1,
  quarterPicker: !1,
  timePicker: !1,
  modelAuto: !1,
  multiDates: !1,
  range: !1,
  inline: !1,
  sixWeeks: !1,
  focusStartDate: !1,
  yearFirst: !1,
  loading: !1,
  centered: !1
}, ou = {
  name: void 0,
  required: !1,
  autocomplete: "off",
  state: void 0,
  clearable: !0,
  alwaysClearable: !1,
  hideInputIcon: !1,
  id: void 0,
  inputmode: "none"
}, cl = {
  type: "local",
  hideOnOffsetDates: !1,
  label: "W"
}, E0 = (e) => {
  const { getMapKey: n, getMapKeyType: t, getTimeObjFromCurrent: a } = _t();
  function s(L, ae) {
    let Y;
    return e.timezone ? Y = new Ha(L ?? /* @__PURE__ */ new Date(), e.timezone) : Y = L ? new Date(L) : /* @__PURE__ */ new Date(), ae ? je(Y, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }) : Y;
  }
  const l = () => {
    const L = ne.value.enableSeconds ? ":ss" : "", ae = ne.value.enableMinutes ? ":mm" : "";
    return ne.value.is24 ? `HH${ae}${L}` : `hh${ae}${L} aa`;
  }, r = () => {
    var L;
    return e.monthPicker ? "MM/yyyy" : e.timePicker ? l() : e.weekPicker ? `${((L = C.value) == null ? void 0 : L.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : ne.value.enableTimePicker ? `MM/dd/yyyy, ${l()}` : "MM/dd/yyyy";
  }, i = (L) => a(s(), L, ne.value.enableSeconds), o = () => I.value.enabled ? ne.value.startTime && Array.isArray(ne.value.startTime) ? [i(ne.value.startTime[0]), i(ne.value.startTime[1])] : null : ne.value.startTime && !Array.isArray(ne.value.startTime) ? i(ne.value.startTime) : null, u = (L) => L ? typeof L == "boolean" ? L ? 2 : 0 : Math.max(+L, 2) : 0, c = (L) => {
    const ae = t(e.monthPicker, e.yearPicker);
    return new Map(
      L.map((Y) => {
        const W = s(Y, d.value);
        return [n(W, ae), W];
      })
    );
  }, d = S(() => e.monthPicker || e.yearPicker || e.quarterPicker), p = S(() => {
    const L = typeof e.multiCalendars == "object" && e.multiCalendars, ae = {
      static: !0,
      solo: !1
    };
    if (!e.multiCalendars) return { ...ae, count: u(!1) };
    const Y = L ? e.multiCalendars : {}, W = L ? Y.count ?? !0 : e.multiCalendars, K = u(W);
    return Object.assign(ae, Y, { count: K });
  }), f = S(() => o()), w = S(() => ({ ...T0, ...e.ariaLabels })), m = S(() => ({ ...C0, ...e.filters })), k = S(() => typeof e.transitions == "boolean" ? e.transitions ? iu : !1 : { ...iu, ...e.transitions }), y = S(() => ({ ...$0, ...e.actionRow })), h = S(() => typeof e.textInput == "object" ? {
    ...ru,
    ...e.textInput,
    format: typeof e.textInput.format == "string" ? e.textInput.format : z.value.input,
    pattern: e.textInput.format ?? z.value.input,
    enabled: !0
  } : {
    ...ru,
    format: z.value.input,
    pattern: z.value.input,
    enabled: e.textInput
  }), g = S(() => {
    const L = { input: !1 };
    return typeof e.inline == "object" ? { ...L, ...e.inline, enabled: !0 } : {
      enabled: e.inline,
      ...L
    };
  }), x = S(() => ({ ...x0, ...e.config })), $ = S(() => typeof e.highlight == "function" ? e.highlight : {
    ...S0,
    ...e.highlight
  }), C = S(() => {
    var L, ae;
    return typeof e.weekNumbers == "object" ? {
      type: ((L = e.weekNumbers) == null ? void 0 : L.type) ?? cl.type,
      hideOnOffsetDates: ((ae = e.weekNumbers) == null ? void 0 : ae.hideOnOffsetDates) ?? cl.hideOnOffsetDates,
      label: e.weekNumbers.label ?? cl.label
    } : e.weekNumbers ? cl : void 0;
  }), O = S(() => {
    var L, ae;
    return typeof e.multiDates == "boolean" ? { enabled: e.multiDates, dragSelect: !0, limit: null } : {
      enabled: !!e.multiDates,
      limit: (L = e.multiDates) != null && L.limit ? +e.multiDates.limit : null,
      dragSelect: ((ae = e.multiDates) == null ? void 0 : ae.dragSelect) ?? !0
    };
  }), _ = S(() => {
    var L;
    return {
      minDate: e.minDate ? s(e.minDate) : null,
      maxDate: e.maxDate ? s(e.maxDate) : null,
      disabledDates: Array.isArray(e.disabledDates) ? c(e.disabledDates) : e.disabledDates,
      allowedDates: Array.isArray(e.allowedDates) ? c(e.allowedDates) : null,
      highlight: typeof $.value == "object" && Array.isArray($.value.dates) ? c($.value.dates) : $.value,
      markers: (L = e.markers) != null && L.length ? new Map(
        e.markers.map((ae) => {
          const Y = s(ae.date);
          return [n(Y, Ua.DATE), ae];
        })
      ) : null
    };
  }), I = S(() => typeof e.range == "object" ? { enabled: !0, ...lu, ...e.range } : {
    enabled: e.range,
    ...lu
  }), D = S(() => ({
    ...Object.fromEntries(
      Object.keys(e.ui).map((L) => {
        const ae = L, Y = e.ui[ae];
        if (ae === "dayClass") return [ae, e.ui[ae]];
        const W = typeof e.ui[ae] == "string" ? { [Y]: !0 } : Object.fromEntries(Y.map((K) => [K, !0]));
        return [L, W];
      })
    )
  })), z = S(() => {
    var L, ae;
    return {
      ...M0,
      ...e.formats,
      input: ((L = e.formats) == null ? void 0 : L.input) ?? r(),
      preview: ((ae = e.formats) == null ? void 0 : ae.preview) ?? r()
    };
  }), H = S(() => {
    if (e.teleport)
      return typeof e.teleport == "string" ? e.teleport : typeof e.teleport == "boolean" ? "body" : e.teleport;
  }), ne = S(() => ({ ...D0, ...e.timeConfig })), te = S(() => {
    if (e.flow)
      return { steps: [], partial: !1, ...e.flow };
  }), q = S(() => {
    const L = h.value.enabled ? "text" : "none";
    return e.inputAttrs ? { ...ou, inputmode: L, ...e.inputAttrs } : { ...ou, inputmode: L };
  }), ie = S(() => {
    var L, ae, Y, W, K, de;
    return {
      offset: ((L = e.floating) == null ? void 0 : L.offset) ?? 10,
      arrow: ((ae = e.floating) == null ? void 0 : ae.arrow) ?? !0,
      strategy: ((Y = e.floating) == null ? void 0 : Y.strategy) ?? void 0,
      placement: ((W = e.floating) == null ? void 0 : W.placement) ?? void 0,
      flip: ((K = e.floating) == null ? void 0 : K.flip) ?? !0,
      shift: ((de = e.floating) == null ? void 0 : de.shift) ?? !0
    };
  });
  return {
    transitions: k,
    multiCalendars: p,
    startTime: f,
    ariaLabels: w,
    filters: m,
    actionRow: y,
    textInput: h,
    inline: g,
    config: x,
    highlight: $,
    weekNumbers: C,
    range: I,
    safeDates: _,
    multiDates: O,
    ui: D,
    formats: z,
    teleport: H,
    timeConfig: ne,
    flow: te,
    inputAttrs: q,
    floatingConfig: ie,
    getDate: s
  };
}, _t = () => {
  const e = (h, g) => nn(h, g ?? Ua.DATE), n = (h, g) => h ? Ua.MONTH_AND_YEAR : g ? Ua.YEAR : Ua.DATE, t = (h, g, x) => g.get(e(h, x)), a = (h) => h, s = (h) => h === 0 ? h : !h || Number.isNaN(+h) ? null : +h, l = () => [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
    "[data-datepicker-instance]"
  ].join(", "), r = (h, g) => {
    let x = [...document.querySelectorAll(l())];
    x = x.filter((C) => !h.contains(C) || "datepicker-instance" in C.dataset);
    const $ = x.indexOf(h);
    if ($ >= 0 && (g ? $ - 1 >= 0 : $ + 1 <= x.length))
      return x[$ + (g ? -1 : 1)];
  }, i = (h) => String(h).padStart(2, "0"), o = (h, g) => h == null ? void 0 : h.querySelector(`[data-dp-element="${g}"]`), u = (h, g, x = !1) => {
    h && g.allowStopPropagation && (x && h.stopImmediatePropagation(), h.stopPropagation());
  }, c = (h, g, x = !1, $) => {
    if (h.key === ct.enter || h.key === ct.space)
      return x && h.preventDefault(), g();
    if ($) return $(h);
  }, d = (h, g) => {
    g.allowStopPropagation && h.stopPropagation(), g.allowPreventDefault && h.preventDefault();
  }, p = (h) => {
    if (h)
      return [...h.querySelectorAll("input, button, select, textarea, a[href]")][0];
  }, f = () => "ontouchstart" in globalThis || navigator.maxTouchPoints > 0, w = (h) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][h], m = (h) => {
    const g = [], x = ($) => $.filter((C) => !!C);
    for (let $ = 0; $ < h.length; $ += 3) {
      const C = [h[$], h[$ + 1], h[$ + 2]];
      g.push(x(C));
    }
    return g;
  }, k = {
    prop: (h) => `"${h}" prop must be enabled!`,
    dateArr: (h) => `You need to use array as "model-value" binding in order to support "${h}"`
  }, y = (h, g, x, $, C) => {
    const O = {
      hours: An,
      minutes: Hn,
      seconds: la
    };
    if (!g) return $ ? [O[h](x), O[h](x)] : O[h](x);
    if (Array.isArray(g) && $) {
      const _ = g[0] ?? x, I = g[1];
      return [O[h](_), I ? O[h](I) : C[h][1] ?? O[h](x)];
    }
    return Array.isArray(g) && !$ ? O[h](g[g.length - 1] ?? x) : O[h](g);
  };
  return {
    getMapKey: e,
    getMapKeyType: n,
    getMapDate: t,
    convertType: a,
    getNumVal: s,
    findNextFocusableElement: r,
    padZero: i,
    getElWithin: o,
    checkStopPropagation: u,
    checkKeyDown: c,
    handleEventPropagation: d,
    findFocusableEl: p,
    isTouchDevice: f,
    hoursToAmPmHours: w,
    getGroupedList: m,
    setTimeModelValue: (h, g, x, $) => {
      h.hours = y("hours", g, x, $, h), h.minutes = y("minutes", g, x, $, h), h.seconds = y("seconds", g, x, $, h);
    },
    getTimeObjFromCurrent: (h, g, x) => {
      const $ = {
        hours: An(h),
        minutes: Hn(h),
        seconds: x ? la(h) : 0
      };
      return Object.assign($, g);
    },
    errorMapper: k
  };
}, Lt = () => {
  const { getDate: e } = Ze(), { getMapDate: n, getGroupedList: t } = _t(), a = (y, h) => {
    if (!y) return e();
    const g = e(y), x = je(g, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
    return h ? Ng(x) : x;
  }, s = (y, h) => {
    const g = e(h);
    return je(g, {
      hours: +(y.hours ?? An(g)),
      minutes: +(y.minutes ?? Hn(g)),
      seconds: +(y.seconds ?? la(g)),
      milliseconds: 0
    });
  }, l = (y, h) => {
    const g = on(y, { weekStartsOn: +h }), x = Ai(y, { weekStartsOn: +h });
    return [g, x];
  }, r = (y, h) => !y || !h ? !1 : Wn(a(y), a(h)), i = (y, h) => !y || !h ? !1 : Ya(a(y), a(h)), o = (y, h) => !y || !h ? !1 : Dn(a(y), a(h)), u = (y, h, g) => y != null && y[0] && (y != null && y[1]) ? o(g, y[0]) && r(g, y[1]) : y != null && y[0] && h ? o(g, y[0]) && r(g, h) || r(g, y[0]) && o(g, h) : !1, c = (y, h) => {
    const g = o(y, h) ? h : y, x = o(h, y) ? h : y;
    return Ii({ start: g, end: x });
  }, d = (y) => `dp-${nn(y, "yyyy-MM-dd")}`, p = (y) => a(je(e(y), { date: 1 })), f = (y, h) => {
    if (h) {
      const g = We(e(h));
      if (g > y) return 12;
      if (g === y) return Xe(e(h));
    }
  }, w = (y, h) => {
    if (h) {
      const g = We(e(h));
      return g < y ? -1 : g === y ? Xe(e(h)) : void 0;
    }
  }, m = (y) => {
    if (y) return We(e(y));
  }, k = (y) => ({
    hours: An(y),
    minutes: Hn(y),
    seconds: la(y)
  });
  return {
    resetDateTime: a,
    groupListAndMap: (y, h) => t(y).map((g) => g.map((x) => {
      const { active: $, disabled: C, isBetween: O, highlighted: _ } = h(x);
      return {
        ...x,
        active: $,
        disabled: C,
        className: {
          dp__overlay_cell_active: $,
          dp__overlay_cell: !$,
          dp__overlay_cell_disabled: C,
          dp__overlay_cell_pad: !0,
          dp__overlay_cell_active_disabled: C && $,
          dp__cell_in_between: O,
          "dp--highlighted": _
        }
      };
    })),
    setTime: s,
    getWeekFromDate: l,
    isDateAfter: o,
    isDateBefore: r,
    isDateBetween: u,
    isDateEqual: i,
    getDaysInBetween: c,
    getCellId: d,
    resetDate: p,
    getMinMonth: f,
    getMaxMonth: w,
    getYearFromDate: m,
    getTimeObj: k,
    setTimeValue: (y) => je(e(), k(y)),
    sanitizeTime: (y, h, g) => h && (g || g === 0) ? Object.fromEntries(
      ["hours", "minutes", "seconds"].map((x) => x === h ? [x, g] : [x, Number.isNaN(+y[x]) ? void 0 : +y[x]])
    ) : {
      hours: Number.isNaN(+y.hours) ? void 0 : +y.hours,
      minutes: Number.isNaN(+y.minutes) ? void 0 : +y.minutes,
      seconds: Number.isNaN(+(y.seconds ?? "")) ? void 0 : +y.seconds
    },
    getBeforeAndAfterInRange: (y, h) => {
      const g = Od(a(h), y), x = an(a(h), y);
      return { before: g, after: x };
    },
    isModelAuto: (y) => Array.isArray(y) ? !!y[0] && !!y[1] : !1,
    matchDate: (y, h) => y ? h ? h instanceof Map ? !!n(y, h) : h(e(y)) : !1 : !0,
    checkHighlightMonth: (y, h, g) => typeof y == "function" ? y({ month: h, year: g }) : y.months.some((x) => x.month === h && x.year === g),
    checkHighlightYear: (y, h) => typeof y == "function" ? y(h) : y.years.includes(h)
  };
}, ql = () => {
  const {
    defaults: { config: e }
  } = Ze(), n = J(0);
  et(() => {
    t(), globalThis.addEventListener("resize", t, { passive: !0 });
  }), Jt(() => {
    globalThis.removeEventListener("resize", t);
  });
  const t = () => {
    n.value = globalThis.document.documentElement.clientWidth;
  };
  return {
    isMobile: S(() => n.value <= e.value.mobileBreakpoint ? !0 : void 0)
  };
}, ra = () => {
  const {
    getDate: e,
    state: n,
    modelValue: t,
    rootProps: a,
    defaults: { formats: s, textInput: l }
  } = Ze(), r = (w) => nn(vn(e(), w), s.value.year, { locale: a.locale }), i = (w) => nn(Ed(e(), w), s.value.month, { locale: a.locale }), o = (w) => nn(w, s.value.weekDay, { locale: a.locale }), u = (w) => nn(w, s.value.quarter, { locale: a.locale }), c = (w, m) => [w, m].map((k) => u(k)).join("-"), d = (w) => nn(w, s.value.day, { locale: a.locale }), p = (w, m, k) => {
    const y = k ? s.value.preview : s.value.input;
    if (!w) return "";
    if (typeof y == "function") return y(w);
    const h = m ?? y, g = { locale: a.locale };
    return Array.isArray(w) ? `${nn(w[0], h, g)}${a.modelAuto && !w[1] ? "" : l.value.rangeSeparator}${w[1] ? nn(w[1], h, g) : ""}` : nn(w, h, g);
  }, f = () => {
    const w = (m) => nn(m, l.value.format);
    return Array.isArray(t.value) ? `${w(t.value[0])} ${l.value.rangeSeparator} ${t.value[1] ? w(t.value[1]) : ""}` : "";
  };
  return {
    formatYear: r,
    formatMonth: i,
    formatWeekDay: o,
    formatQuarter: u,
    formatSelectedDate: p,
    formatForTextInput: () => n.isInputFocused && t.value ? Array.isArray(t.value) ? f() : nn(t.value, l.value.format) : p(t.value),
    formatPreview: (w) => p(w, void 0, !0),
    formatQuarterText: c,
    formatDay: d
  };
}, jl = () => {
  const { rootProps: e } = Ze(), { formatYear: n, formatMonth: t } = ra();
  return {
    getMonths: () => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((a) => ({
      text: t(a),
      value: a
    })),
    getYears: () => {
      const a = [];
      for (let s = +e.yearRange[0]; s <= +e.yearRange[1]; s++)
        a.push({ value: +s, text: n(s) });
      return e.reverseYears ? a.reverse() : a;
    },
    isOutOfYearRange: (a) => a < +e.yearRange[0] || a > +e.yearRange[1]
  };
}, I0 = (e) => ({
  openMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.openMenu();
  },
  closeMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.closeMenu();
  },
  selectDate: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.selectDate();
  },
  clearValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.clearValue();
  },
  formatInputValue: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.formatInputValue();
  },
  updateInternalModelValue: (n) => {
    var t;
    return (t = e.value) == null ? void 0 : t.updateInternalModelValue(n);
  },
  setMonthYear: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.setMonthYear(n, t);
  },
  parseModel: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.parseModel();
  },
  switchView: (n, t) => {
    var a;
    return (a = e.value) == null ? void 0 : a.switchView(n, t);
  },
  handleFlow: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.handleFlow();
  },
  toggleMenu: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.toggleMenu();
  },
  dpMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpMenuRef();
  },
  dpWrapMenuRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.dpWrapMenuRef();
  },
  inputRef: () => {
    var n;
    return (n = e.value) == null ? void 0 : n.inputRef();
  }
}), us = () => ({
  boolHtmlAttribute: (e) => e ? !0 : void 0
}), A0 = () => {
  const {
    getDate: e,
    rootProps: n,
    defaults: { textInput: t, startTime: a, timeConfig: s }
  } = Ze(), { getTimeObjFromCurrent: l } = _t(), r = J(!1), i = S(
    () => Array.isArray(a.value) ? a.value[0] : a.value ?? l(e(), {}, s.value.enableSeconds)
  ), o = (c, d) => {
    var g, x;
    const p = /[^a-zA-Z]+/g, f = /\D+/g, w = d.split(f), m = c.split(p), k = c.match(p) || [], y = d.match(f) || [];
    let h = "";
    for (let $ = 0; $ < w.length && $ < m.length; $++) {
      $ > 0 && y[$ - 1] && (h += k[$ - 1] || y[$ - 1]);
      const C = (g = w[$]) == null ? void 0 : g.length;
      h += (x = m[$]) == null ? void 0 : x.slice(0, C);
    }
    return h;
  }, u = (c, d, p) => {
    const f = ti(c, o(d, c), e(), {
      locale: n.locale
    });
    return _s(f) && bd(f) ? p || r.value ? f : je(f, {
      hours: +i.value.hours,
      minutes: +i.value.minutes,
      seconds: +(i.value.seconds ?? 0),
      milliseconds: 0
    }) : null;
  };
  return {
    textPasted: r,
    parseFreeInput: (c, d) => {
      if (typeof t.value.pattern == "string")
        return u(c, t.value.pattern, d);
      if (Array.isArray(t.value.pattern)) {
        let p = null;
        for (const f of t.value.pattern)
          if (p = u(c, f, d), p)
            break;
        return p;
      }
      return typeof t.value.pattern == "function" ? t.value.pattern(c) : null;
    },
    applyMaxValues: (c, d) => {
      const p = {
        MM: 12,
        DD: 31,
        hh: 23,
        mm: 59,
        ss: 59
      };
      let f = "", w = 0;
      for (let m = 0; m < d.length; m++) {
        const k = d[m], y = k.length, h = c.slice(w, w + y);
        if (!h) break;
        if (h.length < y)
          f += h;
        else {
          let g = Number.parseInt(h, 10);
          p[k] && g > p[k] && (g = p[k]), f += g.toString().padStart(y, "0").slice(0, y);
        }
        w += y;
      }
      return f;
    },
    createMaskedValue: (c, d) => {
      const p = /(YYYY|MM|DD|hh|mm|ss)/g, f = [...d.matchAll(p)].map((h) => h[0]), w = d.replace(p, "|").split("|").filter(Boolean), m = f.map((h) => h.length);
      let k = "", y = 0;
      for (let h = 0; h < f.length; h++) {
        const g = m[h], x = c.slice(y, y + g);
        if (!x) break;
        k += x, x.length === g && w[h] && (k += w[h]), y += g;
      }
      return k;
    }
  };
};
var yn = /* @__PURE__ */ ((e) => (e.Input = "input", e.DatePicker = "date-picker", e.Calendar = "calendar", e.DatePickerHeader = "date-picker-header", e.Menu = "menu", e.ActionRow = "action-row", e.TimePicker = "time-picker", e.TimeInput = "time-input", e.PassTrough = "pass-trough", e.MonthPicker = "month-picker", e.YearMode = "year-mode", e.QuarterPicker = "quarter-picker", e.YearPicker = "year-picker", e))(yn || {});
const La = [
  "time-input",
  "time-picker",
  "pass-trough"
  /* PassTrough */
], Bd = [
  { name: "trigger", use: [
    "input"
    /* Input */
  ] },
  { name: "input-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "clear-icon", use: [
    "input"
    /* Input */
  ] },
  { name: "dp-input", use: [
    "input"
    /* Input */
  ] },
  { name: "clock-icon", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "arrow-left", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "arrow-right", use: [
    "date-picker-header",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  {
    name: "arrow-up",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "arrow-down",
    use: [
      "time-picker",
      "time-input",
      "date-picker-header",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "calendar-icon",
    use: [
      "date-picker-header",
      "time-picker",
      "pass-trough",
      "year-mode"
      /* YearMode */
    ]
  },
  { name: "day", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "month-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker"
      /* MonthPicker */
    ]
  },
  {
    name: "year-overlay-value",
    use: [
      "date-picker-header",
      "pass-trough",
      "year-mode",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "year-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year-overlay-header", use: [
    "date-picker-header",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "hours-overlay-value",
    use: La
  },
  {
    name: "hours-overlay-header",
    use: La
  },
  {
    name: "minutes-overlay-value",
    use: La
  },
  {
    name: "minutes-overlay-header",
    use: La
  },
  {
    name: "seconds-overlay-value",
    use: La
  },
  {
    name: "seconds-overlay-header",
    use: La
  },
  { name: "hours", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "minutes", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "seconds", use: [
    "time-input",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "month", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "year", use: [
    "date-picker-header",
    "time-picker",
    "pass-trough",
    "year-mode"
    /* YearMode */
  ] },
  { name: "action-buttons", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "action-preview", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "calendar-header", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "marker-tooltip", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-extra", use: [
    "menu"
    /* Menu */
  ] },
  { name: "time-picker-overlay", use: [
    "time-picker",
    "time-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "am-pm-button", use: [
    "time-picker",
    "time-input",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "left-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  { name: "right-sidebar", use: [
    "menu"
    /* Menu */
  ] },
  {
    name: "month-year",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  { name: "time-picker", use: [
    "date-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "action-row", use: [
    "action-row"
    /* ActionRow */
  ] },
  { name: "marker", use: [
    "calendar",
    "pass-trough"
    /* PassTrough */
  ] },
  { name: "quarter", use: [
    "quarter-picker",
    "pass-trough"
    /* PassTrough */
  ] },
  {
    name: "top-extra",
    use: [
      "date-picker-header",
      "pass-trough",
      "month-picker",
      "quarter-picker",
      "year-picker"
      /* YearPicker */
    ]
  },
  {
    name: "tp-inline-arrow-up",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  {
    name: "tp-inline-arrow-down",
    use: [
      "date-picker",
      "time-input",
      "time-picker",
      "pass-trough"
      /* PassTrough */
    ]
  },
  { name: "arrow", use: [
    "menu"
    /* Menu */
  ] },
  { name: "menu-header", use: [
    "menu"
    /* Menu */
  ] }
], En = (e, n) => Bd.filter((t) => e[t.name] && t.use.includes(n)).map((t) => t.name), Wd = (e, n) => Bd.map((t) => t.name).concat((n == null ? void 0 : n.filter((t) => t.slot).map((t) => t.slot)) ?? []).filter((t) => !!e[t]), P0 = {
  key: 1,
  class: "dp__input_wrap"
}, R0 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], V0 = {
  key: 1,
  class: "dp--clear-btn"
}, F0 = ["aria-label"], L0 = /* @__PURE__ */ ke({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 }
  },
  emits: ["clear", "open", "set-input-date", "close", "select-date", "set-empty-date", "toggle", "focus", "blur", "real-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      inputValue: r,
      rootProps: i,
      defaults: { textInput: o, ariaLabels: u, inline: c, config: d, range: p, multiDates: f, ui: w, inputAttrs: m }
    } = Ze(), { checkMinMaxRange: k, isValidDate: y } = un(), { parseFreeInput: h, textPasted: g, createMaskedValue: x, applyMaxValues: $ } = A0(), { checkKeyDown: C, checkStopPropagation: O } = _t(), { boolHtmlAttribute: _ } = us(), I = Ge("dp-input"), D = J(null), z = J(!1), H = S(
      () => ({
        dp__pointer: !i.disabled && !i.readonly && !o.value.enabled,
        dp__disabled: i.disabled,
        dp__input_readonly: !o.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !m.value.clearable,
        dp__input_icon_pad: !m.value.hideInputIcon,
        dp__input_valid: typeof m.value.state == "boolean" ? m.value.state : !1,
        dp__input_invalid: typeof m.value.state == "boolean" ? !m.value.state : !1,
        dp__input_focus: z.value || s.isMenuOpen,
        dp__input_reg: !o.value.enabled,
        ...w.value.input
      })
    ), ne = () => {
      a("set-input-date", null), m && i.autoApply && (a("set-empty-date"), D.value = null);
    }, te = (F) => {
      var Z;
      if ((Z = o.value.separators) != null && Z.length) {
        const ve = new RegExp(
          o.value.separators.map((G) => G.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")
        );
        return F.split(ve);
      }
      return F.split(o.value.rangeSeparator);
    }, q = (F) => {
      const [Z, ve] = te(F);
      if (Z) {
        const G = h(Z.trim(), r.value), oe = ve ? h(ve.trim(), r.value) : void 0;
        if (Dn(G, oe)) return;
        const be = G && oe ? [G, oe] : [G];
        k(oe, be, 0) && (D.value = G ? be : null);
      }
    }, ie = () => {
      g.value = !0;
    }, L = (F) => {
      if (p.value.enabled)
        q(F);
      else if (f.value.enabled) {
        const Z = F.split(";");
        D.value = Z.map((ve) => h(ve.trim())).filter((ve) => !!ve);
      } else
        D.value = h(F, r.value);
    }, ae = (F) => {
      var oe, be;
      const Z = typeof F == "string" ? F : (oe = F.target) == null ? void 0 : oe.value, ve = (be = o == null ? void 0 : o.value) == null ? void 0 : be.maskFormat;
      let G = Z;
      if (typeof ve == "string") {
        const A = /(YYYY|MM|DD|hh|mm|ss)/g, B = [...ve.matchAll(A)].map((R) => R[0]), M = Z.replace(/\D/g, ""), V = $(M, B);
        G = x(V, ve);
      }
      G === "" ? ne() : (o.value.openMenu && !s.isMenuOpen && a("open"), L(G), a("set-input-date", D.value)), g.value = !1, r.value = G, l("text-input", F, D.value);
    }, Y = (F) => {
      o.value.enabled ? (L(F.target.value), o.value.enterSubmit && y(D.value) && r.value !== "" ? (a("set-input-date", D.value, !0), D.value = null) : o.value.enterSubmit && r.value === "" && (D.value = null, a("clear"))) : de(F);
    }, W = (F, Z) => {
      o.value.enabled && o.value.tabSubmit && !Z && L(F.target.value), o.value.tabSubmit && y(D.value) && r.value !== "" ? (a("set-input-date", D.value, !0, !0), D.value = null) : o.value.tabSubmit && r.value === "" && (D.value = null, a("clear"));
    }, K = () => {
      z.value = !0, a("focus"), Ke().then(() => {
        var F;
        o.value.enabled && o.value.selectOnFocus && ((F = I.value) == null || F.select());
      });
    }, de = (F) => {
      if (O(F, d.value, !0), o.value.enabled && o.value.openMenu && !c.value.input) {
        if (o.value.openMenu === "open" && !s.isMenuOpen) return a("open");
        if (o.value.openMenu === "toggle") return a("toggle");
      } else o.value.enabled || a("toggle");
    }, he = () => {
      a("real-blur"), z.value = !1, (!s.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), (i.autoApply && o.value.enabled && D.value && !s.isMenuOpen || o.value.applyOnBlur) && (a("set-input-date", D.value), a("select-date"), D.value = null);
    }, me = (F) => {
      O(F, d.value, !0), a("clear");
    }, Te = () => {
      a("close");
    }, we = (F) => {
      if (F.key === "Tab" && W(F), F.key === "Enter" && Y(F), F.key === "Escape" && o.value.escClose && Te(), !o.value.enabled) {
        if (F.code === "Tab") return;
        F.preventDefault();
      }
    }, X = () => {
      var F;
      (F = I.value) == null || F.focus({ preventScroll: !0 });
    }, pe = (F) => {
      D.value = F;
    }, Me = (F) => {
      F.key === ct.tab && W(F, !0);
    };
    return n({
      focusInput: X,
      setParsedDate: pe
    }), (F, Z) => {
      var ve, G;
      return b(), T("div", { onClick: de }, [
        !F.$slots["dp-input"] && !v(c).enabled ? U(F.$slots, "trigger", { key: 0 }) : P("", !0),
        !F.$slots.trigger && (!v(c).enabled || v(c).input) ? (b(), T("div", P0, [
          !F.$slots.trigger && (!v(c).enabled || v(c).enabled && v(c).input) ? U(F.$slots, "dp-input", {
            key: 0,
            value: v(r),
            isMenuOpen: e.isMenuOpen,
            onInput: ae,
            onEnter: Y,
            onTab: W,
            onClear: me,
            onBlur: he,
            onKeypress: we,
            onPaste: ie,
            onFocus: K,
            openMenu: () => F.$emit("open"),
            closeMenu: () => F.$emit("close"),
            toggleMenu: () => F.$emit("toggle")
          }, () => [
            E("input", {
              id: v(m).id,
              ref: "dp-input",
              "data-test-id": "dp-input",
              name: v(m).name,
              class: j(H.value),
              inputmode: v(m).inputmode,
              placeholder: v(i).placeholder,
              disabled: v(_)(v(i).disabled),
              readonly: v(_)(v(i).readonly),
              required: v(_)(v(m).required),
              value: v(r),
              autocomplete: v(m).autocomplete,
              "aria-label": v(u).input,
              "aria-disabled": v(i).disabled || void 0,
              "aria-invalid": v(m).state === !1 ? !0 : void 0,
              onInput: ae,
              onBlur: he,
              onFocus: K,
              onKeypress: we,
              onKeydown: Z[0] || (Z[0] = (oe) => we(oe)),
              onPaste: ie,
              onInvalid: Z[1] || (Z[1] = (oe) => v(l)("invalid", oe))
            }, null, 42, R0)
          ]) : P("", !0),
          E("div", {
            onClick: Z[4] || (Z[4] = (oe) => a("toggle"))
          }, [
            F.$slots["input-icon"] && !v(m).hideInputIcon ? (b(), T("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: Z[2] || (Z[2] = (oe) => a("toggle"))
            }, [
              U(F.$slots, "input-icon")
            ])) : P("", !0),
            !F.$slots["input-icon"] && !v(m).hideInputIcon && !F.$slots["dp-input"] ? (b(), ce(v(qs), {
              key: 1,
              "aria-label": (ve = v(u)) == null ? void 0 : ve.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: Z[3] || (Z[3] = (oe) => a("toggle"))
            }, null, 8, ["aria-label"])) : P("", !0)
          ]),
          F.$slots["clear-icon"] && (v(m).alwaysClearable || v(r) && v(m).clearable && !v(i).disabled && !v(i).readonly) ? (b(), T("span", V0, [
            U(F.$slots, "clear-icon", { clear: me })
          ])) : P("", !0),
          !F.$slots["clear-icon"] && (v(m).alwaysClearable || v(m).clearable && v(r) && !v(i).disabled && !v(i).readonly) ? (b(), T("button", {
            key: 2,
            "aria-label": (G = v(u)) == null ? void 0 : G.clearInput,
            class: "dp--clear-btn",
            type: "button",
            "data-test-id": "clear-input-value-btn",
            onKeydown: Z[5] || (Z[5] = (oe) => v(C)(oe, () => me(oe), !0, Me)),
            onClick: Z[6] || (Z[6] = Ve((oe) => me(oe), ["prevent"]))
          }, [
            se(v(Fb), { class: "dp__input_icons" })
          ], 40, F0)) : P("", !0)
        ])) : P("", !0)
      ]);
    };
  }
}), N0 = {
  ref: "action-row",
  class: "dp__action_row"
}, z0 = ["title"], B0 = {
  ref: "action-buttons-container",
  class: "dp__action_buttons",
  "data-dp-element": "action-row"
}, W0 = ["disabled"], Y0 = /* @__PURE__ */ ke({
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { default: 0 }
  },
  emits: ["close-picker", "select-date", "select-now"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      rootEmit: s,
      rootProps: l,
      modelValue: r,
      defaults: { actionRow: i, multiCalendars: o, inline: u, range: c, multiDates: d, formats: p }
    } = Ze(), { isTimeValid: f, isMonthValid: w } = un(), { formatPreview: m } = ra(), { checkKeyDown: k, convertType: y } = _t(), { boolHtmlAttribute: h } = us(), g = Ge("action-buttons-container"), x = Ge("action-row"), $ = J(!1), C = J({});
    et(() => {
      O(), globalThis.addEventListener("resize", O);
    }), Jt(() => {
      globalThis.removeEventListener("resize", O);
    });
    const O = () => {
      $.value = !1, setTimeout(() => {
        var ae, Y;
        const ie = (ae = g.value) == null ? void 0 : ae.getBoundingClientRect(), L = (Y = x.value) == null ? void 0 : Y.getBoundingClientRect();
        ie && L && (C.value.maxWidth = `${L.width - ie.width - 20}px`), $.value = !0;
      }, 0);
    }, _ = S(() => c.value.enabled && !c.value.partialRange && r.value ? r.value.length === 2 : !0), I = S(
      () => !f.value(r.value) || !w.value(r.value) || !_.value
    ), D = () => {
      const ie = p.value.preview;
      return l.timePicker || l.monthPicker, ie(y(r.value));
    }, z = () => {
      const ie = r.value;
      return o.value.count > 0 ? `${m(ie[0])} - ${m(ie[1])}` : [m(ie[0]), m(ie[1])];
    }, H = S(() => !r.value || !a.menuMount ? "" : typeof p.value.preview == "string" ? Array.isArray(r.value) ? r.value.length === 2 && r.value[1] ? z() : d.value.enabled ? r.value.map((ie) => `${m(ie)}`) : l.modelAuto ? `${m(r.value[0])}` : `${m(r.value[0])} -` : m(r.value) : D()), ne = () => d.value.enabled ? "; " : " - ", te = S(
      () => Array.isArray(H.value) ? H.value.join(ne()) : H.value
    ), q = () => {
      f.value(r.value) && w.value(r.value) && _.value ? t("select-date") : s("invalid-select");
    };
    return (ie, L) => (b(), T("div", N0, [
      ie.$slots["action-row"] ? U(ie.$slots, "action-row", Mt(lt({ key: 0 }, {
        modelValue: v(r),
        disabled: I.value,
        selectDate: () => ie.$emit("select-date"),
        closePicker: () => ie.$emit("close-picker")
      }))) : (b(), T($e, { key: 1 }, [
        v(i).showPreview ? (b(), T("div", {
          key: 0,
          class: "dp__selection_preview",
          title: te.value || void 0,
          style: Fe(C.value)
        }, [
          ie.$slots["action-preview"] && $.value ? U(ie.$slots, "action-preview", {
            key: 0,
            value: v(r),
            formatValue: te.value
          }) : P("", !0),
          !ie.$slots["action-preview"] && $.value ? (b(), T($e, { key: 1 }, [
            He(le(te.value), 1)
          ], 64)) : P("", !0)
        ], 12, z0)) : P("", !0),
        E("div", B0, [
          ie.$slots["action-buttons"] ? U(ie.$slots, "action-buttons", {
            key: 0,
            value: v(r),
            selectDate: q,
            selectionDisabled: I.value
          }) : P("", !0),
          ie.$slots["action-buttons"] ? P("", !0) : (b(), T($e, { key: 1 }, [
            !v(u).enabled && v(i).showCancel ? (b(), T("button", {
              key: 0,
              ref: "cancel-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: L[0] || (L[0] = (ae) => ie.$emit("close-picker")),
              onKeydown: L[1] || (L[1] = (ae) => v(k)(ae, () => ie.$emit("close-picker")))
            }, le(v(i).cancelBtnLabel), 545)) : P("", !0),
            v(i).showNow ? (b(), T("button", {
              key: 1,
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_cancel",
              onClick: L[2] || (L[2] = (ae) => ie.$emit("select-now")),
              onKeydown: L[3] || (L[3] = (ae) => v(k)(ae, () => ie.$emit("select-now")))
            }, le(v(i).nowBtnLabel), 33)) : P("", !0),
            v(i).showSelect ? (b(), T("button", {
              key: 2,
              ref: "select-btn",
              type: "button",
              "data-dp-action-element": "0",
              class: "dp__action_button dp__action_select",
              disabled: v(h)(I.value),
              "data-test-id": "select-button",
              onKeydown: L[4] || (L[4] = (ae) => v(k)(ae, () => q())),
              onClick: q
            }, le(v(i).selectBtnLabel), 41, W0)) : P("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Gl = () => {
  const {
    rootProps: e,
    defaults: { multiCalendars: n }
  } = Ze(), t = S(() => (l) => {
    var r;
    return (r = e.hideNavigation) == null ? void 0 : r.includes(l);
  }), a = S(() => (l) => n.value.count ? n.value.solo ? !0 : l === 0 : !0), s = S(() => (l) => n.value.count ? n.value.solo ? !0 : l === n.value.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: a, showRightIcon: s };
}, H0 = ["role", "aria-label", "tabindex"], U0 = { class: "dp__selection_grid_header" }, q0 = ["aria-selected", "aria-disabled", "data-dp-action-element", "data-dp-element-active", "data-test-id", "onClick", "onKeydown", "onMouseover"], j0 = ["aria-label", "data-dp-action-element"], Ks = /* @__PURE__ */ ke({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    useRelative: { type: Boolean },
    height: {},
    overlayLabel: {},
    isLast: { type: Boolean },
    level: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      setState: s,
      defaults: { ariaLabels: l, config: r }
    } = Ze(), { hideNavigationButtons: i } = Gl(), { handleEventPropagation: o, checkKeyDown: u } = _t(), c = Ge("toggle-button"), d = Ge("overlay-container"), p = Ge("grid-wrap"), f = J(!1), w = J(null), m = J(), k = J(0);
    Df(() => {
      w.value = null;
    }), et(async () => {
      await Ke(), C(), s("arrowNavigationLevel", a.level ?? 1);
    }), Jt(() => {
      s("arrowNavigationLevel", (a.level ?? 1) - 1);
    });
    const y = S(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !a.useRelative,
        "dp--overlay-relative": a.useRelative
      })
    ), h = S(
      () => a.useRelative ? { height: `${a.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), g = S(() => ({
      dp__overlay_col: !0
    })), x = S(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: f.value,
        dp__button_bottom: a.isLast
      })
    ), $ = S(() => {
      var ne, te;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((ne = a.items) == null ? void 0 : ne.length) <= 6,
        dp__container_block: ((te = a.items) == null ? void 0 : te.length) > 6
      };
    });
    Ne(
      () => a.items,
      () => C(!1),
      { deep: !0 }
    );
    const C = (ne = !0) => {
      Ke().then(() => {
        const te = document.querySelector(`[data-dp-element-active="${a.level ?? 1}"]`), q = Kt(p), ie = Kt(c), L = Kt(d), ae = ie ? ie.getBoundingClientRect().height : 0;
        q && (q.getBoundingClientRect().height ? k.value = q.getBoundingClientRect().height - ae : k.value = r.value.modeHeight - ae), te && L && ne && (L.scrollTop = te.offsetTop - L.offsetTop - (k.value / 2 - te.getBoundingClientRect().height) - ae);
      });
    }, O = (ne) => {
      ne.disabled || t("selected", ne.value);
    }, _ = () => {
      t("toggle"), t("reset-flow");
    }, I = (ne) => {
      r.value.escClose && (_(), o(ne, r.value));
    }, D = (ne) => {
      m.value = ne, t("hover-value", ne);
    }, z = (ne) => {
      if (ne.key === ct.esc) return I(ne);
    }, H = (ne) => {
      if (ne.key === ct.enter) return _();
    };
    return (ne, te) => {
      var q;
      return b(), T("div", {
        ref: "grid-wrap",
        class: j(y.value),
        style: Fe(h.value),
        role: e.useRelative ? void 0 : "dialog",
        "aria-label": e.overlayLabel,
        tabindex: e.useRelative ? void 0 : "0",
        onKeydown: z,
        onClick: te[0] || (te[0] = Ve(() => {
        }, ["prevent"]))
      }, [
        E("div", {
          ref: "overlay-container",
          class: j($.value),
          style: Fe({ "--dp-overlay-height": `${k.value}px` }),
          role: "grid"
        }, [
          E("div", U0, [
            U(ne.$slots, "header")
          ]),
          U(ne.$slots, "overlay", {}, () => [
            (b(!0), T($e, null, Oe(e.items, (ie, L) => (b(), T("div", {
              key: L,
              class: j(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
              role: "row"
            }, [
              (b(!0), T($e, null, Oe(ie, (ae) => (b(), T("div", {
                key: ae.value,
                role: "gridcell",
                class: j(g.value),
                "aria-selected": ae.active || void 0,
                "aria-disabled": ae.disabled || void 0,
                "data-dp-action-element": e.level ?? 1,
                "data-dp-element-active": ae.active ? e.level ?? 1 : void 0,
                tabindex: "0",
                "data-test-id": ae.text,
                onClick: Ve((Y) => O(ae), ["prevent"]),
                onKeydown: (Y) => v(u)(Y, () => O(ae), !0),
                onMouseover: (Y) => D(ae.value)
              }, [
                E("div", {
                  class: j(ae.className)
                }, [
                  U(ne.$slots, "item", { item: ae }, () => [
                    He(le(ae.text), 1)
                  ])
                ], 2)
              ], 42, q0))), 128))
            ], 2))), 128))
          ])
        ], 6),
        ne.$slots["button-icon"] ? Gt((b(), T("button", {
          key: 0,
          ref: "toggle-button",
          type: "button",
          "aria-label": (q = v(l)) == null ? void 0 : q.toggleOverlay,
          class: j(x.value),
          tabindex: "0",
          "data-dp-action-element": e.level ?? 1,
          onClick: _,
          onKeydown: H
        }, [
          U(ne.$slots, "button-icon")
        ], 42, j0)), [
          [Bn, !v(i)(e.type)]
        ]) : P("", !0)
      ], 46, H0);
    };
  }
}), G0 = ["data-dp-mobile"], Kl = /* @__PURE__ */ ke({
  __name: "InstanceWrap",
  props: {
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const {
      defaults: { multiCalendars: n }
    } = Ze(), { isMobile: t } = ql(), a = S(
      () => n.value.count > 0 ? [...new Array(n.value.count).keys()] : [0]
    );
    return (s, l) => (b(), T("div", {
      class: j({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: v(n).count > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": v(t)
    }, [
      U(s.$slots, "default", {
        instances: a.value,
        wrapClass: { dp__instance_calendar: v(n).count > 0 }
      })
    ], 10, G0));
  }
}), K0 = ["data-dp-element", "aria-label", "aria-disabled"], Os = /* @__PURE__ */ ke({
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const { checkKeyDown: t } = _t(), a = n;
    return (s, l) => (b(), T("button", {
      ref: "arrow-btn",
      type: "button",
      "data-dp-element": e.elName,
      "data-dp-action-element": "0",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: l[0] || (l[0] = (r) => a("activate")),
      onKeydown: l[1] || (l[1] = (r) => v(t)(r, () => a("activate"), !0))
    }, [
      E("span", {
        class: j(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        U(s.$slots, "default")
      ], 2)
    ], 40, K0));
  }
}), Z0 = ["aria-label", "data-test-id"], Yd = /* @__PURE__ */ ke({
  __name: "YearModePicker",
  props: {
    items: {},
    instance: {},
    year: {},
    showYearPicker: { type: Boolean, default: !1 },
    isDisabled: {}
  },
  emits: ["handle-year", "year-select", "toggle-year-picker"],
  setup(e, { emit: n }) {
    const t = n, a = e, { showRightIcon: s, showLeftIcon: l } = Gl(), {
      rootProps: r,
      defaults: { config: i, ariaLabels: o, ui: u }
    } = Ze(), { showTransition: c, transitionName: d } = js(), { formatYear: p } = ra(), { boolHtmlAttribute: f } = us(), w = J(!1), m = S(() => p(a.year)), k = (g = !1, x) => {
      w.value = !w.value, t("toggle-year-picker", { flow: g, show: x });
    }, y = (g) => {
      w.value = !1, t("year-select", g);
    }, h = (g = !1) => {
      t("handle-year", g);
    };
    return (g, x) => {
      var $, C, O, _, I;
      return b(), T($e, null, [
        E("div", {
          class: j(["dp--year-mode-picker", { "dp--hidden-el": w.value }])
        }, [
          v(l)(e.instance) ? (b(), ce(Os, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": ($ = v(o)) == null ? void 0 : $.prevYear,
            disabled: v(f)(e.isDisabled(!1)),
            class: j((C = v(u)) == null ? void 0 : C.navBtnPrev),
            onActivate: x[0] || (x[0] = (D) => h(!1))
          }, {
            default: ue(() => [
              g.$slots["arrow-left"] ? U(g.$slots, "arrow-left", { key: 0 }) : P("", !0),
              g.$slots["arrow-left"] ? P("", !0) : (b(), ce(v(Pd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
          E("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(O = v(o)) == null ? void 0 : O.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            "data-dp-action-element": "0",
            onClick: x[1] || (x[1] = () => k(!1)),
            onKeydown: x[2] || (x[2] = Pt(Ve(() => k(!1), ["prevent"]), ["enter"]))
          }, [
            g.$slots.year ? U(g.$slots, "year", {
              key: 0,
              text: m.value,
              value: e.year
            }) : P("", !0),
            g.$slots.year ? P("", !0) : (b(), T($e, { key: 1 }, [
              He(le(e.year), 1)
            ], 64))
          ], 40, Z0),
          v(s)(e.instance) ? (b(), ce(Os, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (_ = v(o)) == null ? void 0 : _.nextYear,
            disabled: v(f)(e.isDisabled(!0)),
            class: j((I = v(u)) == null ? void 0 : I.navBtnNext),
            onActivate: x[3] || (x[3] = (D) => h(!0))
          }, {
            default: ue(() => [
              g.$slots["arrow-right"] ? U(g.$slots, "arrow-right", { key: 0 }) : P("", !0),
              g.$slots["arrow-right"] ? P("", !0) : (b(), ce(v(Rd), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : P("", !0)
        ], 2),
        se(ht, {
          name: v(d)(e.showYearPicker),
          css: v(c)
        }, {
          default: ue(() => {
            var D, z;
            return [
              e.showYearPicker ? (b(), ce(Ks, {
                key: 0,
                items: e.items,
                config: v(i),
                "is-last": v(r).autoApply && !v(i).keepActionRow,
                "overlay-label": (z = (D = v(o)) == null ? void 0 : D.yearPicker) == null ? void 0 : z.call(D, !0),
                type: "year",
                onToggle: k,
                onSelected: x[4] || (x[4] = (H) => y(H))
              }, dt({
                "button-icon": ue(() => [
                  g.$slots["calendar-icon"] ? U(g.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                  g.$slots["calendar-icon"] ? P("", !0) : (b(), ce(v(qs), { key: 1 }))
                ]),
                _: 2
              }, [
                g.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: ue(({ item: H }) => [
                    U(g.$slots, "year-overlay-value", {
                      text: H.text,
                      value: H.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "config", "is-last", "overlay-label"])) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Hd = (e) => {
  const {
    getDate: n,
    rootEmit: t,
    state: a,
    month: s,
    year: l,
    modelValue: r,
    calendars: i,
    rootProps: o,
    defaults: { multiCalendars: u, range: c, safeDates: d, filters: p, highlight: f }
  } = Ze(), { resetDate: w, getYearFromDate: m, checkHighlightYear: k, groupListAndMap: y } = Lt(), { getYears: h } = jl(), { validateMonthYear: g, checkMinMaxValue: x } = un(), $ = J([!1]), C = S(() => h()), O = S(() => (W, K) => {
    const de = je(w(n()), {
      month: s.value(W),
      year: l.value(W)
    }), he = K ? kd(de) : Za(de);
    return g(he, o.preventMinMaxNavigation, K);
  }), _ = () => Array.isArray(r.value) && u.value.solo && r.value[1], I = () => {
    for (let W = 0; W < u.value.count; W++)
      if (W === 0)
        i.value[W] = i.value[0];
      else if (W === u.value.count - 1 && _())
        i.value[W] = {
          month: Xe(r.value[1]),
          year: We(r.value[1])
        };
      else {
        const K = je(n(), i.value[W - 1]);
        i.value[W] = { month: Xe(K), year: We(Ei(K, 1)) };
      }
  }, D = (W) => {
    if (!W) return I();
    const K = je(n(), i.value[W]);
    return i.value[0].year = We(Id(K, u.value.count - 1)), I();
  }, z = (W, K) => {
    const de = Fg(K, W);
    return c.value.showLastInRange && de > 1 ? K : W;
  }, H = (W) => o.focusStartDate || u.value.solo ? W[0] : W[1] ? z(W[0], W[1]) : W[0], ne = () => {
    if (r.value) {
      const W = Array.isArray(r.value) ? H(r.value) : r.value;
      i.value[0] = { month: Xe(W), year: We(W) };
    }
  }, te = () => {
    ne(), u.value.count && I();
  };
  Ne(r, (W, K) => {
    a.isTextInputDate && JSON.stringify(W ?? {}) !== JSON.stringify(K ?? {}) && te();
  }), et(() => {
    te();
  });
  const q = (W, K) => {
    i.value[K].year = W, t("update-month-year", { instance: K, year: W, month: i.value[K].month }), u.value.count && !u.value.solo && D(K);
  }, ie = S(() => (W) => y(C.value, (K) => {
    var Te;
    const de = l.value(W) === K.value, he = x(
      K.value,
      m(d.value.minDate),
      m(d.value.maxDate)
    ) || ((Te = p.value.years) == null ? void 0 : Te.includes(l.value(W))), me = k(f.value, K.value);
    return { active: de, disabled: he, highlighted: me };
  })), L = (W, K) => {
    q(W, K), Y(K);
  }, ae = (W, K = !1) => {
    if (!O.value(W, K)) {
      const de = K ? l.value(W) + 1 : l.value(W) - 1;
      q(de, W);
    }
  }, Y = (W, K = !1, de) => {
    K || e("reset-flow"), de === void 0 ? $.value[W] = !$.value[W] : $.value[W] = de, $.value[W] ? t("overlay-toggle", { open: !0, overlay: Nt.year }) : t("overlay-toggle", { open: !1, overlay: Nt.year });
  };
  return {
    isDisabled: O,
    groupedYears: ie,
    showYearPicker: $,
    selectYear: q,
    setStartDate: () => {
      o.startDate && (r.value && o.focusStartDate || !r.value) && q(We(n(o.startDate)), 0);
    },
    toggleYearPicker: Y,
    handleYearSelect: L,
    handleYear: ae
  };
}, Zl = () => {
  const { isDateAfter: e, isDateBefore: n, isDateEqual: t } = Lt(), {
    getDate: a,
    rootEmit: s,
    rootProps: l,
    modelValue: r,
    defaults: { range: i }
  } = Ze();
  return {
    getRangeWithFixedDate: (o) => Array.isArray(r.value) && (r.value.length === 2 || r.value.length === 1 && i.value.partialRange) ? i.value.fixedStart && (e(o, r.value[0]) || t(o, r.value[0])) ? [r.value[0], o] : i.value.fixedEnd && (n(o, r.value[1]) || t(o, r.value[1])) ? [o, r.value[1]] : (s("invalid-fixed-range", o), r.value) : [],
    setPresetDate: (o) => {
      Array.isArray(o.value) && o.value.length <= 2 && i.value.enabled ? r.value = o.value.map((u) => a(u)) : Array.isArray(o.value) || (r.value = a(o.value));
    },
    checkRangeAutoApply: (o, u, c) => {
      i && (o[0] && o[1] && l.autoApply && u("auto-apply", c), o[0] && !o[1] && (l.modelAuto || i.value.partialRange) && l.autoApply && u("auto-apply", c));
    },
    setMonthOrYearRange: (o) => {
      let u = r.value ? r.value.slice() : [];
      return u.length === 2 && u[1] !== null && (u = []), u.length ? (n(o, u[0]) ? u.unshift(o) : u[1] = o, s("range-end", o)) : (u = [o], s("range-start", o)), u;
    },
    handleMultiDatesSelect: (o, u) => {
      if (r.value && Array.isArray(r.value))
        if (r.value.some((c) => t(o, c))) {
          const c = r.value.filter((d) => !t(d, o));
          r.value = c.length ? c : null;
        } else (u && +u > r.value.length || !u) && r.value.push(o);
      else
        r.value = [o];
    }
  };
}, X0 = (e, n) => {
  const {
    getDate: t,
    rootEmit: a,
    state: s,
    calendars: l,
    year: r,
    modelValue: i,
    rootProps: o,
    defaults: { range: u, highlight: c, safeDates: d, filters: p, multiDates: f }
  } = Ze();
  Gs(() => {
    s.isTextInputDate && L(We(t(o.startDate)), 0);
  });
  const { checkMinMaxRange: w, checkMinMaxValue: m } = un(), { isDateBetween: k, resetDateTime: y, resetDate: h, getMinMonth: g, getMaxMonth: x, checkHighlightMonth: $, groupListAndMap: C } = Lt(), { checkRangeAutoApply: O, getRangeWithFixedDate: _, handleMultiDatesSelect: I, setMonthOrYearRange: D, setPresetDate: z } = Zl(), { padZero: H } = _t(), { getMonths: ne, isOutOfYearRange: te } = jl(), q = S(() => ne()), ie = J(null), {
    selectYear: L,
    groupedYears: ae,
    showYearPicker: Y,
    toggleYearPicker: W,
    handleYearSelect: K,
    handleYear: de,
    isDisabled: he,
    setStartDate: me
  } = Hd(n);
  et(() => {
    me();
  });
  const Te = (N) => N ? { month: Xe(N), year: We(N) } : { month: null, year: null }, we = () => i.value ? Array.isArray(i.value) ? i.value.map((N) => Te(N)) : Te(i.value) : Te(), X = (N, fe) => {
    const Ce = l.value[N], Re = we();
    return Array.isArray(Re) ? Re.some((Ee) => Ee.year === (Ce == null ? void 0 : Ce.year) && Ee.month === fe) : (Ce == null ? void 0 : Ce.year) === Re.year && fe === Re.month;
  }, pe = (N, fe, Ce) => {
    var Ee, Ye;
    const Re = we();
    return Array.isArray(Re) ? r.value(fe) === ((Ee = Re[Ce]) == null ? void 0 : Ee.year) && N === ((Ye = Re[Ce]) == null ? void 0 : Ye.month) : !1;
  }, Me = (N, fe) => {
    if (u.value.enabled) {
      const Ce = we();
      if (Array.isArray(i.value) && Array.isArray(Ce)) {
        const Re = pe(N, fe, 0) || pe(N, fe, 1), Ee = je(h(t()), { month: N, year: r.value(fe) });
        return k(i.value, ie.value, Ee) && !Re;
      }
      return !1;
    }
    return !1;
  }, F = S(() => (N) => C(q.value, (fe) => {
    var At;
    const Ce = X(N, fe.value), Re = m(
      fe.value,
      g(r.value(N), d.value.minDate),
      x(r.value(N), d.value.maxDate)
    ) || R(d.value.disabledDates, r.value(N), fe.value) || ((At = p.value.months) == null ? void 0 : At.includes(fe.value)) || !Q(d.value.allowedDates, r.value(N), fe.value) || te(r.value(N)), Ee = Me(fe.value, N), Ye = $(c.value, fe.value, r.value(N));
    return { active: Ce, disabled: Re, isBetween: Ee, highlighted: Ye };
  })), Z = (N, fe) => je(h(t()), { month: N, year: r.value(fe) }), ve = (N, fe) => {
    const Ce = i.value ? i.value : h(t());
    i.value = je(Ce, { month: N, year: r.value(fe) }), n("auto-apply"), n("update-flow-step");
  }, G = (N, fe) => {
    const Ce = Z(N, fe);
    u.value.fixedEnd || u.value.fixedStart ? i.value = _(Ce) : i.value ? w(Ce, i.value) && (i.value = D(Z(N, fe))) : i.value = [Z(N, fe)], Ke().then(() => {
      O(i.value, n, i.value.length < 2);
    });
  }, oe = (N, fe) => {
    I(Z(N, fe), f.value.limit), n("auto-apply", !0);
  }, be = (N, fe) => (l.value[fe].month = N, B(fe, l.value[fe].year, N), f.value.enabled ? oe(N, fe) : u.value.enabled ? G(N, fe) : ve(N, fe)), A = (N, fe) => {
    L(N, fe), B(fe, N, null);
  }, B = (N, fe, Ce) => {
    let Re = Ce;
    if (!Re && Re !== 0) {
      const Ee = we();
      Re = Array.isArray(Ee) ? Ee[N].month : Ee.month;
    }
    a("update-month-year", { instance: N, year: fe, month: Re });
  }, M = (N, fe) => {
    ie.value = Z(N, fe);
  }, V = (N) => {
    z({
      value: N
    }), n("auto-apply");
  }, R = (N, fe, Ce) => {
    if (N instanceof Map) {
      const Re = `${H(Ce + 1)}-${fe}`;
      return N.size ? N.has(Re) : !1;
    }
    return typeof N == "function" ? N(y(je(t(), { month: Ce, year: fe }), !0)) : !1;
  }, Q = (N, fe, Ce) => {
    if (N instanceof Map) {
      const Re = `${H(Ce + 1)}-${fe}`;
      return N.size ? N.has(Re) : !0;
    }
    return !0;
  };
  return {
    groupedMonths: F,
    groupedYears: ae,
    year: r,
    isDisabled: he,
    showYearPicker: Y,
    modelValue: i,
    toggleYearPicker: W,
    handleYearSelect: K,
    handleYear: de,
    presetDate: V,
    setHoverDate: M,
    selectMonth: be,
    selectYear: A,
    getModelMonthYear: we
  };
}, J0 = /* @__PURE__ */ ke({
  __name: "MonthPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply", "update-flow-step", "mount"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, l = Ht(), {
      rootProps: r,
      defaults: { config: i }
    } = Ze(), o = En(l, yn.YearMode);
    et(() => {
      a("mount");
    });
    const {
      groupedMonths: u,
      groupedYears: c,
      year: d,
      isDisabled: p,
      showYearPicker: f,
      modelValue: w,
      presetDate: m,
      setHoverDate: k,
      selectMonth: y,
      selectYear: h,
      toggleYearPicker: g,
      handleYearSelect: x,
      handleYear: $,
      getModelMonthYear: C
    } = X0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: w,
      year: d,
      getModelMonthYear: C,
      selectMonth: y,
      selectYear: h,
      handleYear: $
    }), presetDate: m, toggleYearPicker: (O) => g(0, O) }), (O, _) => (b(), ce(Kl, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: ue(({ instances: I, wrapClass: D }) => [
        (b(!0), T($e, null, Oe(I, (z) => (b(), T("div", {
          key: z,
          class: j(D)
        }, [
          O.$slots["top-extra"] ? U(O.$slots, "top-extra", {
            key: 0,
            value: v(w)
          }) : P("", !0),
          U(O.$slots, "month-year", lt({ ref_for: !0 }, {
            year: v(d),
            months: v(u)(z),
            years: v(c)(z),
            selectMonth: v(y),
            selectYear: v(h),
            instance: z
          }), () => [
            se(Ks, {
              items: v(u)(z),
              "is-last": v(r).autoApply && !v(i).keepActionRow,
              height: v(i).modeHeight,
              "no-overlay-focus": !!(e.noOverlayFocus || v(r).textInput),
              "use-relative": "",
              level: 0,
              type: "month",
              onSelected: (H) => v(y)(H, z),
              onHoverValue: (H) => v(k)(H, z)
            }, dt({
              header: ue(() => [
                se(Yd, {
                  items: v(c)(z),
                  instance: z,
                  "show-year-picker": v(f)[z],
                  year: v(d)(z),
                  "is-disabled": (H) => v(p)(z, H),
                  onHandleYear: (H) => v($)(z, H),
                  onYearSelect: (H) => v(x)(H, z),
                  onToggleYearPicker: (H) => v(g)(z, H == null ? void 0 : H.flow, H == null ? void 0 : H.show)
                }, dt({ _: 2 }, [
                  Oe(v(o), (H, ne) => ({
                    name: H,
                    fn: ue((te) => [
                      U(O.$slots, H, lt({ ref_for: !0 }, te))
                    ])
                  }))
                ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
              ]),
              _: 2
            }, [
              O.$slots["month-overlay-value"] ? {
                name: "item",
                fn: ue(({ item: H }) => [
                  U(O.$slots, "month-overlay-value", {
                    text: H.text,
                    value: H.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "onSelected", "onHoverValue"])
          ])
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), Q0 = (e, n) => {
  const {
    rootEmit: t,
    getDate: a,
    state: s,
    modelValue: l,
    rootProps: r,
    defaults: { highlight: i, multiDates: o, filters: u, range: c, safeDates: d }
  } = Ze(), { getYears: p } = jl(), { isDateBetween: f, resetDate: w, resetDateTime: m, getYearFromDate: k, checkHighlightYear: y, groupListAndMap: h } = Lt(), { checkRangeAutoApply: g, setMonthOrYearRange: x } = Zl(), { checkMinMaxValue: $, checkMinMaxRange: C } = un();
  Gs(() => {
    s.isTextInputDate && (_.value = We(a(r.startDate)));
  });
  const O = J(null), _ = J();
  et(() => {
    r.startDate && (l.value && r.focusStartDate || !l.value) && (_.value = We(a(r.startDate)));
  });
  const I = (q) => Array.isArray(l.value) ? l.value.some((ie) => We(ie) === q) : l.value ? We(l.value) === q : !1, D = (q) => c.value.enabled && Array.isArray(l.value) ? f(l.value, O.value, te(q)) : !1, z = (q) => {
    var ie;
    return (ie = d.value.allowedDates) != null && ie.size ? d.value.allowedDates.has(`${q}`) : !0;
  }, H = (q) => d.value.disabledDates instanceof Map ? d.value.disabledDates.size ? d.value.disabledDates.has(`${q}`) : !1 : typeof d.value.disabledDates == "function" ? d.value.disabledDates(vn(m(Za(a())), q)) : !0, ne = S(() => h(p(), (q) => {
    const ie = I(q.value), L = $(
      q.value,
      k(d.value.minDate),
      k(d.value.maxDate)
    ) || u.value.years.includes(q.value) || !z(q.value) || H(q.value), ae = D(q.value) && !ie, Y = y(i.value, q.value);
    return { active: ie, disabled: L, isBetween: ae, highlighted: Y };
  })), te = (q) => vn(w(Za(a())), q);
  return {
    groupedYears: ne,
    focusYear: _,
    setHoverValue: (q) => {
      O.value = vn(w(a()), q);
    },
    selectYear: (q) => {
      var ie;
      if (t("update-month-year", { instance: 0, year: q, month: Number.NaN }), o.value.enabled)
        return l.value ? Array.isArray(l.value) && (((ie = l.value) == null ? void 0 : ie.map((L) => We(L))).includes(q) ? l.value = l.value.filter((L) => We(L) !== q) : l.value.push(vn(m(a()), q))) : l.value = [vn(m(Za(a())), q)], n("auto-apply", !0);
      c.value.enabled ? C(te(q), l.value) && (l.value = x(te(q)), Ke().then(() => {
        g(l.value, n, l.value.length < 2);
      })) : (l.value = te(q), n("auto-apply"));
    }
  };
}, ew = /* @__PURE__ */ ke({
  __name: "YearPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      modelValue: l,
      defaults: { config: r },
      rootProps: i
    } = Ze(), { groupedYears: o, focusYear: u, selectYear: c, setHoverValue: d } = Q0(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: l,
      selectYear: c
    }) }), (p, f) => (b(), T("div", null, [
      p.$slots["top-extra"] ? U(p.$slots, "top-extra", {
        key: 0,
        value: v(l)
      }) : P("", !0),
      p.$slots["month-year"] ? U(p.$slots, "month-year", Mt(lt({ key: 1 }, {
        years: v(o),
        selectYear: v(c)
      }))) : (b(), ce(Ks, {
        key: 2,
        items: v(o),
        "is-last": v(i).autoApply && !v(r).keepActionRow,
        height: v(r).modeHeight,
        "no-overlay-focus": !!(e.noOverlayFocus || v(i).textInput),
        "focus-value": v(u),
        type: "year",
        "use-relative": "",
        onSelected: v(c),
        onHoverValue: v(d)
      }, dt({ _: 2 }, [
        p.$slots["year-overlay-value"] ? {
          name: "item",
          fn: ue(({ item: w }) => [
            U(p.$slots, "year-overlay-value", {
              text: w.text,
              value: w.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), tw = {
  key: 0,
  class: "dp__time_input"
}, nw = ["data-compact", "data-collapsed"], aw = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], sw = ["aria-label", "disabled", "data-dp-action-element", "data-test-id", "onKeydown", "onClick"], lw = ["data-test-id", "aria-label", "data-dp-action-element", "onKeydown", "onClick", "onMousedown"], rw = { key: 0 }, iw = ["aria-label", "data-dp-action-element", "data-compact"], ow = /* @__PURE__ */ ke({
  __name: "TimeInput",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    order: {},
    closeTimePickerBtn: {},
    disabledTimesConfig: {},
    validateTime: {}
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "overlay-opened", "overlay-closed", "set-hours", "set-minutes", "reset-flow", "mounted"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: l,
      rootEmit: r,
      rootProps: i,
      defaults: { ariaLabels: o, filters: u, config: c, range: d, multiCalendars: p, timeConfig: f }
    } = Ze(), { checkKeyDown: w, hoursToAmPmHours: m } = _t(), { boolHtmlAttribute: k } = us(), { sanitizeTime: y, groupListAndMap: h } = Lt(), { transitionName: g, showTransition: x } = js(), $ = ka({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), C = J("AM"), O = J(null), _ = J(), I = J(!1);
    et(() => {
      a("mounted");
    });
    const D = (R) => je(l(), {
      hours: R.hours,
      minutes: R.minutes,
      seconds: f.value.enableSeconds ? R.seconds : 0,
      milliseconds: 0
    }), z = S(() => i.timePicker || f.value.timePickerInline ? 0 : 1), H = S(
      () => (R) => Te(R, s[R]) || te(R, s[R])
    ), ne = S(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), te = (R, Q) => d.value.enabled && !d.value.disableTimeRangeValidation ? !s.validateTime(R, Q) : !1, q = (R, Q) => {
      if (d.value.enabled && !d.value.disableTimeRangeValidation) {
        const N = Q ? +f.value[`${R}Increment`] : -+f.value[`${R}Increment`], fe = s[R] + N;
        return !s.validateTime(R, fe);
      }
      return !1;
    }, ie = S(() => (R) => !F(+s[R] + +f.value[`${R}Increment`], R) || q(R, !0)), L = S(() => (R) => !F(+s[R] - +f.value[`${R}Increment`], R) || q(R, !1)), ae = (R, Q) => pd(je(l(), R), Q), Y = (R, Q) => Ab(je(l(), R), Q), W = S(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !f.value.timePickerInline,
        dp__time_col_reg_block: !f.value.enableSeconds && f.value.is24 && !f.value.timePickerInline,
        dp__time_col_reg_inline: !f.value.enableSeconds && f.value.is24 && f.value.timePickerInline,
        dp__time_col_reg_with_button: !f.value.enableSeconds && !f.value.is24,
        dp__time_col_sec: f.value.enableSeconds && f.value.is24,
        dp__time_col_sec_with_button: f.value.enableSeconds && !f.value.is24
      })
    ), K = S(
      () => f.value.timePickerInline && d.value.enabled && !p.value.count
    ), de = S(() => {
      const R = [{ type: "hours" }];
      return f.value.enableMinutes && R.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), f.value.enableSeconds && R.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), R;
    }), he = S(() => de.value.filter((R) => !R.separator)), me = S(() => (R) => {
      if (R === "hours") {
        const Q = A(+s.hours);
        return { text: Q < 10 ? `0${Q}` : `${Q}`, value: Q };
      }
      return { text: s[R] < 10 ? `0${s[R]}` : `${s[R]}`, value: s[R] };
    }), Te = (R, Q) => {
      var fe;
      if (!s.disabledTimesConfig) return !1;
      const N = s.disabledTimesConfig(s.order, R === "hours" ? Q : void 0);
      return N[R] ? !!((fe = N[R]) != null && fe.includes(Q)) : !0;
    }, we = (R, Q) => Q !== "hours" || C.value === "AM" ? R : R + 12, X = (R) => {
      const Q = f.value.is24 ? 24 : 12, N = R === "hours" ? Q : 60, fe = +f.value[`${R}GridIncrement`], Ce = R === "hours" && !f.value.is24 ? fe : 0, Re = [];
      for (let Ee = Ce; Ee < N; Ee += fe)
        Re.push({
          value: f.value.is24 ? Ee : we(Ee, R),
          text: Ee < 10 ? `0${Ee}` : `${Ee}`
        });
      return R === "hours" && !f.value.is24 && Re.unshift({ value: C.value === "PM" ? 12 : 0, text: "12" }), h(Re, (Ee) => ({ active: !1, disabled: u.value.times[R].includes(Ee.value) || !F(Ee.value, R) || Te(R, Ee.value) || te(R, Ee.value) }));
    }, pe = (R) => R >= 0 ? R : 59, Me = (R) => R >= 0 ? R : 23, F = (R, Q) => {
      const N = i.minTime ? D(y(i.minTime)) : null, fe = i.maxTime ? D(y(i.maxTime)) : null, Ce = D(
        y(
          ne.value,
          Q,
          Q === "minutes" || Q === "seconds" ? pe(R) : Me(R)
        )
      );
      return N && fe ? (Wn(Ce, fe) || Ya(Ce, fe)) && (Dn(Ce, N) || Ya(Ce, N)) : N ? Dn(Ce, N) || Ya(Ce, N) : fe ? Wn(Ce, fe) || Ya(Ce, fe) : !0;
    }, Z = (R) => f.value[`no${R[0].toUpperCase() + R.slice(1)}Overlay`], ve = (R) => {
      Z(R) || ($[R] = !$[R], $[R] ? (I.value = !0, a("overlay-opened", R)) : (I.value = !1, a("overlay-closed", R)));
    }, G = (R) => R === "hours" ? An : R === "minutes" ? Hn : la, oe = () => {
      _.value && clearTimeout(_.value);
    }, be = (R, Q = !0, N) => {
      const fe = Q ? ae : Y, Ce = Q ? +f.value[`${R}Increment`] : -+f.value[`${R}Increment`];
      F(+s[R] + Ce, R) && a(
        `update:${R}`,
        G(R)(
          fe({ [R]: +s[R] }, { [R]: +f.value[`${R}Increment`] })
        )
      ), !(N != null && N.keyboard) && c.value.timeArrowHoldThreshold && (_.value = setTimeout(() => {
        be(R, Q);
      }, c.value.timeArrowHoldThreshold));
    }, A = (R) => f.value.is24 ? R : (R >= 12 ? C.value = "PM" : C.value = "AM", m(R)), B = () => {
      C.value === "PM" ? (C.value = "AM", a("update:hours", s.hours - 12)) : (C.value = "PM", a("update:hours", s.hours + 12)), r("am-pm-change", C.value);
    }, M = (R) => {
      $[R] = !0;
    }, V = (R, Q) => (ve(R), a(`update:${R}`, Q));
    return n({ openChildCmp: M }), (R, Q) => v(i).disabled ? P("", !0) : (b(), T("div", tw, [
      (b(!0), T($e, null, Oe(de.value, (N, fe) => {
        var Ce, Re, Ee;
        return b(), T("div", {
          key: fe,
          class: j(W.value),
          "data-compact": K.value && !v(f).enableSeconds,
          "data-collapsed": K.value && v(f).enableSeconds
        }, [
          N.separator ? (b(), T($e, { key: 0 }, [
            I.value ? P("", !0) : (b(), T($e, { key: 0 }, [
              He(":")
            ], 64))
          ], 64)) : (b(), T($e, { key: 1 }, [
            E("button", {
              type: "button",
              class: j({
                dp__btn: !0,
                dp__inc_dec_button: !v(f).timePickerInline,
                dp__inc_dec_button_inline: v(f).timePickerInline,
                dp__tp_inline_btn_top: v(f).timePickerInline,
                dp__inc_dec_button_disabled: ie.value(N.type),
                "dp--hidden-el": I.value
              }),
              "data-test-id": `${N.type}-time-inc-btn-${s.order}`,
              "aria-label": (Ce = v(o)) == null ? void 0 : Ce.incrementValue(N.type),
              tabindex: "0",
              "data-dp-action-element": z.value,
              onKeydown: (Ye) => v(w)(Ye, () => be(N.type, !0, { keyboard: !0 }), !0),
              onClick: (Ye) => v(c).timeArrowHoldThreshold ? void 0 : be(N.type, !0),
              onMousedown: (Ye) => v(c).timeArrowHoldThreshold ? be(N.type, !0) : void 0,
              onMouseup: oe
            }, [
              v(f).timePickerInline ? U(R.$slots, "tp-inline-arrow-up", { key: 1 }, () => [
                Q[2] || (Q[2] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Q[3] || (Q[3] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : U(R.$slots, "arrow-up", { key: 0 }, () => [
                se(v(Fd))
              ])
            ], 42, aw),
            E("button", {
              type: "button",
              "aria-label": `${me.value(N.type).text}-${(Re = v(o)) == null ? void 0 : Re.openTpOverlay(N.type)}`,
              class: j({
                dp__time_display: !0,
                dp__time_display_block: !v(f).timePickerInline,
                dp__time_display_inline: v(f).timePickerInline,
                "dp--time-invalid": H.value(N.type),
                "dp--time-overlay-btn": !H.value(N.type),
                "dp--hidden-el": I.value
              }),
              disabled: v(k)(Z(N.type)),
              tabindex: "0",
              "data-dp-action-element": z.value,
              "data-test-id": `${N.type}-toggle-overlay-btn-${s.order}`,
              onKeydown: (Ye) => v(w)(Ye, () => ve(N.type), !0),
              onClick: (Ye) => ve(N.type)
            }, [
              U(R.$slots, N.type, {
                text: me.value(N.type).text,
                value: me.value(N.type).value
              }, () => [
                He(le(me.value(N.type).text), 1)
              ])
            ], 42, sw),
            E("button", {
              type: "button",
              class: j({
                dp__btn: !0,
                dp__inc_dec_button: !v(f).timePickerInline,
                dp__inc_dec_button_inline: v(f).timePickerInline,
                dp__tp_inline_btn_bottom: v(f).timePickerInline,
                dp__inc_dec_button_disabled: L.value(N.type),
                "dp--hidden-el": I.value
              }),
              "data-test-id": `${N.type}-time-dec-btn-${s.order}`,
              "aria-label": (Ee = v(o)) == null ? void 0 : Ee.decrementValue(N.type),
              tabindex: "0",
              "data-dp-action-element": z.value,
              onKeydown: (Ye) => v(w)(Ye, () => be(N.type, !1, { keyboard: !0 }), !0),
              onClick: (Ye) => v(c).timeArrowHoldThreshold ? void 0 : be(N.type, !1),
              onMousedown: (Ye) => v(c).timeArrowHoldThreshold ? be(N.type, !1) : void 0,
              onMouseup: oe
            }, [
              v(f).timePickerInline ? U(R.$slots, "tp-inline-arrow-down", { key: 1 }, () => [
                Q[4] || (Q[4] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                Q[5] || (Q[5] = E("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ]) : U(R.$slots, "arrow-down", { key: 0 }, () => [
                se(v(Ld))
              ])
            ], 42, lw)
          ], 64))
        ], 10, nw);
      }), 128)),
      v(f).is24 ? P("", !0) : (b(), T("div", rw, [
        U(R.$slots, "am-pm-button", {
          toggle: B,
          value: C.value
        }, () => {
          var N;
          return [
            E("button", {
              ref_key: "amPmButton",
              ref: O,
              type: "button",
              class: "dp__pm_am_button",
              role: "button",
              "aria-label": (N = v(o)) == null ? void 0 : N.amPmButton,
              tabindex: "0",
              "data-dp-action-element": z.value,
              "data-compact": K.value,
              onClick: B,
              onKeydown: Q[0] || (Q[0] = (fe) => v(w)(fe, () => B(), !0))
            }, le(C.value), 41, iw)
          ];
        })
      ])),
      (b(!0), T($e, null, Oe(he.value, (N, fe) => (b(), ce(ht, {
        key: fe,
        name: v(g)($[N.type]),
        css: v(x)
      }, {
        default: ue(() => {
          var Ce, Re;
          return [
            $[N.type] ? (b(), ce(Ks, {
              key: 0,
              items: X(N.type),
              "is-last": v(i).autoApply && !v(c).keepActionRow,
              type: N.type,
              "aria-labels": v(o),
              level: v(f).timePickerInline || v(i).timePicker ? 1 : 2,
              "overlay-label": (Re = (Ce = v(o)).timeOverlay) == null ? void 0 : Re.call(Ce, N.type),
              onSelected: (Ee) => V(N.type, Ee),
              onToggle: (Ee) => ve(N.type),
              onResetFlow: Q[1] || (Q[1] = (Ee) => R.$emit("reset-flow"))
            }, dt({
              "button-icon": ue(() => [
                U(R.$slots, "clock-icon", {}, () => [
                  R.$slots["clock-icon"] ? P("", !0) : (b(), ce(mt(v(f).timePickerInline ? v(qs) : v(Vd)), { key: 0 }))
                ])
              ]),
              _: 2
            }, [
              R.$slots[`${N.type}-overlay-value`] ? {
                name: "item",
                fn: ue(({ item: Ee }) => [
                  U(R.$slots, `${N.type}-overlay-value`, {
                    text: Ee.text,
                    value: Ee.value
                  })
                ]),
                key: "0"
              } : void 0,
              R.$slots[`${N.type}-overlay-header`] ? {
                name: "header",
                fn: ue(() => [
                  U(R.$slots, `${N.type}-overlay-header`, {
                    toggle: () => ve(N.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "type", "aria-labels", "level", "overlay-label", "onSelected", "onToggle"])) : P("", !0)
          ];
        }),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), uw = ["data-dp-mobile"], cw = ["aria-label", "tabindex"], dw = ["role", "aria-label", "tabindex"], fw = ["aria-label"], Ud = /* @__PURE__ */ ke({
  __name: "TimePicker",
  props: {
    hours: {},
    minutes: {},
    seconds: {},
    disabledTimesConfig: { type: [Function, null] },
    noOverlayFocus: { type: Boolean },
    validateTime: { type: Function }
  },
  emits: ["update:hours", "update:minutes", "update:seconds", "mount", "reset-flow"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      setState: r,
      modelValue: i,
      rootProps: o,
      defaults: { ariaLabels: u, textInput: c, config: d, range: p, timeConfig: f }
    } = Ze(), { isModelAuto: w } = Lt(), { checkKeyDown: m, findFocusableEl: k } = _t(), { transitionName: y, showTransition: h } = js(), { hideNavigationButtons: g } = Gl(), { isMobile: x } = ql(), $ = Ht(), C = Ge("overlay"), O = Ge("close-tp-btn"), _ = Ge("tp-input"), I = J(!1);
    et(() => {
      a("mount");
    });
    const D = S(() => p.value.enabled && o.modelAuto ? w(i.value) : !0), z = J(!1), H = (me) => ({
      hours: Array.isArray(s.hours) ? s.hours[me] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[me] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[me] : s.seconds
    }), ne = S(() => {
      const me = [];
      if (p.value.enabled)
        for (let Te = 0; Te < 2; Te++)
          me.push(H(Te));
      else
        me.push(H(0));
      return me;
    }), te = (me, Te = !1, we = "") => {
      Te || a("reset-flow"), z.value = me, r("arrowNavigationLevel", me ? 1 : 0), l("overlay-toggle", { open: me, overlay: Nt.time }), Ke(() => {
        var X;
        we !== "" && ((X = _.value) != null && X[0]) && _.value[0].openChildCmp(we);
      });
    }, q = S(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !d.value.keepActionRow
    })), ie = En($, yn.TimeInput), L = (me, Te, we) => p.value.enabled ? Te === 0 ? [me, ne.value[1][we]] : [ne.value[0][we], me] : me, ae = (me) => {
      a("update:hours", me);
    }, Y = (me) => {
      a("update:minutes", me);
    }, W = (me) => {
      a("update:seconds", me);
    }, K = () => {
      if (C.value && !c.value.enabled && !s.noOverlayFocus) {
        const me = k(C.value);
        me && me.focus({ preventScroll: !0 });
      }
    }, de = (me) => {
      I.value = !1, l("overlay-toggle", { open: !1, overlay: me });
    }, he = (me) => {
      I.value = !0, l("overlay-toggle", { open: !0, overlay: me });
    };
    return n({ toggleTimePicker: te }), (me, Te) => {
      var we;
      return b(), T("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": v(x)
      }, [
        !v(o).timePicker && !v(f).timePickerInline ? Gt((b(), T("button", {
          key: 0,
          ref: "open-tp-btn",
          type: "button",
          "data-dp-action-element": "0",
          class: j({ ...q.value, "dp--hidden-el": z.value }),
          "aria-label": (we = v(u)) == null ? void 0 : we.openTimePicker,
          tabindex: e.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: Te[0] || (Te[0] = (X) => v(m)(X, () => te(!0))),
          onClick: Te[1] || (Te[1] = (X) => te(!0))
        }, [
          U(me.$slots, "clock-icon", {}, () => [
            se(v(Vd))
          ])
        ], 42, cw)), [
          [Bn, !v(g)("time")]
        ]) : P("", !0),
        se(ht, {
          name: v(y)(z.value),
          css: v(h) && !v(f).timePickerInline
        }, {
          default: ue(() => {
            var X, pe;
            return [
              z.value || v(o).timePicker || v(f).timePickerInline ? (b(), T("div", {
                key: 0,
                ref: "overlay",
                role: v(f).timePickerInline ? void 0 : "dialog",
                class: j({
                  dp__overlay: !v(f).timePickerInline,
                  "dp--overlay-absolute": !v(o).timePicker && !v(f).timePickerInline,
                  "dp--overlay-relative": v(o).timePicker
                }),
                style: Fe(v(o).timePicker ? { height: `${v(d).modeHeight}px` } : void 0),
                "aria-label": (X = v(u)) == null ? void 0 : X.timePicker,
                tabindex: v(f).timePickerInline ? void 0 : 0
              }, [
                E("div", {
                  class: j(
                    v(f).timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  U(me.$slots, "time-picker-overlay", {
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: ae,
                    setMinutes: Y,
                    setSeconds: W
                  }, () => [
                    E("div", {
                      class: j(v(f).timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                    }, [
                      (b(!0), T($e, null, Oe(ne.value, (Me, F) => Gt((b(), ce(ow, lt({ key: F }, { ref_for: !0 }, {
                        order: F,
                        hours: Me.hours,
                        minutes: Me.minutes,
                        seconds: Me.seconds,
                        closeTimePickerBtn: O.value,
                        disabledTimesConfig: e.disabledTimesConfig,
                        disabled: F === 0 ? v(p).fixedStart : v(p).fixedEnd
                      }, {
                        ref_for: !0,
                        ref: "tp-input",
                        "validate-time": (Z, ve) => e.validateTime(Z, L(ve, F, Z)),
                        "onUpdate:hours": (Z) => ae(L(Z, F, "hours")),
                        "onUpdate:minutes": (Z) => Y(L(Z, F, "minutes")),
                        "onUpdate:seconds": (Z) => W(L(Z, F, "seconds")),
                        onMounted: K,
                        onOverlayClosed: de,
                        onOverlayOpened: he
                      }), dt({ _: 2 }, [
                        Oe(v(ie), (Z, ve) => ({
                          name: Z,
                          fn: ue((G) => [
                            U(me.$slots, Z, lt({ ref_for: !0 }, G))
                          ])
                        }))
                      ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                        [Bn, F === 0 ? !0 : D.value]
                      ])), 128))
                    ], 2)
                  ]),
                  !v(o).timePicker && !v(f).timePickerInline ? Gt((b(), T("button", {
                    key: 0,
                    ref: "close-tp-btn",
                    "data-dp-action-element": "1",
                    type: "button",
                    class: j({ ...q.value, "dp--hidden-el": I.value }),
                    "aria-label": (pe = v(u)) == null ? void 0 : pe.closeTimePicker,
                    tabindex: "0",
                    onKeydown: Te[2] || (Te[2] = (Me) => v(m)(Me, () => te(!1))),
                    onClick: Te[3] || (Te[3] = (Me) => te(!1))
                  }, [
                    U(me.$slots, "calendar-icon", {}, () => [
                      se(v(qs))
                    ])
                  ], 42, fw)), [
                    [Bn, !v(g)("time")]
                  ]) : P("", !0)
                ], 2)
              ], 14, dw)) : P("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, uw);
    };
  }
}), qd = (e) => {
  const {
    getDate: n,
    modelValue: t,
    time: a,
    rootProps: s,
    defaults: { range: l, timeConfig: r }
  } = Ze(), { isDateEqual: i, setTime: o } = Lt(), u = (O, _) => Array.isArray(a[O]) ? a[O][_] : a[O], c = (O) => r.value.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[O] : a.seconds : 0, d = (O, _) => O ? o(
    _ !== void 0 ? { hours: u("hours", _), minutes: u("minutes", _), seconds: c(_) } : { hours: a.hours, minutes: a.minutes, seconds: c() },
    O
  ) : Ib(n(), c(_)), p = (O, _) => {
    a[O] = _;
  }, f = S(() => s.modelAuto && l.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : l.value.enabled), w = (O, _) => {
    const I = Object.fromEntries(
      Object.keys(a).map((D) => D === O ? [D, _] : [D, a[D]].slice())
    );
    if (f.value && !l.value.disableTimeRangeValidation) {
      const D = (H) => t.value ? o(
        {
          hours: I.hours[H],
          minutes: I.minutes[H],
          seconds: I.seconds[H]
        },
        t.value[H]
      ) : null, z = (H) => Eb(t.value[H], 0);
      return !(i(D(0), D(1)) && (Dn(D(0), z(1)) || Wn(D(1), z(0))));
    }
    return !0;
  }, m = (O, _) => {
    w(O, _) && (p(O, _), e && e());
  }, k = (O) => {
    m("hours", O);
  }, y = (O) => {
    m("minutes", O);
  }, h = (O) => {
    m("seconds", O);
  }, g = (O, _) => {
    k(O.hours), y(O.minutes), h(O.seconds), t.value && _(t.value);
  }, x = (O) => {
    if (O) {
      const _ = Array.isArray(O), I = _ ? [+O[0].hours, +O[1].hours] : +O.hours, D = _ ? [+O[0].minutes, +O[1].minutes] : +O.minutes, z = _ ? [+(O[0].seconds ?? 0), +(O[1].seconds ?? 0)] : +(O.seconds ?? 0);
      p("hours", I), p("minutes", D), r.value.enableSeconds && p("seconds", z);
    }
  }, $ = (O, _) => {
    const I = {
      hours: Array.isArray(a.hours) ? a.hours[O] : a.hours,
      disabledArr: []
    };
    return (_ || _ === 0) && (I.hours = _), Array.isArray(s.disabledTimes) && (I.disabledArr = l.value.enabled && Array.isArray(s.disabledTimes[O]) ? s.disabledTimes[O] : s.disabledTimes), I;
  }, C = S(() => (O, _) => {
    var I;
    if (Array.isArray(s.disabledTimes)) {
      const { disabledArr: D, hours: z } = $(O, _), H = D.filter((ne) => +ne.hours === z);
      return ((I = H[0]) == null ? void 0 : I.minutes) === "*" ? { hours: [z], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (H == null ? void 0 : H.map((ne) => +ne.minutes)) ?? [],
        seconds: (H == null ? void 0 : H.map((ne) => ne.seconds ? +ne.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    assignTime: p,
    updateHours: k,
    updateMinutes: y,
    updateSeconds: h,
    getSetDateTime: d,
    updateTimeValues: g,
    getSecondsValue: c,
    assignStartTime: x,
    validateTime: w,
    disabledTimesConfig: C
  };
}, hw = (e) => {
  const {
    getDate: n,
    time: t,
    modelValue: a,
    state: s,
    defaults: { startTime: l, range: r, timeConfig: i }
  } = Ze(), { getTimeObj: o } = Lt();
  Gs(() => {
    s.isTextInputDate && $();
  });
  const { updateTimeValues: u, getSetDateTime: c, assignTime: d, assignStartTime: p, disabledTimesConfig: f, validateTime: w } = qd(m);
  function m() {
    e("update-flow-step");
  }
  const k = (O) => {
    const { hours: _, minutes: I, seconds: D } = O;
    return { hours: +_, minutes: +I, seconds: D ? +D : 0 };
  }, y = () => {
    if (i.value.startTime) {
      if (Array.isArray(i.value.startTime)) {
        const _ = k(i.value.startTime[0]), I = k(i.value.startTime[1]);
        return [je(n(), _), je(n(), I)];
      }
      const O = k(i.value.startTime);
      return je(n(), O);
    }
    return r.value.enabled ? [null, null] : null;
  }, h = () => {
    if (r.value.enabled) {
      const [O, _] = y();
      a.value = [c(O, 0), c(_, 1)];
    } else
      a.value = c(y());
  }, g = (O) => Array.isArray(O) ? [o(n(O[0])), o(n(O[1]))] : [o(O ?? n())], x = (O, _, I) => {
    d("hours", O), d("minutes", _), d("seconds", i.value.enableSeconds ? I : 0);
  }, $ = () => {
    const [O, _] = g(a.value);
    return r.value.enabled ? x(
      [O.hours, _.hours],
      [O.minutes, _.minutes],
      [O.seconds, _.seconds]
    ) : x(O.hours, O.minutes, O.seconds);
  };
  et(() => (p(l.value), a.value ? $() : h()));
  const C = () => {
    Array.isArray(a.value) ? a.value = a.value.map((O, _) => O && c(O, _)) : a.value = c(a.value), e("time-update");
  };
  return {
    modelValue: a,
    time: t,
    disabledTimesConfig: f,
    validateTime: w,
    updateTime: (O) => {
      u(O, C);
    }
  };
}, mw = /* @__PURE__ */ ke({
  __name: "TimePickerSolo",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["time-update", "mount", "reset-flow", "update-flow-step"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ht(), l = En(s, yn.TimePicker), r = Ge("time-input"), { time: i, modelValue: o, disabledTimesConfig: u, updateTime: c, validateTime: d } = hw(a);
    return et(() => {
      a("mount");
    }), n({ getSidebarProps: () => ({
      modelValue: o,
      time: i,
      updateTime: c
    }), toggleTimePicker: (p, f = !1, w = "") => {
      var m;
      (m = r.value) == null || m.toggleTimePicker(p, f, w);
    } }), (p, f) => (b(), ce(Kl, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: ue(({ wrapClass: w }) => [
        E("div", {
          class: j(w)
        }, [
          se(Ud, lt({ ref: "time-input" }, p.$props, {
            hours: v(i).hours,
            minutes: v(i).minutes,
            seconds: v(i).seconds,
            "disabled-times-config": v(u),
            "validate-time": v(d),
            "onUpdate:hours": f[0] || (f[0] = (m) => v(c)({ hours: m, minutes: v(i).minutes, seconds: v(i).seconds })),
            "onUpdate:minutes": f[1] || (f[1] = (m) => v(c)({ hours: v(i).hours, minutes: m, seconds: v(i).seconds })),
            "onUpdate:seconds": f[2] || (f[2] = (m) => v(c)({ hours: v(i).hours, minutes: v(i).minutes, seconds: m })),
            onResetFlow: f[3] || (f[3] = (m) => p.$emit("reset-flow"))
          }), dt({ _: 2 }, [
            Oe(v(l), (m, k) => ({
              name: m,
              fn: ue((y) => [
                U(p.$slots, m, Mt(zt(y)))
              ])
            }))
          ]), 1040, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time"])
        ], 2)
      ]),
      _: 3
    }));
  }
}), vw = (e, n) => {
  const {
    getDate: t,
    rootProps: a,
    defaults: { filters: s }
  } = Ze(), { validateMonthYearInRange: l, validateMonthYear: r } = un(), i = (p, f) => {
    let w = p;
    return s.value.months.includes(Xe(w)) ? (w = f ? gn(p, 1) : ns(p, 1), i(w, f)) : w;
  }, o = (p, f) => {
    let w = p;
    return s.value.years.includes(We(w)) ? (w = f ? Ei(p, 1) : Id(p, 1), o(w, f)) : w;
  }, u = (p, f = !1) => {
    const w = je(t(), { month: e.month, year: e.year });
    let m = p ? gn(w, 1) : ns(w, 1);
    a.disableYearSelect && (m = vn(m, e.year));
    let k = Xe(m), y = We(m);
    s.value.months.includes(k) && (m = i(m, p), k = Xe(m), y = We(m)), s.value.years.includes(y) && (m = o(m, p), y = We(m)), l(k, y, p, a.preventMinMaxNavigation) && c(k, y, f);
  }, c = (p, f, w = !1) => {
    n("update-month-year", { month: p, year: f, fromNav: w });
  }, d = S(() => (p) => r(
    je(t(), { month: e.month, year: e.year }),
    a.preventMinMaxNavigation,
    p
  ));
  return { handleMonthYearChange: u, isDisabled: d, updateMonthYear: c };
}, pw = { class: "dp--header-wrap" }, gw = {
  key: 0,
  class: "dp__month_year_wrap"
}, yw = { key: 0 }, bw = { class: "dp__month_year_wrap" }, ww = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], kw = /* @__PURE__ */ ke({
  __name: "DpHeader",
  props: {
    month: {},
    year: {},
    instance: {},
    years: {},
    months: {},
    menuWrapRef: {}
  },
  emits: ["mount", "reset-flow", "update-month-year"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      rootEmit: l,
      rootProps: r,
      modelValue: i,
      defaults: { ariaLabels: o, filters: u, config: c, highlight: d, safeDates: p, ui: f }
    } = Ze(), { transitionName: w, showTransition: m } = js(), { showLeftIcon: k, showRightIcon: y } = Gl(), { handleMonthYearChange: h, isDisabled: g, updateMonthYear: x } = vw(s, a), { getMaxMonth: $, getMinMonth: C, getYearFromDate: O, groupListAndMap: _, checkHighlightYear: I, checkHighlightMonth: D } = Lt(), { checkKeyDown: z } = _t(), { formatYear: H } = ra(), { checkMinMaxValue: ne } = un(), { boolHtmlAttribute: te } = us(), q = J(!1), ie = J(!1), L = J(!1);
    et(() => {
      a("mount");
    });
    const ae = (Z) => ({
      get: () => s[Z],
      set: (ve) => {
        const G = Z === hn.month ? hn.year : hn.month;
        a("update-month-year", { [Z]: ve, [G]: s[G] }), Z === hn.month ? we(!0) : X(!0);
      }
    }), Y = S(ae(hn.month)), W = S(ae(hn.year)), K = S(() => (Z) => ({
      month: s.month,
      year: s.year,
      items: Z === hn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: x,
      toggle: Z === hn.month ? we : X
    })), de = S(() => s.months.find((ve) => ve.value === s.month) || { text: "", value: 0 }), he = S(() => _(s.months, (Z) => {
      const ve = s.month === Z.value, G = ne(
        Z.value,
        C(s.year, p.value.minDate),
        $(s.year, p.value.maxDate)
      ) || u.value.months.includes(Z.value), oe = D(d.value, Z.value, s.year);
      return { active: ve, disabled: G, highlighted: oe };
    })), me = S(() => _(s.years, (Z) => {
      const ve = s.year === Z.value, G = ne(
        Z.value,
        O(p.value.minDate),
        O(p.value.maxDate)
      ) || u.value.years.includes(Z.value), oe = I(d.value, Z.value);
      return { active: ve, disabled: G, highlighted: oe };
    })), Te = (Z, ve, G) => {
      G === void 0 ? Z.value = !Z.value : Z.value = G, Z.value ? (L.value = !0, l("overlay-toggle", { open: !0, overlay: ve })) : (L.value = !1, l("overlay-toggle", { open: !1, overlay: ve }));
    }, we = (Z = !1, ve) => {
      pe(Z), Te(q, Nt.month, ve);
    }, X = (Z = !1, ve) => {
      pe(Z), Te(ie, Nt.year, ve);
    }, pe = (Z) => {
      Z || a("reset-flow");
    }, Me = S(() => {
      var Z, ve, G, oe, be, A;
      return [
        {
          type: hn.month,
          index: 1,
          toggle: we,
          modelValue: Y.value,
          updateModelValue: (B) => Y.value = B,
          text: de.value.text,
          showSelectionGrid: q.value,
          items: he.value,
          ariaLabel: (Z = o.value) == null ? void 0 : Z.openMonthsOverlay,
          overlayLabel: ((G = (ve = o.value).monthPicker) == null ? void 0 : G.call(ve, !0)) ?? void 0
        },
        {
          type: hn.year,
          index: 2,
          toggle: X,
          modelValue: W.value,
          updateModelValue: (B) => W.value = B,
          text: H(s.year),
          showSelectionGrid: ie.value,
          items: me.value,
          ariaLabel: (oe = o.value) == null ? void 0 : oe.openYearsOverlay,
          overlayLabel: ((A = (be = o.value).yearPicker) == null ? void 0 : A.call(be, !0)) ?? void 0
        }
      ];
    }), F = S(() => r.disableYearSelect ? [Me.value[0]] : r.yearFirst ? [...Me.value].reverse() : Me.value);
    return n({
      toggleMonthPicker: we,
      toggleYearPicker: X,
      handleMonthYearChange: h
    }), (Z, ve) => {
      var G, oe, be, A, B, M;
      return b(), T("div", pw, [
        Z.$slots["month-year"] ? (b(), T("div", gw, [
          U(Z.$slots, "month-year", Mt(zt({
            month: e.month,
            year: e.year,
            months: e.months,
            years: e.years,
            updateMonthYear: v(x),
            handleMonthYearChange: v(h),
            instance: e.instance,
            isDisabled: v(g)
          })))
        ])) : (b(), T($e, { key: 1 }, [
          Z.$slots["top-extra"] ? (b(), T("div", yw, [
            U(Z.$slots, "top-extra", { value: v(i) })
          ])) : P("", !0),
          E("div", bw, [
            v(k)(e.instance) && !v(r).vertical ? (b(), ce(Os, {
              key: 0,
              "aria-label": (G = v(o)) == null ? void 0 : G.prevMonth,
              disabled: v(te)(v(g)(!1)),
              class: j((oe = v(f)) == null ? void 0 : oe.navBtnPrev),
              "el-name": "action-prev",
              onActivate: ve[0] || (ve[0] = (V) => v(h)(!1, !0))
            }, {
              default: ue(() => [
                Z.$slots["arrow-left"] ? U(Z.$slots, "arrow-left", { key: 0 }) : P("", !0),
                Z.$slots["arrow-left"] ? P("", !0) : (b(), ce(v(Pd), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
            E("div", {
              class: j(["dp__month_year_wrap", {
                dp__year_disable_select: v(r).disableYearSelect
              }])
            }, [
              (b(!0), T($e, null, Oe(F.value, (V) => (b(), T($e, {
                key: V.type
              }, [
                E("button", {
                  type: "button",
                  "data-dp-element": `overlay-${V.type}`,
                  class: j(["dp__btn dp__month_year_select", { "dp--hidden-el": L.value }]),
                  "aria-label": `${V.text}-${V.ariaLabel}`,
                  "data-test-id": `${V.type}-toggle-overlay-${e.instance}`,
                  tabindex: "0",
                  "data-dp-action-element": "0",
                  onClick: (R) => V.toggle(!1),
                  onKeydown: (R) => v(z)(R, () => V.toggle(), !0)
                }, [
                  Z.$slots[V.type] ? U(Z.$slots, V.type, {
                    key: 0,
                    text: V.text,
                    value: s[V.type]
                  }) : P("", !0),
                  Z.$slots[V.type] ? P("", !0) : (b(), T($e, { key: 1 }, [
                    He(le(V.text), 1)
                  ], 64))
                ], 42, ww),
                se(ht, {
                  name: v(w)(V.showSelectionGrid),
                  css: v(m)
                }, {
                  default: ue(() => [
                    V.showSelectionGrid ? (b(), ce(Ks, {
                      key: 0,
                      items: V.items,
                      "is-last": v(r).autoApply && !v(c).keepActionRow,
                      "skip-button-ref": !1,
                      type: V.type,
                      "header-refs": [],
                      "menu-wrap-ref": e.menuWrapRef,
                      "overlay-label": V.overlayLabel,
                      onSelected: V.updateModelValue,
                      onToggle: V.toggle
                    }, dt({
                      "button-icon": ue(() => [
                        Z.$slots["calendar-icon"] ? U(Z.$slots, "calendar-icon", { key: 0 }) : P("", !0),
                        Z.$slots["calendar-icon"] ? P("", !0) : (b(), ce(v(qs), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      Z.$slots[`${V.type}-overlay-value`] ? {
                        name: "item",
                        fn: ue(({ item: R }) => [
                          U(Z.$slots, `${V.type}-overlay-value`, {
                            text: R.text,
                            value: R.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      Z.$slots[`${V.type}-overlay`] ? {
                        name: "overlay",
                        fn: ue(() => [
                          U(Z.$slots, `${V.type}-overlay`, lt({ ref_for: !0 }, K.value(V.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      Z.$slots[`${V.type}-overlay-header`] ? {
                        name: "header",
                        fn: ue(() => [
                          U(Z.$slots, `${V.type}-overlay-header`, {
                            toggle: V.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "is-last", "type", "menu-wrap-ref", "overlay-label", "onSelected", "onToggle"])) : P("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            v(k)(e.instance) && v(r).vertical ? (b(), ce(Os, {
              key: 1,
              "aria-label": (be = v(o)) == null ? void 0 : be.prevMonth,
              "el-name": "action-prev",
              disabled: v(te)(v(g)(!1)),
              class: j((A = v(f)) == null ? void 0 : A.navBtnPrev),
              onActivate: ve[1] || (ve[1] = (V) => v(h)(!1, !0))
            }, {
              default: ue(() => [
                Z.$slots["arrow-up"] ? U(Z.$slots, "arrow-up", { key: 0 }) : P("", !0),
                Z.$slots["arrow-up"] ? P("", !0) : (b(), ce(v(Fd), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : P("", !0),
            v(y)(e.instance) ? (b(), ce(Os, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: v(te)(v(g)(!0)),
              "aria-label": (B = v(o)) == null ? void 0 : B.nextMonth,
              class: j((M = v(f)) == null ? void 0 : M.navBtnNext),
              onActivate: ve[2] || (ve[2] = (V) => v(h)(!0, !0))
            }, {
              default: ue(() => [
                Z.$slots[v(r).vertical ? "arrow-down" : "arrow-right"] ? U(Z.$slots, v(r).vertical ? "arrow-down" : "arrow-right", { key: 0 }) : P("", !0),
                Z.$slots[v(r).vertical ? "arrow-down" : "arrow-right"] ? P("", !0) : (b(), ce(mt(v(r).vertical ? v(Ld) : v(Rd)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : P("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), xw = {
  class: "dp__calendar_header",
  role: "row"
}, Sw = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, $w = ["aria-label"], Tw = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, Cw = { class: "dp__cell_inner" }, Mw = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "data-dp-element-active", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], Dw = /* @__PURE__ */ ke({
  __name: "DpCalendar",
  props: {
    instance: {},
    mappedDates: {},
    month: {},
    year: {}
  },
  emits: ["mount", "select-date", "set-hover-date", "handle-scroll", "handle-swipe"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      getDate: l,
      rootEmit: r,
      rootProps: i,
      defaults: { transitions: o, config: u, ariaLabels: c, multiCalendars: d, weekNumbers: p, multiDates: f, ui: w }
    } = Ze(), { isDateAfter: m, isDateEqual: k, resetDateTime: y, getCellId: h } = Lt(), { checkKeyDown: g, checkStopPropagation: x, isTouchDevice: $ } = _t(), { formatWeekDay: C } = ra(), O = Ge("calendar-wrap"), _ = Ge("active-tooltip"), I = J([]), D = J(null), z = J(!0), H = J(!1), ne = J(""), te = J({
      bottom: "",
      left: "",
      transform: ""
    }), q = J({ left: "50%" });
    _p(O, {
      onSwipeEnd: (M, V) => {
        u.value.noSwipe || (i.vertical ? (V === "up" || V === "down") && a("handle-swipe", V === "up" ? "left" : "right") : (V === "left" || V === "right") && a("handle-swipe", V === "right" ? "left" : "right"));
      }
    });
    const ie = S(() => i.calendar ? i.calendar(s.mappedDates) : s.mappedDates), L = S(() => i.dayNames ? Array.isArray(i.dayNames) ? i.dayNames : i.dayNames() : B());
    et(() => {
      a("mount", { cmp: "calendar", dayRefs: I.value }), u.value.monthChangeOnScroll && O.value && O.value.addEventListener("wheel", Z, { passive: !1 });
    }), Jt(() => {
      u.value.monthChangeOnScroll && O.value && O.value.removeEventListener("wheel", Z);
    });
    const ae = (M) => M ? i.vertical ? "vNext" : "next" : i.vertical ? "vPrevious" : "previous", Y = (M, V) => {
      if (i.transitions) {
        const R = y(je(l(), { month: s.month, year: s.year }));
        ne.value = m(y(je(l(), { month: M, year: V })), R) ? o.value[ae(!0)] : o.value[ae(!1)], z.value = !1, Ke(() => {
          z.value = !0;
        });
      }
    }, W = S(
      () => ({
        ...w.value.calendar
      })
    ), K = (M) => ({ type: "dot", ...M }), de = S(() => (M) => {
      const V = K(M);
      return {
        dp__marker_dot: V.type === "dot",
        dp__marker_line: V.type === "line"
      };
    }), he = S(() => (M) => k(M, D.value)), me = S(() => ({
      dp__calendar: !0,
      dp__calendar_next: d.value.count > 0 && s.instance !== 0
    })), Te = S(() => (M) => i.hideOffsetDates ? M.current : !0), we = async (M, V) => {
      var Ce;
      const { width: R, height: Q } = M.getBoundingClientRect();
      D.value = V.value;
      let N = { left: `${R / 2}px` }, fe = -50;
      if (await Ke(), (Ce = _.value) == null ? void 0 : Ce[0]) {
        const { left: Re, width: Ee } = _.value[0].getBoundingClientRect();
        Re < 0 && (N = { left: "0" }, fe = 0, q.value.left = `${R / 2}px`), globalThis.innerWidth < Re + Ee && (N = { right: "0" }, fe = 0, q.value.left = `${Ee - R / 2}px`);
      }
      te.value = {
        bottom: `${Q}px`,
        ...N,
        transform: `translateX(${fe}%)`
      };
    }, X = async (M, V, R) => {
      var N, fe, Ce, Re, Ee;
      const Q = Kt((fe = (N = I.value) == null ? void 0 : N[V]) == null ? void 0 : fe[R]);
      Q && ((Ce = M.marker) != null && Ce.customPosition && ((Ee = (Re = M.marker) == null ? void 0 : Re.tooltip) != null && Ee.length) ? te.value = M.marker.customPosition(Q) : await we(Q, M), r("tooltip-open", M.marker));
    }, pe = async (M, V, R) => {
      var Q, N;
      if (H.value && f.value.enabled && f.value.dragSelect)
        return a("select-date", M);
      if (a("set-hover-date", M), (N = (Q = M.marker) == null ? void 0 : Q.tooltip) == null ? void 0 : N.length) {
        if (i.hideOffsetDates && !M.current) return;
        await X(M, V, R);
      }
    }, Me = (M) => {
      D.value && (D.value = null, te.value = structuredClone({ bottom: "", left: "", transform: "" }), r("tooltip-close", M.marker));
    }, F = (M, V, R) => {
      M && (Array.isArray(I.value[V]) ? I.value[V][R] = M : I.value[V] = [M]);
    }, Z = (M) => {
      u.value.monthChangeOnScroll && (M.preventDefault(), a("handle-scroll", M));
    }, ve = (M) => p.value ? p.value.type === "local" ? Vi(M.value, {
      weekStartsOn: +i.weekStart,
      locale: i.locale
    }) : p.value.type === "iso" ? Pi(M.value) : typeof p.value.type == "function" ? p.value.type(M.value) : "" : "", G = (M) => {
      var R;
      const V = M[0];
      return (R = p.value) != null && R.hideOnOffsetDates ? M.some((Q) => Q.current) ? ve(V) : "" : ve(V);
    }, oe = (M, V, R = !0) => {
      !R && $() || (!f.value.enabled || u.value.allowPreventDefault) && (x(M, u.value), a("select-date", V));
    }, be = (M) => {
      x(M, u.value);
    }, A = (M) => {
      f.value.enabled && f.value.dragSelect ? (H.value = !0, a("select-date", M)) : f.value.enabled && a("select-date", M);
    }, B = () => {
      const M = l(), V = on(M, { locale: i.locale, weekStartsOn: +i.weekStart }), R = Ai(M, { locale: i.locale, weekStartsOn: +i.weekStart });
      return Ii({ start: V, end: R }).map((Q) => C(Q));
    };
    return n({ triggerTransition: Y }), (M, V) => (b(), T("div", {
      class: j(me.value)
    }, [
      E("div", {
        ref: "calendar-wrap",
        class: j(W.value),
        role: "grid"
      }, [
        E("div", xw, [
          v(p) ? (b(), T("div", Sw, le(v(p).label), 1)) : P("", !0),
          (b(!0), T($e, null, Oe(L.value, (R, Q) => {
            var N, fe;
            return b(), T("div", {
              key: Q,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (fe = (N = v(c)) == null ? void 0 : N.weekDay) == null ? void 0 : fe.call(N, Q)
            }, [
              U(M.$slots, "calendar-header", {
                day: R,
                index: Q
              }, () => [
                He(le(R), 1)
              ])
            ], 8, $w);
          }), 128))
        ]),
        V[2] || (V[2] = E("div", { class: "dp__calendar_header_separator" }, null, -1)),
        se(ht, {
          name: ne.value,
          css: !!v(o)
        }, {
          default: ue(() => [
            z.value ? (b(), T("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: V[1] || (V[1] = (R) => H.value = !1)
            }, [
              (b(!0), T($e, null, Oe(ie.value, (R, Q) => (b(), T("div", {
                key: Q,
                class: "dp__calendar_row",
                role: "row"
              }, [
                v(p) ? (b(), T("div", Tw, [
                  E("div", Cw, le(G(R.days)), 1)
                ])) : P("", !0),
                (b(!0), T($e, null, Oe(R.days, (N, fe) => {
                  var Ce, Re, Ee;
                  return b(), T("div", {
                    id: v(h)(N.value),
                    ref_for: !0,
                    ref: (Ye) => F(Ye, Q, fe),
                    key: fe + Q,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-selected": (N.classData.dp__active_date || N.classData.dp__range_start || N.classData.dp__range_end) ?? void 0,
                    "aria-disabled": N.classData.dp__cell_disabled || void 0,
                    "aria-label": (Re = (Ce = v(c)) == null ? void 0 : Ce.day) == null ? void 0 : Re.call(Ce, N),
                    tabindex: !N.current && v(i).hideOffsetDates ? void 0 : 0,
                    "data-test-id": v(h)(N.value),
                    "data-dp-element-active": N.classData.dp__active_date ? 0 : void 0,
                    "data-dp-action-element": "0",
                    onClick: Ve((Ye) => oe(Ye, N), ["prevent"]),
                    onTouchend: (Ye) => oe(Ye, N, !1),
                    onKeydown: (Ye) => v(g)(Ye, () => M.$emit("select-date", N)),
                    onMouseenter: (Ye) => pe(N, Q, fe),
                    onMouseleave: (Ye) => Me(N),
                    onMousedown: (Ye) => A(N),
                    onMouseup: V[0] || (V[0] = (Ye) => H.value = !1)
                  }, [
                    E("div", {
                      class: j(["dp__cell_inner", N.classData])
                    }, [
                      M.$slots.day && Te.value(N) ? U(M.$slots, "day", {
                        key: 0,
                        day: +N.text,
                        date: N.value
                      }) : P("", !0),
                      M.$slots.day ? P("", !0) : (b(), T($e, { key: 1 }, [
                        He(le(N.text), 1)
                      ], 64)),
                      N.marker && Te.value(N) ? U(M.$slots, "marker", {
                        key: 2,
                        marker: N.marker,
                        day: +N.text,
                        date: N.value
                      }, () => [
                        E("div", {
                          class: j(de.value(N.marker)),
                          style: Fe(N.marker.color ? { backgroundColor: N.marker.color } : {})
                        }, null, 6)
                      ]) : P("", !0),
                      he.value(N.value) ? (b(), T("div", {
                        key: 3,
                        ref_for: !0,
                        ref: "active-tooltip",
                        class: "dp__marker_tooltip",
                        style: Fe(te.value)
                      }, [
                        (Ee = N.marker) != null && Ee.tooltip ? (b(), T("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: be
                        }, [
                          (b(!0), T($e, null, Oe(N.marker.tooltip, (Ye, At) => (b(), T("div", {
                            key: At,
                            class: "dp__tooltip_text"
                          }, [
                            U(M.$slots, "marker-tooltip", {
                              tooltip: Ye,
                              day: N.value
                            }, () => [
                              E("div", {
                                class: "dp__tooltip_mark",
                                style: Fe(Ye.color ? { backgroundColor: Ye.color } : {})
                              }, null, 4),
                              E("div", null, le(Ye.text), 1)
                            ])
                          ]))), 128)),
                          E("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Fe(q.value)
                          }, null, 4)
                        ])) : P("", !0)
                      ], 4)) : P("", !0)
                    ], 2)
                  ], 40, Mw);
                }), 128))
              ]))), 128))
            ], 32)) : P("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), _w = (e, n, t, a) => {
  const s = J([]), l = J(/* @__PURE__ */ new Date()), r = J(), {
    getDate: i,
    rootEmit: o,
    calendars: u,
    month: c,
    year: d,
    time: p,
    modelValue: f,
    rootProps: w,
    today: m,
    state: k,
    defaults: { multiCalendars: y, startTime: h, range: g, config: x, safeDates: $, multiDates: C, timeConfig: O, flow: _ }
  } = Ze(), { validateMonthYearInRange: I, isDisabled: D, isDateRangeAllowed: z, checkMinMaxRange: H } = un(), { updateTimeValues: ne, getSetDateTime: te, assignTime: q, assignStartTime: ie, validateTime: L, disabledTimesConfig: ae } = qd(a), { formatDay: Y } = ra(), { resetDateTime: W, setTime: K, isDateBefore: de, isDateEqual: he, getDaysInBetween: me } = Lt(), { checkRangeAutoApply: Te, getRangeWithFixedDate: we, handleMultiDatesSelect: X, setPresetDate: pe } = Zl(), { getMapDate: Me } = _t();
  Gs(() => A(k.isTextInputDate));
  const F = (ee) => !x.value.keepViewOnOffsetClick || ee ? !0 : !r.value, Z = (ee, ge, Ae, Ue = !1) => {
    var tt, Ut, qt;
    F(Ue) && ((tt = u.value)[ee] ?? (tt[ee] = u.value[ee] = { month: 0, year: 0 }), u.value[ee].month = ge ?? ((Ut = u.value[ee]) == null ? void 0 : Ut.month), u.value[ee].year = Ae ?? ((qt = u.value[ee]) == null ? void 0 : qt.year));
  }, ve = () => {
    w.autoApply && n("select-date");
  }, G = () => {
    h.value && ie(h.value);
  };
  et(() => {
    f.value || (At(), G()), A(!0), w.focusStartDate && w.startDate && At();
  });
  const oe = S(() => {
    var ee, ge, Ae;
    return (ge = (ee = _.value) == null ? void 0 : ee.steps) != null && ge.length && !((Ae = _.value) != null && Ae.partial) ? e.flowStep === _.value.steps.length : !0;
  }), be = () => {
    var ee, ge, Ae;
    w.autoApply && oe.value && n("auto-apply", (ee = _.value) != null && ee.partial ? e.flowStep !== ((Ae = (ge = _.value) == null ? void 0 : ge.steps) == null ? void 0 : Ae.length) : !1);
  }, A = (ee = !1) => {
    if (f.value)
      return Array.isArray(f.value) ? (s.value = f.value, Ce(ee)) : R(f.value, ee);
    if (y.value.count && ee && !w.startDate)
      return V(i(), ee);
  }, B = () => Array.isArray(f.value) && g.value.enabled ? Xe(f.value[0]) === Xe(f.value[1] ?? f.value[0]) : !1, M = (ee) => {
    const ge = gn(ee, 1);
    return { month: Xe(ge), year: We(ge) };
  }, V = (ee = i(), ge = !1) => {
    if ((!y.value.count || !y.value.static || ge) && Z(0, Xe(ee), We(ee)), y.value.count && (!f.value || B() || !y.value.solo) && (!y.value.solo || ge))
      for (let Ae = 1; Ae < y.value.count; Ae++) {
        const Ue = je(i(), { month: c.value(Ae - 1), year: d.value(Ae - 1) }), tt = pd(Ue, { months: 1 });
        u.value[Ae] = { month: Xe(tt), year: We(tt) };
      }
  }, R = (ee, ge) => {
    V(ee), q("hours", An(ee)), q("minutes", Hn(ee)), q("seconds", la(ee)), y.value.count && ge && Ye();
  }, Q = (ee) => {
    if (y.value.count) {
      if (y.value.solo) return 0;
      const ge = Xe(ee[0]), Ae = Xe(ee[1]);
      return Math.abs(Ae - ge) < y.value.count ? 0 : 1;
    }
    return 1;
  }, N = (ee, ge) => {
    ee[1] && g.value.showLastInRange ? V(ee[Q(ee)], ge) : V(ee[0], ge);
    const Ae = (Ue, tt) => [
      Ue(ee[0]),
      ee != null && ee[1] ? Ue(ee[1]) : p[tt][1]
    ];
    q("hours", Ae(An, "hours")), q("minutes", Ae(Hn, "minutes")), q("seconds", Ae(la, "seconds"));
  }, fe = (ee, ge) => {
    if ((g.value.enabled || w.weekPicker) && !C.value.enabled)
      return N(ee, ge);
    if (C.value.enabled && ge) {
      const Ae = ee[ee.length - 1];
      return R(Ae, ge);
    }
  }, Ce = (ee) => {
    const ge = f.value;
    fe(ge, ee), y.value.count && y.value.solo && Ye();
  }, Re = (ee, ge) => {
    const Ae = je(i(), { month: c.value(ge), year: d.value(ge) }), Ue = ee < 0 ? gn(Ae, 1) : ns(Ae, 1);
    I(Xe(Ue), We(Ue), ee < 0, w.preventMinMaxNavigation) && (Z(ge, Xe(Ue), We(Ue)), o("update-month-year", { instance: ge, month: Xe(Ue), year: We(Ue) }), y.value.count && !y.value.solo && Ee(ge), t());
  }, Ee = (ee) => {
    for (let ge = ee - 1; ge >= 0; ge--) {
      const Ae = ns(je(i(), { month: c.value(ge + 1), year: d.value(ge + 1) }), 1);
      Z(ge, Xe(Ae), We(Ae));
    }
    for (let ge = ee + 1; ge <= y.value.count - 1; ge++) {
      const Ae = gn(je(i(), { month: c.value(ge - 1), year: d.value(ge - 1) }), 1);
      Z(ge, Xe(Ae), We(Ae));
    }
  }, Ye = () => {
    if (Array.isArray(f.value) && f.value.length === 2) {
      const ee = i(i(f.value[1] ?? gn(f.value[0], 1))), [ge, Ae] = [Xe(f.value[0]), We(f.value[0])], [Ue, tt] = [Xe(f.value[1]), We(f.value[1])];
      (ge !== Ue || ge === Ue && Ae !== tt) && y.value.solo && Z(1, Xe(ee), We(ee));
    } else f.value && !Array.isArray(f.value) && (Z(0, Xe(f.value), We(f.value)), V(i()));
  }, At = () => {
    w.startDate && (Z(0, Xe(i(w.startDate)), We(i(w.startDate))), y.value.count && Ee(0));
  }, Vn = (ee, ge) => {
    if (x.value.monthChangeOnScroll) {
      const Ae = Date.now() - l.value.getTime(), Ue = Math.abs(ee.deltaY);
      let tt = 500;
      Ue > 1 && (tt = 100), Ue > 100 && (tt = 0), Ae > tt && (l.value = /* @__PURE__ */ new Date(), Re(
        x.value.monthChangeOnScroll === "inverse" ? ee.deltaY : -ee.deltaY,
        ge
      ));
    }
  }, Sn = (ee, ge, Ae = !1) => {
    x.value.monthChangeOnArrows && w.vertical === Ae && Qt(ee, ge);
  }, Qt = (ee, ge) => {
    Re(ee === "right" ? -1 : 1, ge);
  }, Un = (ee) => {
    if ($.value.markers)
      return Me(ee.value, $.value.markers);
  }, It = (ee, ge) => {
    switch (w.sixWeeks === !0 ? "append" : w.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [ee == 0, !0];
      case "fair":
        return [ee == 0 || ge > ee, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Wt = (ee, ge, Ae, Ue) => {
    if (w.sixWeeks && ee.length < 6) {
      const tt = 6 - ee.length, Ut = (ge.getDay() + 7 - Ue) % 7, qt = 6 - (Ae.getDay() + 7 - Ue) % 7, [oa, Ia] = It(Ut, qt);
      for (let ua = 1; ua <= tt; ua++)
        if (Ia ? !!(ua % 2) == oa : oa) {
          const re = ee[0].days[0], Se = cn(an(re.value, -7), Xe(ge));
          ee.unshift({ days: Se });
        } else {
          const re = ee[ee.length - 1], Se = re.days[re.days.length - 1], qe = cn(an(Se.value, 1), Xe(ge));
          ee.push({ days: qe });
        }
    }
    return ee;
  }, cn = (ee, ge) => {
    const Ae = i(ee), Ue = [];
    for (let tt = 0; tt < 7; tt++) {
      const Ut = an(Ae, tt), qt = Xe(Ut) !== ge;
      Ue.push({
        text: w.hideOffsetDates && qt ? "" : Y(Ut),
        value: Ut,
        current: !qt,
        classData: {}
      });
    }
    return Ue;
  }, $n = (ee, ge) => {
    const Ae = [], Ue = i(new Date(ge, ee)), tt = i(new Date(ge, ee + 1, 0)), Ut = w.weekStart, qt = on(Ue, { weekStartsOn: Ut }), oa = (Ia) => {
      const ua = cn(Ia, ee);
      if (Ae.push({ days: ua }), !Ae[Ae.length - 1].days.some((re) => he(i(re.value), W(tt)))) {
        const re = an(Ia, 7);
        oa(re);
      }
    };
    return oa(qt), Wt(Ae, Ue, tt, Ut);
  }, wt = (ee) => {
    const ge = K(
      { hours: p.hours, minutes: p.minutes, seconds: Ea() },
      i(ee.value)
    );
    o("date-click", ge), C.value.enabled ? X(ge, C.value.limit) : f.value = ge, a(), Ke().then(() => {
      be();
    });
  }, kt = (ee) => g.value.noDisabledRange ? me(s.value[0], ee).some((ge) => D(ge)) : !1, De = () => {
    s.value = f.value ? f.value.slice().filter((ee) => !!ee) : [], s.value.length === 2 && !(g.value.fixedStart || g.value.fixedEnd) && (s.value = []);
  }, ut = (ee, ge) => {
    const Ae = [i(ee.value), an(i(ee.value), +g.value.autoRange)];
    z(Ae) ? (ge && Dt(ee.value), s.value = Ae) : o("invalid-date", ee.value);
  }, Dt = (ee) => {
    const ge = Xe(i(ee)), Ae = We(i(ee));
    if (Z(0, ge, Ae), y.value.count > 0)
      for (let Ue = 1; Ue < y.value.count; Ue++) {
        const tt = M(
          je(i(ee), { year: d.value(Ue - 1), month: c.value(Ue - 1) })
        );
        Z(Ue, tt.month, tt.year);
      }
  }, Tn = (ee) => {
    if (kt(ee.value) || !H(ee.value, f.value, g.value.fixedStart ? 0 : 1))
      return o("invalid-date", ee.value);
    s.value = we(i(ee.value));
  }, Fn = (ee, ge) => {
    if (De(), g.value.autoRange) return ut(ee, ge);
    if (g.value.fixedStart || g.value.fixedEnd) return Tn(ee);
    s.value[0] ? H(i(ee.value), f.value) && !kt(ee.value) ? de(i(ee.value), i(s.value[0])) ? g.value.autoSwitchStartEnd ? (s.value.unshift(i(ee.value)), o("range-end", s.value[0])) : (s.value[0] = i(ee.value), o("range-start", s.value[0])) : (s.value[1] = i(ee.value), o("range-end", s.value[1])) : o("invalid-date", ee.value) : (s.value[0] = i(ee.value), o("range-start", s.value[0]));
  }, Ea = (ee = !0) => O.value.enableSeconds ? Array.isArray(p.seconds) ? ee ? p.seconds[0] : p.seconds[1] : p.seconds : 0, fs = (ee) => {
    s.value[ee] = K(
      {
        hours: p.hours[ee],
        minutes: p.minutes[ee],
        seconds: Ea(ee !== 1)
      },
      s.value[ee]
    );
  }, tr = () => {
    var ee, ge;
    s.value[0] && s.value[1] && +((ee = s.value) == null ? void 0 : ee[0]) > +((ge = s.value) == null ? void 0 : ge[1]) && (s.value.reverse(), o("range-start", s.value[0]), o("range-end", s.value[1]));
  }, Qs = () => {
    var ee, ge, Ae;
    s.value.length && (s.value[0] && !s.value[1] ? fs(0) : (fs(0), fs(1), a()), tr(), f.value = s.value.slice(), Te(
      s.value,
      n,
      s.value.length < 2 || (ee = _.value) != null && ee.steps.length ? e.flowStep !== ((Ae = (ge = _.value) == null ? void 0 : ge.steps) == null ? void 0 : Ae.length) : !1
    ));
  }, nr = (ee, ge = !1) => {
    if (D(ee.value) || !ee.current && w.hideOffsetDates)
      return o("invalid-date", ee.value);
    if (r.value = structuredClone(ee), !g.value.enabled) return wt(ee);
    Array.isArray(p.hours) && Array.isArray(p.minutes) && !C.value.enabled && (Fn(ee, ge), Qs());
  }, ar = (ee, ge) => {
    var Ue, tt;
    Z(ee, ge.month, ge.year, !0), y.value.count && !y.value.solo && Ee(ee), o("update-month-year", { instance: ee, month: ge.month, year: ge.year }), t(y.value.solo ? ee : void 0);
    const Ae = (tt = (Ue = _.value) == null ? void 0 : Ue.steps) != null && tt.length ? _.value.steps[e.flowStep] : void 0;
    !ge.fromNav && (Ae === Nt.month || Ae === Nt.year) && a();
  }, sr = (ee) => {
    pe({
      value: ee
    }), ve(), w.multiCalendars && Ke().then(() => A(!0));
  }, el = () => {
    var ge;
    let ee = i();
    return (ge = w.actionRow) != null && ge.nowBtnRound && (ee = Ob(ee, {
      roundingMethod: w.actionRow.nowBtnRound.rounding ?? "ceil",
      nearestTo: w.actionRow.nowBtnRound.roundTo ?? 15
    })), ee;
  }, qn = () => {
    const ee = el();
    !g.value.enabled && !C.value.enabled ? f.value = ee : f.value && Array.isArray(f.value) && f.value[0] ? C.value.enabled ? f.value = [...f.value, ee] : f.value = de(ee, f.value[0]) ? [ee, f.value[0]] : [f.value[0], ee] : f.value = [ee], ve();
  }, tl = () => {
    if (Array.isArray(f.value))
      if (C.value.enabled) {
        const ee = Hi();
        f.value[f.value.length - 1] = te(ee);
      } else
        f.value = f.value.map((ee, ge) => ee && te(ee, ge));
    else
      f.value = te(f.value);
    n("time-update");
  }, Hi = () => Array.isArray(f.value) && f.value.length ? f.value[f.value.length - 1] : null, xt = (ee) => {
    let ge = "";
    if (g.value.enabled && Array.isArray(f.value))
      for (const Ae of Object.keys(ee)) {
        const Ue = ee[Ae];
        Array.isArray(Ue) && (p[Ae][0] !== Ue[0] && (ge = "range-start"), p[Ae][1] !== Ue[1] && (ge = "range-start"));
      }
    return ge;
  };
  return {
    calendars: u,
    modelValue: f,
    month: c,
    year: d,
    time: p,
    disabledTimesConfig: ae,
    today: m,
    validateTime: L,
    getCalendarDays: $n,
    getMarker: Un,
    handleScroll: Vn,
    handleSwipe: Qt,
    handleArrow: Sn,
    selectDate: nr,
    updateMonthYear: ar,
    presetDate: sr,
    selectCurrentDate: qn,
    updateTime: (ee) => {
      const ge = xt(ee);
      ne(ee, tl), ge && o(ge, f.value[ge === "range-start" ? 0 : 1]);
    },
    assignMonthAndYear: V,
    setStartTime: G
  };
}, Ow = () => {
  const {
    isModelAuto: e,
    matchDate: n,
    isDateAfter: t,
    isDateBefore: a,
    isDateBetween: s,
    isDateEqual: l,
    getWeekFromDate: r,
    getBeforeAndAfterInRange: i
  } = Lt(), {
    getDate: o,
    today: u,
    rootProps: c,
    defaults: { multiCalendars: d, multiDates: p, ui: f, highlight: w, safeDates: m, range: k },
    modelValue: y
  } = Ze(), { isDisabled: h } = un(), g = J(null), x = (M) => {
    !M.current && c.hideOffsetDates || (g.value = M.value);
  }, $ = () => {
    g.value = null;
  }, C = (M) => Array.isArray(y.value) && k.value.enabled && y.value[0] && g.value ? M ? t(g.value, y.value[0]) : a(g.value, y.value[0]) : !0, O = (M, V) => {
    const R = () => y.value ? V ? y.value[0] || null : y.value[1] : null, Q = y.value && Array.isArray(y.value) ? R() : null;
    return l(o(M.value), Q);
  }, _ = (M) => {
    const V = Array.isArray(y.value) ? y.value[0] : null;
    return M ? !a(g.value, V) : !0;
  }, I = (M, V = !0) => (k.value.enabled || c.weekPicker) && Array.isArray(y.value) && y.value.length === 2 ? c.hideOffsetDates && !M.current ? !1 : l(o(M.value), y.value[V ? 0 : 1]) : k.value.enabled ? O(M, V) && _(V) || l(M.value, Array.isArray(y.value) ? y.value[0] : null) && C(V) : !1, D = (M, V) => {
    if (Array.isArray(y.value) && y.value[0] && y.value.length === 1) {
      const R = l(M.value, g.value);
      return V ? t(y.value[0], M.value) && R : a(y.value[0], M.value) && R;
    }
    return !1;
  }, z = (M) => !y.value || c.hideOffsetDates && !M.current ? !1 : k.value.enabled ? c.modelAuto && Array.isArray(y.value) ? l(M.value, y.value[0] ?? u) : !1 : p.value.enabled && Array.isArray(y.value) ? y.value.some((V) => l(V, M.value)) : l(M.value, y.value ? y.value : u), H = (M) => {
    if (k.value.autoRange || c.weekPicker) {
      if (g.value) {
        if (c.hideOffsetDates && !M.current) return !1;
        const V = an(g.value, +k.value.autoRange), R = r(o(g.value), c.weekStart);
        return c.weekPicker ? l(R[1], o(M.value)) : l(V, o(M.value));
      }
      return !1;
    }
    return !1;
  }, ne = (M) => {
    if (k.value.autoRange || c.weekPicker) {
      if (g.value) {
        const V = an(g.value, +k.value.autoRange);
        if (c.hideOffsetDates && !M.current) return !1;
        const R = r(o(g.value), c.weekStart);
        return c.weekPicker ? t(M.value, R[0]) && a(M.value, R[1]) : t(M.value, g.value) && a(M.value, V);
      }
      return !1;
    }
    return !1;
  }, te = (M) => {
    if (k.value.autoRange || c.weekPicker) {
      if (g.value) {
        if (c.hideOffsetDates && !M.current) return !1;
        const V = r(o(g.value), c.weekStart);
        return c.weekPicker ? l(V[0], M.value) : l(g.value, M.value);
      }
      return !1;
    }
    return !1;
  }, q = (M) => s(y.value, g.value, M.value), ie = () => c.modelAuto && Array.isArray(y.value) ? !!y.value[0] : !1, L = () => c.modelAuto ? e(y.value) : !0, ae = (M) => {
    if (c.weekPicker) return !1;
    const V = k.value.enabled ? !I(M) && !I(M, !1) : !0;
    return !h(M.value) && !z(M) && !(!M.current && c.hideOffsetDates) && V;
  }, Y = (M) => k.value.enabled ? c.modelAuto ? ie() && z(M) : !1 : z(M), W = (M) => w.value ? n(M.value, m.value.highlight) : !1, K = (M) => {
    const V = h(M.value);
    return V && (typeof w.value == "function" ? !w.value(M.value, V) : !w.value.options.highlightDisabled);
  }, de = (M) => {
    var V;
    return typeof w.value == "function" ? w.value(M.value) : (V = w.value.weekdays) == null ? void 0 : V.includes(M.value.getDay());
  }, he = (M) => (k.value.enabled || c.weekPicker) && (!(d.value.count > 0) || M.current) && L() && !(!M.current && c.hideOffsetDates) && !z(M) ? q(M) : !1, me = (M) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: V, after: R } = i(+k.value.maxRange, y.value[0]);
      return Wn(M.value, V) || Dn(M.value, R);
    }
    return !1;
  }, Te = (M) => {
    if (Array.isArray(y.value) && y.value.length === 1) {
      const { before: V, after: R } = i(+k.value.minRange, y.value[0]);
      return s([V, R], y.value[0], M.value);
    }
    return !1;
  }, we = (M) => k.value.enabled && (k.value.maxRange || k.value.minRange) ? k.value.maxRange && k.value.minRange ? me(M) || Te(M) : k.value.maxRange ? me(M) : Te(M) : !1, X = (M) => {
    const { isRangeStart: V, isRangeEnd: R } = Z(M), Q = k.value.enabled ? V || R : !1;
    return {
      dp__cell_offset: !M.current,
      dp__pointer: !c.disabled && !(!M.current && c.hideOffsetDates) && !h(M.value) && !we(M),
      dp__cell_disabled: h(M.value) || we(M),
      dp__cell_highlight: !K(M) && (W(M) || de(M)) && !Y(M) && !Q && !te(M) && !(he(M) && c.weekPicker) && !R,
      dp__cell_highlight_active: !K(M) && (W(M) || de(M)) && Y(M),
      dp__today: !c.noToday && l(M.value, u) && M.current,
      "dp--past": a(M.value, u),
      "dp--future": t(M.value, u)
    };
  }, pe = (M) => ({
    dp__active_date: Y(M),
    dp__date_hover: ae(M)
  }), Me = (M) => {
    if (y.value && !Array.isArray(y.value)) {
      const V = r(y.value, c.weekStart);
      return {
        ...A(M),
        dp__range_start: l(V[0], M.value),
        dp__range_end: l(V[1], M.value),
        dp__range_between_week: t(M.value, V[0]) && a(M.value, V[1])
      };
    }
    return {
      ...A(M)
    };
  }, F = (M) => {
    if (y.value && Array.isArray(y.value)) {
      const V = r(y.value[0], c.weekStart), R = y.value[1] ? r(y.value[1], c.weekStart) : [];
      return {
        ...A(M),
        dp__range_start: l(V[0], M.value) || l(R[0], M.value),
        dp__range_end: l(V[1], M.value) || l(R[1], M.value),
        dp__range_between_week: t(M.value, V[0]) && a(M.value, V[1]) || t(M.value, R[0]) && a(M.value, R[1]),
        dp__range_between: t(M.value, V[1]) && a(M.value, R[0])
      };
    }
    return {
      ...A(M)
    };
  }, Z = (M) => {
    const V = d.value.count > 0 ? M.current && I(M) && L() : I(M) && L(), R = d.value.count > 0 ? M.current && I(M, !1) && L() : I(M, !1) && L();
    return { isRangeStart: V, isRangeEnd: R };
  }, ve = (M) => k.value.enabled && (k.value.fixedStart || k.value.fixedEnd) && Array.isArray(y.value) && y.value.length === 2, G = (M, V, R, Q) => !ve(y.value) || !g.value ? !1 : V ? k.value.fixedEnd && l(M.value, g.value) && Wn(M.value, y.value[0]) && !R : k.value.fixedStart && l(M.value, g.value) && Dn(M.value, y.value[1]) && !Q, oe = (M, V) => !ve(y.value) || !g.value ? !1 : V ? k.value.fixedEnd && Dn(M.value, g.value) && Wn(M.value, y.value[0]) : k.value.fixedStart && Wn(M.value, g.value) && Dn(M.value, y.value[1]), be = (M) => {
    const { isRangeStart: V, isRangeEnd: R } = Z(M);
    return {
      dp__range_start: V,
      dp__range_end: R,
      dp__range_between: he(M),
      dp__date_hover: l(M.value, g.value) && !V && !R && !c.weekPicker,
      dp__date_hover_start: D(M, !0) || G(M, !0, V, R),
      dp__date_hover_end: D(M, !1) || G(M, !1, V, R),
      "dp--extended-fixed-start": oe(M, !0),
      "dp--extended-fixed-end": oe(M, !1)
    };
  }, A = (M) => ({
    ...be(M),
    dp__cell_auto_range: ne(M),
    dp__cell_auto_range_start: te(M),
    dp__cell_auto_range_end: H(M)
  }), B = (M) => k.value.enabled ? k.value.autoRange ? A(M) : c.modelAuto ? { ...pe(M), ...be(M) } : c.weekPicker ? F(M) : be(M) : c.weekPicker ? Me(M) : pe(M);
  return {
    setHoverDate: x,
    clearHoverDate: $,
    getDayClassData: (M) => c.hideOffsetDates && !M.current ? {} : {
      ...X(M),
      ...B(M),
      [f.value.dayClass ? f.value.dayClass(M.value, y.value) : ""]: !0,
      ...f.value.calendarCell
    }
  };
}, Ew = { key: 0 }, Iw = /* @__PURE__ */ ke({
  __name: "DatePicker",
  props: /* @__PURE__ */ Pu({
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  }, _0),
  emits: ["mount", "update-flow-step", "reset-flow", "focus-menu", "select-date", "time-update", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      month: l,
      year: r,
      modelValue: i,
      time: o,
      disabledTimesConfig: u,
      today: c,
      validateTime: d,
      getCalendarDays: p,
      getMarker: f,
      handleArrow: w,
      handleScroll: m,
      handleSwipe: k,
      selectDate: y,
      updateMonthYear: h,
      presetDate: g,
      selectCurrentDate: x,
      updateTime: $,
      assignMonthAndYear: C,
      setStartTime: O
    } = _w(s, a, pe, Me), _ = Ht(), { setHoverDate: I, getDayClassData: D, clearHoverDate: z } = Ow(), {
      getDate: H,
      rootEmit: ne,
      rootProps: te,
      defaults: { multiCalendars: q, timeConfig: ie }
    } = Ze(), { getYears: L, getMonths: ae } = jl(), { getCellId: Y } = Lt(), W = Ge("calendar-header"), K = Ge("calendar"), de = Ge("time-picker"), he = En(_, yn.Calendar), me = En(_, yn.DatePickerHeader), Te = En(_, yn.TimePicker), we = (B) => {
      a("mount", B);
    };
    Ne(
      q,
      (B, M) => {
        B.count - M.count > 0 && C();
      },
      { deep: !0 }
    );
    const X = S(() => (B) => p(l.value(B), r.value(B)).map((M) => ({
      ...M,
      days: M.days.map((V) => (V.marker = f(V), V.classData = D(V), V))
    })));
    function pe(B) {
      var M, V, R;
      B || B === 0 ? (V = (M = K.value) == null ? void 0 : M[B]) == null || V.triggerTransition(l.value(B), r.value(B)) : (R = K.value) == null || R.forEach((Q, N) => Q == null ? void 0 : Q.triggerTransition(l.value(N), r.value(N)));
    }
    function Me() {
      a("update-flow-step");
    }
    const F = (B, M, V = 0) => {
      var R, Q;
      (Q = (R = W.value) == null ? void 0 : R[V]) == null || Q.toggleMonthPicker(B, M);
    }, Z = (B, M, V = 0) => {
      var R, Q;
      (Q = (R = W.value) == null ? void 0 : R[V]) == null || Q.toggleYearPicker(B, M);
    }, ve = (B, M, V) => {
      var R;
      (R = de.value) == null || R.toggleTimePicker(B, M, V);
    }, G = (B, M) => {
      var V;
      if (!te.range) {
        const R = i.value ? i.value : c, Q = M ? H(M) : R, N = B ? on(Q, { weekStartsOn: 1 }) : Ai(Q, { weekStartsOn: 1 });
        y({
          value: N,
          current: Xe(Q) === l.value(0),
          text: "",
          classData: {}
        }), (V = document.getElementById(Y(N))) == null || V.focus();
      }
    }, oe = (B) => {
      var M, V;
      (V = (M = W.value) == null ? void 0 : M[0]) == null || V.handleMonthYearChange(B, !0);
    }, be = (B) => {
      h(0, { month: l.value(0), year: r.value(0) + (B ? 1 : -1), fromNav: !0 });
    }, A = (B) => {
      ne("overlay-toggle", { open: !1, overlay: B }), a("focus-menu");
    };
    return n({
      clearHoverDate: z,
      presetDate: g,
      selectCurrentDate: x,
      handleArrow: w,
      updateMonthYear: h,
      setStartTime: O,
      toggleMonthPicker: F,
      toggleYearPicker: Z,
      toggleTimePicker: ve,
      getSidebarProps: () => ({
        modelValue: i,
        month: l,
        year: r,
        time: o,
        updateTime: $,
        updateMonthYear: h,
        selectDate: y,
        presetDate: g
      }),
      changeMonth: oe,
      changeYear: be,
      selectWeekDate: G
    }), (B, M) => (b(), T($e, null, [
      se(Kl, { collapse: e.collapse }, {
        default: ue(({ instances: V, wrapClass: R }) => [
          (b(!0), T($e, null, Oe(V, (Q) => (b(), T("div", {
            key: Q,
            class: j(R)
          }, [
            v(te).hideMonthYearSelect ? P("", !0) : (b(), ce(kw, {
              key: 0,
              ref_for: !0,
              ref: "calendar-header",
              months: v(ae)(),
              years: v(L)(),
              month: v(l)(Q),
              year: v(r)(Q),
              instance: Q,
              "menu-wrap-ref": e.menuWrapRef,
              onMount: M[0] || (M[0] = (N) => we(v(wa).header)),
              onResetFlow: M[1] || (M[1] = (N) => B.$emit("reset-flow")),
              onUpdateMonthYear: (N) => v(h)(Q, N),
              onOverlayClosed: A
            }, dt({ _: 2 }, [
              Oe(v(me), (N, fe) => ({
                name: N,
                fn: ue((Ce) => [
                  U(B.$slots, N, lt({ ref_for: !0 }, Ce))
                ])
              }))
            ]), 1032, ["months", "years", "month", "year", "instance", "menu-wrap-ref", "onUpdateMonthYear"])),
            se(Dw, {
              ref_for: !0,
              ref: "calendar",
              "mapped-dates": X.value(Q),
              instance: Q,
              month: v(l)(Q),
              year: v(r)(Q),
              onSelectDate: (N) => v(y)(N, Q !== 1),
              onSetHoverDate: M[2] || (M[2] = (N) => v(I)(N)),
              onHandleScroll: (N) => v(m)(N, Q),
              onHandleSwipe: (N) => v(k)(N, Q),
              onMount: M[3] || (M[3] = (N) => we(v(wa).calendar))
            }, dt({ _: 2 }, [
              Oe(v(he), (N, fe) => ({
                name: N,
                fn: ue((Ce) => [
                  U(B.$slots, N, lt({ ref_for: !0 }, Ce))
                ])
              }))
            ]), 1032, ["mapped-dates", "instance", "month", "year", "onSelectDate", "onHandleScroll", "onHandleSwipe"])
          ], 2))), 128))
        ]),
        _: 3
      }, 8, ["collapse"]),
      v(ie).enableTimePicker ? (b(), T("div", Ew, [
        U(B.$slots, "time-picker", Mt(zt({ time: v(o), updateTime: v($) })), () => [
          se(Ud, {
            ref: "time-picker",
            hours: v(o).hours,
            minutes: v(o).minutes,
            seconds: v(o).seconds,
            "disabled-times-config": v(u),
            "validate-time": v(d),
            "no-overlay-focus": e.noOverlayFocus,
            onMount: M[4] || (M[4] = (V) => we(v(wa).timePicker)),
            "onUpdate:hours": M[5] || (M[5] = (V) => v($)({ hours: V, minutes: v(o).minutes, seconds: v(o).seconds })),
            "onUpdate:minutes": M[6] || (M[6] = (V) => v($)({ hours: v(o).hours, minutes: V, seconds: v(o).seconds })),
            "onUpdate:seconds": M[7] || (M[7] = (V) => v($)({ hours: v(o).hours, minutes: v(o).minutes, seconds: V })),
            onResetFlow: M[8] || (M[8] = (V) => B.$emit("reset-flow"))
          }, dt({ _: 2 }, [
            Oe(v(Te), (V, R) => ({
              name: V,
              fn: ue((Q) => [
                U(B.$slots, V, Mt(zt(Q)))
              ])
            }))
          ]), 1032, ["hours", "minutes", "seconds", "disabled-times-config", "validate-time", "no-overlay-focus"])
        ])
      ])) : P("", !0)
    ], 64));
  }
}), Aw = (e, n) => {
  const {
    getDate: t,
    modelValue: a,
    year: s,
    calendars: l,
    defaults: { highlight: r, range: i, multiDates: o }
  } = Ze(), { isDateBetween: u, isDateEqual: c } = Lt(), { checkRangeAutoApply: d, handleMultiDatesSelect: p, setMonthOrYearRange: f } = Zl();
  Gs();
  const { isDisabled: w } = un(), { formatQuarterText: m } = ra(), {
    selectYear: k,
    groupedYears: y,
    showYearPicker: h,
    isDisabled: g,
    toggleYearPicker: x,
    handleYearSelect: $,
    handleYear: C,
    setStartDate: O
  } = Hd(n), _ = J();
  et(() => {
    O();
  });
  const I = S(() => (L) => a.value ? Array.isArray(a.value) ? a.value.some((ae) => nu(L, ae)) : nu(a.value, L) : !1), D = (L) => {
    if (i.value.enabled) {
      if (Array.isArray(a.value)) {
        const ae = c(L, a.value[0]) || c(L, a.value[1]);
        return u(a.value, _.value, L) && !ae;
      }
      return !1;
    }
    return !1;
  }, z = (L, ae) => L.quarter === Zo(ae) && L.year === We(ae), H = (L) => typeof r.value == "function" ? r.value({ quarter: Zo(L), year: We(L) }) : r.value.quarters.some((ae) => z(ae, L)), ne = S(() => (L) => {
    const ae = je(t(), { year: s.value(L) });
    return Lg({
      start: Za(ae),
      end: kd(ae)
    }).map((Y) => {
      const W = ga(Y), K = Xo(Y), de = w(Y), he = D(W), me = H(W);
      return {
        text: m(W, K),
        value: W,
        active: I.value(W),
        highlighted: me,
        disabled: de,
        isBetween: he
      };
    });
  }), te = (L) => {
    p(L, o.value.limit), n("auto-apply", !0);
  }, q = (L) => {
    a.value = f(L), d(a.value, n, a.value.length < 2);
  }, ie = (L) => {
    a.value = L, n("auto-apply");
  };
  return {
    groupedYears: y,
    year: s,
    isDisabled: g,
    quarters: ne,
    showYearPicker: h,
    modelValue: a,
    selectYear: k,
    toggleYearPicker: x,
    handleYearSelect: $,
    handleYear: C,
    setHoverDate: (L) => {
      _.value = L;
    },
    selectQuarter: (L, ae, Y) => {
      if (!Y)
        return l.value[ae].month = Xe(Xo(L)), o.value.enabled ? te(L) : i.value.enabled ? q(L) : ie(L);
    }
  };
}, Pw = { class: "dp--quarter-items" }, Rw = ["data-test-id", "disabled", "onClick", "onMouseover"], Vw = /* @__PURE__ */ ke({
  __name: "QuarterPicker",
  props: {
    flowStep: {},
    collapse: { type: Boolean },
    menuWrapRef: {},
    noOverlayFocus: { type: Boolean }
  },
  emits: ["reset-flow", "auto-apply"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e, {
      defaults: { config: l }
    } = Ze(), r = Ht(), { boolHtmlAttribute: i } = us(), o = En(r, yn.YearMode), {
      groupedYears: u,
      year: c,
      isDisabled: d,
      quarters: p,
      modelValue: f,
      showYearPicker: w,
      setHoverDate: m,
      selectQuarter: k,
      toggleYearPicker: y,
      handleYearSelect: h,
      handleYear: g
    } = Aw(s, a);
    return n({ getSidebarProps: () => ({
      modelValue: f,
      year: c,
      selectQuarter: k,
      handleYearSelect: h,
      handleYear: g
    }) }), (x, $) => (b(), ce(Kl, {
      collapse: e.collapse,
      stretch: ""
    }, {
      default: ue(({ instances: C, wrapClass: O }) => [
        (b(!0), T($e, null, Oe(C, (_) => (b(), T("div", {
          key: _,
          class: j(O)
        }, [
          E("div", {
            class: "dp-quarter-picker-wrap",
            style: Fe({ minHeight: `${v(l).modeHeight}px` })
          }, [
            x.$slots["top-extra"] ? U(x.$slots, "top-extra", {
              key: 0,
              value: v(f)
            }) : P("", !0),
            E("div", null, [
              se(Yd, {
                items: v(u)(_),
                instance: _,
                "show-year-picker": v(w)[_],
                year: v(c)(_),
                "is-disabled": (I) => v(d)(_, I),
                onHandleYear: (I) => v(g)(_, I),
                onYearSelect: (I) => v(h)(I, _),
                onToggleYearPicker: (I) => v(y)(_, I == null ? void 0 : I.flow, I == null ? void 0 : I.show)
              }, dt({ _: 2 }, [
                Oe(v(o), (I, D) => ({
                  name: I,
                  fn: ue((z) => [
                    U(x.$slots, I, lt({ ref_for: !0 }, z))
                  ])
                }))
              ]), 1032, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
            ]),
            E("div", Pw, [
              (b(!0), T($e, null, Oe(v(p)(_), (I, D) => (b(), T("div", { key: D }, [
                E("button", {
                  type: "button",
                  class: j(["dp--qr-btn", {
                    "dp--qr-btn-active": I.active,
                    "dp--qr-btn-between": I.isBetween,
                    "dp--qr-btn-disabled": I.disabled,
                    "dp--highlighted": I.highlighted
                  }]),
                  "data-dp-action-element": "0",
                  "data-test-id": I.value,
                  disabled: v(i)(I.disabled),
                  onClick: (z) => v(k)(I.value, _, I.disabled),
                  onMouseover: (z) => v(m)(I.value)
                }, [
                  U(x.$slots, "quarter", {
                    value: I.value,
                    text: I.text
                  }, () => [
                    He(le(I.text), 1)
                  ])
                ], 42, Rw)
              ]))), 128))
            ])
          ], 4)
        ], 2))), 128))
      ]),
      _: 3
    }, 8, ["collapse"]));
  }
}), Fw = ["id", "tabindex", "role", "aria-label"], Lw = {
  key: 0,
  class: "dp--menu-load-container"
}, Nw = {
  key: 1,
  class: "dp--menu-header"
}, zw = ["data-dp-mobile"], Bw = {
  key: 0,
  class: "dp__sidebar_left"
}, Ww = ["data-dp-mobile"], Yw = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], Hw = { class: "dp__instance_calendar" }, Uw = {
  key: 2,
  class: "dp__sidebar_right"
}, qw = {
  key: 2,
  class: "dp__action_extra"
}, jw = /* @__PURE__ */ ke({
  __name: "DatepickerMenu",
  props: {
    collapse: { type: Boolean },
    noOverlayFocus: { type: Boolean },
    getInputRect: { type: Function }
  },
  emits: ["close-picker", "select-date", "auto-apply", "time-update", "menu-blur"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = Ht(), {
      state: l,
      rootProps: r,
      defaults: { textInput: i, inline: o, config: u, ui: c, ariaLabels: d },
      setState: p
    } = Ze(), { isMobile: f } = ql(), { handleEventPropagation: w, getElWithin: m, checkStopPropagation: k, checkKeyDown: y } = _t();
    zb();
    const h = Ge("inner-menu"), g = Ge("dp-menu"), x = Ge("dyn-cmp"), $ = J(0), C = J(!1), O = J(!1), { flowStep: _, updateFlowStep: I, childMount: D, resetFlow: z, handleFlow: H } = Wb(x), ne = (A) => {
      O.value = !0, u.value.allowPreventDefault && A.preventDefault(), k(A, u.value, !0);
    };
    et(() => {
      C.value = !0, te(), globalThis.addEventListener("resize", te);
      const A = Kt(g);
      A && !i.value.enabled && !o.value.enabled && p("menuFocused", !0), A && (A.addEventListener("pointerdown", ne), A.addEventListener("mousedown", ne)), document.addEventListener("mousedown", be);
    }), Jt(() => {
      globalThis.removeEventListener("resize", te), document.removeEventListener("mousedown", be);
      const A = Kt(g);
      A && (A.removeEventListener("pointerdown", ne), A.removeEventListener("mousedown", ne));
    });
    const te = () => {
      const A = Kt(h);
      A && ($.value = A.getBoundingClientRect().width);
    }, q = S(() => r.monthPicker ? J0 : r.yearPicker ? ew : r.timePicker ? mw : r.quarterPicker ? Vw : Iw), ie = () => {
      const A = Kt(g);
      A && A.focus({ preventScroll: !0 });
    }, L = S(() => {
      var A;
      return ((A = x.value) == null ? void 0 : A.getSidebarProps()) || {};
    }), ae = En(s, yn.ActionRow), Y = En(s, yn.PassTrough), W = S(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), K = S(
      () => ({
        dp__menu: !0,
        dp__menu_index: !o.value.enabled,
        dp__relative: o.value.enabled,
        ...c.value.menu
      })
    ), de = (A) => {
      k(A, u.value, !0);
    }, he = (A) => {
      u.value.escClose && (a("close-picker"), w(A, u.value));
    }, me = (A) => {
      r.arrowNavigation || (A === mn.left || A === mn.up ? pe("handleArrow", mn.left, 0, A === mn.up) : pe("handleArrow", mn.right, 0, A === mn.down));
    }, Te = (A) => {
      p("shiftKeyInMenu", A.shiftKey), !r.hideMonthYearSelect && A.code === ct.tab && A.target.classList.contains("dp__menu") && l.shiftKeyInMenu && (A.preventDefault(), k(A, u.value, !0), a("close-picker"));
    }, we = (A) => {
      var B, M, V;
      (B = x.value) == null || B.toggleTimePicker(!1, !1), (M = x.value) == null || M.toggleMonthPicker(!1, !1, A), (V = x.value) == null || V.toggleYearPicker(!1, !1, A);
    }, X = (A, B = 0) => {
      var M, V, R;
      return A === "month" ? (M = x.value) == null ? void 0 : M.toggleMonthPicker(!1, !0, B) : A === "year" ? (V = x.value) == null ? void 0 : V.toggleYearPicker(!1, !0, B) : A === "time" ? (R = x.value) == null ? void 0 : R.toggleTimePicker(!0, !1) : we(B);
    }, pe = (A, ...B) => {
      var M, V;
      (M = x.value) != null && M[A] && ((V = x.value) == null || V[A](...B));
    }, Me = () => {
      pe("selectCurrentDate");
    }, F = (A) => {
      pe("presetDate", Qe(A));
    }, Z = () => {
      pe("clearHoverDate");
    }, ve = (A, B) => {
      pe("updateMonthYear", A, B);
    }, G = (A, B) => {
      A.preventDefault(), me(B);
    }, oe = (A) => {
      var B, M, V;
      if (Te(A), A.key === ct.home || A.key === ct.end)
        return pe(
          "selectWeekDate",
          A.key === ct.home,
          A.target.getAttribute("id")
        );
      switch ((A.key === ct.pageUp || A.key === ct.pageDown) && (A.shiftKey ? (pe("changeYear", A.key === ct.pageUp), (B = m(g.value, "overlay-year")) == null || B.focus()) : (pe("changeMonth", A.key === ct.pageUp), (M = m(g.value, A.key === ct.pageUp ? "action-prev" : "action-next")) == null || M.focus()), A.target.getAttribute("id") && ((V = g.value) == null || V.focus({ preventScroll: !0 }))), A.key) {
        case ct.esc:
          return he(A);
        case ct.arrowLeft:
          return G(A, mn.left);
        case ct.arrowRight:
          return G(A, mn.right);
        case ct.arrowUp:
          return G(A, mn.up);
        case ct.arrowDown:
          return G(A, mn.down);
        default:
          return;
      }
    }, be = (A) => {
      var B;
      o.value.enabled && !o.value.input && !((B = g.value) != null && B.contains(A.target)) && O.value && (O.value = !1, a("menu-blur"));
    };
    return n({
      updateMonthYear: ve,
      switchView: X,
      onValueCleared: () => {
        var A, B;
        (B = (A = x.value) == null ? void 0 : A.setStartTime) == null || B.call(A);
      },
      handleFlow: H
    }), (A, B) => {
      var M, V, R;
      return b(), T("div", {
        id: v(r).menuId,
        ref: "dp-menu",
        tabindex: v(o).enabled ? void 0 : "0",
        role: v(o).enabled ? void 0 : "dialog",
        "aria-label": (M = v(d)) == null ? void 0 : M.menu,
        class: j(K.value),
        onMouseleave: Z,
        onClick: de,
        onKeydown: oe
      }, [
        (v(r).disabled || v(r).readonly) && v(o).enabled || v(r).loading ? (b(), T("div", {
          key: 0,
          class: j(W.value)
        }, [
          v(r).loading ? (b(), T("div", Lw, [...B[5] || (B[5] = [
            E("span", { class: "dp--menu-loader" }, null, -1)
          ])])) : P("", !0)
        ], 2)) : P("", !0),
        A.$slots["menu-header"] ? (b(), T("div", Nw, [
          U(A.$slots, "menu-header")
        ])) : P("", !0),
        U(A.$slots, "arrow"),
        E("div", {
          ref: "inner-menu",
          class: j({
            dp__menu_content_wrapper: ((V = v(r).presetDates) == null ? void 0 : V.length) || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((R = v(r).presetDates) == null ? void 0 : R.length) || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"])
          }),
          "data-dp-mobile": v(f),
          style: Fe({ "--dp-menu-width": `${$.value}px` })
        }, [
          A.$slots["left-sidebar"] ? (b(), T("div", Bw, [
            U(A.$slots, "left-sidebar", Mt(zt(L.value)))
          ])) : P("", !0),
          v(r).presetDates.length ? (b(), T("div", {
            key: 1,
            class: j({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": v(f)
          }, [
            (b(!0), T($e, null, Oe(v(r).presetDates, (Q, N) => (b(), T($e, { key: N }, [
              Q.slot ? U(A.$slots, Q.slot, {
                key: 0,
                presetDate: F,
                label: Q.label,
                value: Q.value
              }) : (b(), T("button", {
                key: 1,
                type: "button",
                style: Fe(Q.style || {}),
                class: j(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": Q.testId ?? void 0,
                "data-dp-mobile": v(f),
                onClick: Ve((fe) => F(Q.value), ["prevent"]),
                onKeydown: (fe) => v(y)(fe, () => F(Q.value), !0)
              }, le(Q.label), 47, Yw))
            ], 64))), 128))
          ], 10, Ww)) : P("", !0),
          E("div", Hw, [
            (b(), ce(mt(q.value), {
              ref: "dyn-cmp",
              "flow-step": v(_),
              collapse: e.collapse,
              "no-overlay-focus": e.noOverlayFocus,
              "menu-wrap-ref": g.value,
              onMount: v(D),
              onUpdateFlowStep: v(I),
              onResetFlow: v(z),
              onFocusMenu: ie,
              onSelectDate: B[0] || (B[0] = (Q) => A.$emit("select-date")),
              onAutoApply: B[1] || (B[1] = (Q) => A.$emit("auto-apply", Q)),
              onTimeUpdate: B[2] || (B[2] = (Q) => A.$emit("time-update"))
            }, dt({ _: 2 }, [
              Oe(v(Y), (Q, N) => ({
                name: Q,
                fn: ue((fe) => [
                  U(A.$slots, Q, Mt(zt({ ...fe })))
                ])
              }))
            ]), 1064, ["flow-step", "collapse", "no-overlay-focus", "menu-wrap-ref", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ]),
          A.$slots["right-sidebar"] ? (b(), T("div", Uw, [
            U(A.$slots, "right-sidebar", Mt(zt(L.value)))
          ])) : P("", !0)
        ], 14, zw),
        A.$slots["action-extra"] ? (b(), T("div", qw, [
          A.$slots["action-extra"] ? U(A.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: Me
          }) : P("", !0)
        ])) : P("", !0),
        !v(r).autoApply || v(u).keepActionRow ? (b(), ce(Y0, {
          key: 3,
          "menu-mount": C.value,
          "calendar-width": $.value,
          onClosePicker: B[3] || (B[3] = (Q) => A.$emit("close-picker")),
          onSelectDate: B[4] || (B[4] = (Q) => A.$emit("select-date")),
          onSelectNow: Me
        }, dt({ _: 2 }, [
          Oe(v(ae), (Q, N) => ({
            name: Q,
            fn: ue((fe) => [
              U(A.$slots, Q, Mt(zt(fe)))
            ])
          }))
        ]), 1032, ["menu-mount", "calendar-width"])) : P("", !0)
      ], 42, Fw);
    };
  }
}), Gw = ["data-dp-mobile"], Kw = /* @__PURE__ */ ke({
  __name: "VueDatePicker",
  setup(e, { expose: n }) {
    const {
      rootEmit: t,
      setState: a,
      inputValue: s,
      modelValue: l,
      rootProps: r,
      defaults: { inline: i, config: o, textInput: u, range: c, multiDates: d, teleport: p, floatingConfig: f }
    } = Ze(), { validateDate: w, isValidTime: m } = un(), { menuTransition: k, showTransition: y } = js(), { isMobile: h } = ql(), { findNextFocusableElement: g, getNumVal: x } = _t(), $ = Ht(), C = J(!1), O = J(i.value.enabled || r.centered), _ = kl(r, "modelValue"), I = kl(r, "timezone"), D = Ge("dp-menu-wrap"), z = Ge("dp-menu"), H = Ge("input-cmp"), ne = Ge("picker-wrapper"), te = Ge("menu-arrow"), q = J(!1), ie = J(!1), L = J(!1), ae = J(!0), Y = (De) => (f.value.arrow && De.push(
      Cg({ element: f.value.arrow === !0 ? te : f.value.arrow })
    ), f.value.flip && De.push(xg(typeof f.value.flip == "object" ? f.value.flip : {})), f.value.shift && De.push(kg(typeof f.value.shift == "object" ? f.value.shift : {})), De), { floatingStyles: W, middlewareData: K, placement: de, y: he } = Mg(
      H,
      D,
      {
        strategy: f.value.strategy,
        placement: f.value.placement,
        middleware: Y([wg(f.value.offset)]),
        whileElementsMounted: bg
      }
    );
    et(() => {
      we(r.modelValue), Ke().then(() => {
        i.value.enabled || globalThis.addEventListener("resize", be);
      }), i.value.enabled && (C.value = !0), globalThis.addEventListener("keyup", A), globalThis.addEventListener("keydown", B);
    }), Jt(() => {
      i.value.enabled || globalThis.removeEventListener("resize", be), globalThis.removeEventListener("keyup", A), globalThis.removeEventListener("keydown", B);
    });
    const me = Wd($, r.presetDates), Te = En($, yn.Input);
    Ne(
      [_, I],
      () => {
        we(_.value);
      },
      { deep: !0 }
    ), Ne([de, he], () => {
      !i.value.enabled && !r.centered && ae.value && (O.value = !1, Ke().then(() => {
        ae.value = !1, O.value = !0;
      }));
    });
    const { parseExternalModelValue: we, emitModelValue: X, formatInputValue: pe, checkBeforeEmit: Me } = Bb(), F = S(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: i.value.enabled,
        "dp--flex-display-collapsed": L.value,
        dp__flex_display_with_input: i.value.input
      })
    ), Z = S(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), ve = S(() => i.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), G = () => {
      var De, ut;
      return ((ut = (De = H.value) == null ? void 0 : De.$el) == null ? void 0 : ut.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, oe = () => {
      C.value && o.value.closeOnScroll && Ee();
    }, be = () => {
      var ut;
      const De = ((ut = z.value) == null ? void 0 : ut.$el.getBoundingClientRect().width) ?? 0;
      L.value = document.body.offsetWidth <= De;
    }, A = (De) => {
      De.key === "Tab" && !i.value.enabled && !r.teleport && o.value.tabOutClosesMenu && (ne.value.contains(document.activeElement) || Ee()), ie.value = De.shiftKey;
    }, B = (De) => {
      ie.value = De.shiftKey;
    }, M = () => {
      !r.disabled && !r.readonly && (ae.value = !0, C.value = !0, C.value && t("open"), C.value || Re(), we(r.modelValue));
    }, V = () => {
      var De, ut;
      s.value = "", Re(), (De = z.value) == null || De.onValueCleared(), (ut = H.value) == null || ut.setParsedDate(null), t("update:model-value", null), t("cleared"), o.value.closeOnClearValue && Ee();
    }, R = () => {
      const De = l.value;
      return !De || !Array.isArray(De) && w(De) ? !0 : Array.isArray(De) ? d.value.enabled || De.length === 2 && w(De[0]) && w(De[1]) ? !0 : c.value.partialRange && !r.timePicker ? w(De[0]) : !1 : !1;
    }, Q = () => {
      Me() && R() ? (X(), Ee()) : t("invalid-select");
    }, N = (De) => {
      fe(), X(), o.value.closeOnAutoApply && !De && Ee();
    }, fe = () => {
      H.value && u.value.enabled && H.value.setParsedDate(l.value);
    }, Ce = (De = !1) => {
      r.autoApply && m(l.value) && R() && (c.value.enabled && Array.isArray(l.value) ? (c.value.partialRange || l.value.length === 2) && N(De) : N(De));
    }, Re = () => {
      u.value.enabled || (l.value = null);
    }, Ee = (De = !1) => {
      ae.value = !0, De && l.value && o.value.setDateOnMenuClose && Q(), i.value.enabled || (C.value && (C.value = !1, a("menuFocused", !1), a("shiftKeyInMenu", !1), t("closed"), s.value && we(_.value)), Re(), t("blur"));
    }, Ye = (De, ut, Dt = !1) => {
      if (!De) {
        l.value = null;
        return;
      }
      const Tn = Array.isArray(De) ? De.every((Ea) => w(Ea)) : w(De), Fn = m(De);
      Tn && Fn ? (a("isTextInputDate", !0), l.value = De, ut ? (q.value = Dt, Q(), t("text-submit")) : r.autoApply && Ce(!0), Ke().then(() => {
        a("isTextInputDate", !1);
      })) : t("invalid-date", De);
    }, At = () => {
      r.autoApply && m(l.value) && X(), fe();
    }, Vn = () => C.value ? Ee() : M(), Sn = (De) => {
      l.value = De;
    }, Qt = () => {
      u.value.enabled && (a("isInputFocused", !0), pe()), t("focus");
    }, Un = () => {
      var De;
      u.value.enabled && (a("isInputFocused", !1), we(r.modelValue), q.value && ((De = g(ne.value, ie.value)) == null || De.focus())), t("blur");
    }, It = (De, ut) => {
      z.value && z.value.updateMonthYear(ut ?? 0, {
        month: x(De.month),
        year: x(De.year)
      });
    }, Wt = (De) => {
      we(De ?? r.modelValue);
    }, cn = (De, ut) => {
      var Dt;
      (Dt = z.value) == null || Dt.switchView(De, ut);
    }, $n = (De, ut) => {
      if (C.value)
        return o.value.onClickOutside ? o.value.onClickOutside(De, ut) : Ee(!0);
    }, wt = (De = 0) => {
      var ut;
      (ut = z.value) == null || ut.handleFlow(De);
    }, kt = () => D;
    return Dp(D, (De) => $n(R, De), {
      ignore: [H]
    }), n({
      closeMenu: Ee,
      selectDate: Q,
      clearValue: V,
      openMenu: M,
      onScroll: oe,
      formatInputValue: pe,
      // exposed for testing purposes
      updateInternalModelValue: Sn,
      // modify internal modelValue
      setMonthYear: It,
      parseModel: Wt,
      switchView: cn,
      toggleMenu: Vn,
      handleFlow: wt,
      getDpWrapMenuRef: kt,
      dpMenuRef: () => z,
      dpWrapMenuRef: () => D,
      inputRef: () => H
    }), (De, ut) => (b(), T("div", {
      ref: "picker-wrapper",
      class: j(F.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": v(h)
    }, [
      se(L0, {
        ref: "input-cmp",
        "is-menu-open": C.value,
        onClear: V,
        onOpen: M,
        onSetInputDate: Ye,
        onSetEmptyDate: v(X),
        onSelectDate: Q,
        onToggle: Vn,
        onClose: Ee,
        onFocus: Qt,
        onBlur: Un,
        onRealBlur: ut[0] || (ut[0] = (Dt) => v(a)("isInputFocused", !1))
      }, dt({ _: 2 }, [
        Oe(v(Te), (Dt, Tn) => ({
          name: Dt,
          fn: ue((Fn) => [
            U(De.$slots, Dt, Mt(zt(Fn)))
          ])
        }))
      ]), 1032, ["is-menu-open", "onSetEmptyDate"]),
      se(Pn, {
        to: v(p),
        disabled: !v(p)
      }, {
        default: ue(() => [
          E("div", {
            ref: "dp-menu-wrap",
            class: j({
              "dp--menu-wrapper": !v(i).enabled,
              dp__outer_menu_wrap: !0,
              "dp--centered": v(r).centered
            }),
            style: Fe(!v(i).enabled && !v(r).centered ? v(W) : void 0)
          }, [
            se(ht, {
              name: v(k)(v(de).startsWith("top")),
              css: v(y) && !v(i).enabled && !v(r).centered && O.value
            }, {
              default: ue(() => [
                C.value && O.value ? (b(), ce(jw, {
                  key: 0,
                  ref: "dp-menu",
                  class: j({ [Z.value]: !0 }),
                  "no-overlay-focus": ve.value,
                  collapse: L.value,
                  "get-input-rect": G,
                  onClosePicker: Ee,
                  onSelectDate: Q,
                  onAutoApply: Ce,
                  onTimeUpdate: At,
                  onMenuBlur: ut[1] || (ut[1] = (Dt) => v(t)("blur"))
                }, dt({ _: 2 }, [
                  Oe(v(me), (Dt, Tn) => ({
                    name: Dt,
                    fn: ue((Fn) => [
                      U(De.$slots, Dt, Mt(zt({ ...Fn })))
                    ])
                  })),
                  !v(i).enabled && !v(r).centered && v(f).arrow === !0 ? {
                    name: "arrow",
                    fn: ue(() => {
                      var Dt, Tn;
                      return [
                        E("div", {
                          ref: "menu-arrow",
                          class: j({
                            dp__arrow_top: v(de) === "bottom",
                            dp__arrow_bottom: v(de) === "top"
                          }),
                          style: Fe({
                            left: ((Dt = v(K).arrow) == null ? void 0 : Dt.x) != null ? `${v(K).arrow.x}px` : "",
                            top: ((Tn = v(K).arrow) == null ? void 0 : Tn.y) != null ? `${v(K).arrow.y}px` : ""
                          })
                        }, null, 6)
                      ];
                    }),
                    key: "0"
                  } : void 0
                ]), 1032, ["class", "no-overlay-focus", "collapse"])) : P("", !0)
              ]),
              _: 3
            }, 8, ["name", "css"])
          ], 6)
        ]),
        _: 3
      }, 8, ["to", "disabled"])
    ], 10, Gw));
  }
}), Zw = /* @__PURE__ */ ke({
  __name: "VueDatePickerRoot",
  props: /* @__PURE__ */ Pu({
    multiCalendars: { type: [Boolean, Number, String, Object] },
    modelValue: {},
    modelType: {},
    dark: { type: Boolean },
    transitions: { type: [Boolean, Object] },
    ariaLabels: {},
    hideNavigation: {},
    timezone: {},
    vertical: { type: Boolean },
    hideMonthYearSelect: { type: Boolean },
    disableYearSelect: { type: Boolean },
    yearRange: {},
    autoApply: { type: Boolean },
    disabledDates: { type: [Array, Function] },
    startDate: {},
    hideOffsetDates: { type: Boolean },
    noToday: { type: Boolean },
    allowedDates: {},
    markers: {},
    presetDates: {},
    flow: {},
    preventMinMaxNavigation: { type: Boolean },
    reverseYears: { type: Boolean },
    weekPicker: { type: Boolean },
    filters: {},
    arrowNavigation: { type: Boolean },
    highlight: { type: [Function, Object] },
    teleport: { type: [String, Boolean] },
    centered: { type: Boolean },
    locale: {},
    weekStart: {},
    weekNumbers: { type: [Boolean, Object] },
    dayNames: { type: [Function, Array] },
    monthPicker: { type: Boolean },
    yearPicker: { type: Boolean },
    modelAuto: { type: Boolean },
    formats: {},
    multiDates: { type: [Boolean, Object] },
    minDate: {},
    maxDate: {},
    minTime: {},
    maxTime: {},
    inputAttrs: {},
    timeConfig: {},
    placeholder: {},
    timePicker: { type: Boolean },
    range: { type: [Boolean, Object] },
    menuId: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    inline: { type: [Boolean, Object] },
    textInput: { type: [Boolean, Object] },
    sixWeeks: { type: [Boolean, String] },
    actionRow: {},
    focusStartDate: { type: Boolean },
    disabledTimes: { type: [Function, Array] },
    calendar: { type: Function },
    config: {},
    quarterPicker: { type: Boolean },
    yearFirst: { type: Boolean },
    loading: { type: Boolean },
    ui: {},
    floating: {}
  }, O0),
  emits: ["update:model-value", "internal-model-change", "text-submit", "text-input", "open", "closed", "focus", "blur", "cleared", "flow-step", "update-month-year", "invalid-select", "invalid-fixed-range", "invalid-date", "tooltip-open", "tooltip-close", "am-pm-change", "range-start", "range-end", "date-click", "overlay-toggle", "invalid"],
  setup(e, { expose: n, emit: t }) {
    const a = t, s = e;
    Lb(s, a);
    const l = Ht(), r = Wd(l, s.presetDates), i = Ge("date-picker");
    return n(I0(i)), (o, u) => (b(), ce(Kw, { ref: "date-picker" }, dt({ _: 2 }, [
      Oe(v(r), (c, d) => ({
        name: c,
        fn: ue((p) => [
          U(o.$slots, c, Mt(zt(p)))
        ])
      }))
    ]), 1536));
  }
}), uu = "theme-mode", Xw = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", jd = Pf("theme", () => {
  const e = J("light"), n = J("light"), t = S(() => n.value === "dark"), a = S(() => n.value === "light"), s = (o) => {
    document.documentElement.setAttribute("data-theme", o);
  }, l = (o) => {
    e.value = o, n.value = o, s(o), localStorage.setItem(uu, o);
  };
  return {
    themeMode: e,
    resolvedTheme: n,
    isDark: t,
    isLight: a,
    setThemeMode: l,
    toggleTheme: () => {
      l(e.value === "dark" ? "light" : "dark");
    },
    initTheme: () => {
      const o = localStorage.getItem(uu);
      l(o === "light" || o === "dark" ? o : Xw());
    }
  };
}), Jw = {
  key: 0,
  class: "v-datepicker-label"
}, Qw = { class: "v-datepicker-icon-wrapper" }, ek = { class: "v-datepicker-clear-wrapper" }, tk = {
  key: 1,
  class: "v-datepicker-helper-text"
}, nk = {
  key: 0,
  class: "form-error"
}, ak = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "VDatepicker",
  props: /* @__PURE__ */ Ft({
    name: { default: "" },
    helperText: { default: "" },
    validation: { default: void 0 },
    size: { default: void 0 },
    icon: { default: "lucide:calendar" },
    autoApply: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    width: { default: "100%" },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = jd(), t = rn(e, "modelValue"), a = Ht(), s = Pl(), l = [
      "input-icon",
      "clear-icon",
      "arrow-left",
      "arrow-right",
      "arrow-up",
      "arrow-down",
      "clock-icon",
      "calendar-icon"
    ], r = e, i = S(() => r.size ?? "md"), o = J(!1), u = S(() => {
      const w = s.disabled;
      return w !== void 0 && w !== !1 && w !== "false";
    }), c = S(() => {
      const w = t.value;
      return Array.isArray(w) ? w.some((m) => m != null && m !== "") : w != null && w !== "";
    }), d = S(() => {
      var w;
      return !!((w = r.validation) != null && w.$error);
    }), p = (w) => typeof w == "object" && w !== null && !Array.isArray(w), f = S(() => {
      const w = p(s.ui) ? s.ui : void 0;
      if (!r.modern) return w;
      const m = w == null ? void 0 : w.menu, k = Array.isArray(m) ? m : m ? [m] : [];
      return { ...w, menu: ["v-datepicker-menu--modern", ...k] };
    });
    return (w, m) => {
      var k, y, h, g;
      return b(), T("div", {
        class: j([[
          `v-datepicker--${i.value}`,
          {
            "v-datepicker-wrapper--modern": r.modern,
            "v-datepicker-wrapper--sized": r.modern && !!r.size,
            "v-datepicker-wrapper--open": o.value,
            "v-datepicker-wrapper--filled": c.value,
            "v-datepicker-wrapper--labelled": !!r.name,
            "v-datepicker-wrapper--disabled": u.value,
            "v-datepicker-wrapper--error": d.value
          }
        ], "v-datepicker-wrapper"]),
        style: Fe({ width: r.width })
      }, [
        r.name ? (b(), T("label", Jw, le(r.name), 1)) : P("", !0),
        se(v(Zw), lt({
          modelValue: t.value,
          "onUpdate:modelValue": m[0] || (m[0] = (x) => t.value = x),
          "auto-apply": r.autoApply,
          "calendar-class-name": "v-datepicker-calendar",
          class: [
            "v-datepicker",
            {
              "v-datepicker-error": (k = e.validation) == null ? void 0 : k.$error,
              "v-datepicker-no-clear": !r.clearable
            }
          ],
          dark: v(n).isDark,
          "input-class-name": [
            "v-datepicker-input",
            {
              "v-datepicker-input-error": (y = e.validation) == null ? void 0 : y.$error
            }
          ],
          timezone: "UTC",
          "week-start": 0,
          teleport: "body"
        }, w.$attrs, {
          ui: f.value,
          onClosed: m[1] || (m[1] = (x) => o.value = !1),
          onOpen: m[2] || (m[2] = (x) => o.value = !0)
        }), dt({ _: 2 }, [
          v(a)["input-icon"] ? {
            name: "input-icon",
            fn: ue(() => [
              U(w.$slots, "input-icon", {}, void 0, !0)
            ]),
            key: "0"
          } : {
            name: "input-icon",
            fn: ue(() => [
              E("div", Qw, [
                se(ye, {
                  icon: e.icon,
                  class: "v-datepicker-icon"
                }, null, 8, ["icon"])
              ])
            ]),
            key: "1"
          },
          r.clearable ? r.clearable && v(a)["clear-icon"] ? {
            name: "clear-icon",
            fn: ue((x) => [
              U(w.$slots, "clear-icon", Mt(zt(x)), void 0, !0)
            ]),
            key: "3"
          } : {
            name: "clear-icon",
            fn: ue(({ clear: x }) => [
              E("div", ek, [
                se(ye, {
                  class: "v-datepicker-clear-icon",
                  icon: "lucide:x",
                  onClick: x
                }, null, 8, ["onClick"])
              ])
            ]),
            key: "4"
          } : {
            name: "clear-icon",
            fn: ue(() => []),
            key: "2"
          },
          v(a)["arrow-left"] ? {
            name: "arrow-left",
            fn: ue(() => [
              U(w.$slots, "arrow-left", {}, void 0, !0)
            ]),
            key: "5"
          } : {
            name: "arrow-left",
            fn: ue(() => [
              se(ye, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-left"
              })
            ]),
            key: "6"
          },
          v(a)["arrow-right"] ? {
            name: "arrow-right",
            fn: ue(() => [
              U(w.$slots, "arrow-right", {}, void 0, !0)
            ]),
            key: "7"
          } : {
            name: "arrow-right",
            fn: ue(() => [
              se(ye, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-right"
              })
            ]),
            key: "8"
          },
          v(a)["arrow-up"] ? {
            name: "arrow-up",
            fn: ue(() => [
              U(w.$slots, "arrow-up", {}, void 0, !0)
            ]),
            key: "9"
          } : {
            name: "arrow-up",
            fn: ue(() => [
              se(ye, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-up"
              })
            ]),
            key: "10"
          },
          v(a)["arrow-down"] ? {
            name: "arrow-down",
            fn: ue(() => [
              U(w.$slots, "arrow-down", {}, void 0, !0)
            ]),
            key: "11"
          } : {
            name: "arrow-down",
            fn: ue(() => [
              se(ye, {
                class: "v-datepicker-arrow-icon",
                icon: "lucide:chevron-down"
              })
            ]),
            key: "12"
          },
          v(a)["clock-icon"] ? {
            name: "clock-icon",
            fn: ue(() => [
              U(w.$slots, "clock-icon", {}, void 0, !0)
            ]),
            key: "13"
          } : {
            name: "clock-icon",
            fn: ue(() => [
              se(ye, {
                class: "v-datepicker-clock-icon",
                icon: "lucide:clock"
              })
            ]),
            key: "14"
          },
          v(a)["calendar-icon"] ? {
            name: "calendar-icon",
            fn: ue(() => [
              U(w.$slots, "calendar-icon", {}, void 0, !0)
            ]),
            key: "15"
          } : {
            name: "calendar-icon",
            fn: ue(() => [
              se(ye, {
                icon: e.icon,
                class: "v-datepicker-calendar-icon"
              }, null, 8, ["icon"])
            ]),
            key: "16"
          },
          Oe(v(a), (x, $) => ({
            name: $,
            fn: ue((C) => [
              l.includes($) ? P("", !0) : U(w.$slots, $, Mt(lt({ key: 0 }, C)), void 0, !0)
            ])
          }))
        ]), 1040, ["modelValue", "auto-apply", "class", "dark", "input-class-name", "ui"]),
        E("fieldset", {
          class: j([{ "v-datepicker-fieldset--error": (h = e.validation) == null ? void 0 : h.$error }, "v-datepicker-fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: j([{ "v-datepicker-legend--visible": !!r.name }, "v-datepicker-legend"])
          }, [
            E("span", null, le(r.name), 1)
          ], 2)
        ], 2),
        e.helperText && !((g = e.validation) != null && g.$error) ? (b(), T("p", tk, le(e.helperText), 1)) : P("", !0),
        se(ht, {
          mode: "out-in",
          name: "error-slide"
        }, {
          default: ue(() => {
            var x, $, C, O;
            return [
              (x = e.validation) != null && x.$error ? (b(), T("p", nk, le((O = (C = ($ = e.validation) == null ? void 0 : $.$errors) == null ? void 0 : C[0]) == null ? void 0 : O.$message), 1)) : P("", !0)
            ];
          }),
          _: 1
        })
      ], 6);
    };
  }
}), YD = /* @__PURE__ */ Le(ak, [["__scopeId", "data-v-31ab4d59"]]), Zs = (e) => e == null, Gd = (e, n) => e.length <= n ? e : `${e.slice(0, n)}...`, Es = (e, n = 2) => {
  if (e === 0) return "0 Bytes";
  const t = 1024, a = n < 0 ? 0 : n, s = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], l = Math.floor(Math.log(e) / Math.log(t));
  return `${parseFloat((e / Math.pow(t, l)).toFixed(a))} ${s[l]}`;
}, Kd = (e) => e.slice((e.lastIndexOf(".") - 1 >>> 0) + 2), HD = (e) => {
  const n = Kd(e).toLowerCase();
  return [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "svg",
    "bmp"
  ].includes(n);
}, sk = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  UAH: "₴",
  JPY: "¥",
  CNY: "¥"
}, Is = (e, n = "USD") => {
  if (Zs(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  let a, s, l;
  typeof n == "string" ? n === "compact" || n === "chart" || n === "default" ? (l = n, a = "USD") : a = n : (a = n.code ?? "USD", s = n.decimals, l = n.format);
  const r = sk[a] || a, i = t < 0, o = Math.abs(t);
  if (l === "compact") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 0,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${r}${c}` : `${r}${c}`;
  }
  if (l === "chart") {
    const c = new Intl.NumberFormat("en-US", {
      notation: "compact",
      compactDisplay: "short",
      minimumFractionDigits: s ?? 1,
      maximumFractionDigits: s ?? 1
    }).format(o);
    return i ? `-${r}${c}` : `${r}${c}`;
  }
  const u = o.toLocaleString("en-US", {
    minimumFractionDigits: s ?? 0,
    maximumFractionDigits: s ?? 0
  });
  return i ? `-${r}${u}` : `${r}${u}`;
}, Zd = (e, n) => {
  if (Zs(e)) return { text: "" };
  const t = !!e, a = (n == null ? void 0 : n.trueText) ?? "Yes", s = (n == null ? void 0 : n.falseText) ?? "No", l = (n == null ? void 0 : n.colored) ?? !0, r = t ? a : s;
  return l ? { text: r, class: t ? "text-success" : "text-negative" } : { text: r };
}, Ni = (e, n) => {
  if (Zs(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  return `${((typeof n == "object" ? n.multiplier ?? !1 : !1) ? t * 100 : t).toLocaleString("en-US", {
    minimumFractionDigits: a,
    maximumFractionDigits: a
  })}%`;
}, aa = (e, n) => {
  if (Zs(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.type) ?? "default", s = typeof n == "object" ? n.decimals : void 0, l = typeof n == "object" ? n.multiply : void 0, r = l !== void 0 ? t * l : t;
  switch (a) {
    case "compact":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 1
      }).format(r);
    case "chart":
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short",
        minimumFractionDigits: s ?? 1,
        maximumFractionDigits: s ?? 1
      }).format(r);
    case "percent":
      return `${r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      })}%`;
    case "decimal":
      return r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 2,
        maximumFractionDigits: s ?? 2
      });
    case "default":
    default:
      return r.toLocaleString("en-US", {
        minimumFractionDigits: s ?? 0,
        maximumFractionDigits: s ?? 0
      });
  }
}, Xd = (e, n) => {
  if (!e) return "";
  let t;
  if (e instanceof Date)
    t = Ie.fromJSDate(e).toUTC();
  else if (typeof e == "string") {
    const s = Ie.fromISO(e, { zone: "utc" });
    if (s.isValid)
      t = s;
    else {
      const l = new Date(e);
      if (isNaN(l.getTime())) return String(e);
      t = Ie.fromJSDate(l).toUTC();
    }
  } else if (typeof e == "number")
    t = Ie.fromMillis(e).toUTC();
  else
    return String(e);
  const a = typeof n == "string" ? n : (n == null ? void 0 : n.format) ?? "short";
  switch (a) {
    case "short":
      return t.toFormat("MM/dd/yyyy");
    case "long":
      return t.toFormat("MMMM dd, yyyy");
    case "time":
      return t.toFormat("h:mm:ss a");
    case "datetime":
      return t.toFormat("MM/dd/yyyy h:mm:ss a");
    default:
      return t.toFormat(a);
  }
}, Jd = (e, n) => {
  if (Zs(e)) return "";
  const t = Number(e);
  if (isNaN(t)) return String(e);
  const a = typeof n == "object" ? n.decimals ?? 2 : 2;
  if (t === 0) return "0 Bytes";
  const s = 1024, l = [
    "Bytes",
    "KB",
    "MB",
    "GB",
    "TB"
  ], r = Math.floor(Math.log(t) / Math.log(s));
  return `${parseFloat((t / Math.pow(s, r)).toFixed(a))} ${l[r]}`;
}, UD = (e) => typeof e != "string" ? String(e || "") : e.replace(/[_-]/g, " ").replace(/\s+/g, " ").trim().toLowerCase().split(" ").map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" "), lk = {
  key: 0,
  class: "loader-message"
}, rk = /* @__PURE__ */ ke({
  __name: "VLoader",
  props: {
    size: { default: "medium" },
    message: { default: "" },
    fullscreen: { type: Boolean, default: !1 },
    variant: { default: "primary" },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = S(() => `loader-${n.size}`), a = S(() => `loader-${n.variant}`), s = S(() => ({
      "loader-fullscreen": n.fullscreen
    }));
    return (l, r) => (b(), T("div", {
      class: j([[s.value, { "loader-container--modern": n.modern }], "loader-container"]),
      role: "status"
    }, [
      E("div", {
        class: j([[t.value, a.value], "loader"])
      }, [...r[0] || (r[0] = [
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1),
        E("div", { class: "loader-circle" }, null, -1)
      ])], 2),
      e.message ? (b(), T("span", lk, le(e.message), 1)) : P("", !0),
      r[1] || (r[1] = E("span", { class: "sr-only" }, "Loading...", -1))
    ], 2));
  }
}), Xs = /* @__PURE__ */ Le(rk, [["__scopeId", "data-v-7cc51a38"]]), ik = ["id", "accept", "disabled", "multiple"], ok = {
  key: 0,
  class: "drag-n-drop__loading"
}, uk = {
  key: 1,
  class: "drag-n-drop__content"
}, ck = { class: "drag-n-drop__icon-wrapper" }, dk = { class: "drag-n-drop__text" }, fk = {
  key: 0,
  class: "drag-n-drop__title text-primary font-medium text-base"
}, hk = { class: "drag-n-drop__hint text-secondaryText text-sm" }, mk = { key: 0 }, vk = { key: 1 }, pk = { key: 2 }, gk = {
  key: 2,
  class: "drag-n-drop__preview"
}, yk = { class: "drag-n-drop__preview-header" }, bk = { class: "drag-n-drop__title text-mainText font-medium" }, wk = { class: "drag-n-drop__hint text-secondaryText text-xs mt-1" }, kk = { class: "drag-n-drop__file-icon" }, xk = { class: "drag-n-drop__file-info" }, Sk = ["title"], $k = { class: "drag-n-drop__file-size" }, Tk = ["disabled", "onClick"], Ck = {
  key: 1,
  class: "drag-n-drop__actions"
}, Mk = /* @__PURE__ */ ke({
  __name: "DragNDrop",
  props: {
    loading: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    button: { type: Boolean, default: !1 },
    id: { default: void 0 },
    accept: { default: "" },
    maxSize: { default: 10 * 1024 * 1024 },
    maxFiles: { default: 10 },
    disabled: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["upload", "submit", "error"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Ca(), l = S(() => `fileInput-${t.id ?? s}`), r = J(!1), i = J([]), o = J(null), u = S(() => i.value.length > 0), c = S(() => !t.multiple || i.value.length < t.maxFiles), d = (C) => {
      const O = Kd(C).toLowerCase();
      return {
        pdf: "mdi:file-pdf-box",
        doc: "mdi:file-word-box",
        docx: "mdi:file-word-box",
        xls: "mdi:file-excel-box",
        xlsx: "mdi:file-excel-box",
        ppt: "mdi:file-powerpoint-box",
        pptx: "mdi:file-powerpoint-box",
        zip: "mdi:folder-zip",
        rar: "mdi:folder-zip",
        jpg: "mdi:file-image",
        jpeg: "mdi:file-image",
        png: "mdi:file-image",
        gif: "mdi:file-image",
        svg: "mdi:file-image",
        txt: "mdi:file-document",
        csv: "mdi:file-delimited"
      }[O] || "mdi:file-document-outline";
    }, p = (C) => t.maxSize && C.size > t.maxSize ? `File "${C.name}" exceeds maximum size of ${Es(t.maxSize)}` : null, f = () => {
      i.value = [];
    }, w = (C) => {
      i.value.splice(C, 1), a("upload", i.value, () => {
      });
    }, m = (C) => {
      const O = [];
      for (const _ of C) {
        const I = p(_);
        if (I) {
          a("error", I);
          continue;
        }
        O.push(_);
      }
      if (O.length !== 0) {
        if (!t.multiple)
          i.value = [O[0]];
        else {
          const _ = t.maxFiles - i.value.length, I = O.slice(0, _);
          O.length > _ && a("error", `Maximum ${t.maxFiles} files allowed`), i.value = [...i.value, ...I];
        }
        a("upload", i.value, () => {
        });
      }
    }, k = (C) => {
      t.disabled || t.loading || (C.preventDefault(), r.value = !0);
    }, y = (C) => {
      C.preventDefault(), r.value = !1;
    }, h = (C) => {
      var _;
      if (C.preventDefault(), r.value = !1, t.disabled || t.loading || !c.value) return;
      const O = Array.from(((_ = C.dataTransfer) == null ? void 0 : _.files) || []);
      m(O);
    }, g = (C) => {
      const O = C.target, _ = Array.from(O.files || []);
      m(_), o.value && (o.value.value = "");
    }, x = () => {
      i.value.length !== 0 && a("submit", i.value, f);
    }, $ = () => {
      var C;
      t.disabled || t.loading || !c.value || (C = o.value) == null || C.click();
    };
    return (C, O) => (b(), T("div", {
      class: j([{ "drag-n-drop--modern": t.modern }, "drag-n-drop"])
    }, [
      E("input", lt({
        id: l.value,
        ref_key: "fileRef",
        ref: o,
        accept: t.accept,
        disabled: t.disabled || t.loading,
        multiple: t.multiple,
        class: "drag-n-drop__input",
        name: "file",
        type: "file"
      }, C.$attrs, { onChange: g }), null, 16, ik),
      E("div", {
        class: j([{
          "drag-n-drop__dropzone--dragging": r.value,
          "drag-n-drop__dropzone--disabled": t.disabled || t.loading,
          "drag-n-drop__dropzone--has-files": u.value
        }, "drag-n-drop__dropzone"]),
        onClick: $,
        onDragleave: y,
        onDragover: k,
        onDrop: h
      }, [
        t.loading ? (b(), T("div", ok, [
          se(Xs, { class: "w-8 h-8" }),
          O[0] || (O[0] = E("p", { class: "text-secondaryText text-sm mt-2" }, " Processing files... ", -1))
        ])) : u.value ? (b(), T("div", gk, [
          E("div", yk, [
            se(ye, {
              size: 24,
              class: "text-primary",
              icon: "mdi:file-multiple-outline"
            }),
            E("span", bk, le(i.value.length) + " file" + le(i.value.length > 1 ? "s" : "") + " selected ", 1)
          ]),
          E("p", wk, " Click to add " + le(t.multiple ? "more" : "another") + " file" + le(t.multiple ? "s" : ""), 1)
        ])) : (b(), T("div", uk, [
          E("div", ck, [
            se(ye, {
              icon: r.value ? "mdi:cloud-download" : "mdi:cloud-upload-outline",
              size: 48,
              class: "drag-n-drop__icon"
            }, null, 8, ["icon"])
          ]),
          E("div", dk, [
            r.value ? (b(), T("p", fk, " Release to drop files here ")) : (b(), T($e, { key: 1 }, [
              U(C.$slots, "title", {}, () => [
                O[1] || (O[1] = E("p", { class: "drag-n-drop__title text-mainText font-medium text-base mb-1" }, " Drop files here or click to browse ", -1))
              ], !0),
              U(C.$slots, "subtitle", {}, () => [
                E("p", hk, [
                  t.accept ? (b(), T("span", mk, "Supported: " + le(t.accept), 1)) : P("", !0),
                  t.accept && t.maxSize ? (b(), T("span", vk, " • ")) : P("", !0),
                  t.maxSize ? (b(), T("span", pk, "Max: " + le(v(Es)(t.maxSize)), 1)) : P("", !0)
                ])
              ], !0)
            ], 64))
          ]),
          U(C.$slots, "action", {}, () => [
            se(vt, {
              modern: t.modern,
              class: "mt-2",
              icon: "mdi:folder-open-outline",
              text: "Browse Files",
              variant: "primary",
              onClick: Ve($, ["stop"])
            }, null, 8, ["modern"])
          ], !0)
        ]))
      ], 34),
      u.value && !t.loading ? (b(), ce(Er, {
        key: 0,
        class: "drag-n-drop__files",
        name: "file-list",
        tag: "div"
      }, {
        default: ue(() => [
          (b(!0), T($e, null, Oe(i.value, (_, I) => (b(), T("div", {
            key: `${_.name}-${_.size}-${I}`,
            class: "drag-n-drop__file-item"
          }, [
            E("div", kk, [
              se(ye, {
                icon: d(_.name),
                size: 20,
                class: "text-primary"
              }, null, 8, ["icon"])
            ]),
            E("div", xk, [
              E("p", {
                title: _.name,
                class: "drag-n-drop__file-name"
              }, le(v(Gd)(_.name, 40)), 9, Sk),
              E("p", $k, le(v(Es)(_.size)), 1)
            ]),
            E("button", {
              disabled: t.loading,
              class: "drag-n-drop__file-remove",
              type: "button",
              onClick: Ve((D) => w(I), ["stop"])
            }, [
              se(ye, {
                size: 20,
                icon: "mdi:close-circle"
              })
            ], 8, Tk)
          ]))), 128))
        ]),
        _: 1
      })) : P("", !0),
      u.value && t.button && !t.loading ? (b(), T("div", Ck, [
        se(vt, {
          modern: t.modern,
          class: "w-full",
          icon: "mdi:check-circle-outline",
          text: "Submit Files",
          variant: "primary",
          onClick: x
        }, null, 8, ["modern"])
      ])) : P("", !0)
    ], 2));
  }
}), qD = /* @__PURE__ */ Le(Mk, [["__scopeId", "data-v-864862db"]]), Dk = ["accept", "disabled", "multiple"], _k = { class: "v-file-upload__icon-wrapper" }, Ok = { class: "v-file-upload__text-container" }, Ek = {
  key: 0,
  class: "v-file-upload__loading"
}, Ik = {
  key: 0,
  class: "v-file-upload__list"
}, Ak = { class: "v-file-upload__item-main flex items-center gap-3 overflow-hidden" }, Pk = { class: "v-file-upload__item-icon" }, Rk = { class: "flex flex-col min-w-0" }, Vk = ["title"], Fk = { class: "text-xs text-secondaryText" }, Lk = ["disabled", "onClick"], Nk = /* @__PURE__ */ ke({
  __name: "VFileUpload",
  props: {
    modelValue: { default: void 0 },
    accept: { default: "*" },
    multiple: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    maxSize: { default: void 0 },
    label: { default: "Click to upload or drag and drop" },
    subLabel: { default: "SVG, PNG, JPG" },
    showList: { type: Boolean, default: !0 },
    variant: { default: "default" },
    immediate: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "upload", "error", "file-select"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = J(!1), l = J(null), r = J(t.modelValue ?? []), i = S({
      get: () => t.modelValue ?? r.value,
      set: (w) => {
        r.value = w, a("update:modelValue", w);
      }
    }), o = () => {
      i.value = [], l.value && (l.value.value = "");
    }, u = (w) => {
      if (!(t.loading || t.disabled)) {
        if (t.maxSize !== void 0) {
          const { maxSize: m } = t;
          if (w.filter((y) => y.size > m).length) {
            a("error", `File size exceeds limit of ${Es(m)}`);
            return;
          }
        }
        if (t.immediate) {
          const m = w[0] || null;
          a("file-select", m), a("upload", w, o);
          return;
        }
        t.multiple ? i.value = [...i.value, ...w] : i.value = w.slice(0, 1), a("change", i.value), a("upload", i.value, o);
      }
    }, c = (w) => {
      var k;
      s.value = !1;
      const m = Array.from(((k = w.dataTransfer) == null ? void 0 : k.files) || []);
      m.length && u(m);
    }, d = (w) => {
      const m = w.target, k = Array.from(m.files || []);
      k.length && u(k);
    }, p = (w) => {
      if (t.loading || t.disabled) return;
      const m = [...i.value];
      m.splice(w, 1), i.value = m, a("change", m);
    }, f = () => {
      var w;
      !t.loading && !t.disabled && ((w = l.value) == null || w.click());
    };
    return (w, m) => (b(), T("div", {
      class: j([{ "v-file-upload--modern": e.modern }, "v-file-upload w-full"])
    }, [
      E("div", {
        class: j([{
          "v-file-upload__dropzone--dragging": s.value,
          "v-file-upload__dropzone--loading": e.loading,
          "v-file-upload__dropzone--disabled": e.disabled,
          "v-file-upload__dropzone--compact": e.variant === "compact"
        }, "v-file-upload__dropzone"]),
        onClick: f,
        onDragenter: m[0] || (m[0] = Ve((k) => s.value = !0, ["prevent"])),
        onDragleave: m[1] || (m[1] = Ve((k) => s.value = !1, ["prevent"])),
        onDragover: m[2] || (m[2] = Ve((k) => s.value = !0, ["prevent"])),
        onDrop: Ve(c, ["prevent"])
      }, [
        E("input", {
          ref_key: "inputRef",
          ref: l,
          accept: e.accept,
          disabled: e.disabled || e.loading,
          multiple: e.multiple,
          class: "hidden",
          type: "file",
          onChange: d
        }, null, 40, Dk),
        E("div", {
          class: j([{ "v-file-upload__content--loading": e.loading }, "v-file-upload__content"])
        }, [
          E("div", _k, [
            U(w.$slots, "icon", {}, () => [
              se(ye, {
                size: e.variant === "compact" ? 20 : 28,
                class: "text-secondaryText",
                icon: "lucide:cloud-upload"
              }, null, 8, ["size"])
            ], !0)
          ]),
          E("div", Ok, [
            m[3] || (m[3] = E("div", { class: "v-file-upload__text" }, [
              E("span", { class: "v-file-upload__action font-medium text-primary hover:text-primary-dark transition-colors" }, " Click to upload "),
              E("span", { class: "v-file-upload__hint text-secondaryText" }, " or drag and drop ")
            ], -1)),
            e.subLabel ? (b(), T("p", {
              key: 0,
              class: j([{ "mt-1": e.variant !== "compact" }, "text-xs text-secondaryText"])
            }, le(e.subLabel), 3)) : P("", !0)
          ])
        ], 2),
        e.loading ? (b(), T("div", Ek, [
          se(Xs, {
            size: e.variant === "compact" ? "small" : "medium",
            variant: "primary"
          }, null, 8, ["size"]),
          m[4] || (m[4] = E("p", { class: "v-file-upload__uploading text-secondaryText text-sm" }, " Uploading... ", -1))
        ])) : P("", !0)
      ], 34),
      e.showList && i.value.length > 0 && !e.immediate ? (b(), T("div", Ik, [
        (b(!0), T($e, null, Oe(i.value, (k, y) => (b(), T("div", {
          key: `${k.name}-${k.size}-${y}`,
          class: "v-file-upload__item"
        }, [
          E("div", Ak, [
            E("div", Pk, [
              se(ye, {
                size: e.modern ? 16 : void 0,
                class: "text-primary",
                icon: "lucide:file"
              }, null, 8, ["size"])
            ]),
            E("div", Rk, [
              E("span", {
                title: k.name,
                class: "v-file-upload__item-name text-sm font-medium text-mainText truncate"
              }, le(v(Gd)(k.name, 30)), 9, Vk),
              E("span", Fk, le(v(Es)(k.size)), 1)
            ])
          ]),
          E("button", {
            disabled: e.loading || e.disabled,
            class: "v-file-upload__remove",
            type: "button",
            onClick: Ve((h) => p(y), ["stop"])
          }, [
            se(ye, {
              size: 20,
              icon: "lucide:trash-2"
            })
          ], 8, Lk)
        ]))), 128))
      ])) : P("", !0)
    ], 2));
  }
}), jD = /* @__PURE__ */ Le(Nk, [["__scopeId", "data-v-4a05eb51"]]), zk = { class: "v-input-container" }, Bk = ["for"], Wk = ["id"], Yk = ["id"], Hk = /* @__PURE__ */ ke({
  __name: "VInput",
  props: /* @__PURE__ */ Ft({
    name: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    helperText: { default: "" },
    validation: {},
    error: { default: void 0 },
    icon: { default: "" },
    size: { default: void 0 },
    id: {},
    debounce: { type: [Boolean, Number], default: !1 },
    loading: { type: Boolean, default: !1 },
    textarea: { type: Boolean, default: !1 },
    rows: { default: 4 },
    showClearButton: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: !1 },
    attachedEnd: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ft(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = S(() => !!t.name), s = S(() => {
      var te;
      return !!((te = t.validation) != null && te.$error || t.error);
    }), l = S(() => {
      var te, q;
      return ((q = (te = t.validation) == null ? void 0 : te.$errors[0]) == null ? void 0 : q.$message) ?? t.error ?? "";
    }), r = rn(e, "modelValue"), i = n, o = Ht(), u = Ca(), c = J(!1), d = J(!1), p = J(null), f = S(() => t.id || `v-input-${u}`), w = typeof t.debounce == "number" ? t.debounce : t.debounce ? 800 : 0, m = J(r.value ?? "");
    Ne(r, (te) => {
      te !== m.value && (m.value = te ?? "");
    });
    const k = lm((te) => {
      r.value = te;
    }, w), y = (te) => {
      const q = te.target.value;
      m.value = q;
      let ie = q;
      if (t.type === "number" && q !== "") {
        const L = Number(q);
        isNaN(L) || (ie = L);
      }
      k(ie);
    }, h = () => {
      var te;
      m.value = "", r.value = t.type === "number" ? void 0 : "", i("clear"), (te = p.value) == null || te.focus();
    }, g = S(() => t.type === "password" ? c.value ? "text" : "password" : t.type), x = () => {
      c.value = !c.value;
    }, $ = S(() => t.size ? {
      sm: "v-input-field--sm",
      md: "v-input-field--md",
      lg: "v-input-field--lg"
    }[t.size] : t.modern ? null : "v-input-field--md"), C = S(() => t.type === "search"), O = S(() => t.icon || C.value || !!o["icon-left"] || t.loading), _ = S(() => t.type === "password" || I.value || !!o["icon-right"]), I = S(
      () => t.type !== "password" && m.value !== "" && t.showClearButton
    ), D = S(() => t.icon ? t.icon : C.value ? "mdi:search" : ""), z = S(
      () => m.value !== "" && m.value !== null && m.value !== void 0
    ), H = S(() => {
      if (s.value) return `${f.value}-error`;
      if (t.helperText) return `${f.value}-helper`;
    }), ne = S(() => t.name ? d.value ? t.placeholder : "" : t.placeholder);
    return (te, q) => (b(), T("div", {
      class: j([
        "v-input-wrapper",
        { "v-input--modern": t.modern, "v-input--attached-end": t.attachedEnd }
      ])
    }, [
      E("div", zk, [
        a.value ? (b(), T("label", {
          key: 0,
          class: j([
            "v-label",
            {
              "v-label--active": d.value || z.value,
              "v-label--error": s.value,
              "v-label--with-icon": O.value && !(d.value || z.value),
              "v-label--textarea": e.textarea
            }
          ]),
          for: f.value
        }, le(t.name), 11, Bk)) : P("", !0),
        O.value ? (b(), T("div", {
          key: 1,
          class: j([
            "v-input-icon v-input-icon-left",
            {
              "v-input-icon-textarea": e.textarea,
              // Legacy tints only a focused search field; modern tints any left icon on focus.
              "v-input-icon--active": d.value && (C.value || t.modern) || e.loading,
              "v-input-icon--error": s.value
            }
          ])
        }, [
          U(te.$slots, "icon-left", {}, () => [
            D.value || e.loading ? (b(), ce(ye, {
              key: 0,
              icon: D.value,
              loading: e.loading,
              class: "v-input-icon-svg"
            }, null, 8, ["icon", "loading"])) : P("", !0)
          ], !0)
        ], 2)) : P("", !0),
        (b(), ce(mt(e.textarea ? "textarea" : "input"), lt({
          id: f.value,
          key: `${e.textarea ? "textarea" : "input"}-${f.value}`,
          ref_key: "inputRef",
          ref: p,
          class: [
            "v-input-field",
            $.value,
            {
              "v-input-field--textarea": e.textarea,
              "v-input-field--with-left-icon": O.value,
              "v-input-field--with-right-icon": _.value,
              "v-input-field--date": e.type === "date" && !e.textarea,
              "v-input-field--disabled": e.disabled
            }
          ],
          "aria-describedby": H.value,
          "aria-invalid": s.value ? !0 : void 0,
          disabled: e.disabled,
          placeholder: ne.value,
          value: m.value
        }, {
          ...te.$attrs,
          type: e.textarea ? void 0 : g.value,
          rows: e.textarea ? e.rows : void 0
        }, {
          onBlur: q[0] || (q[0] = (ie) => d.value = !1),
          onFocus: q[1] || (q[1] = (ie) => d.value = !0),
          onInput: y
        }), null, 16, ["id", "class", "aria-describedby", "aria-invalid", "disabled", "placeholder", "value"])),
        _.value ? (b(), T("div", {
          key: 2,
          class: j([
            "v-input-icon v-input-icon-right",
            { "v-input-icon-textarea": e.textarea }
          ])
        }, [
          U(te.$slots, "icon-right", {}, () => [
            I.value ? (b(), T("button", {
              key: 0,
              "aria-label": "Clear input",
              class: "v-input-clear-btn",
              title: "Clear",
              type: "button",
              onClick: h
            }, [
              se(ye, {
                class: "v-input-icon-svg v-input-icon-svg--sm",
                icon: "lucide:x"
              })
            ])) : t.type === "password" ? (b(), T("div", {
              key: 1,
              class: "v-input-password-toggle",
              role: "button",
              tabindex: "0",
              onClick: x,
              onKeydown: Pt(x, ["enter", "space"])
            }, [
              se(ye, {
                icon: g.value === "text" ? "lucide:eye-off" : "lucide:eye",
                class: "v-input-icon-svg"
              }, null, 8, ["icon"])
            ], 32)) : P("", !0)
          ], !0)
        ], 2)) : P("", !0),
        E("fieldset", {
          class: j([
            "v-fieldset",
            {
              "v-fieldset--active": d.value,
              "v-fieldset--error": s.value,
              "v-fieldset--disabled": e.disabled,
              "v-fieldset--flat": !e.shadow
            }
          ]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: j(["v-legend", { "v-legend--visible": a.value && (z.value || d.value) }])
          }, [
            E("span", null, le(t.name), 1)
          ], 2)
        ], 2)
      ]),
      U(te.$slots, "helper-text", {}, () => [
        e.helperText && !s.value ? (b(), T("p", {
          key: 0,
          id: `${f.value}-helper`,
          class: "v-input-helper-text"
        }, le(e.helperText), 9, Wk)) : P("", !0)
      ], !0),
      se(ht, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: ue(() => [
          U(te.$slots, "error-message", {}, () => [
            s.value ? (b(), T("p", {
              key: 0,
              id: `${f.value}-error`,
              class: "v-input-error-message"
            }, le(l.value), 9, Yk)) : P("", !0)
          ], !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Fs = /* @__PURE__ */ Le(Hk, [["__scopeId", "data-v-06089328"]]), Uk = { class: "v-collapse__wrap" }, qk = ["aria-hidden"], jk = /* @__PURE__ */ ke({
  __name: "VCollapse",
  props: /* @__PURE__ */ Ft({
    duration: { default: 200 },
    unmount: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = rn(e, "modelValue");
    return (t, a) => (b(), T("div", {
      class: j([{ "v-collapse--expanded": n.value }, "v-collapse"]),
      style: Fe({ "--v-collapse-duration": `${e.duration}ms` })
    }, [
      E("div", Uk, [
        !e.unmount || n.value ? (b(), T("div", {
          key: 0,
          "aria-hidden": !n.value,
          class: "v-collapse__content"
        }, [
          U(t.$slots, "default", {}, void 0, !0)
        ], 8, qk)) : P("", !0)
      ])
    ], 6));
  }
}), Gk = /* @__PURE__ */ Le(jk, [["__scopeId", "data-v-d2e88ce5"]]), Kk = { class: "v-composer__preview" }, Zk = {
  key: 1,
  class: "v-composer__meta"
}, Xk = {
  key: 0,
  class: "v-composer__edited"
}, Jk = { class: "v-composer__meta-actions" }, Qk = ["inert"], e1 = ["id", "aria-invalid", "aria-label", "placeholder", "rows"], t1 = {
  key: 0,
  class: "v-composer__message v-composer__message--error"
}, n1 = {
  key: 1,
  class: "v-composer__message"
}, a1 = { class: "v-composer__footer" }, s1 = {
  key: 0,
  class: "v-composer__failed"
}, l1 = {
  key: 1,
  class: "v-composer__hint"
}, r1 = { class: "v-composer__footer-actions" }, i1 = /* @__PURE__ */ ke({
  __name: "VComposer",
  props: /* @__PURE__ */ Ft({
    initialValue: { default: "" },
    preview: { default: "" },
    placeholder: { default: "" },
    openLabel: { default: "Write" },
    submitLabel: { default: "Send" },
    status: { default: "idle" },
    validation: {},
    error: {},
    helperText: { default: "" },
    copyable: { type: Boolean, default: !1 },
    rows: { default: 5 }
  }, {
    modelValue: { default: "" },
    modelModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Ft(["submit", "expand"], ["update:modelValue", "update:open"]),
  setup(e, { emit: n }) {
    const t = n, { copy: a, copied: s, isSupported: l } = pi({ copiedDuring: 2e3 }), r = Ca(), i = Ge("field"), o = Ge("root"), u = rn(e, "modelValue"), c = rn(e, "open");
    let d = !1;
    const p = S(() => {
      var _;
      return !!((_ = e.validation) != null && _.$error || e.error);
    }), f = S(() => {
      var _, I;
      return ((I = (_ = e.validation) == null ? void 0 : _.$errors[0]) == null ? void 0 : I.$message) ?? e.error ?? "";
    }), w = S(() => e.initialValue !== "" && u.value !== e.initialValue), m = S(() => e.status === "sending"), k = S(() => e.status === "sent"), y = S(() => e.status === "error" ? "Retry" : k.value ? "Send again" : e.submitLabel), h = () => {
      c.value || (c.value = !0, t("expand"));
    }, g = () => {
      var _;
      return ((_ = o.value) == null ? void 0 : _.contains(document.activeElement)) ?? !1;
    }, x = ({ restoreFocus: _ } = {}) => {
      const I = _ ?? g();
      c.value = !1, I && Ke(() => {
        var D, z;
        (z = (D = o.value) == null ? void 0 : D.querySelector(".v-composer__row button")) == null || z.focus();
      });
    }, $ = () => {
      var _;
      u.value = e.initialValue, (_ = i.value) == null || _.focus();
    }, C = (_) => {
      if (!m.value) {
        if (d = !0, _) {
          _();
          return;
        }
        t("submit", u.value);
      }
    }, O = (_) => {
      if (_.key === "Enter" && (_.metaKey || _.ctrlKey)) {
        _.preventDefault(), C();
        return;
      }
      _.key === "Escape" && (_.preventDefault(), _.stopPropagation(), x());
    };
    return Ne(c, async (_) => {
      if (!_) return;
      await Ke();
      const I = i.value;
      I && (I.focus(), I.setSelectionRange(I.value.length, I.value.length));
    }), Ne(() => e.status, (_, I) => {
      if (_ !== "sent" || I !== "sending") return;
      const D = d || g();
      d = !1, x({ restoreFocus: D });
    }), (_, I) => (b(), T("div", {
      ref_key: "root",
      ref: o,
      class: j([{
        "v-composer--open": c.value,
        "v-composer--sent": k.value && !c.value,
        "v-composer--error": p.value,
        "v-composer--failed": e.status === "error" && !c.value
      }, "v-composer"])
    }, [
      c.value ? (b(), T("div", Zk, [
        U(_.$slots, "meta", {}, void 0, !0),
        w.value ? (b(), T("span", Xk, "edited")) : P("", !0),
        E("span", Jk, [
          e.copyable && v(l) ? (b(), ce(vt, {
            key: 0,
            "aria-label": v(s) ? "Copied" : "Copy to clipboard",
            icon: v(s) ? "lucide:check" : "lucide:copy",
            modern: "",
            variant: "neutral",
            onClick: I[0] || (I[0] = (D) => v(a)(u.value))
          }, null, 8, ["aria-label", "icon"])) : P("", !0),
          se(vt, {
            "aria-label": "Collapse",
            icon: "lucide:x",
            modern: "",
            variant: "neutral",
            onClick: I[1] || (I[1] = (D) => x())
          })
        ])
      ])) : (b(), T("div", {
        key: 0,
        class: "v-composer__row",
        onClick: h
      }, [
        se(ye, {
          icon: k.value ? "lucide:check" : "lucide:pen-line",
          size: 15,
          class: "v-composer__icon"
        }, null, 8, ["icon"]),
        E("span", Kk, [
          U(_.$slots, "preview", {}, () => [
            He(le(e.preview || e.placeholder), 1)
          ], !0)
        ]),
        se(vt, {
          "aria-controls": v(r),
          icon: k.value ? void 0 : "lucide:send",
          text: k.value ? "View" : e.openLabel,
          variant: k.value ? "neutral" : "primary",
          "aria-expanded": "false",
          modern: "",
          onClick: Ve(h, ["stop"])
        }, null, 8, ["aria-controls", "icon", "text", "variant"])
      ])),
      se(Gk, { "model-value": c.value }, {
        default: ue(() => [
          E("div", {
            inert: !c.value,
            class: "v-composer__body"
          }, [
            Gt(E("textarea", {
              id: v(r),
              ref_key: "field",
              ref: i,
              "onUpdate:modelValue": I[2] || (I[2] = (D) => u.value = D),
              "aria-invalid": p.value,
              "aria-label": e.placeholder || e.submitLabel,
              placeholder: e.placeholder,
              rows: e.rows,
              class: "v-composer__field",
              onKeydown: O
            }, null, 40, e1), [
              [oi, u.value]
            ]),
            p.value ? (b(), T("p", t1, le(f.value), 1)) : e.helperText ? (b(), T("p", n1, le(e.helperText), 1)) : P("", !0),
            E("div", a1, [
              e.status === "error" ? (b(), T("span", s1, "Couldn't send — your text is kept")) : (b(), T("span", l1, [
                U(_.$slots, "hint", {}, () => [
                  I[4] || (I[4] = E("kbd", null, "⌘/Ctrl", -1)),
                  I[5] || (I[5] = He()),
                  I[6] || (I[6] = E("kbd", null, "↵", -1)),
                  I[7] || (I[7] = He(" to send · ", -1)),
                  I[8] || (I[8] = E("kbd", null, "Esc", -1)),
                  I[9] || (I[9] = He(" to collapse ", -1))
                ], !0)
              ])),
              E("span", r1, [
                e.initialValue ? (b(), ce(vt, {
                  key: 0,
                  disabled: !w.value,
                  class: "v-composer__reset",
                  modern: "",
                  text: "Reset",
                  variant: "neutral",
                  onClick: $
                }, null, 8, ["disabled"])) : P("", !0),
                U(_.$slots, "actions", { submit: C }, () => [
                  se(vt, {
                    loading: m.value,
                    text: y.value,
                    class: "v-composer__submit",
                    icon: "lucide:send",
                    modern: "",
                    variant: "primary",
                    onClick: I[3] || (I[3] = (D) => C())
                  }, null, 8, ["loading", "text"])
                ], !0)
              ])
            ])
          ], 8, Qk)
        ]),
        _: 3
      }, 8, ["model-value"])
    ], 2));
  }
}), GD = /* @__PURE__ */ Le(i1, [["__scopeId", "data-v-670d3534"]]), o1 = (e) => e.map((n) => n.text.trim()).filter((n) => n.length > 0), KD = (e) => e.map((n) => ({ text: n })), u1 = ["aria-pressed", "disabled", "onClick"], c1 = /* @__PURE__ */ ke({
  __name: "VToggleGroup",
  props: {
    modelValue: {},
    options: {},
    size: {},
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = {
      sm: "px-2 py-1 text-xs gap-1",
      md: "px-3 py-1.5 text-sm gap-1.5",
      lg: "px-4 py-2 text-base gap-2"
    }, s = {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    }, l = S(() => e.modern && e.size ? `v-toggle-group--${e.size}` : ""), r = (i) => {
      i.disabled || t("update:modelValue", i.value);
    };
    return (i, o) => (b(), T("div", {
      class: j([[l.value, { "v-toggle-group--modern": e.modern }], "v-toggle-group inline-flex items-center gap-1 bg-base-200 rounded-lg p-1 shadow-md border border-base-400"])
    }, [
      (b(!0), T($e, null, Oe(e.options, (u) => (b(), ce(xa, {
        key: String(u.value),
        "allow-html": !0,
        text: u.tooltip || "",
        class: "v-toggle-group__item flex items-center"
      }, {
        default: ue(() => [
          E("button", {
            class: j([[
              e.modern ? "transition-colors" : "transition-all",
              // Modern sizes items from CSS, and its active item is a neutral raised surface.
              e.modern ? "" : a[e.size ?? "md"],
              e.modelValue === u.value ? e.modern ? "v-toggle-group__button--active" : "bg-primary text-white shadow-sm" : "text-secondaryText hover:text-mainText hover:bg-base-300",
              u.disabled && "opacity-50 cursor-not-allowed"
            ], "flex items-center rounded-md font-medium whitespace-nowrap"]),
            "aria-pressed": e.modelValue === u.value,
            disabled: u.disabled,
            type: "button",
            onClick: (c) => r(u)
          }, [
            u.icon ? (b(), ce(ye, {
              key: 0,
              class: j(s[e.size ?? "md"]),
              icon: u.icon
            }, null, 8, ["class", "icon"])) : P("", !0),
            E("span", null, le(u.label), 1)
          ], 10, u1)
        ]),
        _: 2
      }, 1032, ["text"]))), 128))
    ], 2));
  }
}), d1 = /* @__PURE__ */ Le(c1, [["__scopeId", "data-v-1eb5a9e7"]]), f1 = { class: "v-list-editor__header" }, h1 = {
  key: 0,
  class: "v-list-editor__label"
}, m1 = { class: "v-list-editor__tools" }, v1 = ["disabled"], p1 = {
  key: 0,
  class: "v-list-editor__manual"
}, g1 = ["onClick"], y1 = {
  key: 0,
  class: "v-list-editor__error"
}, b1 = {
  key: 1,
  class: "v-list-editor__bulk"
}, w1 = { class: "v-list-editor__hint" }, k1 = { class: "v-list-editor__hint-detected" }, x1 = { class: "v-list-editor__summary" }, S1 = { class: "v-list-editor__count" }, $1 = ["onClick"], T1 = /* @__PURE__ */ ke({
  __name: "VListEditor",
  props: /* @__PURE__ */ Ft({
    label: { default: () => {
    } },
    itemLabel: { default: "Item" },
    itemLabelPlural: { default: () => {
    } },
    placeholder: { default: () => {
    } },
    markerClass: { default: () => {
    } },
    maxItems: { default: () => {
    } },
    maxLength: { default: () => {
    } },
    modes: { default: "both" },
    validation: { default: () => {
    } },
    itemError: { type: Function, default: void 0 },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: n }) {
    const t = rn(e, "modelValue"), a = Ge("inputs"), s = e.modes === "both", l = J(e.modes === "bulk" ? "bulk" : "manual"), r = J(""), i = [
      { value: "manual", label: "Manual", icon: "lucide:plus" },
      { value: "bulk", label: "Bulk", icon: "lucide:list" }
    ], o = /* @__PURE__ */ new WeakMap();
    let u = 0;
    const c = (Y) => {
      const W = Au(Y);
      let K = o.get(W);
      return K || (K = `item-${++u}`, o.set(W, K)), K;
    }, d = S(() => e.maxItems === void 0 || t.value.length < e.maxItems), p = S(() => `Add ${e.itemLabel.toLowerCase()}`), f = S(() => e.itemLabelPlural ?? `${e.itemLabel}s`), w = (Y) => Y === 0 ? e.placeholder ?? `${e.itemLabel} 1` : `${e.itemLabel} ${Y + 1}`, m = S(() => {
      var Y;
      return !!((Y = e.validation) != null && Y.$error);
    }), k = S(() => {
      var Y, W, K;
      return String(((K = (W = (Y = e.validation) == null ? void 0 : Y.$errors) == null ? void 0 : W[0]) == null ? void 0 : K.$message) ?? "");
    }), y = () => {
      var Y, W;
      (W = (Y = e.validation) == null ? void 0 : Y.$touch) == null || W.call(Y);
    }, h = (Y, W) => {
      var K;
      return ((K = e.itemError) == null ? void 0 : K.call(e, Y, W)) ?? void 0;
    }, g = async (Y) => {
      var K, de, he;
      await Ke();
      const W = (K = a.value) == null ? void 0 : K[Y];
      (he = (de = W == null ? void 0 : W.$el) == null ? void 0 : de.querySelector("textarea, input")) == null || he.focus();
    }, x = (Y) => {
      if (!d.value) return;
      const W = Y === void 0 ? t.value.length : Y + 1;
      t.value.splice(W, 0, { text: "" }), g(W);
    }, $ = (Y) => {
      t.value.length <= 1 || (t.value.splice(Y, 1), y(), g(Math.max(0, Y - 1)));
    }, C = (Y) => {
      x(Y);
    }, O = (Y, W) => {
      W.length > 0 || $(Y);
    }, _ = () => {
      x();
    }, I = [
      { char: `
`, label: "newline", regex: /\n/ },
      { char: ",", label: "comma", regex: /,/ },
      { char: ";", label: "semicolon", regex: /;/ },
      { char: "|", label: "pipe", regex: /\|/ },
      { char: "/", label: "slash", regex: /\// },
      { char: "	", label: "tab", regex: /\t/ }
    ], D = S(() => I.filter((Y) => Y.regex.test(r.value))), z = S(() => {
      const Y = r.value.trim();
      if (!Y) return [];
      const W = D.value.length ? new RegExp(D.value.map((de) => de.regex.source).join("|")) : /\s+/, K = [...new Set(Y.split(W).map((de) => de.trim()).filter(Boolean))].map((de) => e.maxLength ? de.slice(0, e.maxLength) : de);
      return e.maxItems ? K.slice(0, e.maxItems) : K;
    }), H = (Y) => {
      const W = [...t.value];
      return Y.map((K) => {
        const de = W.findIndex((he) => he.text === K);
        if (de !== -1) {
          const [he] = W.splice(de, 1);
          return he;
        }
        return { text: K };
      });
    }, ne = S(() => {
      if (!e.itemError) return {};
      const Y = {};
      return z.value.forEach((W) => {
        const K = t.value.findIndex((de) => de.text === W);
        K !== -1 && (Y[W] = e.itemError(t.value[K], K) ?? void 0);
      }), Y;
    }), te = (Y) => {
      r.value = Y, t.value = H(z.value);
    }, q = (Y) => {
      te(String(Y ?? ""));
    }, ie = () => {
      te("");
    }, L = (Y) => {
      te(z.value.filter((W) => W !== Y).join(`
`));
    }, ae = (Y) => {
      if (Y !== l.value) {
        if (Y === "bulk")
          r.value = o1(t.value).join(`
`);
        else {
          const W = H(z.value);
          t.value = W.length ? W : [{ text: "" }], r.value = "";
        }
        l.value = Y;
      }
    };
    return n({ focusRow: g }), (Y, W) => (b(), T("div", {
      class: j([{ "v-list-editor--modern": e.modern }, "v-list-editor"])
    }, [
      E("div", f1, [
        e.label ? (b(), T("span", h1, le(e.label), 1)) : P("", !0),
        E("div", m1, [
          l.value === "manual" ? (b(), ce(xa, {
            key: 0,
            placement: "top",
            text: d.value ? "" : `Up to ${e.maxItems} ${f.value.toLowerCase()}`
          }, {
            default: ue(() => [
              E("button", {
                disabled: !d.value,
                class: "v-list-editor__add",
                type: "button",
                onClick: _
              }, [
                se(ye, {
                  icon: "lucide:plus",
                  size: "14"
                }),
                He(" " + le(p.value), 1)
              ], 8, v1)
            ]),
            _: 1
          }, 8, ["text"])) : P("", !0),
          s ? (b(), ce(d1, {
            key: 1,
            "model-value": l.value,
            modern: e.modern,
            options: i,
            size: "sm",
            "onUpdate:modelValue": ae
          }, null, 8, ["model-value", "modern"])) : P("", !0)
        ])
      ]),
      l.value === "manual" ? (b(), T("div", p1, [
        E("div", {
          class: j([{ "v-list-editor__box--error": m.value }, "v-list-editor__box"])
        }, [
          se(Er, {
            class: "v-list-editor__rows",
            name: "v-list-editor-row",
            tag: "div"
          }, {
            default: ue(() => [
              (b(!0), T($e, null, Oe(t.value, (K, de) => (b(), T("div", {
                key: c(K),
                class: "v-list-editor__row"
              }, [
                e.markerClass ? (b(), T("span", {
                  key: 0,
                  class: j([e.markerClass, "v-list-editor__marker"])
                }, null, 2)) : P("", !0),
                se(Fs, {
                  ref_for: !0,
                  ref: "inputs",
                  modelValue: K.text,
                  "onUpdate:modelValue": (he) => K.text = he,
                  error: h(K, de),
                  maxlength: e.maxLength,
                  modern: e.modern,
                  placeholder: w(de),
                  "show-clear-button": !1,
                  class: "flex-1 min-w-0",
                  name: "",
                  onBlur: y,
                  onKeydown: [
                    Pt(Ve((he) => C(de), ["exact", "prevent", "stop"]), ["enter"]),
                    Pt(Ve((he) => O(de, K.text), ["stop"]), ["backspace"])
                  ]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "maxlength", "modern", "placeholder", "onKeydown"]),
                t.value.length > 1 ? (b(), T("button", {
                  key: 1,
                  "aria-label": "Remove",
                  class: "v-list-editor__remove",
                  type: "button",
                  onClick: (he) => $(de)
                }, [
                  se(ye, {
                    icon: "lucide:x",
                    size: "14"
                  })
                ], 8, g1)) : P("", !0)
              ]))), 128))
            ]),
            _: 1
          })
        ], 2),
        m.value ? (b(), T("p", y1, le(k.value), 1)) : P("", !0)
      ])) : (b(), T("div", b1, [
        se(Fs, {
          error: m.value ? k.value : void 0,
          "model-value": r.value,
          modern: e.modern,
          placeholder: `Enter ${f.value.toLowerCase()}, one per line or comma-separated`,
          rows: 4,
          textarea: !0,
          name: "",
          onBlur: y,
          "onUpdate:modelValue": q
        }, null, 8, ["error", "model-value", "modern", "placeholder"]),
        E("p", w1, [
          W[1] || (W[1] = He(" Separate by: newline · , · ; · | · / · tab ", -1)),
          D.value.length ? (b(), T($e, { key: 0 }, [
            W[0] || (W[0] = He(" · ", -1)),
            E("span", k1, " Detected: " + le(D.value.map((K) => K.label).join(", ")), 1)
          ], 64)) : P("", !0)
        ]),
        z.value.length > 0 ? (b(), T($e, { key: 0 }, [
          E("div", x1, [
            E("span", S1, le(z.value.length) + " " + le(z.value.length === 1 ? "item" : "items") + " detected ", 1),
            E("button", {
              class: "v-list-editor__clear",
              type: "button",
              onClick: ie
            }, " Clear all ")
          ]),
          se(Er, {
            class: "v-list-editor__preview",
            name: "v-list-editor-chip",
            tag: "div"
          }, {
            default: ue(() => [
              (b(!0), T($e, null, Oe(z.value, (K) => (b(), ce(xa, {
                key: K,
                placement: "top",
                text: ne.value[K] ?? ""
              }, {
                default: ue(() => [
                  se(Ju, {
                    color: ne.value[K] ? "error" : "primary",
                    label: K,
                    class: "v-list-editor__chip",
                    size: "md",
                    variant: "outline"
                  }, {
                    "icon-right": ue(() => [
                      E("button", {
                        class: "v-list-editor__chip-remove",
                        type: "button",
                        onClick: (de) => L(K)
                      }, [
                        se(ye, {
                          class: "size-2.5",
                          icon: "lucide:x"
                        })
                      ], 8, $1)
                    ]),
                    _: 2
                  }, 1032, ["color", "label"])
                ]),
                _: 2
              }, 1032, ["text"]))), 128))
            ]),
            _: 1
          })
        ], 64)) : P("", !0)
      ]))
    ], 2));
  }
}), ZD = /* @__PURE__ */ Le(T1, [["__scopeId", "data-v-f83df93a"]]), C1 = { class: "v-floating" }, M1 = ["disabled", "onClick"], D1 = {
  key: 0,
  class: "v-floating-item-icon"
}, _1 = { class: "v-floating-item-label" }, O1 = 120, cu = 8, E1 = /* @__PURE__ */ ke({
  __name: "VFloating",
  props: {
    placement: { default: "bottom-right" },
    teleport: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    offset: { default: 8 },
    openOnHover: { type: Boolean, default: !1 },
    hoverDelay: { default: 200 },
    items: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    closeOnSelect: { type: Boolean, default: !0 },
    unstyled: { type: Boolean, default: !1 },
    contentClass: { default: "" }
  },
  emits: ["select"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, l = J(!1), r = J(null), i = J(null), o = J({ top: 0, left: 0, right: 0 }), u = J(!1);
    let c = !1, d = null;
    function p() {
      !l.value || !i.value || c || (c = !0, requestAnimationFrame(() => {
        c = !1, y();
      }));
    }
    const f = S(() => a.items.length > 0), w = S(() => a.disabled), m = S(() => {
      const we = a.placement, X = {
        "v-floating--bottom-left": we === "bottom-left",
        "v-floating--bottom-right": we === "bottom-right",
        "v-floating--top-left": we === "top-left",
        "v-floating--top-right": we === "top-right",
        "v-floating--teleported": a.teleport
      };
      return a.unstyled ? {
        ...X,
        "v-floating--unstyled": !0,
        [a.contentClass]: !!a.contentClass
      } : {
        ...X,
        "v-floating--dropdown": f.value,
        "v-floating--popover": !f.value,
        "v-floating--styled": !0,
        [a.contentClass]: !!a.contentClass
      };
    }), k = S(() => a.teleport ? u.value ? {
      position: "fixed",
      zIndex: "9999",
      top: `${o.value.top}px`,
      left: o.value.left !== void 0 ? `${o.value.left}px` : void 0,
      right: o.value.right !== void 0 ? `${o.value.right}px` : void 0
      // Prevent following scroll by using fixed positioning as-is
      // The dropdown will stay in place relative to viewport, not following the trigger
    } : {} : {}), y = () => {
      if (!(!r.value || !i.value)) {
        if (a.teleport) {
          const we = r.value.getBoundingClientRect(), X = i.value.offsetWidth, pe = i.value.offsetHeight, [Me, F] = a.placement.split("-"), Z = a.offset;
          let ve;
          Me === "bottom" ? ve = we.bottom + Z : ve = we.top - pe - Z;
          let G;
          F === "left" ? G = we.left : G = we.right - X, G + X > window.innerWidth && (G = window.innerWidth - X - cu), G < 0 && (G = cu), o.value.top = ve, o.value.left = G, o.value.right = void 0;
        } else
          o.value.top = 0, o.value.left = 0;
        u.value = !0;
      }
    }, h = () => {
      w.value || (l.value = !l.value, l.value ? (u.value = !1, Ke(() => {
        i.value && r.value && (y(), me());
      })) : Te());
    }, g = () => {
      l.value && (l.value = !1, u.value = !1, Te());
    }, x = () => {
      w.value || l.value || (l.value = !0, u.value = !1, Ke(() => {
        i.value && r.value && (y(), me());
      }));
    }, $ = typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    let C = null, O = null;
    const _ = () => {
      C && (clearTimeout(C), C = null);
    }, I = () => {
      O && (clearTimeout(O), O = null);
    }, D = () => {
      _(), I();
    }, z = () => {
      I(), !l.value && (_(), C = setTimeout(() => {
        C = null, x();
      }, a.hoverDelay));
    }, H = () => {
      D(), O = setTimeout(() => {
        O = null, g();
      }, O1);
    }, ne = () => {
      !a.openOnHover || !$ || z();
    }, te = () => {
      !a.openOnHover || !$ || H();
    }, q = () => {
      !a.openOnHover || !$ || I();
    }, ie = () => {
      !a.openOnHover || !$ || H();
    }, L = () => {
      a.openOnHover && (D(), x());
    }, ae = () => {
      a.openOnHover && (D(), g());
    }, Y = (we) => {
      we.disabled || we.loading || (s("select", we.value), a.closeOnSelect && !we.loading && g());
    }, W = (we) => {
      we.key === "Escape" && l.value && g();
    }, K = (we) => {
      if (!a.closeOnClickOutside || !l.value) return;
      const X = we.composedPath(), pe = r.value && X.includes(r.value), Me = i.value && X.includes(i.value);
      !pe && !Me && g();
    };
    et(() => {
      document.addEventListener("click", K, !0);
    }), ss(() => {
      document.removeEventListener("click", K, !0), Te(), D();
    });
    const de = () => {
      !l.value || !a.teleport || p();
    }, he = () => {
      !l.value || !a.teleport || p();
    };
    function me() {
      a.teleport && (window.addEventListener("scroll", de, {
        passive: !0,
        capture: !0
      }), window.addEventListener("resize", he, { passive: !0 }), r.value && (d = new ResizeObserver(() => p()), d.observe(r.value)), document.addEventListener("keydown", W));
    }
    function Te() {
      window.removeEventListener("scroll", de, { capture: !0 }), window.removeEventListener("resize", he), document.removeEventListener("keydown", W), d && (d.disconnect(), d = null);
    }
    return n({
      isOpen: l,
      open: x,
      close: g,
      toggle: h
    }), (we, X) => (b(), T("div", C1, [
      E("div", {
        ref_key: "triggerRef",
        ref: r,
        class: j([{ "v-floating-trigger--disabled": w.value }, "v-floating-trigger"]),
        onClick: h,
        onFocusin: L,
        onFocusout: ae,
        onMouseenter: ne,
        onMouseleave: te
      }, [
        U(we.$slots, "trigger", {
          isDisabled: w.value,
          isOpen: l.value
        }, void 0, !0)
      ], 34),
      (b(), ce(Pn, {
        disabled: !e.teleport,
        to: "body"
      }, [
        l.value ? (b(), T("div", {
          key: 0,
          ref_key: "floatingRef",
          ref: i,
          class: j([[
            m.value,
            { "v-floating--positioning": !u.value }
          ], "v-floating-content"]),
          style: Fe(k.value),
          onMouseenter: q,
          onMouseleave: ie
        }, [
          U(we.$slots, "content", { close: g }, () => [
            f.value ? (b(!0), T($e, { key: 0 }, Oe(e.items, (pe) => (b(), T("button", {
              key: pe.value,
              class: j([{
                "v-floating-item--loading": pe.loading,
                "v-floating-item--active": pe.active,
                "v-floating-item--disabled": pe.disabled
              }, "v-floating-item"]),
              disabled: pe.disabled || pe.loading,
              onClick: (Me) => Y(pe)
            }, [
              U(we.$slots, "item-icon", { item: pe }, () => [
                pe.icon ? (b(), T("span", D1, [
                  se(ye, {
                    icon: pe.icon,
                    loading: pe.loading,
                    size: 16
                  }, null, 8, ["icon", "loading"])
                ])) : P("", !0)
              ], !0),
              E("span", _1, le(pe.label), 1)
            ], 10, M1))), 128)) : P("", !0)
          ], !0)
        ], 38)) : P("", !0)
      ], 8, ["disabled"]))
    ]));
  }
}), Ta = /* @__PURE__ */ Le(E1, [["__scopeId", "data-v-7e3df60c"]]), I1 = [`
`, ",", ";", "	"], A1 = {
  "\n": "new line",
  "	": "tab",
  ",": "comma",
  ";": "semicolon",
  "|": "pipe",
  "/": "slash",
  " ": "space"
}, Qd = (e) => {
  const n = (e ?? []).filter((t) => t !== "");
  return n.length > 0 ? n : I1;
}, P1 = (e) => e.replace(/[\\\]^\-[]/g, "\\$&"), ef = (e) => {
  const n = Qd(e).flatMap((t) => [...t]);
  return new RegExp(`[${n.map(P1).join("")}]`);
}, tf = (e) => e.replace(/\r/g, ""), R1 = (e, n) => tf(e).split(ef(n)).map((t) => t.trim()).filter(Boolean), wl = (e, n) => {
  const t = R1(e, n), a = [...new Set(t)];
  return { unique: a, duplicates: t.length - a.length };
}, XD = (e, n) => ef(n).test(tf(e)), V1 = (e) => A1[e] ?? `"${e}"`, F1 = (e) => {
  const n = Qd(e).map(V1);
  return n.length === 1 ? n[0] : `${n.slice(0, -1).join(", ")} or ${n[n.length - 1]}`;
}, L1 = { class: "v-bulk-editor" }, N1 = { class: "v-bulk-editor__head" }, z1 = { class: "v-bulk-editor__title" }, B1 = { class: "v-bulk-editor__count" }, W1 = ["aria-label"], Y1 = { class: "v-bulk-editor__meta" }, H1 = { class: "v-bulk-editor__num" }, U1 = {
  key: 0,
  class: "v-bulk-editor__num v-bulk-editor__dupes"
}, q1 = { class: "v-bulk-editor__footer" }, j1 = { class: "v-bulk-editor__actions" }, G1 = /* @__PURE__ */ ke({
  __name: "VBulkInputEditor",
  props: {
    items: {},
    separators: { default: () => {
    } },
    title: {}
  },
  emits: ["apply", "cancel"],
  setup(e, { emit: n }) {
    const t = n, a = J(e.items.join(`
`)), s = S(() => wl(a.value, e.separators)), l = S(() => `Separate by ${F1(e.separators)}`), r = () => {
      a.value = "";
    }, i = () => {
      t("apply", s.value.unique);
    }, o = () => {
      t("cancel");
    };
    return (u, c) => (b(), T("div", L1, [
      E("div", N1, [
        E("b", z1, le(e.title), 1),
        E("span", B1, le(s.value.unique.length) + " items", 1)
      ]),
      Gt(E("textarea", {
        "onUpdate:modelValue": c[0] || (c[0] = (d) => a.value = d),
        "aria-label": `${e.title}, one per line`,
        class: "v-bulk-editor__textarea",
        spellcheck: "false"
      }, null, 8, W1), [
        [oi, a.value]
      ]),
      E("div", Y1, [
        E("span", H1, le(s.value.unique.length) + " unique", 1),
        s.value.duplicates > 0 ? (b(), T("span", U1, le(s.value.duplicates) + " duplicates removed ", 1)) : P("", !0),
        E("span", null, le(l.value), 1)
      ]),
      E("div", q1, [
        se(vt, {
          modern: "",
          text: "Clear",
          variant: "link",
          onClick: r
        }),
        E("div", j1, [
          se(vt, {
            modern: "",
            text: "Cancel",
            variant: "neutral",
            onClick: o
          }),
          se(vt, {
            modern: "",
            text: "Apply",
            variant: "primary",
            onClick: i
          })
        ])
      ])
    ]));
  }
}), K1 = /* @__PURE__ */ Le(G1, [["__scopeId", "data-v-94bf6423"]]), Z1 = { class: "v-bulk-input" }, X1 = ["onKeydown"], J1 = /* @__PURE__ */ ke({
  __name: "VBulkInput",
  props: /* @__PURE__ */ Ft({
    name: { default: "" },
    placeholder: { default: "" },
    icon: { default: () => {
    } },
    chipLabel: { default: "Items" },
    listTitle: { default: () => {
    } },
    debounce: { type: [Boolean, Number], default: !1 },
    separators: { default: () => {
    } },
    disabled: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = rn(e, "modelValue"), t = Ge("floating"), a = J(null);
    let s = null, l = !1;
    const r = S(() => n.value.length > 1), i = S(() => a.value ?? n.value[0] ?? ""), o = S(
      () => typeof e.debounce == "number" ? e.debounce : e.debounce ? 800 : 0
    ), u = S(() => e.listTitle ?? e.chipLabel), c = S(() => `${e.chipLabel} ${n.value.length}`), d = (_, I) => _.length === I.length && _.every((D, z) => D === I[z]), p = (_) => {
      d(n.value, _) || (n.value = _);
    }, f = () => {
      s !== null && (clearTimeout(s), s = null);
    }, w = (_) => {
      s = null;
      const { unique: I } = wl(_, e.separators);
      I.length > 1 && (a.value = null), p(I);
    }, m = (_) => {
      const I = String(_ ?? "");
      if (a.value = I, f(), o.value === 0) {
        w(I);
        return;
      }
      s = setTimeout(() => w(I), o.value);
    }, k = () => {
      f(), a.value = "", p([]);
    }, y = (_) => {
      const I = _.relatedTarget;
      I instanceof Node && _.currentTarget.contains(I) || a.value !== null && (f(), p(wl(a.value, e.separators).unique), a.value = null);
    }, h = (_) => {
      var D;
      const { unique: I } = wl(((D = _.clipboardData) == null ? void 0 : D.getData("text")) ?? "", e.separators);
      I.length < 2 || (_.preventDefault(), f(), a.value = null, p(I));
    }, g = () => {
      f(), a.value = null, p([]);
    }, x = (_, I) => {
      f(), a.value = null, p(_), I();
    }, $ = () => {
      var _;
      e.disabled || (_ = t.value) == null || _.open();
    }, C = () => {
      var _;
      l = ((_ = t.value) == null ? void 0 : _.isOpen) ?? !1;
    }, O = () => {
      if (l) {
        l = !1;
        return;
      }
      $();
    };
    return ss(f), (_, I) => (b(), T("div", Z1, [
      r.value ? (b(), T("div", {
        key: 1,
        class: "v-bulk-input__chip-field",
        role: "button",
        tabindex: "0",
        onClick: O,
        onKeydown: Pt(Ve($, ["prevent"]), ["enter", "space"]),
        onPointerdown: C
      }, [
        e.icon ? (b(), ce(ye, {
          key: 0,
          icon: e.icon,
          size: 15,
          class: "v-bulk-input__icon"
        }, null, 8, ["icon"])) : P("", !0),
        se(Qu, {
          label: c.value,
          closable: "",
          color: "primary",
          modern: "",
          size: "sm",
          onClose: g
        }, null, 8, ["label"])
      ], 40, X1)) : (b(), T("div", {
        key: 0,
        class: "v-bulk-input__field",
        onFocusout: y,
        onPasteCapture: h
      }, [
        se(Fs, {
          disabled: e.disabled,
          icon: e.icon,
          "model-value": i.value,
          name: e.name,
          placeholder: e.placeholder,
          "attached-end": "",
          modern: "",
          onClear: k,
          "onUpdate:modelValue": m
        }, null, 8, ["disabled", "icon", "model-value", "name", "placeholder"])
      ], 32)),
      se(Ta, {
        ref: "floating",
        class: "v-bulk-input__floating",
        "content-class": "v-bulk-input__popover",
        placement: "bottom-right"
      }, {
        trigger: ue(() => [
          se(vt, {
            disabled: e.disabled,
            icon: r.value ? "lucide:pencil" : "lucide:list",
            text: r.value ? "Edit" : "List",
            variant: r.value ? "primary" : "neutral",
            class: "v-bulk-input__button",
            modern: ""
          }, null, 8, ["disabled", "icon", "text", "variant"])
        ]),
        content: ue(({ close: D }) => [
          se(K1, {
            items: n.value,
            separators: e.separators,
            title: u.value,
            onApply: (z) => x(z, D),
            onCancel: D
          }, null, 8, ["items", "separators", "title", "onApply", "onCancel"])
        ]),
        _: 1
      }, 512)
    ]));
  }
}), JD = /* @__PURE__ */ Le(J1, [["__scopeId", "data-v-b2f2eaf9"]]), Q1 = ["aria-busy"], ex = ["aria-label", "aria-pressed", "title", "disabled", "onClick"], tx = { key: 1 }, nx = {
  key: 0,
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center justify-center"
}, ax = /* @__PURE__ */ ke({
  __name: "VSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: {},
    fullWidth: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    deselectable: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 },
    wrap: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = Ge("container"), s = Ge("pill");
    let l = null, r = 0, i = !1;
    const o = J(!1), u = {
      primary: "bg-primary-100 text-primary-700",
      success: "bg-success-100 text-success-700",
      warning: "bg-warning-100 text-warning-700",
      error: "bg-error-100 text-error-700",
      info: "bg-info-100 text-info-700",
      neutral: "bg-base-300 text-secondaryText",
      violet: "bg-violet-100 text-violet-700"
    }, c = (h) => {
      if (e.modern) return "";
      const g = !!(h.icon && !h.label);
      switch (e.size) {
        case "none":
          return "";
        case "sm":
          return g ? "p-1" : "text-xs px-2 py-1";
        case "lg":
          return g ? "p-2.5" : "text-base px-4 py-2.5";
        default:
          return g ? "p-2" : "text-sm px-3 py-2";
      }
    }, d = S(() => e.modern && e.size ? `v-segmented-control--${e.size}` : ""), p = S(() => {
      switch (e.size) {
        // Modern text is 13px, so a 16px icon would tower over it in all but the tallest track.
        case "sm":
          return 14;
        case "lg":
          return 20;
        case void 0:
        case "md":
          return e.modern ? 14 : 16;
        default:
          return 16;
      }
    }), f = (h) => h.value === e.modelValue, w = (h) => e.loading && f(h), m = (h) => {
      o.value || i || h <= 0 || (i = !0, r = requestAnimationFrame(() => {
        r = requestAnimationFrame(() => {
          o.value = !0, i = !1;
        });
      }));
    }, k = () => {
      const h = a.value, g = s.value;
      if (!h || !g) return;
      const x = h.querySelectorAll("button"), $ = e.options.findIndex((O) => O.value === e.modelValue), C = x[$];
      if (!C) {
        g.style.opacity = "0";
        return;
      }
      g.style.opacity = "1", g.style.width = `${C.offsetWidth}px`, e.wrap ? (g.style.transform = `translate(${C.offsetLeft}px, ${C.offsetTop}px)`, g.style.height = `${C.offsetHeight}px`) : g.style.transform = `translateX(${C.offsetLeft}px)`, m(C.offsetWidth);
    }, y = (h) => {
      if (!(h.disabled || e.disabled || e.loading)) {
        if (e.deselectable && f(h)) {
          t("update:modelValue", null);
          return;
        }
        t("update:modelValue", h.value);
      }
    };
    return et(() => {
      Ke(k);
      const h = a.value;
      !h || typeof ResizeObserver > "u" || (l = new ResizeObserver(() => k()), l.observe(h));
    }), _f(k), Jt(() => {
      l == null || l.disconnect(), l = null, cancelAnimationFrame(r);
    }), (h, g) => (b(), T("div", {
      ref: "container",
      "aria-busy": e.loading,
      class: j([[d.value, {
        "v-segmented-control--modern": e.modern,
        "v-segmented-control--wrap": e.wrap,
        "w-full": e.fullWidth,
        "opacity-50 pointer-events-none": e.disabled,
        // No dimming while loading: the spinner already says the control is busy, and fading the
        // whole track would hide the option the user just picked.
        "pointer-events-none": e.loading
      }], "v-segmented-control relative inline-flex items-center rounded-lg bg-base-200 p-1 border-[1px] border-base-400 shadow-md gap-1"])
    }, [
      E("span", {
        ref: "pill",
        class: j([{ "sliding-pill--ready": o.value }, "sliding-pill absolute left-0 top-1 rounded-md pointer-events-none bg-primary/15 ring-1 ring-inset ring-primary/40 shadow-sm"])
      }, null, 2),
      (b(!0), T($e, null, Oe(e.options, (x) => (b(), T("button", {
        key: x.value,
        "aria-label": x.ariaLabel,
        "aria-pressed": f(x),
        title: x.ariaLabel,
        class: j([[
          c(x),
          e.fullWidth ? "flex-1" : "",
          f(x) ? "v-segment--active text-primary" : "text-secondaryText hover:text-mainText",
          x.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        ], "relative z-10 flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 focus-visible:ring-offset-base-200"]),
        disabled: x.disabled || e.disabled,
        type: "button",
        onClick: ($) => y(x)
      }, [
        U(h.$slots, `option-${x.value}`, {
          option: x,
          selected: f(x)
        }, () => [
          E("span", {
            class: j([{ "opacity-0": w(x) }, "flex items-center gap-1.5 transition-opacity duration-150"])
          }, [
            x.icon ? (b(), ce(ye, {
              key: 0,
              icon: x.icon,
              size: p.value
            }, null, 8, ["icon", "size"])) : P("", !0),
            x.label ? (b(), T("span", tx, le(x.label), 1)) : P("", !0),
            x.badge !== void 0 ? (b(), T("span", {
              key: 2,
              class: j([u[x.badgeColor ?? "neutral"], "ml-0.5 rounded-full px-1.5 py-0.5 text-[11px] font-semibold leading-none"])
            }, le(x.badge), 3)) : P("", !0)
          ], 2),
          w(x) ? (b(), T("span", nx, [
            se(ye, {
              size: p.value,
              icon: "lucide:loader-2",
              loading: ""
            }, null, 8, ["size"])
          ])) : P("", !0)
        ], !0)
      ], 10, ex))), 128))
    ], 10, Q1));
  }
}), sx = /* @__PURE__ */ Le(ax, [["__scopeId", "data-v-489ade9e"]]), lx = { class: "flex-none" }, rx = {
  key: 0,
  class: "v-filter-popover__summary min-w-0 truncate font-normal text-primary-700"
}, ix = {
  key: 1,
  class: "v-filter-popover__count inline-grid h-[1.125rem] min-w-[1.125rem] flex-none place-items-center rounded-full bg-primary-500 px-1 text-[0.6875rem] font-semibold tabular-nums text-white"
}, ox = { class: "flex flex-col gap-3" }, ux = {
  key: 0,
  class: "v-filter-popover__chips flex flex-wrap gap-1.5 border-b border-base-400 pb-3"
}, cx = { class: "text-[0.6875rem] font-medium uppercase tracking-wider text-secondaryText" }, dx = /* @__PURE__ */ ke({
  __name: "VFilterPopover",
  props: /* @__PURE__ */ Ft({
    groups: {},
    label: { default: "Filters" }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = rn(e, "modelValue"), t = (o) => {
      const u = n.value[o.key];
      return typeof u == "string" || typeof u == "number" ? u : o.defaultValue;
    }, a = S(
      () => e.groups.flatMap((o) => {
        const u = t(o);
        if (u === o.defaultValue) return [];
        const c = o.options.find((d) => d.value === u);
        return c ? [{ key: o.key, label: `${o.chipPrefix ?? ""}${c.label}` }] : [];
      })
    ), s = S(() => a.value.map((o) => o.label).join(", ")), l = (o, u) => {
      n.value = { ...n.value, [o]: u };
    }, r = (o, u) => {
      u !== null && l(o.key, u);
    }, i = (o) => {
      const u = e.groups.find((c) => c.key === o);
      u && l(o, u.defaultValue);
    };
    return (o, u) => (b(), ce(Ta, {
      class: "v-filter-popover flex-none max-w-full",
      "content-class": "w-[28.75rem] max-w-[calc(100vw-2rem)] origin-top-left",
      placement: "bottom-left"
    }, {
      trigger: ue(() => [
        se(vt, {
          class: "v-filter-popover__trigger max-w-full",
          modern: "",
          variant: "neutral"
        }, {
          iconLeft: ue(() => [
            se(ye, {
              size: 15,
              icon: "lucide:sliders-horizontal"
            })
          ]),
          default: ue(() => [
            E("span", lx, le(e.label), 1),
            a.value.length > 0 ? (b(), T("span", rx, le(s.value), 1)) : P("", !0),
            a.value.length > 0 ? (b(), T("span", ix, le(a.value.length), 1)) : P("", !0)
          ]),
          _: 1
        })
      ]),
      content: ue(() => [
        E("div", ox, [
          a.value.length > 0 ? (b(), T("div", ux, [
            (b(!0), T($e, null, Oe(a.value, (c) => (b(), ce(Qu, {
              key: c.key,
              label: c.label,
              closable: "",
              modern: "",
              size: "sm",
              onClose: (d) => i(c.key)
            }, null, 8, ["label", "onClose"]))), 128))
          ])) : P("", !0),
          (b(!0), T($e, null, Oe(e.groups, (c) => (b(), T("div", {
            key: c.key,
            class: "v-filter-popover__group flex flex-col gap-1.5"
          }, [
            E("h4", cx, le(c.title), 1),
            U(o.$slots, c.key, {
              update: (d) => l(c.key, d),
              value: t(c)
            }, () => [
              se(sx, {
                "model-value": t(c),
                options: c.options,
                modern: "",
                wrap: "",
                "onUpdate:modelValue": (d) => r(c, d)
              }, null, 8, ["model-value", "options", "onUpdate:modelValue"])
            ], !0)
          ]))), 128))
        ])
      ]),
      _: 3
    }));
  }
}), QD = /* @__PURE__ */ Le(dx, [["__scopeId", "data-v-24272fbf"]]);
function Sr(e) {
  return e === 0 ? !1 : Array.isArray(e) && e.length === 0 ? !0 : !e;
}
function fx(e) {
  return (...n) => !e(...n);
}
function hx(e, n) {
  return e === void 0 && (e = "undefined"), e === null && (e = "null"), e === !1 && (e = "false"), e.toString().toLowerCase().indexOf(n.trim()) !== -1;
}
function mx(e) {
  return e.filter((n) => !n.$isLabel);
}
function $r(e, n) {
  return (t) => t.reduce((a, s) => s[e] && s[e].length ? (a.push({
    $groupLabel: s[n],
    $isLabel: !0
  }), a.concat(s[e])) : a, []);
}
const du = (...e) => (n) => e.reduce((t, a) => a(t), n);
var vx = {
  data() {
    return {
      search: "",
      isOpen: !1,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: !0
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: !0
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: !0
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: !1
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(e, n) {
        return Sr(e) ? "" : n ? e[n] : e;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: !1
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: !1
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: !1
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: !1
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const e = this.search || "", n = e.toLowerCase().trim();
      let t = this.options.concat();
      return this.internalSearch ? t = this.groupValues ? this.filterAndFlat(t, n, this.label) : this.filterOptions(t, n, this.label, this.customLabel) : t = this.groupValues ? $r(this.groupValues, this.groupLabel)(t) : t, t = this.hideSelected ? t.filter(fx(this.isSelected)) : t, this.taggable && n.length && !this.isExistingOption(n) && (this.tagPosition === "bottom" ? t.push({ isTag: !0, label: e }) : t.unshift({ isTag: !0, label: e })), t.slice(0, this.optionsLimit);
    },
    valueKeys() {
      return this.trackBy ? this.internalValue.map((e) => e[this.trackBy]) : this.internalValue;
    },
    optionKeys() {
      return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map((n) => this.customLabel(n, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("update:modelValue", this.multiple ? [] : null));
      },
      deep: !0
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(e, n, t) {
      return du(
        this.filterGroups(n, t, this.groupValues, this.groupLabel, this.customLabel),
        $r(this.groupValues, this.groupLabel)
      )(e);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(e) {
      return du(
        $r(this.groupValues, this.groupLabel),
        mx
      )(e);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(e) {
      this.search = e;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(e) {
      return this.options ? this.optionKeys.indexOf(e) > -1 : !1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(e) {
      const n = this.trackBy ? e[this.trackBy] : e;
      return this.valueKeys.indexOf(n) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(e) {
      return !!e.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(e) {
      if (Sr(e)) return "";
      if (e.isTag) return e.label;
      if (e.$isLabel) return e.$groupLabel;
      const n = this.customLabel(e, this.label);
      return Sr(n) ? "" : n;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(e, n) {
      if (e.$isLabel && this.groupSelect) {
        this.selectGroup(e);
        return;
      }
      if (!(this.blockKeys.indexOf(n) !== -1 || this.disabled || e.$isDisabled || e.$isLabel) && !(this.max && this.multiple && this.internalValue.length === this.max) && !(n === "Tab" && !this.pointerDirty)) {
        if (e.isTag)
          this.$emit("tag", e.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();
        else {
          if (this.isSelected(e)) {
            n !== "Tab" && this.removeElement(e);
            return;
          }
          this.multiple ? this.$emit("update:modelValue", this.internalValue.concat([e])) : this.$emit("update:modelValue", e), this.$emit("select", e, this.id), this.clearOnSelect && (this.search = "");
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(e) {
      const n = this.options.find((t) => t[this.groupLabel] === e.$groupLabel);
      if (n) {
        if (this.wholeGroupSelected(n)) {
          this.$emit("remove", n[this.groupValues], this.id);
          const t = this.trackBy ? n[this.groupValues].map((s) => s[this.trackBy]) : n[this.groupValues], a = this.internalValue.filter(
            (s) => t.indexOf(this.trackBy ? s[this.trackBy] : s) === -1
          );
          this.$emit("update:modelValue", a);
        } else {
          const t = n[this.groupValues].filter(
            (a) => !(this.isOptionDisabled(a) || this.isSelected(a))
          );
          this.max && t.splice(this.max - this.internalValue.length), this.$emit("select", t, this.id), this.$emit(
            "update:modelValue",
            this.internalValue.concat(t)
          );
        }
        this.closeOnSelect && this.deactivate();
      }
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(e) {
      return e[this.groupValues].every(
        (n) => this.isSelected(n) || this.isOptionDisabled(n)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(e) {
      return e[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(e, n = !0) {
      if (this.disabled || e.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const t = typeof e == "object" ? this.valueKeys.indexOf(e[this.trackBy]) : this.valueKeys.indexOf(e);
      if (this.multiple) {
        const a = this.internalValue.slice(0, t).concat(this.internalValue.slice(t + 1));
        this.$emit("update:modelValue", a);
      } else
        this.$emit("update:modelValue", null);
      this.$emit("remove", e, this.id), this.closeOnSelect && n && this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      this.blockKeys.indexOf("Delete") === -1 && this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && this.pointer === 0 && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.preventAutofocus || this.$nextTick(() => this.$refs.search && this.$refs.search.focus())) : this.preventAutofocus || typeof this.$el < "u" && this.$el.focus(), this.$emit("open", this.id));
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search !== null && typeof this.$refs.search < "u" && this.$refs.search.blur() : typeof this.$el < "u" && this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window > "u") return;
      const e = this.$el.getBoundingClientRect().top, n = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      n > this.maxHeight || n > e || this.openDirection === "below" || this.openDirection === "bottom" ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(n - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(e - 40, this.maxHeight));
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(e, n, t, a) {
      return n ? e.filter((s) => hx(a(s, t), n)).sort((s, l) => typeof this.filteringSortFunc == "function" ? this.filteringSortFunc(s, l) : a(s, t).length - a(l, t).length) : e;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(e, n, t, a, s) {
      return (l) => l.map((r) => {
        if (!r[t])
          return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
        const i = this.filterOptions(r[t], e, n, s);
        return i.length ? {
          [a]: r[a],
          [t]: i
        } : [];
      });
    }
  }
}, px = {
  data() {
    return {
      pointer: 0,
      pointerDirty: !1
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: !0
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = !1;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(e, n) {
      return {
        "multiselect__option--highlight": e === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(n)
      };
    },
    groupHighlight(e, n) {
      if (!this.groupSelect)
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": n.$isLabel }
        ];
      const t = this.options.find((a) => a[this.groupLabel] === n.$groupLabel);
      return t && !this.wholeGroupDisabled(t) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": e === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(t) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key: e } = "Enter") {
      this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
    },
    pointerForward() {
      var e;
      this.pointer < this.filteredOptions.length - 1 && (this.pointer++, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
    },
    pointerBackward() {
      var e;
      this.pointer > 0 ? (this.pointer--, ((e = this.$refs.list) == null ? void 0 : e.scrollTop) >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
    },
    pointerReset() {
      this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
    },
    pointerAdjust() {
      this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
    },
    pointerSet(e) {
      this.pointer = e, this.pointerDirty = !0;
    }
  }
}, nf = {
  name: "vue-multiselect",
  mixins: [vx, px],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: !1
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: !0
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (e) => `and ${e} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: !1
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: !0
    },
    showNoResults: {
      type: Boolean,
      default: !0
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: !1
    },
    /**
     * Uses Vue Teleport's feature. Teleports the open dropdown to the bottom of the body element
     * @default false
     * @type {Boolean}
     */
    useTeleport: {
      type: Boolean,
      default: !1
    },
    /**
     * Classes to apply to the `multiselect__content-wrapper` element. This element is a teleport element (when enabled), so can be used to specifically target
     * the teleported element
     */
    contentWrapperClass: {
      type: [String, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dropdownStyles: {},
      ready: !1
    };
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      return this.searchable || this.multiple && this.modelValue && this.modelValue.length ? this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" } : "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      return this.openDirection === "above" || this.openDirection === "top" ? !0 : this.openDirection === "below" || this.openDirection === "bottom" ? !1 : this.preferredOpenDirection === "above";
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : !0);
    },
    isRequired() {
      return this.required === !1 ? !1 : this.internalValue.length <= 0;
    }
  },
  watch: {
    isOpen(e) {
      e && (this.useTeleport ? (this.ready = !1, this.$nextTick(() => {
        const n = this.$el.getBoundingClientRect();
        this.dropdownStyles = {
          position: "absolute",
          top: `${n.bottom + window.scrollY}px`,
          left: `${n.left + window.scrollX}px`,
          width: `${n.width}px`,
          zIndex: 9999
        }, this.ready = !0;
      })) : this.ready = !0);
    }
  }
};
const gx = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"], yx = {
  ref: "tags",
  class: "multiselect__tags"
}, bx = { class: "multiselect__tags-wrap" }, wx = ["textContent"], kx = ["onKeydown", "onMousedown"], xx = ["textContent"], Sx = { class: "multiselect__spinner" }, $x = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"], Tx = ["id", "aria-multiselectable"], Cx = { key: 0 }, Mx = { class: "multiselect__option" }, Dx = ["aria-selected", "id", "role"], _x = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"], Ox = ["data-select", "data-deselect", "onMouseenter", "onMousedown"], Ex = { class: "multiselect__option" }, Ix = { class: "multiselect__option" };
function Ax(e, n, t, a, s, l) {
  return b(), T("div", {
    tabindex: e.searchable ? -1 : t.tabindex,
    class: j([{ "multiselect--active": e.isOpen, "multiselect--disabled": t.disabled, "multiselect--above": l.isAbove, "multiselect--has-options-group": l.hasOptionGroup }, "multiselect"]),
    onFocus: n[14] || (n[14] = (r) => e.activate()),
    onBlur: n[15] || (n[15] = (r) => e.searchable ? !1 : e.deactivate()),
    onKeydown: [
      n[16] || (n[16] = Pt(Ve((r) => e.pointerForward(), ["self", "prevent"]), ["down"])),
      n[17] || (n[17] = Pt(Ve((r) => e.pointerBackward(), ["self", "prevent"]), ["up"])),
      n[18] || (n[18] = Pt(Ve((r) => e.addPointerElement(r), ["stop", "self"]), ["enter", "tab"]))
    ],
    onKeyup: n[19] || (n[19] = Pt((r) => e.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": e.isOpen,
    "aria-owns": "listbox-" + e.id,
    "aria-activedescendant": e.isOpen && e.pointer !== null ? e.id + "-" + e.pointer : null
  }, [
    U(e.$slots, "caret", { toggle: e.toggle }, () => [
      E(
        "div",
        {
          onMousedown: n[0] || (n[0] = Ve((r) => e.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    U(e.$slots, "clear", { search: e.search }),
    E(
      "div",
      yx,
      [
        U(e.$slots, "selection", {
          search: e.search,
          remove: e.removeElement,
          values: l.visibleValues,
          isOpen: e.isOpen
        }, () => [
          Gt(E(
            "div",
            bx,
            [
              (b(!0), T(
                $e,
                null,
                Oe(l.visibleValues, (r, i) => U(e.$slots, "tag", {
                  option: r,
                  search: e.search,
                  remove: e.removeElement
                }, () => [
                  (b(), T(
                    "span",
                    {
                      class: "multiselect__tag",
                      key: i,
                      onMousedown: n[1] || (n[1] = Ve(() => {
                      }, ["prevent"]))
                    },
                    [
                      E("span", {
                        textContent: le(e.getOptionLabel(r))
                      }, null, 8, wx),
                      E("i", {
                        tabindex: "1",
                        onKeydown: Pt(Ve((o) => e.removeElement(r), ["prevent"]), ["enter"]),
                        onMousedown: Ve((o) => e.removeElement(r), ["prevent"]),
                        class: "multiselect__tag-icon"
                      }, null, 40, kx)
                    ],
                    32
                    /* NEED_HYDRATION */
                  ))
                ])),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [Bn, l.visibleValues.length > 0]
          ]),
          e.internalValue && e.internalValue.length > t.limit ? U(e.$slots, "limit", { key: 0 }, () => [
            E("strong", {
              class: "multiselect__strong",
              textContent: le(t.limitText(e.internalValue.length - t.limit))
            }, null, 8, xx)
          ]) : P("v-if", !0)
        ]),
        se(ht, { name: "multiselect__loading" }, {
          default: ue(() => [
            U(e.$slots, "loading", {}, () => [
              Gt(E(
                "div",
                Sx,
                null,
                512
                /* NEED_PATCH */
              ), [
                [Bn, t.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        e.searchable ? (b(), T("input", {
          key: 0,
          ref: "search",
          name: t.name,
          id: e.id,
          type: "text",
          autocomplete: "off",
          spellcheck: t.spellcheck,
          placeholder: e.placeholder,
          required: l.isRequired,
          style: Fe(l.inputStyle),
          value: e.search,
          disabled: t.disabled,
          tabindex: t.tabindex,
          "aria-label": t.name + "-searchbox",
          onInput: n[2] || (n[2] = (r) => e.updateSearch(r.target.value)),
          onFocus: n[3] || (n[3] = Ve((r) => e.activate(), ["prevent"])),
          onBlur: n[4] || (n[4] = Ve((r) => e.deactivate(), ["prevent"])),
          onKeyup: n[5] || (n[5] = Pt((r) => e.deactivate(), ["esc"])),
          onKeydown: [
            n[6] || (n[6] = Pt(Ve((r) => e.pointerForward(), ["prevent"]), ["down"])),
            n[7] || (n[7] = Pt(Ve((r) => e.pointerBackward(), ["prevent"]), ["up"])),
            n[8] || (n[8] = Pt(Ve((r) => e.addPointerElement(r), ["prevent", "stop", "self"]), ["enter"])),
            n[9] || (n[9] = Pt(Ve((r) => e.removeLastElement(), ["stop"]), ["delete"]))
          ],
          class: "multiselect__input",
          "aria-controls": "listbox-" + e.id
        }, null, 44, $x)) : P("v-if", !0),
        l.isSingleLabelVisible ? (b(), T(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: n[10] || (n[10] = Ve((...r) => e.toggle && e.toggle(...r), ["prevent"]))
          },
          [
            U(e.$slots, "singleLabel", { option: l.singleValue }, () => [
              He(
                le(e.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : P("v-if", !0),
        l.isPlaceholderVisible ? (b(), T(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: n[11] || (n[11] = Ve((...r) => e.toggle && e.toggle(...r), ["prevent"]))
          },
          [
            U(e.$slots, "placeholder", {}, () => [
              He(
                le(e.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : P("v-if", !0)
      ],
      512
      /* NEED_PATCH */
    ),
    (b(), ce(Pn, {
      to: "body",
      disabled: !t.useTeleport
    }, [
      se(ht, { name: "multiselect" }, {
        default: ue(() => [
          e.isOpen && s.ready ? (b(), T(
            "div",
            {
              key: 0,
              class: j(["multiselect__content-wrapper", t.contentWrapperClass]),
              onFocus: n[12] || (n[12] = (...r) => e.activate && e.activate(...r)),
              tabindex: "-1",
              onMousedown: n[13] || (n[13] = Ve(() => {
              }, ["prevent"])),
              style: Fe([s.dropdownStyles, { maxHeight: e.optimizedHeight + "px" }]),
              ref: "list"
            },
            [
              E("ul", {
                class: "multiselect__content",
                style: Fe(l.contentStyle),
                role: "listbox",
                id: "listbox-" + e.id,
                "aria-multiselectable": e.multiple
              }, [
                U(e.$slots, "beforeList"),
                e.multiple && e.max === e.internalValue.length ? (b(), T("li", Cx, [
                  E("span", Mx, [
                    U(e.$slots, "maxElements", {}, () => [
                      He(
                        "Maximum of " + le(e.max) + " options selected. First remove a selected option to select another.",
                        1
                        /* TEXT */
                      )
                    ])
                  ])
                ])) : P("v-if", !0),
                !e.max || e.internalValue.length < e.max ? (b(!0), T(
                  $e,
                  { key: 1 },
                  Oe(e.filteredOptions, (r, i) => (b(), T("li", {
                    class: "multiselect__element",
                    key: i,
                    "aria-selected": e.isSelected(r),
                    id: e.id + "-" + i,
                    role: r && (r.$isLabel || r.$isDisabled) ? null : "option"
                  }, [
                    r && (r.$isLabel || r.$isDisabled) ? P("v-if", !0) : (b(), T("span", {
                      key: 0,
                      class: j([e.optionHighlight(i, r), "multiselect__option"]),
                      onClick: Ve((o) => e.select(r), ["stop"]),
                      onMouseenter: Ve((o) => e.pointerSet(i), ["self"]),
                      "data-select": r && r.isTag ? e.tagPlaceholder : l.selectLabelText,
                      "data-selected": l.selectedLabelText,
                      "data-deselect": l.deselectLabelText
                    }, [
                      U(e.$slots, "option", {
                        option: r,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          le(e.getOptionLabel(r)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, _x)),
                    r && (r.$isLabel || r.$isDisabled) ? (b(), T("span", {
                      key: 1,
                      "data-select": e.groupSelect && l.selectGroupLabelText,
                      "data-deselect": e.groupSelect && l.deselectGroupLabelText,
                      class: j([e.groupHighlight(i, r), "multiselect__option"]),
                      onMouseenter: Ve((o) => e.groupSelect && e.pointerSet(i), ["self"]),
                      onMousedown: Ve((o) => e.selectGroup(r), ["prevent"])
                    }, [
                      U(e.$slots, "option", {
                        option: r,
                        search: e.search,
                        index: i
                      }, () => [
                        E(
                          "span",
                          null,
                          le(e.getOptionLabel(r)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, Ox)) : P("v-if", !0)
                  ], 8, Dx))),
                  128
                  /* KEYED_FRAGMENT */
                )) : P("v-if", !0),
                Gt(E(
                  "li",
                  null,
                  [
                    E("span", Ex, [
                      U(e.$slots, "noResult", { search: e.search }, () => [
                        n[20] || (n[20] = He("No elements found. Consider changing the search query."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Bn, t.showNoResults && e.filteredOptions.length === 0 && e.search && !t.loading]
                ]),
                Gt(E(
                  "li",
                  null,
                  [
                    E("span", Ix, [
                      U(e.$slots, "noOptions", {}, () => [
                        n[21] || (n[21] = He("List is empty."))
                      ])
                    ])
                  ],
                  512
                  /* NEED_PATCH */
                ), [
                  [Bn, t.showNoOptions && (e.options.length === 0 || l.hasOptionGroup === !0 && e.filteredOptions.length === 0) && !e.search && !t.loading]
                ]),
                U(e.$slots, "afterList")
              ], 12, Tx)
            ],
            38
            /* CLASS, STYLE, NEED_HYDRATION */
          )) : P("v-if", !0)
        ]),
        _: 3
        /* FORWARDED */
      })
    ], 8, ["disabled"]))
  ], 42, gx);
}
nf.render = Ax;
const Px = { class: "v-select" }, Rx = { class: "multiselect__select" }, Vx = {
  key: 0,
  class: "v-select__helper-text"
}, Fx = {
  key: 0,
  class: "v-select__error-message"
}, Lx = /* @__PURE__ */ ke({
  __name: "VSelect",
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Select option" },
    disabled: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !0 },
    clearOnSelect: { type: Boolean, default: !0 },
    closeOnSelect: { type: Boolean, default: !0 },
    label: { default: "label" },
    trackBy: { default: "value" },
    loading: { type: Boolean, default: !1 },
    taggable: { type: Boolean, default: !1 },
    maxHeight: { default: 300 },
    optionsLimit: { default: 1e3 },
    teleportToBody: { type: Boolean, default: !0 },
    name: { default: "" },
    allowEmpty: { type: Boolean, default: !1 },
    noResultsText: { default: "No results found" },
    helperText: { default: "" },
    validation: { default: void 0 },
    error: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "select", "remove", "search-change", "open", "close"],
  setup(e, { emit: n }) {
    const t = e, a = ["noResult", "helper-text", "error-message"], s = (D) => !a.includes(D), l = S(() => {
      var D;
      return !!((D = t.validation) != null && D.$error || t.error);
    }), r = S(() => {
      var D, z;
      return ((z = (D = t.validation) == null ? void 0 : D.$errors[0]) == null ? void 0 : z.$message) ?? t.error ?? "";
    }), i = S(() => !!t.name), o = S(() => i.value ? u.value ? t.placeholder : "" : t.placeholder), u = J(!1), c = S(() => Array.isArray(t.modelValue) ? t.modelValue.length > 0 : t.modelValue && typeof t.modelValue == "object" ? !0 : t.modelValue !== null && t.modelValue !== void 0), d = n, p = (D) => {
      d("update:modelValue", D);
    }, f = (D) => {
      d("select", D);
    }, w = (D) => {
      d("remove", D);
    }, m = (D) => {
      d("search-change", D);
    }, k = J(null);
    let y = null, h = null, g = null;
    const x = () => {
      var ie;
      if (!y || !k.value) return;
      const D = (ie = k.value.$el) == null ? void 0 : ie.querySelector(".multiselect__tags");
      if (!D) return;
      const z = D.getBoundingClientRect(), H = window.innerHeight - z.bottom, ne = Math.min(y.scrollHeight, t.maxHeight), te = H < ne && z.top > H, q = te ? Math.max(4, z.top - ne - 4) : Math.min(window.innerHeight - ne - 4, z.bottom + 4);
      Object.assign(y.style, {
        position: "fixed",
        top: `${q}px`,
        left: `${z.left}px`,
        width: `${z.width}px`,
        maxHeight: `${t.maxHeight}px`,
        zIndex: "10000"
      }), y.classList.toggle("opened-above", te);
    }, $ = () => requestAnimationFrame(x), C = () => {
      t.teleportToBody && Ke(() => {
        var D, z;
        y = (z = (D = k.value) == null ? void 0 : D.$el) == null ? void 0 : z.querySelector(".multiselect__content-wrapper"), y && (h || (g = y.parentElement, h = document.createComment("v-multiselect-anchor"), g == null || g.replaceChild(h, y), document.body.appendChild(y)), y.classList.add("v-ms-floating"), t.modern && y.classList.add("v-ms-modern"), x(), window.addEventListener("scroll", $, { passive: !0 }), window.addEventListener("resize", $, { passive: !0 }));
      });
    }, O = () => {
      y && (window.removeEventListener("scroll", $), window.removeEventListener("resize", $), y.classList.remove("v-ms-floating", "v-ms-modern", "opened-above"), y.removeAttribute("style"), h && g && g.replaceChild(y, h), h = null, g = null, y = null);
    }, _ = () => {
      C(), u.value = !0, d("open");
    }, I = () => {
      var D;
      O(), u.value = !1, (D = t.validation) == null || D.$touch(), d("close");
    };
    return ss(() => O()), (D, z) => (b(), T("div", {
      class: j([{ "v-select--modern": t.modern }, "v-select-wrapper"])
    }, [
      E("div", Px, [
        i.value ? (b(), T("label", {
          key: 0,
          class: j([{
            "v-select__label--active": u.value || c.value,
            "v-select__label--error": l.value
          }, "v-select__label"])
        }, le(t.name), 3)) : P("", !0),
        se(v(nf), lt({
          ref_key: "msRef",
          ref: k,
          "allow-empty": t.allowEmpty,
          "clear-on-select": t.clearOnSelect,
          "close-on-select": t.closeOnSelect,
          disabled: t.disabled,
          label: t.label,
          loading: t.loading,
          "max-height": t.maxHeight,
          "model-value": t.modelValue,
          multiple: t.multiple,
          options: t.options,
          "options-limit": t.optionsLimit,
          placeholder: o.value,
          searchable: t.searchable,
          "show-labels": !1,
          taggable: t.taggable,
          "track-by": t.trackBy
        }, D.$attrs, {
          onClose: I,
          onOpen: _,
          onRemove: w,
          onSelect: f,
          "onUpdate:modelValue": p,
          onSearchChange: m
        }), dt({
          caret: ue(() => [
            E("div", Rx, [
              se(ye, {
                loading: t.loading,
                class: "v-select__caret-icon",
                icon: "mdi:chevron-down"
              }, null, 8, ["loading"])
            ])
          ]),
          noResult: ue(() => [
            U(D.$slots, "noResult", {}, () => [
              He(le(t.noResultsText || "No results found"), 1)
            ], !0)
          ]),
          _: 2
        }, [
          Oe(Object.keys(D.$slots).filter(s), (H) => ({
            name: H,
            fn: ue((ne) => [
              U(D.$slots, H, Mt(zt(ne ?? {})), void 0, !0)
            ])
          }))
        ]), 1040, ["allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "loading", "max-height", "model-value", "multiple", "options", "options-limit", "placeholder", "searchable", "taggable", "track-by"]),
        E("fieldset", {
          class: j([{
            "v-select__fieldset--active": u.value,
            "v-select__fieldset--error": l.value
          }, "v-select__fieldset"]),
          "aria-hidden": "true"
        }, [
          E("legend", {
            class: j([{ "v-select__legend--visible": i.value && (c.value || u.value) }, "v-select__legend"])
          }, [
            E("span", null, le(t.name), 1)
          ], 2)
        ], 2)
      ]),
      U(D.$slots, "helper-text", {}, () => [
        t.helperText && !l.value ? (b(), T("p", Vx, le(t.helperText), 1)) : P("", !0)
      ], !0),
      se(ht, {
        mode: "out-in",
        name: "error-slide"
      }, {
        default: ue(() => [
          U(D.$slots, "error-message", {}, () => [
            l.value ? (b(), T("p", Fx, le(r.value), 1)) : P("", !0)
          ], !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Nx = /* @__PURE__ */ Le(Lx, [["__scopeId", "data-v-ca26f5be"]]), zx = ["for"], Bx = { class: "v-switch__container" }, Wx = ["id", "checked", "disabled"], Yx = { class: "v-switch__label" }, Hx = /* @__PURE__ */ ke({
  __name: "VSwitch",
  props: {
    modelValue: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    trueIcon: {},
    falseIcon: {},
    trueLabel: {},
    falseLabel: {},
    color: {},
    id: {},
    modern: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Pl(), l = Ca(), r = S(() => t.id || `v-switch-${l}`), i = S({
      get: () => !!t.modelValue,
      set: (w) => a("update:modelValue", w)
    }), o = (w) => {
      w.target instanceof HTMLInputElement && (i.value = w.target.checked, w.target.checked = i.value);
    }, u = {
      positive: "success",
      negative: "error"
    }, c = (w) => /^#|^rgb|^hsl|^oklch|^color/.test(w) ? w : `rgb(var(--color-${u[w] ?? w}) / 1)`, d = S(() => t.modern ? 10 : 16), p = S(() => t.modern ? 10 : 12), f = S(() => {
      if (t.disabled && t.modern) return {};
      if (t.disabled)
        return {
          backgroundColor: "#d1d5db",
          borderColor: "#d1d5db"
        };
      if (t.color && i.value) {
        const w = c(t.color);
        return {
          backgroundColor: w,
          borderColor: w
        };
      }
      return {};
    });
    return (w, m) => (b(), T("label", {
      class: j([{
        "v-switch--modern": t.modern,
        "v-switch--disabled": t.disabled,
        "v-switch--loading": t.loading && !t.disabled
      }, "v-switch"]),
      for: r.value
    }, [
      E("span", Bx, [
        E("input", lt({
          id: r.value,
          checked: i.value,
          disabled: t.disabled || t.loading,
          class: "v-switch__input",
          type: "checkbox"
        }, v(s), { onChange: o }), null, 16, Wx),
        E("span", {
          class: j([
            "v-switch__track",
            { "v-switch__track--checked": i.value },
            { "v-switch__track--disabled": t.disabled },
            { "v-switch__track--custom-color": t.color && i.value }
          ]),
          style: Fe(f.value)
        }, [
          E("span", {
            class: j(["v-switch__thumb", { "v-switch__thumb--checked": i.value }])
          }, [
            t.loading ? (b(), ce(ye, {
              key: 0,
              loading: !0,
              size: p.value,
              class: "v-switch__spinner",
              icon: "lucide:loading"
            }, null, 8, ["size"])) : w.$slots.icon ? U(w.$slots, "icon", { key: 1 }, () => [
              U(w.$slots, i.value ? "true-icon" : "false-icon", {}, void 0, !0)
            ], !0) : (b(), T($e, { key: 2 }, [
              i.value && t.trueIcon ? (b(), ce(ye, {
                key: 0,
                icon: t.trueIcon,
                size: d.value
              }, null, 8, ["icon", "size"])) : !i.value && t.falseIcon ? (b(), ce(ye, {
                key: 1,
                icon: t.falseIcon,
                size: d.value
              }, null, 8, ["icon", "size"])) : P("", !0)
            ], 64))
          ], 2)
        ], 6)
      ]),
      E("span", Yx, [
        U(w.$slots, "default", {}, () => [
          He(le(i.value ? t.trueLabel : t.falseLabel), 1)
        ], !0)
      ])
    ], 10, zx));
  }
}), e_ = /* @__PURE__ */ Le(Hx, [["__scopeId", "data-v-2f6c82f7"]]), tn = J(/* @__PURE__ */ new Map());
let fu = 1e3;
const af = () => {
  const e = S(() => (d) => tn.value.get(d)), n = S(() => (d) => {
    const p = tn.value.get(d);
    return p ? p.isOpen : !1;
  }), t = S(() => (d) => {
    const p = tn.value.get(d);
    return p ? p.zIndex : 1e3;
  }), a = S(() => Array.from(tn.value.values()).filter((d) => d.isOpen)), s = S(() => a.value.length > 0), l = (d) => {
    tn.value.has(d) || tn.value.set(d, {
      id: d,
      isOpen: !1,
      zIndex: 1e3
    });
  }, r = (d) => {
    tn.value.delete(d);
  }, i = (d) => {
    l(d);
    const p = tn.value.get(d);
    p && (fu += 10, p.zIndex = fu, p.isOpen = !0);
  }, o = (d) => {
    const p = tn.value.get(d);
    p && (p.isOpen = !1);
  };
  return {
    modals: tn,
    getModal: e,
    isOpen: n,
    getZIndex: t,
    openModals: a,
    hasOpenModals: s,
    register: l,
    unregister: r,
    open: i,
    close: o,
    toggle: (d) => {
      const p = tn.value.get(d);
      p && (p.isOpen ? o(d) : i(d));
    },
    closeAll: () => {
      tn.value.forEach((d) => {
        d.isOpen = !1;
      });
    }
  };
}, Xl = (e, n = !0) => {
  const t = af();
  t.register(e);
  const a = S(() => t.isOpen.value(e)), s = S(() => t.getZIndex.value(e)), l = S(() => t.getModal.value(e)), r = () => t.open(e), i = () => t.close(e), o = () => t.toggle(e);
  return n && ss(() => {
    t.unregister(e);
  }), {
    isOpen: a,
    zIndex: s,
    modal: l,
    open: r,
    close: i,
    toggle: o
  };
}, hu = { duration: 200, easing: "cubic-bezier(0, 0, 0.2, 1)" }, mu = { duration: 160, easing: "cubic-bezier(0.4, 0, 1, 1)" }, dl = 0, Tr = () => {
  const { innerWidth: e, innerHeight: n } = window;
  return {
    top: n * dl,
    left: e * dl,
    width: e * (1 - 2 * dl),
    height: n * (1 - 2 * dl)
  };
}, vu = (e) => e instanceof HTMLElement ? e : void 0, Ux = (e) => {
  var t;
  const n = vu(e);
  return n ? n.offsetHeight : ((t = vu(e == null ? void 0 : e.$el)) == null ? void 0 : t.offsetHeight) ?? 0;
}, ai = "v-table-fullscreen", xs = J(!1);
let Cr = null;
const pu = (e, n, t) => {
  const a = n.width / t.width, s = n.height / t.height, l = n.left - t.left, r = n.top - t.top;
  e.style.transformOrigin = "top left", e.style.transform = `translate(${l}px, ${r}px) scale(${a}, ${s})`;
}, qx = (e) => {
  const { wrapperRef: n, placeholderRef: t } = e, a = J(!1), s = J(null), l = J(null), r = J(0);
  let i = null, o = null, u = 0, c = !1;
  const { zIndex: d, open: p, close: f } = Xl(ai, !1), w = af(), m = () => {
    r.value = (e.chromeRefs ?? []).reduce((D, z) => D + Ux(z.value), 0);
  }, k = async () => {
    const D = n.value;
    if (!D) return;
    const z = ++u, H = D.getBoundingClientRect();
    s.value = H, l.value = Tr(), m();
    const ne = window.scrollX, te = window.scrollY;
    if (a.value = !0, await Ke(), z !== u) return;
    (window.scrollX !== ne || window.scrollY !== te) && window.scrollTo({ left: ne, top: te, behavior: "instant" }), D.style.transition = "none";
    const q = D.getBoundingClientRect();
    pu(D, H, q), D.offsetHeight, D.style.transition = `transform ${hu.duration}ms ${hu.easing}`, D.style.transform = "translate(0, 0) scale(1, 1)";
    const ie = (L) => {
      L.target !== D || L.propertyName !== "transform" || (D.removeEventListener("transitionend", ie), o = null, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    o = { el: D, handler: ie }, D.addEventListener("transitionend", ie);
  }, y = async () => {
    var L;
    const D = n.value;
    if (!D) return;
    const z = ++u, H = window.scrollX, ne = window.scrollY;
    if (await Ke(), z !== u) return;
    (window.scrollX !== H || window.scrollY !== ne) && window.scrollTo({ left: H, top: ne, behavior: "instant" }), o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null);
    const te = D.getBoundingClientRect(), q = ((L = t == null ? void 0 : t.value) == null ? void 0 : L.getBoundingClientRect()) ?? s.value ?? te;
    D.style.transition = `transform ${mu.duration}ms ${mu.easing}`, pu(D, q, te);
    const ie = (ae) => {
      ae.target !== D || ae.propertyName !== "transform" || (D.removeEventListener("transitionend", ie), i = null, a.value = !1, D.style.transform = "", D.style.transition = "", D.style.transformOrigin = "");
    };
    i = { el: D, handler: ie }, D.addEventListener("transitionend", ie);
  }, h = () => {
    a.value ? y() : k();
  }, g = () => {
    a.value && y();
  };
  Ne(a, (D) => {
    D ? p() : c || f();
  });
  const x = (D) => {
    D.key !== "Escape" || !a.value || Math.max(
      0,
      ...w.openModals.value.filter((H) => H.id !== ai).map((H) => H.zIndex)
    ) > d.value || h();
  };
  Ne(a, (D) => {
    D ? window.addEventListener("keydown", x) : window.removeEventListener("keydown", x);
  });
  const $ = () => {
    a.value && (l.value = Tr(), m());
  };
  Ne(a, (D) => {
    D ? window.addEventListener("resize", $) : window.removeEventListener("resize", $);
  }), Ne(a, async (D) => {
    var z;
    await Ke(), await ((z = e.onToggle) == null ? void 0 : z.call(e, D));
  });
  const C = () => {
    m(), s.value = Cr, l.value = Tr(), a.value = !0;
  };
  Ru(() => {
    a.value && (c = !0, l.value = null, a.value = !1, u += 1, o && (o.el.removeEventListener("transitionend", o.handler), o = null), i && (i.el.removeEventListener("transitionend", i.handler), i = null), xs.value = !0, Cr = s.value, Ke().then(() => {
      c = !1, xs.value && (xs.value = !1, Cr = null, f());
    }));
  }), Vu(() => {
    xs.value && Qe(e.isEnabled) && (xs.value = !1, C());
  }), Jt(() => {
    a.value && f(), window.removeEventListener("keydown", x), window.removeEventListener("resize", $), i && (i.el.removeEventListener("transitionend", i.handler), i = null), o && (o.el.removeEventListener("transitionend", o.handler), o = null);
  });
  const O = S(() => !a.value || !s.value ? null : {
    width: `${s.value.width}px`,
    height: `${s.value.height}px`
  }), _ = S(() => {
    if (!a.value || !l.value) return null;
    const { top: D, left: z, width: H, height: ne } = l.value;
    return {
      top: `${D}px`,
      left: `${z}px`,
      width: `${H}px`,
      height: `${ne}px`
    };
  }), I = S(() => !a.value || !l.value ? 0 : l.value.height - r.value);
  return {
    isFullscreen: ri(a),
    isEnabled: S(() => Qe(e.isEnabled)),
    zIndex: d,
    placeholderStyle: O,
    panelStyle: _,
    contentHeight: I,
    toggle: h,
    close: g
  };
}, jx = { class: "v-bulk-action-bar__count" }, Gx = { class: "v-bulk-action-bar__badge" }, Kx = /* @__PURE__ */ ke({
  __name: "VBulkActionBar",
  props: /* @__PURE__ */ Ft({
    items: {},
    clearOn: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ft(["clear"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = rn(e, "modelValue"), a = n, { isOpen: s, zIndex: l } = Xl(
      ai,
      !1
    ), r = S(() => t.value.length), i = S(() => r.value > 0), o = S(() => {
      var w;
      return ((w = e.items) == null ? void 0 : w.length) ?? null;
    }), u = S(
      () => o.value !== null && r.value < o.value
    ), c = S(() => s.value ? l.value + 2 : 50), d = S(() => JSON.stringify(e.clearOn ?? null)), p = () => {
      t.value = [], a("clear");
    }, f = () => {
      e.items && (t.value = [...e.items]);
    };
    return Ne(d, () => {
      r.value && p();
    }), (w, m) => (b(), ce(Pn, { to: "body" }, [
      se(ht, { name: "v-bulk-action-bar" }, {
        default: ue(() => [
          i.value ? (b(), T("div", {
            key: 0,
            style: Fe({ zIndex: c.value }),
            class: "v-bulk-action-bar"
          }, [
            E("div", jx, [
              E("span", Gx, le(r.value), 1),
              m[0] || (m[0] = E("span", { class: "v-bulk-action-bar__label" }, "selected", -1))
            ]),
            u.value ? (b(), T("button", {
              key: 0,
              class: "v-bulk-action-bar__select-all",
              type: "button",
              onClick: f
            }, " Select all " + le(o.value), 1)) : P("", !0),
            m[1] || (m[1] = E("div", { class: "v-bulk-action-bar__divider" }, null, -1)),
            U(w.$slots, "actions", {}, void 0, !0),
            E("button", {
              "aria-label": "Clear selection",
              class: "v-bulk-action-bar__clear",
              type: "button",
              onClick: p
            }, [
              se(ye, {
                size: 16,
                icon: "lucide:x"
              })
            ])
          ], 4)) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), t_ = /* @__PURE__ */ Le(Kx, [["__scopeId", "data-v-ecadfb85"]]), Zx = ["data-overlay-open"], Xx = {
  key: 0,
  class: "v-drawer__header"
}, Jx = {
  key: 0,
  class: "v-drawer__title"
}, Qx = {
  key: 1,
  fill: "none",
  height: "24",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, eS = { class: "v-drawer__content" }, tS = {
  key: 1,
  class: "v-drawer__footer"
}, nS = /* @__PURE__ */ ke({
  __name: "VDrawer",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    position: { default: "right" },
    width: { default: "md" },
    backdropBlur: { default: "xs" },
    keepAlive: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["close", "open"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: l, zIndex: r } = Xl(t.id), i = S(() => `v-drawer__container--width-${t.width}`), o = S(() => `v-drawer__container--${t.position}`), u = S(() => t.backdropBlur === "none" ? "" : `v-drawer__backdrop--blur-${t.backdropBlur}`), c = () => {
      l(), a("close");
    }, d = () => {
      t.closeOnBackdrop && c();
    }, p = (f) => {
      t.closeOnEscape && f.key === "Escape" && c();
    };
    return (f, w) => (b(), ce(Pn, { to: "body" }, [
      se(ht, {
        name: "v-drawer",
        onAfterEnter: w[1] || (w[1] = (m) => a("open"))
      }, {
        default: ue(() => [
          e.keepAlive || v(s) ? Gt((b(), T("div", {
            key: 0,
            class: j([[u.value, { "v-drawer--modern": e.modern }], "v-drawer__backdrop"]),
            "data-overlay-open": v(s) || void 0,
            style: Fe({ zIndex: v(r) }),
            onClick: d,
            onKeydown: p
          }, [
            E("div", {
              class: j([[i.value, o.value], "v-drawer__container"]),
              onClick: w[0] || (w[0] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || f.$slots.header ? (b(), T("div", Xx, [
                U(f.$slots, "header", {}, () => [
                  e.title ? (b(), T("h3", Jx, le(e.title), 1)) : P("", !0)
                ], !0),
                e.showCloseButton ? (b(), T("button", {
                  key: 0,
                  "aria-label": "Close drawer",
                  class: "v-drawer__close-btn",
                  type: "button",
                  onClick: c
                }, [
                  e.modern ? (b(), ce(ye, {
                    key: 0,
                    size: 16,
                    icon: "lucide:x"
                  })) : (b(), T("svg", Qx, [...w[2] || (w[2] = [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }, null, -1),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    }, null, -1)
                  ])]))
                ])) : P("", !0)
              ])) : P("", !0),
              E("div", eS, [
                U(f.$slots, "default", {}, void 0, !0)
              ]),
              f.$slots.footer ? (b(), T("div", tS, [
                U(f.$slots, "footer", {}, void 0, !0)
              ])) : P("", !0)
            ], 2)
          ], 46, Zx)), [
            [Bn, e.keepAlive ? v(s) : !0]
          ]) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), n_ = /* @__PURE__ */ Le(nS, [["__scopeId", "data-v-5a5b6aa2"]]), aS = ["data-overlay-open"], sS = {
  key: 0,
  class: "modal-header"
}, lS = {
  key: 0,
  class: "modal-heading"
}, rS = {
  key: 0,
  class: "modal-title"
}, iS = {
  key: 0,
  class: "modal-description"
}, oS = {
  key: 0,
  class: "modal-title"
}, uS = {
  key: 1,
  fill: "none",
  height: "24",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, cS = { class: "modal-content" }, dS = {
  key: 1,
  class: "modal-footer"
}, fS = {
  key: 0,
  class: "modal-footer-actions"
}, hS = /* @__PURE__ */ ke({
  __name: "VModal",
  props: {
    id: {},
    title: { default: "" },
    showCloseButton: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    maxWidth: { default: "md" },
    footerActions: { type: [Boolean, Object], default: void 0 },
    loading: { type: Boolean },
    description: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["close", "open", "confirm"],
  setup(e, { emit: n }) {
    const t = e, a = n, { isOpen: s, close: l, zIndex: r } = Xl(t.id), i = S(() => `modal-container--${t.maxWidth}`), o = {
      confirmText: "Confirm",
      cancelText: "Cancel",
      confirmVariant: "primary",
      cancelVariant: "default",
      showConfirm: !0,
      showCancel: !0
    }, u = S(() => t.footerActions ? t.footerActions === !0 ? o : { ...o, ...t.footerActions } : null), c = () => {
      l(), a("close");
    }, d = () => {
      t.closeOnBackdrop && c();
    }, p = (f) => {
      t.closeOnEscape && f.key === "Escape" && c();
    };
    return (f, w) => (b(), ce(Pn, { to: "body" }, [
      se(ht, {
        name: e.modern ? "modal-modern" : "modal",
        onAfterEnter: w[2] || (w[2] = (m) => a("open"))
      }, {
        default: ue(() => [
          v(s) ? (b(), T("div", {
            key: 0,
            class: j([{ "modal-backdrop--modern": e.modern }, "modal-backdrop"]),
            "data-overlay-open": v(s) || void 0,
            style: Fe({ zIndex: v(r) }),
            onClick: d,
            onKeydown: p
          }, [
            E("div", {
              class: j([i.value, "modal-container"]),
              onClick: w[1] || (w[1] = Ve(() => {
              }, ["stop"]))
            }, [
              e.title || e.showCloseButton || f.$slots.header ? (b(), T("div", sS, [
                e.modern ? (b(), T("div", lS, [
                  U(f.$slots, "header", {}, () => [
                    e.title ? (b(), T("h3", rS, le(e.title), 1)) : P("", !0)
                  ], !0),
                  e.description ? (b(), T("p", iS, le(e.description), 1)) : P("", !0)
                ])) : U(f.$slots, "header", { key: 1 }, () => [
                  e.title ? (b(), T("h3", oS, le(e.title), 1)) : P("", !0)
                ], !0),
                e.showCloseButton ? (b(), T("button", {
                  key: 2,
                  "aria-label": "Close modal",
                  class: "modal-close-btn",
                  type: "button",
                  onClick: c
                }, [
                  e.modern ? (b(), ce(ye, {
                    key: 0,
                    size: 16,
                    icon: "lucide:x"
                  })) : (b(), T("svg", uS, [...w[3] || (w[3] = [
                    E("line", {
                      x1: "18",
                      x2: "6",
                      y1: "6",
                      y2: "18"
                    }, null, -1),
                    E("line", {
                      x1: "6",
                      x2: "18",
                      y1: "6",
                      y2: "18"
                    }, null, -1)
                  ])]))
                ])) : P("", !0)
              ])) : P("", !0),
              E("div", cS, [
                U(f.$slots, "default", {}, void 0, !0)
              ]),
              f.$slots.footer || u.value ? (b(), T("div", dS, [
                U(f.$slots, "footer", {}, () => [
                  u.value ? (b(), T("div", fS, [
                    u.value.showCancel ? (b(), ce(vt, {
                      key: 0,
                      disabled: t.loading,
                      modern: t.modern,
                      variant: u.value.cancelVariant,
                      type: "button",
                      onClick: c
                    }, {
                      default: ue(() => [
                        He(le(u.value.cancelText), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "modern", "variant"])) : P("", !0),
                    u.value.showConfirm ? (b(), ce(vt, {
                      key: 1,
                      loading: t.loading,
                      modern: t.modern,
                      variant: u.value.confirmVariant,
                      type: "button",
                      onClick: w[0] || (w[0] = (m) => a("confirm"))
                    }, {
                      default: ue(() => [
                        He(le(u.value.confirmText), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "modern", "variant"])) : P("", !0)
                  ])) : P("", !0)
                ], !0)
              ])) : P("", !0)
            ], 2)
          ], 46, aS)) : P("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), a_ = /* @__PURE__ */ Le(hS, [["__scopeId", "data-v-429bb3b1"]]), mS = (e) => {
  const n = Nu(), t = J(!0), a = J(!1), s = J(null), l = () => t.value && Qe((e == null ? void 0 : e.when) ?? !0);
  Af((c) => c.meta.requiresAuth === !1 || !l() ? !0 : (a.value = !0, s.value = c, !1)), Ne(
    [() => Qe((e == null ? void 0 : e.when) ?? !0), t],
    ([c, d]) => {
      (!c || !d) && a.value && i();
    }
  );
  const r = () => {
    if (!s.value) return;
    const c = s.value;
    t.value = !1, a.value = !1, s.value = null, n.push(c).finally(() => {
      t.value = !0;
    });
  }, i = () => {
    a.value = !1, s.value = null;
  };
  return { isPending: a, pendingTo: s, isEnabled: t, confirm: r, cancel: i, enable: () => {
    t.value = !0;
  }, disable: () => {
    t.value = !1;
  } };
}, vS = ["aria-label"], pS = {
  key: 0,
  class: "unsaved-changes__card mx-4 flex w-full max-w-sm overflow-hidden rounded-xl"
}, gS = { class: "flex flex-1 flex-col p-5" }, yS = { class: "flex items-start gap-3" }, bS = { class: "min-w-0 flex-1" }, wS = { class: "mb-1 text-sm font-semibold leading-snug text-mainText" }, kS = { class: "text-xs leading-relaxed text-secondaryText" }, xS = { class: "mt-4 flex items-center justify-end gap-2 border-t border-base-300 pt-4" }, SS = /* @__PURE__ */ ke({
  __name: "VUnsavedChangesModal",
  props: {
    open: { type: Boolean, default: !1 },
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" },
    zIndex: { default: 50 }
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: n }) {
    const t = n, a = Ge("dialog");
    return Ne(() => e.open, (s) => {
      s && Ke(() => {
        var l;
        return (l = a.value) == null ? void 0 : l.focus();
      });
    }), (s, l) => (b(), ce(Pn, { to: "body" }, [
      se(ht, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: ue(() => [
          e.open ? (b(), T("div", {
            key: 0,
            ref: "dialog",
            "aria-label": e.title,
            style: Fe({ "--_z-index": e.zIndex }),
            "aria-modal": "true",
            class: "unsaved-changes__backdrop fixed inset-0 flex items-center justify-center",
            role: "dialog",
            tabindex: "-1",
            onClick: l[3] || (l[3] = Ve((r) => t("cancel"), ["self"])),
            onKeydown: l[4] || (l[4] = Pt((r) => t("cancel"), ["esc"]))
          }, [
            se(ht, {
              appear: "",
              "enter-active-class": "transition duration-200 ease-out",
              "enter-from-class": "opacity-0 scale-95 -translate-y-2",
              "enter-to-class": "opacity-100 scale-100 translate-y-0",
              "leave-active-class": "transition duration-150 ease-in",
              "leave-from-class": "opacity-100 scale-100 translate-y-0",
              "leave-to-class": "opacity-0 scale-95 -translate-y-2"
            }, {
              default: ue(() => [
                e.open ? (b(), T("div", pS, [
                  l[7] || (l[7] = E("div", { class: "w-1 flex-shrink-0 bg-gradient-to-b from-warning via-warning/60 to-warning/10" }, null, -1)),
                  E("div", gS, [
                    E("div", yS, [
                      l[6] || (l[6] = E("div", { class: "mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-warning-200 bg-warning-50" }, [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-4 w-4 text-warning",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2.2",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }),
                          E("path", { d: "M12 9v4" }),
                          E("path", { d: "M12 17h.01" })
                        ])
                      ], -1)),
                      E("div", bS, [
                        E("h2", wS, le(e.title), 1),
                        E("div", kS, [
                          U(s.$slots, "description", {}, () => [
                            He(le(e.description), 1)
                          ], !0)
                        ])
                      ]),
                      E("button", {
                        "aria-label": "Cancel and keep editing",
                        class: "-mr-1 -mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-secondaryText transition-colors hover:bg-base-200",
                        type: "button",
                        onClick: l[0] || (l[0] = (r) => t("cancel"))
                      }, [...l[5] || (l[5] = [
                        E("svg", {
                          "aria-hidden": "true",
                          class: "h-3.5 w-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          viewBox: "0 0 24 24"
                        }, [
                          E("path", { d: "M18 6 6 18M6 6l12 12" })
                        ], -1)
                      ])])
                    ]),
                    E("div", xS, [
                      E("button", {
                        class: "h-8 rounded-md border border-error/25 bg-transparent px-3 text-xs text-error transition-all hover:border-error/40 hover:bg-error/5 active:scale-95",
                        type: "button",
                        onClick: l[1] || (l[1] = (r) => t("confirm"))
                      }, le(e.leaveLabel), 1),
                      E("button", {
                        class: "h-8 rounded-md border-2 border-primary bg-primary px-4 text-xs text-white shadow-sm transition-all hover:border-primary-dark hover:bg-primary-dark active:scale-95",
                        type: "button",
                        onClick: l[2] || (l[2] = (r) => t("cancel"))
                      }, le(e.confirmLabel), 1)
                    ])
                  ])
                ])) : P("", !0)
              ]),
              _: 3
            })
          ], 44, vS)) : P("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), $S = /* @__PURE__ */ Le(SS, [["__scopeId", "data-v-4050f9cd"]]), s_ = /* @__PURE__ */ ke({
  __name: "NavigationGuardModal",
  props: {
    when: {},
    title: { default: "Unsaved changes" },
    description: { default: "Leaving now will discard your changes. This cannot be undone." },
    confirmLabel: { default: "Keep editing" },
    leaveLabel: { default: "Discard & leave" }
  },
  setup(e) {
    const { isPending: n, confirm: t, cancel: a } = mS({ when: () => Qe(e.when) });
    return (s, l) => (b(), ce($S, {
      "confirm-label": e.confirmLabel,
      description: e.description,
      "leave-label": e.leaveLabel,
      open: v(n),
      title: e.title,
      onCancel: v(a),
      onConfirm: v(t)
    }, dt({ _: 2 }, [
      s.$slots.description ? {
        name: "description",
        fn: ue(() => [
          U(s.$slots, "description")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["confirm-label", "description", "leave-label", "open", "title", "onCancel", "onConfirm"]));
  }
}), TS = { class: "v-meter" }, CS = ["aria-valuemax", "aria-valuenow"], MS = /* @__PURE__ */ ke({
  __name: "VMeter",
  props: {
    value: {},
    max: {},
    goal: { default: "reach" },
    label: {},
    hint: {},
    pending: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  setup(e) {
    const n = S(() => e.value !== null), t = S(() => e.value === null ? !1 : e.goal === "reach" ? e.value >= e.max : e.value <= e.max), a = S(() => e.value === null || e.max <= 0 ? 0 : Math.min(1, e.value / e.max)), s = S(() => e.value === null ? "Not measured" : `${e.value.toLocaleString("en-US")} / ${e.max.toLocaleString("en-US")}`), l = S(() => n.value ? t.value ? "lucide:circle-check" : "lucide:triangle-alert" : "lucide:circle-help");
    return (r, i) => (b(), T("div", TS, [
      n.value || e.pending ? (b(), T("div", {
        key: 0,
        class: j([`v-meter__track--${e.size}`, "v-meter__track"])
      }, [
        E("div", {
          "aria-valuemax": e.max,
          "aria-valuenow": e.value ?? void 0,
          class: j([t.value ? "v-meter__fill--met" : "v-meter__fill--unmet", "v-meter__fill"]),
          style: Fe({ "--v-meter-fill": a.value }),
          "aria-valuemin": "0",
          role: "meter"
        }, null, 14, CS)
      ], 2)) : P("", !0),
      se(xa, {
        disabled: !e.hint,
        text: e.hint ?? ""
      }, {
        default: ue(() => [
          E("span", {
            class: j([{ "v-meter__value--pending": e.pending, "v-meter__value--help": !!e.hint }, "v-meter__value"])
          }, [
            e.pending ? (b(), ce(ye, {
              key: 0,
              loading: !0,
              size: 14,
              icon: "lucide:loading"
            })) : (b(), ce(ye, {
              key: 1,
              class: j(n.value ? t.value ? "v-meter__icon--met" : "v-meter__icon--unmet" : ""),
              icon: l.value,
              size: 14
            }, null, 8, ["class", "icon"])),
            U(r.$slots, "label", {}, () => [
              He(le(e.label ?? s.value), 1)
            ], !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["disabled", "text"])
    ]));
  }
}), l_ = /* @__PURE__ */ Le(MS, [["__scopeId", "data-v-f009ff9b"]]), DS = {
  key: 0,
  class: "v-progress-bar__header"
}, _S = {
  key: 0,
  class: "v-progress-bar__step"
}, OS = { key: 1 }, ES = {
  key: 2,
  class: "v-progress-bar__percentage"
}, IS = {
  key: 0,
  class: "v-progress-bar__shine"
}, AS = /* @__PURE__ */ ke({
  __name: "VProgressBar",
  props: {
    percentage: {},
    step: { default: null },
    size: { default: "md" },
    showPercentage: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = S(() => Math.max(0, Math.min(100, n.percentage))), a = S(() => t.value >= 100), s = S(() => ({ sm: "4px", md: "6px", lg: "8px" })[n.size]);
    return (l, r) => (b(), T("div", {
      class: j([{ "v-progress-bar--modern": n.modern }, "v-progress-bar"])
    }, [
      e.step || e.showPercentage ? (b(), T("div", DS, [
        e.step ? (b(), T("span", _S, le(e.step), 1)) : (b(), T("span", OS)),
        e.showPercentage ? (b(), T("div", ES, [
          E("span", {
            class: j({ "text-success": a.value })
          }, le(Math.round(t.value)) + "% ", 3),
          a.value ? (b(), ce(ye, {
            key: 0,
            size: 14,
            class: "text-success ml-1",
            icon: "lucide:check-circle"
          })) : P("", !0)
        ])) : P("", !0)
      ])) : P("", !0),
      E("div", {
        style: Fe({ height: s.value }),
        class: "v-progress-bar__track"
      }, [
        E("div", {
          class: j([{ "v-progress-bar__fill--completed": a.value }, "v-progress-bar__fill"]),
          style: Fe({ width: `${t.value}%` })
        }, [
          a.value ? P("", !0) : (b(), T("div", IS))
        ], 6)
      ], 4)
    ], 2));
  }
}), r_ = /* @__PURE__ */ Le(AS, [["__scopeId", "data-v-7cb5a7fb"]]), PS = ["aria-checked", "aria-label", "title", "onClick"], RS = /* @__PURE__ */ ke({
  __name: "VThemeToggle",
  props: /* @__PURE__ */ Ft({
    compact: { type: Boolean, default: !1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const n = rn(e, "modelValue"), t = [
      { value: "light", icon: "lucide:sun", label: "Light theme" },
      { value: "dark", icon: "lucide:moon", label: "Dark theme" }
    ], a = (s) => {
      n.value !== s && (n.value = s);
    };
    return (s, l) => (b(), T("div", {
      class: j([{ "theme-toggle--compact": e.compact, "theme-toggle--dark": n.value === "dark" }, "theme-toggle"]),
      "aria-label": "Theme",
      role: "radiogroup"
    }, [
      l[0] || (l[0] = E("span", {
        "aria-hidden": "true",
        class: "theme-toggle__thumb"
      }, null, -1)),
      (b(), T($e, null, Oe(t, (r) => E("button", {
        key: r.value,
        "aria-checked": n.value === r.value,
        "aria-label": r.label,
        class: j([{ "theme-toggle__option--active": n.value === r.value }, "theme-toggle__option"]),
        title: r.label,
        role: "radio",
        type: "button",
        onClick: (i) => a(r.value)
      }, [
        se(ye, {
          icon: r.icon,
          size: 14
        }, null, 8, ["icon"])
      ], 10, PS)), 64))
    ], 2));
  }
}), i_ = /* @__PURE__ */ Le(RS, [["__scopeId", "data-v-7284576c"]]);
let si = 1;
var VS = class {
  constructor() {
    xe(this, "subscribers");
    xe(this, "toasts");
    xe(this, "dismissedToasts");
    xe(this, "subscribe", (e) => (this.subscribers.push(e), () => {
      const n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }));
    xe(this, "publish", (e) => {
      this.subscribers.forEach((n) => n(e));
    });
    xe(this, "addToast", (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    });
    xe(this, "create", (e) => {
      var r;
      const { message: n, ...t } = e, a = typeof e.id == "number" || e.id && ((r = e.id) == null ? void 0 : r.length) > 0 ? e.id : si++, s = this.toasts.find((i) => i.id === a), l = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((i) => i.id === a ? (this.publish({
        ...i,
        ...e,
        id: a,
        title: n
      }), {
        ...i,
        ...e,
        id: a,
        dismissible: l,
        title: n
      }) : i) : this.addToast({
        title: n,
        ...t,
        dismissible: l,
        id: a
      }), a;
    });
    xe(this, "dismiss", (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((t) => t({
        id: n.id,
        dismiss: !0
      }));
    }), e));
    xe(this, "message", (e, n) => this.create({
      ...n,
      message: e,
      type: "default"
    }));
    xe(this, "error", (e, n) => this.create({
      ...n,
      type: "error",
      message: e
    }));
    xe(this, "success", (e, n) => this.create({
      ...n,
      type: "success",
      message: e
    }));
    xe(this, "info", (e, n) => this.create({
      ...n,
      type: "info",
      message: e
    }));
    xe(this, "warning", (e, n) => this.create({
      ...n,
      type: "warning",
      message: e
    }));
    xe(this, "loading", (e, n) => this.create({
      ...n,
      type: "loading",
      message: e
    }));
    xe(this, "promise", (e, n) => {
      if (!n) return;
      let t;
      n.loading !== void 0 && (t = this.create({
        ...n,
        promise: e,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const a = Promise.resolve(e instanceof Function ? e() : e);
      let s = t !== void 0, l;
      const r = a.then(async (o) => {
        if (l = ["resolve", o], ms(o))
          s = !1, this.create({
            id: t,
            type: "default",
            message: o
          });
        else if (LS(o) && !o.ok) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${o.status}`) : n.error, d = typeof n.description == "function" ? await n.description(`HTTP error! status: ${o.status}`) : n.description, f = typeof c == "object" && !ms(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: d,
            ...f
          });
        } else if (o instanceof Error) {
          s = !1;
          const c = typeof n.error == "function" ? await n.error(o) : n.error, d = typeof n.description == "function" ? await n.description(o) : n.description, f = typeof c == "object" && !ms(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: d,
            ...f
          });
        } else if (n.success !== void 0) {
          s = !1;
          const c = typeof n.success == "function" ? await n.success(o) : n.success, d = typeof n.description == "function" ? await n.description(o) : n.description, f = typeof c == "object" && !ms(c) ? c : {
            message: c || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "success",
            description: d,
            ...f
          });
        }
      }).catch(async (o) => {
        if (l = ["reject", o], n.error !== void 0) {
          s = !1;
          const u = typeof n.error == "function" ? await n.error(o) : n.error, c = typeof n.description == "function" ? await n.description(o) : n.description, p = typeof u == "object" && !ms(u) ? u : {
            message: u || "",
            id: t || ""
          };
          this.create({
            id: t,
            type: "error",
            description: c,
            ...p
          });
        }
      }).finally(() => {
        var o;
        s && (this.dismiss(t), t = void 0), (o = n.finally) == null || o.call(n);
      }), i = () => new Promise((o, u) => r.then(() => l[0] === "reject" ? u(l[1]) : o(l[1])).catch(u));
      return typeof t != "string" && typeof t != "number" ? { unwrap: i } : Object.assign(t, { unwrap: i });
    });
    xe(this, "custom", (e, n) => {
      const t = (n == null ? void 0 : n.id) || si++, a = this.toasts.find((l) => l.id === t), s = (n == null ? void 0 : n.dismissible) === void 0 ? !0 : n.dismissible;
      return this.dismissedToasts.has(t) && this.dismissedToasts.delete(t), a ? this.toasts = this.toasts.map((l) => l.id === t ? (this.publish({
        ...l,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), {
        ...l,
        component: e,
        dismissible: s,
        id: t,
        ...n
      }) : l) : this.addToast({
        component: e,
        dismissible: s,
        id: t,
        ...n
      }), t;
    });
    xe(this, "getActiveToasts", () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)));
    this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
};
const Yt = new VS();
function FS(e, n) {
  const t = (n == null ? void 0 : n.id) || si++;
  return Yt.create({
    message: e,
    id: t,
    type: "default",
    ...n
  }), t;
}
const LS = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", NS = FS, zS = () => Yt.toasts, BS = () => Yt.getActiveToasts(), fa = Object.assign(NS, {
  success: Yt.success,
  info: Yt.info,
  warning: Yt.warning,
  error: Yt.error,
  custom: Yt.custom,
  message: Yt.message,
  promise: Yt.promise,
  dismiss: Yt.dismiss,
  loading: Yt.loading
}, {
  getHistory: zS,
  getToasts: BS
});
function fl(e) {
  return e.label !== void 0;
}
const WS = 3, sf = "24px", lf = "16px", gu = 4e3, YS = 356, HS = 14, US = 45, rf = 200;
function qS() {
  const e = J(!1);
  return jt(() => {
    const n = () => {
      e.value = document.hidden;
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }), { isDocumentHidden: e };
}
function Xn(...e) {
  return e.filter(Boolean).join(" ");
}
function jS(e) {
  const [n, t] = e.split("-"), a = [];
  return n && a.push(n), t && a.push(t), a;
}
function GS(e, n) {
  const t = {};
  return [e, n].forEach((a, s) => {
    const l = s === 1, r = l ? "--mobile-offset" : "--offset", i = l ? lf : sf;
    function o(u) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((c) => {
        t[`${r}-${c}`] = typeof u == "number" ? `${u}px` : u;
      });
    }
    typeof a == "number" || typeof a == "string" ? o(a) : typeof a == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((u) => {
      a[u] === void 0 ? t[`${r}-${u}`] = i : t[`${r}-${u}`] = typeof a[u] == "number" ? `${a[u]}px` : a[u];
    }) : o(i);
  }), t;
}
const KS = [
  "data-rich-colors",
  "data-styled",
  "data-mounted",
  "data-promise",
  "data-swiped",
  "data-removed",
  "data-visible",
  "data-y-position",
  "data-x-position",
  "data-index",
  "data-front",
  "data-swiping",
  "data-dismissible",
  "data-type",
  "data-invert",
  "data-swipe-out",
  "data-swipe-direction",
  "data-expanded",
  "data-testid"
], ZS = [
  "aria-label",
  "data-disabled",
  "data-close-button-position"
];
var XS = /* @__PURE__ */ ke({
  __name: "Toast",
  props: {
    toast: {},
    toasts: {},
    index: {},
    swipeDirections: {},
    expanded: { type: Boolean },
    invert: { type: Boolean },
    heights: {},
    gap: {},
    position: {},
    closeButtonPosition: {},
    visibleToasts: {},
    expandByDefault: { type: Boolean },
    closeButton: { type: Boolean },
    interacting: { type: Boolean },
    style: {},
    cancelButtonStyle: {},
    actionButtonStyle: {},
    duration: {},
    class: {},
    unstyled: { type: Boolean },
    descriptionClass: {},
    loadingIcon: {},
    classes: {},
    icons: {},
    closeButtonAriaLabel: {},
    defaultRichColors: { type: Boolean }
  },
  emits: [
    "update:heights",
    "update:height",
    "removeToast"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, s = J(null), l = J(null), r = J(!1), i = J(!1), o = J(!1), u = J(!1), c = J(!1), d = J(0), p = J(0), f = J(t.toast.duration || t.duration || gu), w = J(null), m = J(null), k = S(() => t.index === 0), y = S(() => t.index + 1 <= t.visibleToasts), h = S(() => t.toast.type), g = S(() => t.toast.dismissible !== !1), x = S(() => t.toast.class || ""), $ = S(() => t.descriptionClass || ""), C = S(() => {
      const X = t.toast.position || t.position, Me = t.heights.filter((F) => F.position === X).findIndex((F) => F.toastId === t.toast.id);
      return Me >= 0 ? Me : 0;
    }), O = S(() => {
      const X = t.toast.position || t.position;
      return t.heights.filter((Me) => Me.position === X).reduce((Me, F, Z) => Z >= C.value ? Me : Me + F.height, 0);
    }), _ = S(() => C.value * t.gap + O.value || 0), I = S(() => t.toast.closeButton ?? t.closeButton), D = S(() => t.toast.duration || t.duration || gu), z = J(0), H = J(0), ne = J(null), te = S(() => t.position.split("-")), q = S(() => te.value[0]), ie = S(() => te.value[1]), L = S(() => typeof t.toast.title != "string"), ae = S(() => typeof t.toast.description != "string"), { isDocumentHidden: Y } = qS(), W = S(() => h.value && h.value === "loading");
    et(() => {
      r.value = !0, f.value = D.value;
    }), jt(async () => {
      if (!r.value || !m.value) return;
      await Ke();
      const X = m.value, pe = X.style.height;
      X.style.height = "auto";
      const Me = X.getBoundingClientRect().height;
      X.style.height = pe, p.value = Me, a("update:height", {
        toastId: t.toast.id,
        height: Me,
        position: t.toast.position || t.position
      });
    });
    function K() {
      i.value = !0, d.value = _.value, setTimeout(() => {
        a("removeToast", t.toast);
      }, rf);
    }
    function de() {
      var X, pe;
      if (W.value || !g.value) return {};
      K(), (pe = (X = t.toast).onDismiss) == null || pe.call(X, t.toast);
    }
    function he(X) {
      X.button !== 2 && (W.value || !g.value || (w.value = /* @__PURE__ */ new Date(), d.value = _.value, X.target.setPointerCapture(X.pointerId), X.target.tagName !== "BUTTON" && (o.value = !0, ne.value = {
        x: X.clientX,
        y: X.clientY
      })));
    }
    function me() {
      var ve, G, oe, be, A, B, M;
      if (u.value || !g.value) return;
      ne.value = null;
      const X = Number(((ve = m.value) == null ? void 0 : ve.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), pe = Number(((G = m.value) == null ? void 0 : G.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Me = (/* @__PURE__ */ new Date()).getTime() - (((oe = w.value) == null ? void 0 : oe.getTime()) || 0), F = s.value === "x" ? X : pe, Z = Math.abs(F) / Me;
      if (Math.abs(F) >= US || Z > 0.11) {
        d.value = _.value, (A = (be = t.toast).onDismiss) == null || A.call(be, t.toast), s.value === "x" ? l.value = X > 0 ? "right" : "left" : l.value = pe > 0 ? "down" : "up", K(), u.value = !0;
        return;
      } else
        (B = m.value) == null || B.style.setProperty("--swipe-amount-x", "0px"), (M = m.value) == null || M.style.setProperty("--swipe-amount-y", "0px");
      c.value = !1, o.value = !1, s.value = null;
    }
    function Te(X) {
      var oe, be, A, B;
      if (!ne.value || !g.value || (((be = (oe = window == null ? void 0 : window.getSelection()) == null ? void 0 : oe.toString()) == null ? void 0 : be.length) ?? !1)) return;
      const Me = X.clientY - ne.value.y, F = X.clientX - ne.value.x, Z = t.swipeDirections ?? jS(t.position);
      !s.value && (Math.abs(F) > 1 || Math.abs(Me) > 1) && (s.value = Math.abs(F) > Math.abs(Me) ? "x" : "y");
      let ve = {
        x: 0,
        y: 0
      };
      const G = (M) => 1 / (1.5 + Math.abs(M) / 20);
      if (s.value === "y") {
        if (Z.includes("top") || Z.includes("bottom")) if (Z.includes("top") && Me < 0 || Z.includes("bottom") && Me > 0) ve.y = Me;
        else {
          const M = Me * G(Me);
          ve.y = Math.abs(M) < Math.abs(Me) ? M : Me;
        }
      } else if (s.value === "x" && (Z.includes("left") || Z.includes("right")))
        if (Z.includes("left") && F < 0 || Z.includes("right") && F > 0) ve.x = F;
        else {
          const M = F * G(F);
          ve.x = Math.abs(M) < Math.abs(F) ? M : F;
        }
      (Math.abs(ve.x) > 0 || Math.abs(ve.y) > 0) && (c.value = !0), (A = m.value) == null || A.style.setProperty("--swipe-amount-x", `${ve.x}px`), (B = m.value) == null || B.style.setProperty("--swipe-amount-y", `${ve.y}px`);
    }
    et(() => {
      if (r.value = !0, !m.value) return;
      const X = m.value.getBoundingClientRect().height;
      p.value = X;
      const pe = [{
        toastId: t.toast.id,
        height: X,
        position: t.toast.position
      }, ...t.heights];
      a("update:heights", pe);
    }), ss(() => {
      m.value && a("removeToast", t.toast);
    }), jt((X) => {
      if (t.toast.promise && h.value === "loading" || t.toast.duration === 1 / 0 || t.toast.type === "loading") return;
      let pe;
      const Me = () => {
        if (H.value < z.value) {
          const Z = (/* @__PURE__ */ new Date()).getTime() - z.value;
          f.value = f.value - Z;
        }
        H.value = (/* @__PURE__ */ new Date()).getTime();
      }, F = () => {
        f.value !== 1 / 0 && (z.value = (/* @__PURE__ */ new Date()).getTime(), pe = setTimeout(() => {
          var Z, ve;
          (ve = (Z = t.toast).onAutoClose) == null || ve.call(Z, t.toast), K();
        }, f.value));
      };
      t.expanded || t.interacting || Y.value ? Me() : F(), X(() => {
        clearTimeout(pe);
      });
    }), Ne(() => t.toast.delete, (X) => {
      var pe, Me;
      X !== void 0 && X && (K(), (Me = (pe = t.toast).onDismiss) == null || Me.call(pe, t.toast));
    }, { deep: !0 });
    function we() {
      o.value = !1, s.value = null, ne.value = null;
    }
    return (X, pe) => {
      var Me, F, Z, ve, G, oe, be, A, B, M, V, R, Q, N, fe, Ce, Re, Ee, Ye, At, Vn, Sn, Qt, Un, It, Wt, cn;
      return b(), T("li", {
        tabindex: "0",
        ref_key: "toastRef",
        ref: m,
        class: j(v(Xn)(t.class, x.value, (Me = X.classes) == null ? void 0 : Me.toast, (F = X.toast.classes) == null ? void 0 : F.toast, (Z = X.classes) == null ? void 0 : Z[h.value], (G = (ve = X.toast) == null ? void 0 : ve.classes) == null ? void 0 : G[h.value])),
        "data-sonner-toast": "",
        "data-rich-colors": X.toast.richColors ?? X.defaultRichColors,
        "data-styled": !(X.toast.component || (oe = X.toast) != null && oe.unstyled || X.unstyled),
        "data-mounted": r.value,
        "data-promise": !!X.toast.promise,
        "data-swiped": c.value,
        "data-removed": i.value,
        "data-visible": y.value,
        "data-y-position": q.value,
        "data-x-position": ie.value,
        "data-index": X.index,
        "data-front": k.value,
        "data-swiping": o.value,
        "data-dismissible": g.value,
        "data-type": h.value,
        "data-invert": X.toast.invert || X.invert,
        "data-swipe-out": u.value,
        "data-swipe-direction": l.value,
        "data-expanded": !!(X.expanded || X.expandByDefault && r.value),
        "data-testid": X.toast.testId,
        style: Fe({
          "--index": X.index,
          "--toasts-before": X.index,
          "--z-index": X.toasts.length - X.index,
          "--offset": `${i.value ? d.value : _.value}px`,
          "--initial-height": X.expandByDefault ? "auto" : `${p.value}px`,
          ...X.style,
          ...t.toast.style
        }),
        onDragend: we,
        onPointerdown: he,
        onPointerup: me,
        onPointermove: Te
      }, [I.value && !X.toast.component && h.value !== "loading" ? (b(), T("button", {
        key: 0,
        "aria-label": X.closeButtonAriaLabel || "Close toast",
        "data-disabled": W.value,
        "data-close-button": "true",
        "data-close-button-position": X.closeButtonPosition,
        class: j(v(Xn)((be = X.classes) == null ? void 0 : be.closeButton, (B = (A = X.toast) == null ? void 0 : A.classes) == null ? void 0 : B.closeButton)),
        onClick: de
      }, [(M = X.icons) != null && M.close ? (b(), ce(mt((V = X.icons) == null ? void 0 : V.close), { key: 0 })) : U(X.$slots, "close-icon", { key: 1 })], 10, ZS)) : P("v-if", !0), X.toast.component ? (b(), ce(mt(X.toast.component), lt({ key: 1 }, X.toast.componentProps, {
        onCloseToast: de,
        isPaused: X.$props.expanded || X.$props.interacting || v(Y)
      }), null, 16, ["isPaused"])) : (b(), T($e, { key: 2 }, [
        h.value !== "default" || X.toast.icon || X.toast.promise ? (b(), T("div", {
          key: 0,
          "data-icon": "",
          class: j(v(Xn)((R = X.classes) == null ? void 0 : R.icon, (N = (Q = X.toast) == null ? void 0 : Q.classes) == null ? void 0 : N.icon))
        }, [X.toast.icon ? (b(), ce(mt(X.toast.icon), { key: 0 })) : (b(), T($e, { key: 1 }, [h.value === "loading" ? U(X.$slots, "loading-icon", { key: 0 }) : h.value === "success" ? U(X.$slots, "success-icon", { key: 1 }) : h.value === "error" ? U(X.$slots, "error-icon", { key: 2 }) : h.value === "warning" ? U(X.$slots, "warning-icon", { key: 3 }) : h.value === "info" ? U(X.$slots, "info-icon", { key: 4 }) : P("v-if", !0)], 64))], 2)) : P("v-if", !0),
        E("div", {
          "data-content": "",
          class: j(v(Xn)((fe = X.classes) == null ? void 0 : fe.content, (Re = (Ce = X.toast) == null ? void 0 : Ce.classes) == null ? void 0 : Re.content))
        }, [E("div", {
          "data-title": "",
          class: j(v(Xn)((Ee = X.classes) == null ? void 0 : Ee.title, (Ye = X.toast.classes) == null ? void 0 : Ye.title))
        }, [L.value ? (b(), ce(mt(X.toast.title), Mt(lt({ key: 0 }, X.toast.componentProps)), null, 16)) : (b(), T($e, { key: 1 }, [He(le(X.toast.title), 1)], 64))], 2), X.toast.description ? (b(), T("div", {
          key: 0,
          "data-description": "",
          class: j(v(Xn)(X.descriptionClass, $.value, (At = X.classes) == null ? void 0 : At.description, (Vn = X.toast.classes) == null ? void 0 : Vn.description))
        }, [ae.value ? (b(), ce(mt(X.toast.description), Mt(lt({ key: 0 }, X.toast.componentProps)), null, 16)) : (b(), T($e, { key: 1 }, [He(le(X.toast.description), 1)], 64))], 2)) : P("v-if", !0)], 2),
        X.toast.cancel ? (b(), T("button", {
          key: 1,
          style: Fe(X.toast.cancelButtonStyle || X.cancelButtonStyle),
          class: j(v(Xn)((Sn = X.classes) == null ? void 0 : Sn.cancelButton, (Qt = X.toast.classes) == null ? void 0 : Qt.cancelButton)),
          "data-button": "",
          "data-cancel": "",
          onClick: pe[0] || (pe[0] = ($n) => {
            var wt, kt;
            v(fl)(X.toast.cancel) && g.value && ((kt = (wt = X.toast.cancel).onClick) == null || kt.call(wt, $n), K());
          })
        }, le(v(fl)(X.toast.cancel) ? (Un = X.toast.cancel) == null ? void 0 : Un.label : X.toast.cancel), 7)) : P("v-if", !0),
        X.toast.action ? (b(), T("button", {
          key: 2,
          style: Fe(X.toast.actionButtonStyle || X.actionButtonStyle),
          class: j(v(Xn)((It = X.classes) == null ? void 0 : It.actionButton, (Wt = X.toast.classes) == null ? void 0 : Wt.actionButton)),
          "data-button": "",
          "data-action": "",
          onClick: pe[1] || (pe[1] = ($n) => {
            var wt, kt;
            v(fl)(X.toast.action) && ((kt = (wt = X.toast.action).onClick) == null || kt.call(wt, $n), !$n.defaultPrevented && K());
          })
        }, le(v(fl)(X.toast.action) ? (cn = X.toast.action) == null ? void 0 : cn.label : X.toast.action), 7)) : P("v-if", !0)
      ], 64))], 46, KS);
    };
  }
}), JS = XS, Js = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, s] of n) t[a] = s;
  return t;
};
const QS = {}, e$ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function t$(e, n) {
  return b(), T("svg", e$, n[0] || (n[0] = [E("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }, null, -1), E("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }, null, -1)]));
}
var n$ = /* @__PURE__ */ Js(QS, [["render", t$]]);
const a$ = ["data-visible"], s$ = { class: "sonner-spinner" };
var l$ = /* @__PURE__ */ ke({
  __name: "Loader",
  props: { visible: { type: Boolean } },
  setup(e) {
    const n = Array(12).fill(0);
    return (t, a) => (b(), T("div", {
      class: "sonner-loading-wrapper",
      "data-visible": t.visible
    }, [E("div", s$, [(b(!0), T($e, null, Oe(v(n), (s) => (b(), T("div", {
      key: `spinner-bar-${s}`,
      class: "sonner-loading-bar"
    }))), 128))])], 8, a$));
  }
}), r$ = l$;
const i$ = {}, o$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function u$(e, n) {
  return b(), T("svg", o$, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var c$ = /* @__PURE__ */ Js(i$, [["render", u$]]);
const d$ = {}, f$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function h$(e, n) {
  return b(), T("svg", f$, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var m$ = /* @__PURE__ */ Js(d$, [["render", h$]]);
const v$ = {}, p$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function g$(e, n) {
  return b(), T("svg", p$, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var y$ = /* @__PURE__ */ Js(v$, [["render", g$]]);
const b$ = {}, w$ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
};
function k$(e, n) {
  return b(), T("svg", w$, n[0] || (n[0] = [E("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
    "clip-rule": "evenodd"
  }, null, -1)]));
}
var x$ = /* @__PURE__ */ Js(b$, [["render", k$]]);
const S$ = ["aria-label"], $$ = [
  "data-sonner-theme",
  "dir",
  "data-theme",
  "data-rich-colors",
  "data-y-position",
  "data-x-position"
], T$ = typeof window < "u" && typeof document < "u";
function C$() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
var M$ = /* @__PURE__ */ ke({
  name: "Toaster",
  inheritAttrs: !1,
  __name: "Toaster",
  props: {
    id: {},
    invert: {
      type: Boolean,
      default: !1
    },
    theme: { default: "light" },
    position: { default: "bottom-right" },
    closeButtonPosition: { default: "top-left" },
    hotkey: { default: () => ["altKey", "KeyT"] },
    richColors: {
      type: Boolean,
      default: !1
    },
    expand: {
      type: Boolean,
      default: !1
    },
    duration: {},
    gap: { default: HS },
    visibleToasts: { default: WS },
    closeButton: {
      type: Boolean,
      default: !1
    },
    toastOptions: { default: () => ({}) },
    class: { default: "" },
    style: {},
    offset: { default: sf },
    mobileOffset: { default: lf },
    dir: { default: "auto" },
    swipeDirections: {},
    icons: {},
    containerAriaLabel: { default: "Notifications" }
  },
  setup(e) {
    const n = e, t = Pl(), a = J([]), s = S(() => n.id ? a.value.filter((D) => D.toasterId === n.id) : a.value.filter((D) => !D.toasterId));
    function l(D, z) {
      return s.value.filter((H) => !H.position && z === 0 || H.position === D);
    }
    const r = S(() => {
      const D = s.value.filter((z) => z.position).map((z) => z.position);
      return D.length > 0 ? Array.from(new Set([n.position].concat(D))) : [n.position];
    }), i = S(() => {
      const D = {};
      return r.value.forEach((z) => {
        D[z] = a.value.filter((H) => H.position === z);
      }), D;
    }), o = J([]), u = J({}), c = J(!1);
    jt(() => {
      r.value.forEach((D) => {
        D in u.value || (u.value[D] = !1);
      });
    });
    const d = J(n.theme !== "system" ? n.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), p = J(null), f = J(null), w = J(!1), m = n.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function k(D) {
      var z;
      (z = a.value.find((H) => H.id === D.id)) != null && z.delete || Yt.dismiss(D.id), a.value = a.value.filter(({ id: H }) => H !== D.id), setTimeout(() => {
        a.value.find((H) => H.id === D.id) || (o.value = o.value.filter((H) => H.toastId !== D.id));
      }, rf + 50);
    }
    function y(D) {
      var z, H;
      w.value && !((H = (z = D.currentTarget) == null ? void 0 : z.contains) != null && H.call(z, D.relatedTarget)) && (w.value = !1, f.value && (f.value.focus({ preventScroll: !0 }), f.value = null));
    }
    function h(D) {
      D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || w.value || (w.value = !0, f.value = D.relatedTarget);
    }
    function g(D) {
      D.target && D.target instanceof HTMLElement && D.target.dataset.dismissible === "false" || (c.value = !0);
    }
    jt((D) => {
      const z = Yt.subscribe((H) => {
        if (H.dismiss) {
          requestAnimationFrame(() => {
            a.value = a.value.map((ne) => ne.id === H.id ? {
              ...ne,
              delete: !0
            } : ne);
          });
          return;
        }
        Ke(() => {
          const ne = a.value.findIndex((te) => te.id === H.id);
          ne !== -1 ? a.value = [
            ...a.value.slice(0, ne),
            {
              ...a.value[ne],
              ...H
            },
            ...a.value.slice(ne + 1)
          ] : a.value = [H, ...a.value];
        });
      });
      D(z);
    }), jt((D) => {
      if (typeof window > "u") return;
      if (n.theme !== "system") {
        d.value = n.theme;
        return;
      }
      const z = window.matchMedia("(prefers-color-scheme: dark)"), H = (te) => {
        d.value = te ? "dark" : "light";
      };
      H(z.matches);
      const ne = (te) => {
        H(te.matches);
      };
      try {
        z.addEventListener("change", ne);
      } catch {
        z.addListener(ne);
      }
      D(() => {
        try {
          z.removeEventListener("change", ne);
        } catch {
          z.removeListener(ne);
        }
      });
    }), jt(() => {
      p.value && f.value && (f.value.focus({ preventScroll: !0 }), f.value = null, w.value = !1);
    }), jt(() => {
      a.value.length <= 1 && Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }), jt((D) => {
      function z(H) {
        const ne = n.hotkey.every((ie) => H[ie] || H.code === ie), te = Array.isArray(p.value) ? p.value[0] : p.value;
        ne && (r.value.forEach((ie) => {
          u.value[ie] = !0;
        }), te == null || te.focus());
        const q = document.activeElement === p.value || (te == null ? void 0 : te.contains(document.activeElement));
        H.code === "Escape" && q && r.value.forEach((ie) => {
          u.value[ie] = !1;
        });
      }
      T$ && (document.addEventListener("keydown", z), D(() => {
        document.removeEventListener("keydown", z);
      }));
    });
    function x(D) {
      const z = D.currentTarget, H = z.getAttribute("data-y-position") + "-" + z.getAttribute("data-x-position");
      u.value[H] = !0;
    }
    function $(D) {
      if (!c.value) {
        const z = D.currentTarget, H = z.getAttribute("data-y-position") + "-" + z.getAttribute("data-x-position");
        u.value[H] = !1;
      }
    }
    function C() {
      Object.keys(u.value).forEach((D) => {
        u.value[D] = !1;
      });
    }
    function O() {
      c.value = !1;
    }
    function _(D) {
      o.value = D;
    }
    function I(D) {
      const z = o.value.findIndex((H) => H.toastId === D.toastId);
      if (z !== -1) o.value[z] = D;
      else {
        const H = o.value.findIndex((ne) => ne.position === D.position);
        H !== -1 ? o.value.splice(H, 0, D) : o.value.unshift(D);
      }
    }
    return (D, z) => (b(), T($e, null, [P(" Remove item from normal navigation flow, only available via hotkey "), E("section", {
      "aria-label": `${D.containerAriaLabel} ${v(m)}`,
      tabIndex: -1,
      "aria-live": "polite",
      "aria-relevant": "additions text",
      "aria-atomic": "false"
    }, [(b(!0), T($e, null, Oe(r.value, (H, ne) => {
      var te;
      return b(), T("ol", lt({
        key: H,
        ref_for: !0,
        ref_key: "listRef",
        ref: p,
        "data-sonner-toaster": "",
        "data-sonner-theme": d.value,
        class: n.class,
        dir: D.dir === "auto" ? C$() : D.dir,
        tabIndex: -1,
        "data-theme": D.theme,
        "data-rich-colors": D.richColors,
        "data-y-position": H.split("-")[0],
        "data-x-position": H.split("-")[1],
        style: {
          "--front-toast-height": `${((te = o.value[0]) == null ? void 0 : te.height) || 0}px`,
          "--width": `${v(YS)}px`,
          "--gap": `${D.gap}px`,
          ...D.style,
          ...v(t).style,
          ...v(GS)(D.offset, D.mobileOffset)
        }
      }, { ref_for: !0 }, D.$attrs, {
        onBlur: y,
        onFocus: h,
        onMouseenter: x,
        onMousemove: x,
        onMouseleave: $,
        onDragend: C,
        onPointerdown: g,
        onPointerup: O
      }), [(b(!0), T($e, null, Oe(l(H, ne), (q, ie) => {
        var L, ae, Y, W, K, de, he, me, Te, we, X;
        return b(), ce(JS, {
          key: q.id,
          heights: o.value,
          icons: D.icons,
          index: ie,
          toast: q,
          defaultRichColors: D.richColors,
          duration: ((L = D.toastOptions) == null ? void 0 : L.duration) ?? D.duration,
          class: j(((ae = D.toastOptions) == null ? void 0 : ae.class) ?? ""),
          descriptionClass: (Y = D.toastOptions) == null ? void 0 : Y.descriptionClass,
          invert: D.invert,
          visibleToasts: D.visibleToasts,
          closeButton: ((W = D.toastOptions) == null ? void 0 : W.closeButton) ?? D.closeButton,
          interacting: c.value,
          position: H,
          closeButtonPosition: ((K = D.toastOptions) == null ? void 0 : K.closeButtonPosition) ?? D.closeButtonPosition,
          style: Fe((de = D.toastOptions) == null ? void 0 : de.style),
          unstyled: (he = D.toastOptions) == null ? void 0 : he.unstyled,
          classes: (me = D.toastOptions) == null ? void 0 : me.classes,
          cancelButtonStyle: (Te = D.toastOptions) == null ? void 0 : Te.cancelButtonStyle,
          actionButtonStyle: (we = D.toastOptions) == null ? void 0 : we.actionButtonStyle,
          "close-button-aria-label": (X = D.toastOptions) == null ? void 0 : X.closeButtonAriaLabel,
          toasts: i.value[H],
          expandByDefault: D.expand,
          gap: D.gap,
          expanded: u.value[H] || !1,
          swipeDirections: n.swipeDirections,
          "onUpdate:heights": _,
          "onUpdate:height": I,
          onRemoveToast: k
        }, {
          "close-icon": ue(() => [U(D.$slots, "close-icon", {}, () => [se(n$)])]),
          "loading-icon": ue(() => [U(D.$slots, "loading-icon", {}, () => [se(r$, { visible: q.type === "loading" }, null, 8, ["visible"])])]),
          "success-icon": ue(() => [U(D.$slots, "success-icon", {}, () => [se(c$)])]),
          "error-icon": ue(() => [U(D.$slots, "error-icon", {}, () => [se(x$)])]),
          "warning-icon": ue(() => [U(D.$slots, "warning-icon", {}, () => [se(y$)])]),
          "info-icon": ue(() => [U(D.$slots, "info-icon", {}, () => [se(m$)])]),
          _: 2
        }, 1032, [
          "heights",
          "icons",
          "index",
          "toast",
          "defaultRichColors",
          "duration",
          "class",
          "descriptionClass",
          "invert",
          "visibleToasts",
          "closeButton",
          "interacting",
          "position",
          "closeButtonPosition",
          "style",
          "unstyled",
          "classes",
          "cancelButtonStyle",
          "actionButtonStyle",
          "close-button-aria-label",
          "toasts",
          "expandByDefault",
          "gap",
          "expanded",
          "swipeDirections"
        ]);
      }), 128))], 16, $$);
    }), 128))], 8, S$)], 2112));
  }
}), D$ = M$;
const _$ = /* @__PURE__ */ ke({
  __name: "VToaster",
  setup(e) {
    const n = jd(), t = S(() => n.resolvedTheme);
    return (a, s) => (b(), ce(v(D$), {
      duration: 4e3,
      theme: t.value,
      "toast-options": {
        unstyled: !0,
        classes: {
          toast: "toast-custom",
          title: "toast-title",
          description: "toast-description",
          actionButton: "toast-action",
          cancelButton: "toast-cancel",
          closeButton: "toast-close",
          error: "toast-error",
          success: "toast-success",
          warning: "toast-warning",
          info: "toast-info"
        }
      },
      "close-button": "",
      position: "top-right"
    }, null, 8, ["theme"]));
  }
}), o_ = /* @__PURE__ */ Le(_$, [["__scopeId", "data-v-9305e752"]]), O$ = ["id"], E$ = ["id", "aria-controls", "aria-expanded", "disabled", "onClick"], I$ = { class: "v-expansion-panel-header__content" }, A$ = { class: "v-expansion-panel-title" }, P$ = {
  key: 0,
  class: "v-expansion-panel-subtitle"
}, R$ = { class: "v-expansion-panel-header__icon-wrapper" }, V$ = ["id", "aria-hidden", "aria-labelledby"], F$ = { class: "v-expansion-panel-content__wrap" }, L$ = { class: "v-expansion-panel-content__inner" }, N$ = { class: "v-expansion-panel-text" }, z$ = /* @__PURE__ */ ke({
  __name: "VAccordion",
  props: /* @__PURE__ */ Ft({
    items: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    flat: { type: Boolean, default: !1 },
    accordion: { type: Boolean, default: !1 },
    modern: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ft(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = e, a = n, s = Ca(), l = rn(e, "modelValue"), r = (u) => l.value.includes(u), i = (u) => {
      l.value = u, a("change", u);
    }, o = (u, c) => {
      if (t.disabled || c) return;
      const d = r(u);
      if (t.accordion || !t.multiple) {
        i(d ? [] : [u]);
        return;
      }
      i(
        d ? l.value.filter((p) => p !== u) : [...l.value, u]
      );
    };
    return et(() => {
      if (l.value.length) return;
      const u = t.items.filter((c) => c.defaultOpen).map((c) => c.id);
      u.length && (l.value = t.accordion || !t.multiple ? [u[0]] : u);
    }), (u, c) => (b(), T("div", {
      id: v(s),
      class: j([[
        `v-expansion-panels--${e.variant}`,
        {
          "v-expansion-panels--flat": e.flat,
          "v-expansion-panels--disabled": e.disabled,
          "v-expansion-panels--modern": e.modern
        }
      ], "v-expansion-panels"])
    }, [
      (b(!0), T($e, null, Oe(e.items, (d, p) => (b(), T("div", {
        key: d.id,
        class: j([{
          "v-expansion-panel--active": r(d.id),
          "v-expansion-panel--disabled": d.disabled || e.disabled
        }, "v-expansion-panel"])
      }, [
        E("button", {
          id: `${v(s)}-header-${d.id}`,
          "aria-controls": `${v(s)}-content-${d.id}`,
          "aria-expanded": r(d.id),
          disabled: d.disabled || e.disabled,
          class: "v-expansion-panel-header",
          type: "button",
          onClick: (f) => o(d.id, d.disabled)
        }, [
          U(u.$slots, `header-${d.id}`, {
            index: p,
            isOpen: r(d.id),
            item: d
          }, () => [
            U(u.$slots, "header", {
              index: p,
              isOpen: r(d.id),
              item: d
            }, () => [
              d.icon ? (b(), ce(ye, {
                key: 0,
                icon: d.icon,
                size: e.modern ? 16 : void 0,
                class: "v-expansion-panel-header__icon"
              }, null, 8, ["icon", "size"])) : P("", !0),
              E("div", I$, [
                E("div", A$, le(d.title), 1),
                d.subtitle ? (b(), T("div", P$, le(d.subtitle), 1)) : P("", !0)
              ]),
              E("div", R$, [
                se(ye, {
                  class: j(
                    r(d.id) ? "v-expansion-panel-header__expand-icon v-expansion-panel-header__expand-icon--active" : "v-expansion-panel-header__expand-icon"
                  ),
                  icon: e.modern ? "lucide:chevron-down" : "mdi:chevron-down",
                  size: e.modern ? 16 : void 0
                }, null, 8, ["class", "icon", "size"])
              ])
            ], !0)
          ], !0)
        ], 8, E$),
        E("div", {
          id: `${v(s)}-content-${d.id}`,
          "aria-hidden": !r(d.id),
          "aria-labelledby": `${v(s)}-header-${d.id}`,
          class: "v-expansion-panel-content",
          role: "region"
        }, [
          E("div", F$, [
            E("div", L$, [
              U(u.$slots, `content-${d.id}`, {
                index: p,
                item: d
              }, () => [
                U(u.$slots, "content", {
                  index: p,
                  item: d
                }, () => [
                  E("div", N$, le(d.content), 1)
                ], !0)
              ], !0)
            ])
          ])
        ], 8, V$)
      ], 2))), 128))
    ], 10, O$));
  }
}), u_ = /* @__PURE__ */ Le(z$, [["__scopeId", "data-v-79e6a45e"]]), c_ = /* @__PURE__ */ ke({
  __name: "VAnimatedBackground",
  props: {
    count: { default: 15 },
    minRadius: { default: 100 },
    maxRadius: { default: 300 },
    speed: { default: 1 },
    colors: { default: () => [
      "rgba(37, 99, 235, 0.3)",
      // primary
      "rgba(251, 191, 36, 0.3)",
      // accent
      "rgba(14, 165, 233, 0.3)",
      // info
      "rgba(34, 197, 94, 0.3)"
      // success
    ] }
  },
  setup(e) {
    const n = e, t = J(null);
    let a, s = null;
    const l = [], r = (o) => {
      l.length = 0;
      const { colors: u } = n;
      if (u.length !== 0)
        for (let c = 0; c < n.count; c++)
          l.push({
            x: Math.random() * o.width,
            y: Math.random() * o.height,
            radius: Math.random() * (n.maxRadius - n.minRadius) + n.minRadius,
            vx: (Math.random() - 0.5) * n.speed,
            vy: (Math.random() - 0.5) * n.speed,
            color: u[c % u.length]
          });
    }, i = (o, u) => {
      u.clearRect(0, 0, o.width, o.height), l.forEach((c) => {
        c.x += c.vx, c.y += c.vy, (c.x < -c.radius || c.x > o.width + c.radius) && (c.vx *= -1), (c.y < -c.radius || c.y > o.height + c.radius) && (c.vy *= -1);
        const d = u.createRadialGradient(
          c.x,
          c.y,
          0,
          c.x,
          c.y,
          c.radius * 0.7
        ), p = c.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (p) {
          const [, f, w, m] = p;
          d.addColorStop(0, `rgba(${f}, ${w}, ${m}, 0.5)`), d.addColorStop(0.5, `rgba(${f}, ${w}, ${m}, 0.25)`), d.addColorStop(1, `rgba(${f}, ${w}, ${m}, 0)`);
        }
        u.fillStyle = d, u.beginPath(), u.arc(c.x, c.y, c.radius, 0, Math.PI * 2), u.fill();
      }), a = requestAnimationFrame(() => i(o, u));
    };
    return et(() => {
      const o = t.value;
      if (!o) return;
      const u = o.getContext("2d");
      if (!u) return;
      const c = () => {
        o && (o.width = window.innerWidth, o.height = window.innerHeight, l.length === 0 && r(o));
      };
      s = c, c(), window.addEventListener("resize", c), i(o, u);
    }), Jt(() => {
      s && window.removeEventListener("resize", s), a && cancelAnimationFrame(a), l.length = 0;
    }), (o, u) => (b(), T($e, null, [
      E("canvas", {
        ref_key: "canvasRef",
        ref: t,
        class: "fixed inset-0 z-10 pointer-events-none"
      }, null, 512),
      u[0] || (u[0] = E("div", { class: "fixed inset-0 z-10 bg-gradient-to-br from-primary/5 via-accent/5 to-info/5" }, null, -1))
    ], 64));
  }
}), B$ = {
  key: 0,
  class: "v-card__loading"
}, W$ = {
  key: 0,
  class: "v-card__header"
}, Y$ = { class: "v-card__header-content" }, H$ = {
  key: 1,
  class: "v-card__header-text"
}, U$ = {
  key: 0,
  class: "v-card__title"
}, q$ = {
  key: 1,
  class: "v-card__subtitle"
}, j$ = {
  key: 0,
  class: "v-card__description"
}, G$ = {
  key: 1,
  class: "v-card__content"
}, K$ = {
  key: 2,
  class: "v-card__footer"
}, Z$ = /* @__PURE__ */ ke({
  __name: "VCard",
  props: {
    title: { default: "" },
    subtitle: { default: "" },
    description: { default: "" },
    variant: { default: "default" },
    size: { default: "full" },
    radius: { default: "xl" },
    padding: { default: "sm" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    clickable: { type: Boolean },
    icon: { default: "" },
    as: { default: "div" },
    href: { default: "" },
    target: { default: "_self" },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = S(() => t.title || t.subtitle || t.icon || !!c.header), l = S(() => !!c.footer), r = S(() => t.clickable || t.href || t.as === "button"), i = S(() => t.href ? "a" : t.as), o = S(() => {
      const p = ["v-card"];
      return p.push(`v-card--${t.variant}`), p.push(`v-card--${t.size}`), p.push(`v-card--radius-${t.radius}`), t.padding && p.push(`v-card--padding-${t.padding}`), t.disabled && p.push("v-card--disabled"), t.loading && p.push("v-card--loading"), r.value && p.push("v-card--interactive"), t.modern && p.push("v-card--modern"), p;
    }), u = S(() => t.href ? {
      href: t.href,
      target: t.target,
      rel: t.target === "_blank" ? "noopener noreferrer" : void 0
    } : {}), c = Ht(), d = (p) => {
      if (t.disabled || t.loading) {
        p.preventDefault();
        return;
      }
      a("click", p);
    };
    return (p, f) => (b(), ce(mt(i.value), lt({ class: o.value }, u.value, { onClick: d }), {
      default: ue(() => [
        e.loading ? (b(), T("div", B$, [
          U(p.$slots, "loading", {}, () => [
            se(Xs)
          ], !0)
        ])) : (b(), T($e, { key: 1 }, [
          s.value ? (b(), T("header", W$, [
            U(p.$slots, "header", {}, () => [
              E("div", Y$, [
                t.icon ? (b(), ce(ye, {
                  key: 0,
                  icon: t.icon,
                  class: "v-card__icon"
                }, null, 8, ["icon"])) : P("", !0),
                e.title || e.subtitle ? (b(), T("div", H$, [
                  e.title ? (b(), T("h3", U$, le(e.title), 1)) : P("", !0),
                  e.subtitle ? (b(), T("p", q$, le(e.subtitle), 1)) : P("", !0)
                ])) : P("", !0)
              ]),
              e.description ? (b(), T("p", j$, le(e.description), 1)) : P("", !0)
            ], !0)
          ])) : P("", !0),
          !e.modern || c.default ? (b(), T("div", G$, [
            U(p.$slots, "default", {}, void 0, !0)
          ])) : P("", !0),
          l.value ? (b(), T("footer", K$, [
            U(p.$slots, "footer", {}, void 0, !0)
          ])) : P("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), X$ = /* @__PURE__ */ Le(Z$, [["__scopeId", "data-v-d4d6de05"]]), J$ = {
  key: 0,
  class: "space-y-4"
}, Q$ = {
  key: 0,
  class: "v-info-notice__head flex gap-3 items-start"
}, eT = { class: "flex-1" }, tT = {
  key: 0,
  class: "v-info-notice__title font-semibold text-mainText"
}, nT = {
  key: 1,
  class: "v-info-notice__subtitle text-sm text-secondaryText mt-0.5"
}, aT = { class: "v-info-notice__features grid grid-cols-2 md:grid-cols-4 gap-3" }, sT = { class: "min-w-0" }, lT = { class: "v-info-notice__feature-title font-medium text-sm text-mainText truncate" }, rT = {
  key: 0,
  class: "v-info-notice__feature-description text-xs text-secondaryText truncate"
}, iT = {
  key: 1,
  class: "v-info-notice__hint flex items-center gap-2 text-sm text-secondaryText pt-2 border-t border-base-400/30"
}, oT = {
  key: 1,
  class: "v-info-notice__head flex gap-3 items-start"
}, uT = { class: "v-info-notice__body flex-1 text-sm leading-relaxed" }, cT = {
  key: 0,
  class: "v-info-notice__title font-semibold mb-1 text-mainText"
}, dT = {
  key: 1,
  class: "v-info-notice__subtitle text-secondaryText"
}, fT = {
  key: 2,
  class: "text-secondaryText"
}, hT = {
  key: 0,
  class: "flex-shrink-0"
}, mT = /* @__PURE__ */ ke({
  __name: "VInfoNotice",
  props: {
    icon: { default: "lucide:info" },
    iconColor: { default: "primary" },
    title: { default: void 0 },
    subtitle: { default: void 0 },
    card: { type: Boolean, default: !0 },
    size: { default: void 0 },
    features: { default: void 0 },
    hint: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = S(() => n.size ?? (n.modern ? 20 : "50px")), a = S(() => [
      { "p-4": !n.card && !n.modern },
      n.modern ? ["v-info-notice--modern", `v-info-notice--tone-${n.iconColor}`] : []
    ]), s = (u) => `v-info-notice--tone-${u || "primary"}`, l = S(() => {
      const u = {
        primary: "text-primary",
        success: "text-success",
        warning: "text-warning",
        error: "text-error",
        info: "text-info",
        muted: "text-secondaryText"
      };
      return u[n.iconColor] || u.primary;
    }), r = (u) => ({
      primary: "bg-primary/10",
      success: "bg-success/10",
      warning: "bg-warning/10",
      error: "bg-error/10",
      info: "bg-info/10",
      muted: "bg-muted/10"
    })[u || "primary"], i = (u) => ({
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
      info: "text-info",
      muted: "text-secondaryText"
    })[u || "primary"], o = S(() => n.features && n.features.length > 0);
    return (u, c) => (b(), ce(mt(e.card ? X$ : "div"), {
      class: j(a.value)
    }, {
      default: ue(() => [
        o.value ? (b(), T("div", J$, [
          e.title || e.subtitle || u.$slots.title || u.$slots.subtitle ? (b(), T("div", Q$, [
            U(u.$slots, "icon", {}, () => [
              se(ye, {
                class: j(`${l.value} v-info-notice__icon`),
                icon: e.icon,
                size: e.modern ? 20 : 24
              }, null, 8, ["class", "icon", "size"])
            ], !0),
            E("div", eT, [
              e.title || u.$slots.title ? (b(), T("p", tT, [
                U(u.$slots, "title", {}, () => [
                  He(le(e.title), 1)
                ], !0)
              ])) : P("", !0),
              e.subtitle || u.$slots.subtitle ? (b(), T("p", nT, [
                U(u.$slots, "subtitle", {}, () => [
                  He(le(e.subtitle), 1)
                ], !0)
              ])) : P("", !0)
            ])
          ])) : P("", !0),
          E("div", aT, [
            (b(!0), T($e, null, Oe(e.features, (d, p) => (b(), T("div", {
              key: p,
              class: "v-info-notice__feature flex items-center gap-3 p-3 rounded-lg bg-cardBg/50 border border-base-400/50"
            }, [
              E("div", {
                class: j([[r(d.color), s(d.color)], "v-info-notice__feature-icon w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"])
              }, [
                se(ye, {
                  class: j(i(d.color)),
                  icon: d.icon,
                  size: e.modern ? 16 : 20
                }, null, 8, ["class", "icon", "size"])
              ], 2),
              E("div", sT, [
                E("p", lT, le(d.title), 1),
                d.description ? (b(), T("p", rT, le(d.description), 1)) : P("", !0)
              ])
            ]))), 128))
          ]),
          e.hint || u.$slots.hint ? (b(), T("div", iT, [
            se(ye, {
              size: e.modern ? 14 : 16,
              class: "text-secondaryText flex-shrink-0",
              icon: "lucide:info"
            }, null, 8, ["size"]),
            E("span", null, [
              U(u.$slots, "hint", {}, () => [
                He(le(e.hint), 1)
              ], !0)
            ])
          ])) : P("", !0)
        ])) : (b(), T("div", oT, [
          U(u.$slots, "icon", {}, () => [
            se(ye, {
              class: j([l.value, "v-info-notice__icon"]),
              icon: e.icon,
              size: t.value
            }, null, 8, ["class", "icon", "size"])
          ], !0),
          E("div", uT, [
            e.title || u.$slots.title ? (b(), T("p", cT, [
              U(u.$slots, "title", {}, () => [
                He(le(e.title), 1)
              ], !0)
            ])) : P("", !0),
            e.subtitle || u.$slots.subtitle ? (b(), T("p", dT, [
              U(u.$slots, "subtitle", {}, () => [
                He(le(e.subtitle), 1)
              ], !0)
            ])) : P("", !0),
            u.$slots.default ? (b(), T("div", fT, [
              U(u.$slots, "default", {}, void 0, !0)
            ])) : P("", !0)
          ]),
          u.$slots.actions ? (b(), T("div", hT, [
            U(u.$slots, "actions", {}, void 0, !0)
          ])) : P("", !0)
        ]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), d_ = /* @__PURE__ */ Le(mT, [["__scopeId", "data-v-7575fa6d"]]), vT = {
  key: 0,
  class: "scroll-panel__copy"
}, pT = ["aria-label"], gT = { class: "scroll-panel__copy-glyph" }, yT = { class: "scroll-panel__copy-glyph scroll-panel__copy-glyph--check" }, bT = /* @__PURE__ */ ke({
  __name: "VScrollPanel",
  props: {
    copyText: {},
    copyLabel: { default: "Copy to clipboard" },
    maxHeight: { default: () => {
    } },
    modern: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { copy: n, copied: t, isSupported: a } = pi({ copiedDuring: 2e3 });
    return (s, l) => (b(), T("div", {
      class: j([{
        "scroll-panel--modern": e.modern,
        "scroll-panel--capped": e.maxHeight
      }, "scroll-panel overflow-y-auto p-2.5"]),
      style: Fe(e.maxHeight ? { "--v-scroll-panel-max-height": e.maxHeight } : void 0)
    }, [
      e.copyText !== void 0 && v(a) ? (b(), T("div", vT, [
        E("button", {
          "aria-label": v(t) ? "Copied" : e.copyLabel,
          class: j([{ "scroll-panel__copy-btn--copied": v(t) }, "scroll-panel__copy-btn"]),
          type: "button",
          onClick: l[0] || (l[0] = (r) => v(n)(e.copyText))
        }, [
          E("span", gT, [
            se(ye, {
              size: 14,
              icon: "lucide:copy"
            })
          ]),
          E("span", yT, [
            se(ye, {
              size: 14,
              icon: "lucide:check"
            })
          ])
        ], 10, pT)
      ])) : P("", !0),
      U(s.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), f_ = /* @__PURE__ */ Le(bT, [["__scopeId", "data-v-abddb997"]]), wT = {
  key: 0,
  class: "v-tabs__header"
}, kT = { class: "v-tabs__list" }, xT = {
  key: 0,
  "aria-busy": "true",
  "aria-label": "Loading tabs",
  class: "v-tabs__skeleton",
  role: "status"
}, ST = ["id", "aria-controls", "aria-disabled", "aria-selected", "data-tab-id", "tabindex", "onClick", "onFocus"], $T = { class: "v-tabs__tab-label" }, TT = {
  key: 2,
  class: "v-tabs__tab-count"
}, CT = {
  key: 0,
  class: "v-tabs__more"
}, MT = {
  key: 0,
  class: "v-tabs__actions"
}, DT = ["id"], _T = ["id", "aria-labelledby"], OT = { class: "v-tabs__panel" }, ET = {
  key: 2,
  class: "v-tabs__loading"
}, IT = 3, AT = 70, PT = /* @__PURE__ */ ke({
  __name: "VTabs",
  props: {
    tabs: {},
    loading: { type: Boolean },
    reset: { type: Boolean },
    useHash: { type: Boolean, default: !0 },
    tabSelectionMode: { default: "auto" },
    actionsTargetId: { default: void 0 },
    modern: { type: Boolean, default: !1 }
  },
  emits: ["tabSelected"],
  setup(e, { expose: n, emit: t }) {
    const a = Nu(), s = ui(), l = Ca(), r = e, i = t, o = S(
      () => r.tabs.length > 0 && r.tabs.every((q) => q.to)
    );
    Ne(() => r.tabs, (q) => {
    }, { immediate: !0 });
    const u = () => {
      var ie;
      if (!o.value && r.useHash && (s != null && s.hash)) {
        const L = s.hash.replace("#tab-", ""), ae = r.tabs.find((Y) => String(Y.id) === L);
        if (ae)
          return ae.id;
      }
      const q = r.tabs.find((L) => L.activeByDefault);
      return (q == null ? void 0 : q.id) ?? ((ie = r.tabs[0]) == null ? void 0 : ie.id);
    }, c = J(u()), d = S(() => {
      var Y, W;
      if (!o.value) return null;
      const q = r.tabs.flatMap(
        (K) => K.to ? [{ id: K.id, resolved: a.resolve(K.to) }] : []
      ), ie = q.find(({ resolved: K }) => s.name != null && K.name != null ? K.name === s.name : K.path === s.path);
      if (ie) return ie.id;
      const L = (K) => s.path.startsWith(K.endsWith("/") ? K : `${K}/`);
      return ((Y = q.filter(({ resolved: K }) => L(K.path)).sort((K, de) => de.resolved.path.length - K.resolved.path.length)[0]) == null ? void 0 : Y.id) ?? ((W = r.tabs[0]) == null ? void 0 : W.id) ?? null;
    }), p = S(() => d.value !== null ? d.value : r.tabs.some((ie) => ie.id === c.value) ? c.value : u()), f = S(() => r.tabs.find((q) => q.id === p.value)), w = S(() => r.loading && r.tabs.length === 0), m = (q, ie = !0) => {
      const L = r.tabs.find((Y) => Y.id === q);
      if (!L || L.disabled) return;
      if (o.value) {
        if (L.id === p.value) return;
        const Y = () => {
          L.to && a.push(L.to);
        };
        r.tabSelectionMode === "controlled" ? i("tabSelected", { tabId: q, callback: Y, tab: L }) : (Y(), i("tabSelected", {
          tabId: q,
          callback: () => {
          },
          tab: L
        }));
        return;
      }
      const ae = () => {
        c.value = q, r.useHash && ie && s && a && s.hash !== `#tab-${q}` && a.push({
          hash: `#tab-${q}`,
          query: s.query
        });
      };
      r.tabSelectionMode === "controlled" ? i("tabSelected", {
        tabId: q,
        callback: ae,
        tab: L
      }) : (ae(), i("tabSelected", {
        tabId: q,
        callback: () => {
        },
        // Already switched, callback is no-op
        tab: L
      }));
    };
    Ne(
      () => r.reset,
      (q) => {
        q && r.tabs.length > 0 && m(r.tabs[0].id);
      }
    ), et(() => {
      const q = () => {
        !o.value && r.useHash && s && a && s.hash !== `#tab-${c.value}` && a.replace({
          hash: `#tab-${c.value}`,
          query: s.query
        });
      }, ie = r.tabs.find((L) => L.id === p.value);
      q(), i("tabSelected", {
        tabId: p.value,
        callback: () => {
        },
        // Already initialized, callback is no-op
        tab: ie
      });
    });
    const k = (q) => p.value === q, y = (q) => k(q) && !o.value ? `${l}-tabpanel-${q}` : void 0, h = Ge("nav"), g = J(null), x = S(() => {
      const q = O.value.filter((L) => !L.disabled), ie = q.find((L) => L.id === g.value) ?? q.find((L) => L.id === p.value) ?? q[0];
      return (ie == null ? void 0 : ie.id) ?? null;
    }), $ = (q) => {
      var W;
      if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(q.key) || !h.value) return;
      const L = Array.from(h.value.querySelectorAll("[role=tab]")).filter((K) => K.getAttribute("aria-disabled") !== "true");
      if (L.length === 0) return;
      const ae = L.indexOf(document.activeElement);
      let Y = ae;
      q.key === "ArrowRight" ? Y = (ae + 1) % L.length : q.key === "ArrowLeft" ? Y = (ae - 1 + L.length) % L.length : q.key === "Home" ? Y = 0 : Y = L.length - 1, q.preventDefault(), (W = L[Y]) == null || W.focus();
    }, C = J(null), O = J([...r.tabs]), _ = J([]), I = J(/* @__PURE__ */ new Map()), D = () => {
      if (!C.value || r.tabs.length === 0) return;
      const q = C.value, ie = q.offsetWidth;
      if (ie === 0) return;
      q.querySelectorAll(".v-tabs__tab").forEach((he) => {
        const me = he.getAttribute("data-tab-id");
        if (!me) return;
        const Te = r.tabs.find((we) => String(we.id) === me);
        Te && he && I.value.set(Te.id, he.offsetWidth);
      });
      let ae = 0;
      const Y = [];
      for (const he of r.tabs) {
        const me = I.value.get(he.id) || 150;
        Y.push(me), ae += me;
      }
      if (ae <= ie) {
        O.value = [...r.tabs], _.value = [];
        return;
      }
      const W = ie - AT;
      let K = 0, de = 0;
      for (let he = 0; he < r.tabs.length; he++) {
        const me = Y[he];
        if (K + me <= W)
          K += me, de = he + 1;
        else
          break;
      }
      O.value = r.tabs.slice(0, de), _.value = r.tabs.slice(de);
    }, z = S(() => _.value.map((q) => ({
      label: q.count !== void 0 ? `${q.label} (${aa(q.count)})` : q.label,
      value: q.id,
      icon: q.icon,
      disabled: q.disabled,
      active: q.id === p.value
    }))), H = (q) => {
      m(q);
    };
    let ne = null, te = null;
    return et(async () => {
      await Ke(), await Ke(), C.value && (D(), ne = new ResizeObserver(() => {
        te && clearTimeout(te), te = setTimeout(() => {
          D();
        }, 100);
      }), ne.observe(C.value));
    }), ss(() => {
      te && clearTimeout(te), ne && C.value && (ne.unobserve(C.value), ne.disconnect());
    }), Ne(() => r.tabs, async () => {
      await Ke(), D();
    }, { deep: !0 }), n({
      currentTabId: c,
      activeTabId: p,
      selectTab: m
    }), (q, ie) => (b(), T("div", {
      class: j(["v-tabs", { "v-tabs--modern": r.modern }])
    }, [
      r.tabs.length > 0 || r.loading ? (b(), T("div", wT, [
        E("div", kT, [
          E("div", {
            ref_key: "tabsContainerRef",
            ref: C,
            class: "v-tabs__scroll"
          }, [
            w.value ? (b(), T("div", xT, [
              (b(), T($e, null, Oe(IT, (L) => E("span", {
                key: L,
                class: "v-tabs__skeleton-item"
              })), 64))
            ])) : (b(), T("nav", {
              key: 1,
              ref: "nav",
              "aria-label": "Tabs navigation",
              class: "v-tabs__nav",
              role: "tablist",
              onKeydown: $
            }, [
              (b(!0), T($e, null, Oe(O.value, (L) => (b(), T("button", {
                id: `${v(l)}-tab-${L.id}`,
                key: L.id,
                "aria-controls": y(L.id),
                "aria-disabled": L.disabled,
                "aria-selected": k(L.id),
                class: j([
                  "v-tabs__tab",
                  {
                    "v-tabs__tab--active": k(L.id),
                    "v-tabs__tab--disabled": L.disabled
                  },
                  L.styles
                ]),
                "data-tab-id": L.id,
                tabindex: L.id === x.value ? 0 : -1,
                role: "tab",
                type: "button",
                onClick: (ae) => m(L.id),
                onFocus: (ae) => g.value = L.id
              }, [
                L.icon ? (b(), ce(ye, {
                  key: 1,
                  icon: L.icon,
                  class: "v-tabs__tab-icon"
                }, null, 8, ["icon"])) : U(q.$slots, `tab-icon-${L.id}`, { key: 0 }, void 0, !0),
                E("span", $T, le(L.label), 1),
                L.count !== void 0 ? (b(), T("span", TT, le(v(aa)(L.count)), 1)) : P("", !0)
              ], 42, ST))), 128))
            ], 544))
          ], 512),
          _.value.length > 0 ? (b(), T("div", CT, [
            se(Ta, {
              items: z.value,
              placement: "bottom-right",
              onSelect: H
            }, {
              trigger: ue(() => [
                se(vt, {
                  icon: "mdi:dots-horizontal",
                  modern: ""
                })
              ]),
              _: 1
            }, 8, ["items"])
          ])) : P("", !0)
        ]),
        q.$slots["tabs-right"] || e.actionsTargetId ? (b(), T("div", MT, [
          U(q.$slots, "tabs-right", { currentTabId: p.value }, void 0, !0),
          e.actionsTargetId ? (b(), T("div", {
            key: 0,
            id: e.actionsTargetId,
            class: "v-tabs__actions-target"
          }, null, 8, DT)) : P("", !0)
        ])) : P("", !0)
      ])) : P("", !0),
      !r.loading && !o.value ? (b(), T("div", {
        key: 1,
        id: `${v(l)}-tabpanel-${p.value}`,
        "aria-labelledby": `${v(l)}-tab-${p.value}`,
        class: "v-tabs__content",
        role: "tabpanel"
      }, [
        E("div", OT, [
          U(q.$slots, `${p.value}`, {}, () => {
            var L;
            return [
              (L = f.value) != null && L.component ? (b(), ce(mt(f.value.component), { key: 0 })) : P("", !0)
            ];
          }, !0)
        ])
      ], 8, _T)) : r.loading && !o.value ? (b(), T("div", ET, [
        se(Xs, {
          modern: r.modern,
          size: "large"
        }, null, 8, ["modern"])
      ])) : P("", !0)
    ], 2));
  }
}), h_ = /* @__PURE__ */ Le(PT, [["__scopeId", "data-v-8f86a07a"]]), of = Symbol("tableModern"), Oa = () => bn(of, S(() => !1)), RT = ["title"], yu = /* @__PURE__ */ ke({
  __name: "TableCell",
  props: {
    value: {},
    align: { default: "left" },
    depth: { default: 0 },
    isFirstColumn: { type: Boolean, default: !1 },
    row: {},
    column: {},
    colIndex: {},
    rowIndex: {},
    interactive: { type: Boolean, default: !1 },
    isExpanded: { type: Boolean, default: !1 }
  },
  emits: ["toggle-expand"],
  setup(e, { emit: n }) {
    const t = n, a = Ht(), s = Oa(), l = bn("tableCellMetadata", void 0), r = S(() => !e.row || !e.column || e.colIndex === void 0 || e.rowIndex === void 0 || !l ? null : l(e.row, e.column, e.colIndex, e.rowIndex)), i = S(() => {
      if (e.isFirstColumn && e.depth > 0)
        return `${e.depth * 24 + 16}px`;
    }), o = S(
      () => r.value ? r.value.formattedValue : e.value
    ), u = () => {
      if (!(e.interactive || a.default))
        return String(o.value);
    }, c = S(() => {
      var m;
      return !!((m = r.value) != null && m.isExpandable);
    }), d = S(() => !!e.row && !!e.column), p = S(() => {
      var m;
      return [
        {
          "v-table-cell--left": e.align === "left",
          "v-table-cell--center": e.align === "center",
          "v-table-cell--right": e.align === "right",
          "v-table-cell--indented": e.isFirstColumn && e.depth > 0,
          // Styling hook for `modern` (control-sized vertical padding). The legacy rule on this
          // class only touches .v-table-cell-text overflow, which interactive cells already leave visible.
          "v-table-cell--interactive": e.interactive
        },
        (m = r.value) == null ? void 0 : m.cssClass
      ];
    }), f = S(() => {
      var k, y;
      const m = (k = r.value) == null ? void 0 : k.indentStyle;
      return {
        paddingLeft: i.value,
        ...m ? { "--cell-indent": m.paddingLeft } : {},
        ...(y = r.value) == null ? void 0 : y.customStyle
      };
    }), w = () => {
      t("toggle-expand");
    };
    return (m, k) => (b(), T("div", {
      class: j([p.value, "v-table-cell"]),
      style: Fe(f.value)
    }, [
      d.value ? (b(), T($e, { key: 0 }, [
        U(m.$slots, "pin"),
        c.value ? (b(), T("button", {
          key: 0,
          class: "v-table-cell-expand-btn",
          onClick: Ve(w, ["stop"])
        }, [
          se(v(ye), {
            icon: e.isExpanded ? "lucide:chevron-down" : "lucide:chevron-right",
            size: v(s) ? 14 : 18
          }, null, 8, ["icon", "size"])
        ])) : P("", !0),
        E("span", {
          title: u(),
          class: j([{ "v-table-cell-text--truncate": !e.interactive }, "v-table-cell-text"])
        }, [
          U(m.$slots, "default", {}, () => [
            He(le(o.value), 1)
          ])
        ], 10, RT)
      ], 64)) : U(m.$slots, "default", { key: 1 })
    ], 6));
  }
}), VT = ["title"], FT = /* @__PURE__ */ ke({
  __name: "TableCellValue",
  props: {
    value: {},
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = S(() => e.interactive ? void 0 : String(e.value));
    return (t, a) => (b(), T("span", { title: n.value }, le(e.value), 9, VT));
  }
}), LT = /* @__PURE__ */ ke({
  __name: "TableCheckboxCell",
  props: {
    checked: { type: Boolean },
    indeterminate: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = () => {
      t("toggle");
    };
    return (s, l) => (b(), T("div", {
      class: "v-table-checkbox-cell",
      onClick: l[0] || (l[0] = Ve(() => {
      }, ["stop"]))
    }, [
      se(v(ad), {
        disabled: e.disabled,
        indeterminate: e.indeterminate,
        "model-value": e.checked,
        "onUpdate:modelValue": a
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), NT = /* @__PURE__ */ Le(LT, [["__scopeId", "data-v-499acbc1"]]), zT = [
  { key: "text", label: "Text", icon: "lucide:align-left", color: "secondaryText" },
  { key: "multi-text", label: "Multi-text", icon: "lucide:align-justify", color: "secondaryText" },
  { key: "number", label: "Number", icon: "lucide:hash", color: "primary" },
  { key: "decimal", label: "Decimal", icon: "lucide:percent", color: "primary" },
  { key: "boolean", label: "Boolean", icon: "lucide:toggle-right", color: "success" },
  { key: "date", label: "Date", icon: "lucide:calendar", color: "warning" },
  { key: "datetime", label: "Datetime", icon: "lucide:calendar-clock", color: "warning" },
  { key: "select", label: "Select", icon: "lucide:list", color: "primary" },
  { key: "multi-select", label: "Multi-select", icon: "lucide:list-checks", color: "primary" },
  { key: "color", label: "Color", icon: "lucide:palette", color: "error" },
  { key: "json", label: "JSON", icon: "lucide:braces", color: "error" },
  { key: "url", label: "URL", icon: "lucide:link", color: "secondaryText" },
  { key: "link", label: "Link", icon: "lucide:external-link", color: "secondaryText" },
  { key: "asset", label: "Asset", icon: "lucide:image", color: "info" },
  { key: "multi-asset", label: "Multi-asset", icon: "lucide:images", color: "info" },
  { key: "sys", label: "File", icon: "lucide:file", color: "info" }
], m_ = (e) => e;
function cs(e) {
  return new Promise((n, t) => {
    e.oncomplete = e.onsuccess = () => n(e.result), e.onabort = e.onerror = () => t(e.error);
  });
}
function uf(e, n) {
  let t;
  const a = () => {
    if (t)
      return t;
    const s = indexedDB.open(e);
    return s.onupgradeneeded = () => s.result.createObjectStore(n), t = cs(s), t.then((l) => {
      l.onclose = () => t = void 0;
    }, () => {
    }), t;
  };
  return (s, l) => a().then((r) => l(r.transaction(n, s).objectStore(n)));
}
let Mr;
function Jl() {
  return Mr || (Mr = uf("keyval-store", "keyval")), Mr;
}
function bu(e, n = Jl()) {
  return n("readonly", (t) => cs(t.get(e)));
}
function BT(e, n, t = Jl()) {
  return t("readwrite", (a) => (a.put(n, e), cs(a.transaction)));
}
function wu(e, n = Jl()) {
  return n("readwrite", (t) => (t.delete(e), cs(t.transaction)));
}
function WT(e, n) {
  return e.openCursor().onsuccess = function() {
    this.result && (n(this.result), this.result.continue());
  }, cs(e.transaction);
}
function ku(e = Jl()) {
  return e("readonly", (n) => {
    if (n.getAllKeys)
      return cs(n.getAllKeys());
    const t = [];
    return WT(n, (a) => t.push(a.key)).then(() => t);
  });
}
const YT = {
  deserialize: JSON.parse,
  dialect: "redis",
  serialize: JSON.stringify,
  dbName: "keyv",
  storeName: "keyv"
};
class HT {
  constructor(n) {
    this.ttlSupport = !1, this.namespace = "", this.opts = Object.assign({}, YT, n), this.store = uf(this.opts.dbName, this.opts.storeName);
  }
  _getKey(n) {
    return this.namespace ? `${this.namespace}${n}` : n;
  }
  _innerKeyToKey(n) {
    return this.namespace && n.startsWith(this.namespace) ? n.slice(this.namespace.length) : n;
  }
  on(n, t) {
    return this;
  }
  async get(n) {
    try {
      const t = await bu(this._getKey(n), this.store);
      return t ?? void 0;
    } catch {
    }
  }
  async getMany(n) {
    return Promise.all(n.map((t) => this.get(t)));
  }
  /**
   * Note: `await kv.set()` will wait <options.writeDelay> millseconds to save to disk, it would be slow. Please remove `await` if you find performance issues.
   * @param key
   * @param value
   * @param ttl
   * @returns
   */
  async set(n, t, a) {
    return BT(this._getKey(n), t, this.store);
  }
  async delete(n) {
    let t = await this.has(n);
    return await wu(this._getKey(n), this.store), t;
  }
  async deleteMany(n) {
    return (await Promise.all(n.map((a) => this.delete(a)))).every((a) => a);
  }
  async clear() {
    let n = await ku(this.store), t = [];
    for (let a = 0; a < n.length; a++) {
      const s = n[a];
      typeof s == "string" && s.startsWith(this.namespace) && t.push(wu(s, this.store));
    }
    await Promise.all(t);
  }
  async has(n) {
    return await this.get(n) !== void 0;
  }
  disconnect() {
    return Promise.resolve();
  }
  async *iterator(n = this.namespace) {
    let t = await ku(this.store);
    for (let a = 0; a < t.length; a++) {
      let s = t[a];
      typeof s == "string" && (!n || s.startsWith(n)) && (yield [s, await bu(s, this.store)]);
    }
  }
}
class UT {
  constructor(n = "table-configs") {
    xe(this, "keyv");
    this.keyv = new HT({
      dbName: n,
      storeName: "keyv",
      namespace: n
    });
  }
  async get(n) {
    try {
      return await this.keyv.get(n) ?? null;
    } catch (t) {
      return console.error("IndexedDB get error:", t), null;
    }
  }
  async set(n, t) {
    try {
      await this.keyv.set(n, t);
    } catch (a) {
      throw console.error("IndexedDB set error:", a), a;
    }
  }
  async delete(n) {
    try {
      await this.keyv.delete(n);
    } catch (t) {
      throw console.error("IndexedDB delete error:", t), t;
    }
  }
  async clear() {
    try {
      await this.keyv.clear();
    } catch (n) {
      throw console.error("IndexedDB clear error:", n), n;
    }
  }
}
class xu {
  constructor(n = "localStorage") {
    xe(this, "storage");
    this.storage = n === "sessionStorage" ? sessionStorage : localStorage;
  }
  get(n) {
    try {
      const t = this.storage.getItem(n);
      return Promise.resolve(t ? JSON.parse(t) : null);
    } catch (t) {
      return console.error("WebStorage get error:", t), Promise.resolve(null);
    }
  }
  set(n, t) {
    try {
      return this.storage.setItem(n, JSON.stringify(t)), Promise.resolve();
    } catch (a) {
      return console.error("WebStorage set error:", a), a instanceof DOMException && a.name === "QuotaExceededError" && console.warn("Storage quota exceeded, consider using IndexedDB"), Promise.reject(a);
    }
  }
  delete(n) {
    try {
      return this.storage.removeItem(n), Promise.resolve();
    } catch (t) {
      return console.error("WebStorage delete error:", t), Promise.reject(t);
    }
  }
  clear() {
    try {
      return this.storage.clear(), Promise.resolve();
    } catch (n) {
      return console.error("WebStorage clear error:", n), Promise.reject(n);
    }
  }
}
function Su(e = "indexedDB", n) {
  switch (e) {
    case "indexedDB":
      return new UT(n);
    case "localStorage":
      return new xu("localStorage");
    case "sessionStorage":
      return new xu("sessionStorage");
    default:
      throw new Error(`Unknown storage type: ${e}`);
  }
}
const va = class va {
  constructor() {
    xe(this, "adapter");
    xe(this, "storageType");
    this.storageType = "indexedDB", this.adapter = Su(this.storageType, "table-configs");
  }
  static getInstance() {
    return va.instance || (va.instance = new va()), va.instance;
  }
  /**
     * Change storage type globally
     * Useful for testing or fallback scenarios
     */
  setStorageType(n, t) {
    this.storageType = n, this.adapter = Su(n, t);
  }
  getStorageType() {
    return this.storageType;
  }
  getAdapter() {
    return this.adapter;
  }
  /**
     * Get table configuration
     */
  getTableConfig(n) {
    return this.adapter.get(n);
  }
  /**
     * Save table configuration
     */
  async setTableConfig(n, t) {
    await this.adapter.set(n, t);
  }
  /**
     * Delete table configuration
     */
  async deleteTableConfig(n) {
    await this.adapter.delete(n);
  }
  /**
     * Clear all table configurations
     */
  async clearAllConfigs() {
    await this.adapter.clear();
  }
};
xe(va, "instance");
let li = va;
const as = li.getInstance(), Il = (e, n) => (n && as.setStorageType(n), as.getTableConfig(e)), cf = async (e, n, t) => {
  t && as.setStorageType(t), await as.setTableConfig(e, n);
}, qT = { class: "column-picker" }, jT = { class: "column-picker-header" }, GT = { class: "column-picker-header-title" }, KT = { class: "column-picker-body" }, ZT = { class: "column-picker-panel column-picker-panel--left" }, XT = { class: "column-picker-panel-header" }, JT = { class: "column-picker-panel-count" }, QT = { class: "cp-toolbar" }, eC = { class: "cp-search" }, tC = { class: "cp-sort-group" }, nC = { class: "column-picker-panel-list" }, aC = ["onClick"], sC = ["onClick"], lC = {
  key: 0,
  class: "cp-type-group-header"
}, rC = { class: "cp-type-group-label" }, iC = ["onClick"], oC = {
  key: 0,
  class: "cp-type-icon"
}, uC = { class: "cp-available-item-label" }, cC = {
  class: "cp-available-item-toggle",
  "aria-hidden": "true"
}, dC = ["onClick"], fC = {
  key: 0,
  class: "column-picker-empty"
}, hC = { class: "column-picker-panel column-picker-panel--right" }, mC = { class: "column-picker-panel-header" }, vC = { class: "column-picker-panel-search" }, pC = { class: "column-picker-panel-list" }, gC = ["draggable", "onDragover", "onDragstart", "onDrop"], yC = { class: "cp-selected-item-drag" }, bC = {
  key: 0,
  class: "cp-type-icon"
}, wC = { class: "cp-selected-item-label" }, kC = ["title", "onClick"], xC = ["onClick"], SC = {
  key: 0,
  class: "column-picker-empty"
}, $C = { class: "column-picker-footer" }, TC = {
  key: 0,
  class: "column-picker-footer-hint column-picker-footer-hint--limit"
}, CC = {
  key: 1,
  class: "column-picker-footer-hint"
}, Dr = 6, _r = 40, MC = /* @__PURE__ */ ke({
  __name: "TableColumnPicker",
  props: {
    groups: {},
    columns: {},
    originalColumns: {},
    loading: { type: Boolean, default: !1 },
    storageKey: {},
    storageType: {},
    types: {}
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = J(""), l = J("alpha"), r = J(/* @__PURE__ */ new Set()), i = J(/* @__PURE__ */ new Set());
    Ne(l, () => {
      i.value = /* @__PURE__ */ new Set();
    });
    const o = (A) => {
      if (r.value.has(A)) {
        r.value.delete(A);
        const B = new Set(i.value);
        B.delete(A), i.value = B;
      } else
        r.value.add(A);
      r.value = new Set(r.value);
    }, u = S(() => {
      const A = s.value.trim().toLowerCase();
      return A ? t.groups.map((B) => ({
        ...B,
        items: B.items.filter((M) => M.label.toLowerCase().includes(A))
      })).filter((B) => B.items.length > 0) : t.groups;
    });
    Ne(s, (A) => {
      A.trim() ? r.value = new Set(u.value.map((B) => B.key)) : r.value = /* @__PURE__ */ new Set();
    });
    const c = S(() => {
      const A = zT.map((B) => ({ ...B }));
      for (const B of t.types ?? []) {
        const M = A.findIndex((V) => V.key === B.key);
        M === -1 ? A.push(B) : A[M] = B;
      }
      return A;
    }), d = S(
      () => new Map(c.value.map((A) => [A.key, A]))
    ), p = S(
      () => new Map(c.value.map((A, B) => [A.key, B]))
    ), f = (A) => {
      const B = A.replace(/[-_]/g, " ").trim();
      return B.charAt(0).toUpperCase() + B.slice(1);
    }, w = (A) => {
      var B;
      return ((B = d.value.get(A)) == null ? void 0 : B.label) ?? f(A);
    }, m = (A) => {
      const B = A ? d.value.get(A) : void 0;
      return (B == null ? void 0 : B.icon) ?? "lucide:help-circle";
    }, k = (A) => {
      const B = A ? d.value.get(A) : void 0;
      return (B == null ? void 0 : B.color) ?? "secondaryText";
    };
    function y(A) {
      const B = new Set(i.value);
      B.add(A), i.value = B;
    }
    function h(A) {
      const B = [...A.items];
      return l.value === "alpha" ? B.sort((M, V) => {
        const R = M.label.toLowerCase().trim(), Q = V.label.toLowerCase().trim();
        return R < Q ? -1 : R > Q ? 1 : 0;
      }) : B.sort((M, V) => {
        const R = p.value.get(M.icon ?? "") ?? Number.MAX_SAFE_INTEGER, Q = p.value.get(V.icon ?? "") ?? Number.MAX_SAFE_INTEGER;
        if (R !== Q) return R - Q;
        if (R === Number.MAX_SAFE_INTEGER) {
          const Ce = M.icon ?? "", Re = V.icon ?? "";
          if (Ce !== Re) return Ce < Re ? -1 : 1;
        }
        const N = M.label.toLowerCase().trim(), fe = V.label.toLowerCase().trim();
        return N < fe ? -1 : N > fe ? 1 : 0;
      });
    }
    function g(A) {
      return !s.value.trim() && !i.value.has(A.key) && h(A).length > Dr;
    }
    const x = (A) => {
      if (!(s.value.trim() || i.value.has(A.key)))
        return Dr;
    }, $ = (A) => {
      const B = h(A), M = x(A);
      if (l.value !== "by-type")
        return (M !== void 0 ? B.slice(0, M) : B).map((fe) => ({ isHeader: !1, key: fe.key, item: fe }));
      const V = /* @__PURE__ */ new Map();
      for (const N of B) {
        const fe = N.icon ?? "", Ce = V.get(fe);
        Ce ? Ce.push(N) : V.set(fe, [N]);
      }
      const R = [];
      let Q = 0;
      for (const [N, fe] of V) {
        if (M !== void 0 && Q >= M) break;
        R.push({ isHeader: !0, key: `hdr-${N}`, typeKey: N });
        for (const Ce of fe) {
          if (M !== void 0 && Q >= M) break;
          R.push({ isHeader: !1, key: Ce.key, item: Ce }), Q += 1;
        }
      }
      return R;
    }, C = J([]), O = J([]), _ = (A, B = !1) => {
      if (A) {
        const M = /* @__PURE__ */ new Map();
        t.groups.forEach((R) => R.items.forEach((Q) => M.set(Q.key, Q)));
        const V = A.order.filter((R) => A.visible.includes(R)).map((R) => {
          var Ee, Ye;
          const Q = t.columns.find((At) => At.key === R), N = M.get(R), fe = (Q == null ? void 0 : Q.label) ?? (N == null ? void 0 : N.label) ?? ((Ee = A.labels) == null ? void 0 : Ee[R]) ?? R, Ce = (N == null ? void 0 : N.icon) ?? (Q == null ? void 0 : Q.icon), Re = (Ye = A.fixed) == null ? void 0 : Ye[R];
          return { key: R, label: fe, icon: Ce, fixed: Re };
        }).filter((R) => R !== null);
        C.value = V;
      } else {
        const M = B ? t.originalColumns ?? t.columns : t.columns;
        C.value = M.map((V) => ({
          key: V.key,
          label: V.label,
          icon: V.icon,
          fixed: V.fixed
        }));
      }
      O.value = JSON.parse(JSON.stringify(C.value));
    };
    et(async () => {
      if (t.storageKey)
        try {
          const A = await Il(t.storageKey, t.storageType);
          _(A);
          return;
        } catch (A) {
          console.error("[TableColumnPicker] Failed to load from storage:", A);
        }
      _();
    });
    const I = J(""), D = S(() => {
      const A = I.value.trim().toLowerCase();
      return A ? C.value.filter((B) => B.label.toLowerCase().includes(A)) : C.value;
    }), z = S(() => new Set(C.value.map((A) => A.key))), H = S(() => C.value.length >= _r), ne = S(
      () => t.groups.reduce((A, B) => A + B.items.length, 0)
    );
    function te(A) {
      return A.items.filter((B) => z.value.has(B.key)).length;
    }
    function q(A) {
      return A.items.length > 0 && A.items.every((B) => z.value.has(B.key));
    }
    function ie(A) {
      if (q(A)) {
        const B = new Set(A.items.map((M) => M.key));
        C.value = C.value.filter((M) => B.has(M.key) ? !!M.fixed : !0);
      } else {
        const B = A.items.filter((V) => !z.value.has(V.key)), M = _r - C.value.length;
        C.value = [
          ...C.value,
          ...B.slice(0, M).map((V) => ({ key: V.key, label: V.label, icon: V.icon }))
        ];
      }
    }
    const L = (A) => {
      !z.value.has(A.key) && !H.value && (C.value = [...C.value, { key: A.key, label: A.label, icon: A.icon }]);
    }, ae = (A) => {
      const B = C.value.find((M) => M.key === A);
      B != null && B.fixed || (C.value = C.value.filter((M) => M.key !== A));
    }, Y = (A) => {
      z.value.has(A.key) ? ae(A.key) : L(A);
    }, W = async () => {
      if (t.storageKey)
        try {
          await as.deleteTableConfig(t.storageKey);
        } catch (R) {
          console.error("[TableColumnPicker] Failed to clear storage:", R);
        }
      _(null, !0);
      const A = t.originalColumns ?? t.columns, B = new Map(A.map((R) => [R.key, R])), M = /* @__PURE__ */ new Map();
      t.groups.forEach((R) => R.items.forEach((Q) => M.set(Q.key, Q)));
      const V = C.value.map((R) => {
        const Q = B.get(R.key);
        if (Q) return { ...Q, fixed: R.fixed };
        const N = M.get(R.key);
        return {
          key: R.key,
          label: R.label,
          fixed: R.fixed,
          sortable: N == null ? void 0 : N.sortable,
          format: N == null ? void 0 : N.format
        };
      });
      a("update:visible-columns", V), a("close");
    }, K = (A) => A === 0 || A === 1, de = (A) => A.fixed === "left", he = (A) => {
      !K(A) || !C.value[A] || (C.value = C.value.map(
        (M, V) => V === A ? { ...M, fixed: M.fixed === "left" ? void 0 : "left" } : M
      ));
    }, me = () => {
      C.value = C.value.map(
        (A, B) => A.fixed === "left" && !K(B) ? { ...A, fixed: void 0 } : A
      );
    }, Te = J(null), we = J(null), X = (A, B) => {
      I.value.trim() || (Te.value = A, B.dataTransfer && (B.dataTransfer.effectAllowed = "move", B.dataTransfer.setData("text/html", "")));
    }, pe = (A, B) => {
      B.preventDefault(), B.dataTransfer && (B.dataTransfer.dropEffect = "move"), we.value = A;
    }, Me = (A, B) => {
      if (B.preventDefault(), Te.value === null || Te.value === A) {
        Te.value = null, we.value = null;
        return;
      }
      const M = [...C.value], [V] = M.splice(Te.value, 1);
      M.splice(A, 0, V), C.value = M, me(), Te.value = null, we.value = null;
    }, F = () => {
      Te.value = null, we.value = null;
    }, Z = async (A) => {
      if (!t.storageKey) return;
      const B = {}, M = {};
      A.forEach((R) => {
        R.fixed && (B[R.key] = R.fixed), M[R.key] = R.label;
      });
      const V = {
        visible: A.map((R) => R.key),
        order: A.map((R) => R.key),
        fixed: Object.keys(B).length > 0 ? B : void 0,
        labels: M
      };
      try {
        await cf(t.storageKey, V, t.storageType);
      } catch (R) {
        console.error("[TableColumnPicker] Failed to save to storage:", R);
      }
    }, ve = S(
      () => JSON.stringify(C.value) !== JSON.stringify(O.value)
    ), G = async () => {
      const A = new Map(t.columns.map((V) => [V.key, V])), B = /* @__PURE__ */ new Map();
      t.groups.forEach((V) => V.items.forEach((R) => B.set(R.key, R)));
      const M = C.value.map((V) => {
        const R = A.get(V.key);
        if (R) return { ...R, fixed: V.fixed };
        const Q = B.get(V.key);
        return {
          key: V.key,
          label: V.label,
          fixed: V.fixed,
          sortable: Q == null ? void 0 : Q.sortable,
          format: Q == null ? void 0 : Q.format
        };
      });
      await Z(C.value), a("update:visible-columns", M), O.value = JSON.parse(JSON.stringify(C.value)), a("close");
    }, oe = () => {
      C.value = JSON.parse(JSON.stringify(O.value)), a("close");
    };
    function be(A) {
      return A ? { "--cp-type-color-raw": `var(--color-${k(A)})` } : {};
    }
    return (A, B) => (b(), T("div", qT, [
      E("div", jT, [
        E("div", GT, [
          se(v(ye), {
            size: 24,
            icon: "lucide:columns",
            variant: "link"
          }),
          B[5] || (B[5] = E("span", null, "Edit columns", -1))
        ]),
        E("button", {
          class: "column-picker-close-btn",
          title: "Close",
          onClick: oe
        }, [
          se(v(ye), {
            size: 16,
            icon: "lucide:x"
          })
        ])
      ]),
      E("div", KT, [
        E("div", ZT, [
          E("div", XT, [
            E("span", JT, le(ne.value) + " columns available ", 1)
          ]),
          E("div", QT, [
            E("div", eC, [
              se(v(ye), {
                size: 11,
                icon: "lucide:search"
              }),
              Gt(E("input", {
                "onUpdate:modelValue": B[0] || (B[0] = (M) => s.value = M),
                placeholder: "Search…"
              }, null, 512), [
                [oi, s.value]
              ])
            ]),
            E("div", tC, [
              E("button", {
                class: j([{ "cp-sort-btn--active": l.value === "by-type" }, "cp-sort-btn"]),
                title: "Group by type",
                type: "button",
                onClick: B[1] || (B[1] = (M) => l.value = "by-type")
              }, [
                se(v(ye), {
                  size: 10,
                  icon: "lucide:group"
                })
              ], 2),
              B[6] || (B[6] = E("div", { class: "cp-sort-divider" }, null, -1)),
              E("button", {
                class: j([{ "cp-sort-btn--active": l.value === "alpha" }, "cp-sort-btn"]),
                title: "Sort alphabetically",
                type: "button",
                onClick: B[2] || (B[2] = (M) => l.value = "alpha")
              }, " A→Z ", 2)
            ])
          ]),
          E("div", nC, [
            e.loading ? (b(), T($e, { key: 0 }, Oe(6, (M) => E("div", {
              key: M,
              class: "column-picker-skeleton"
            })), 64)) : (b(), T($e, { key: 1 }, [
              (b(!0), T($e, null, Oe(u.value, (M) => (b(), T("div", {
                key: M.key
              }, [
                E("div", {
                  class: "cp-group-header",
                  onClick: (V) => o(M.key)
                }, [
                  E("span", {
                    class: j([{ "cp-group-label--has-selection": te(M) > 0 }, "cp-group-label"])
                  }, le(M.label), 3),
                  E("button", {
                    class: "cp-group-select-btn",
                    type: "button",
                    onClick: Ve((V) => ie(M), ["stop"])
                  }, le(q(M) ? "Deselect all" : "Select all"), 9, sC),
                  E("span", {
                    class: j([te(M) > 0 ? "cp-group-badge--selected" : "cp-group-badge--empty", "cp-group-badge"])
                  }, le(te(M)) + "/" + le(M.items.length), 3),
                  se(v(ye), {
                    class: j([{ "cp-group-chevron--open": r.value.has(M.key) }, "cp-group-chevron"]),
                    size: 10,
                    icon: "lucide:chevron-right"
                  }, null, 8, ["class"])
                ], 8, aC),
                r.value.has(M.key) ? (b(), T($e, { key: 0 }, [
                  (b(!0), T($e, null, Oe($(M), (V) => (b(), T($e, {
                    key: V.key
                  }, [
                    V.isHeader && V.typeKey ? (b(), T("div", lC, [
                      E("div", {
                        style: Fe({ background: `rgb(var(--color-${k(V.typeKey)}))` }),
                        class: "cp-type-group-dot"
                      }, null, 4),
                      E("span", rC, le(w(V.typeKey)), 1)
                    ])) : V.item ? (b(), T("div", {
                      key: 1,
                      class: j([{ "cp-available-item--selected": z.value.has(V.item.key) }, "cp-available-item"]),
                      style: Fe(be(V.item.icon)),
                      onClick: (R) => Y(V.item)
                    }, [
                      V.item.icon ? (b(), T("div", oC, [
                        se(v(ye), {
                          icon: m(V.item.icon),
                          size: 9
                        }, null, 8, ["icon"])
                      ])) : P("", !0),
                      E("span", uC, le(V.item.label), 1),
                      E("span", cC, [
                        se(v(ye), {
                          icon: z.value.has(V.item.key) ? "lucide:check" : "lucide:plus",
                          size: z.value.has(V.item.key) ? 10 : 9
                        }, null, 8, ["icon", "size"])
                      ])
                    ], 14, iC)) : P("", !0)
                  ], 64))), 128)),
                  g(M) ? (b(), T("button", {
                    key: 0,
                    class: "cp-show-more-btn",
                    type: "button",
                    onClick: Ve((V) => y(M.key), ["stop"])
                  }, " Show " + le(h(M).length - Dr) + " more ", 9, dC)) : P("", !0)
                ], 64)) : P("", !0)
              ]))), 128)),
              u.value.length === 0 ? (b(), T("div", fC, " No columns match your search ")) : P("", !0)
            ], 64))
          ])
        ]),
        B[8] || (B[8] = E("div", { class: "column-picker-divider" }, null, -1)),
        E("div", hC, [
          E("div", mC, [
            E("span", {
              class: j([{ "column-picker-panel-count--limit": H.value }, "column-picker-panel-count"])
            }, le(C.value.length) + " selected ", 3),
            E("button", {
              class: "column-picker-text-btn",
              onClick: W
            }, [
              se(v(ye), {
                size: 12,
                icon: "lucide:rotate-ccw"
              }),
              B[7] || (B[7] = He(" Reset to default ", -1))
            ])
          ]),
          E("div", vC, [
            se(v(Fs), {
              modelValue: I.value,
              "onUpdate:modelValue": B[3] || (B[3] = (M) => I.value = M),
              name: "Search",
              placeholder: "Search by column name",
              type: "search"
            }, null, 8, ["modelValue"])
          ]),
          E("div", pC, [
            (b(!0), T($e, null, Oe(D.value, (M, V) => (b(), T("div", {
              key: M.key,
              class: j([{
                "cp-selected-item--dragging": Te.value === V,
                "cp-selected-item--drag-over": we.value === V,
                "cp-selected-item--locked": !!M.fixed
              }, "cp-selected-item"]),
              draggable: !M.fixed && !I.value,
              style: Fe(be(M.icon)),
              onDragend: F,
              onDragleave: B[4] || (B[4] = (R) => we.value = null),
              onDragover: (R) => pe(V, R),
              onDragstart: (R) => X(V, R),
              onDrop: (R) => Me(V, R)
            }, [
              E("div", yC, [
                se(v(ye), {
                  size: 14,
                  icon: M.fixed ? "lucide:lock" : "lucide:grip-vertical"
                }, null, 8, ["icon"])
              ]),
              M.icon ? (b(), T("div", bC, [
                se(v(ye), {
                  icon: m(M.icon),
                  size: 9
                }, null, 8, ["icon"])
              ])) : P("", !0),
              E("span", wC, le(M.label), 1),
              K(V) && !I.value ? (b(), T("button", {
                key: 1,
                class: j([{ "cp-selected-item-pin--active": de(M) }, "cp-selected-item-pin"]),
                title: de(M) ? "Unpin column" : "Pin column to left",
                onClick: Ve((R) => he(V), ["stop"])
              }, [
                se(v(ye), {
                  icon: de(M) ? "lucide:pin" : "lucide:pin-off",
                  size: 12
                }, null, 8, ["icon"])
              ], 10, kC)) : P("", !0),
              M.fixed ? P("", !0) : (b(), T("button", {
                key: 2,
                class: "cp-selected-item-remove",
                title: "Remove column",
                onClick: (R) => ae(M.key)
              }, [
                se(v(ye), {
                  size: 12,
                  icon: "lucide:x"
                })
              ], 8, xC))
            ], 46, gC))), 128)),
            C.value.length === 0 ? (b(), T("div", SC, " No columns selected. Use the left panel to add columns. ")) : P("", !0)
          ])
        ])
      ]),
      E("div", $C, [
        H.value ? (b(), T("span", TC, [
          se(v(ye), {
            size: 24,
            icon: "lucide:alert-circle"
          }),
          He(" Max " + le(_r) + " columns reached ")
        ])) : (b(), T("span", CC, [
          se(v(ye), {
            size: 24,
            icon: "lucide:info"
          }),
          B[9] || (B[9] = He(" Drag to reorder · Pin first 2 columns ", -1))
        ])),
        se(v(vt), {
          disabled: !ve.value,
          class: "h-[30px]",
          text: "Apply",
          variant: "primary",
          onClick: G
        }, null, 8, ["disabled"])
      ])
    ]));
  }
}), DC = { class: "column-setup" }, _C = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, OC = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, EC = {
  key: 2,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, IC = { class: "column-setup-toggle-count" }, AC = ["draggable", "onDragover", "onDragstart", "onDrop"], PC = {
  key: 0,
  class: "column-setup-item-drag"
}, RC = ["title", "onClick"], VC = {
  key: 0,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, FC = {
  key: 1,
  fill: "none",
  height: "14",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.2",
  viewBox: "0 0 24 24",
  width: "14"
}, LC = ["title", "onClick"], NC = {
  key: 2,
  class: "column-setup-item-badge column-setup-item-badge--warning",
  title: "Fixed will be removed — move to top 2 positions"
}, zC = { class: "column-setup-footer" }, BC = {
  key: 0,
  class: "column-setup-hint"
}, $u = "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24", WC = /* @__PURE__ */ ke({
  __name: "TableColumnSetup",
  props: {
    columns: {},
    config: { default: () => ({}) }
  },
  emits: ["update:visible-columns", "close"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = async () => {
      var Y;
      if (!((Y = t.config) != null && Y.key)) return null;
      try {
        return await Il(t.config.key, t.config.type);
      } catch (W) {
        return console.error("Failed to load column setup from storage:", W), null;
      }
    }, l = async (Y) => {
      var W;
      if ((W = t.config) != null && W.key)
        try {
          const K = {};
          Y.forEach((he) => {
            he.fixed && (K[he.key] = he.fixed);
          });
          const de = {
            visible: Y.filter((he) => he.visible).map((he) => he.key),
            order: Y.map((he) => he.key),
            fixed: Object.keys(K).length > 0 ? K : void 0
            // Only save if there are fixed columns
          };
          await cf(t.config.key, de, t.config.type);
        } catch (K) {
          console.error("Failed to save column setup to storage:", K);
        }
    }, r = (Y) => Y.reduce((W, K) => K.children && K.children.length > 0 ? [...W, ...r(K.children)] : [...W, K], []), i = (Y) => {
      var de;
      const W = r(t.columns);
      if (Y) {
        const { visible: he, order: me, fixed: Te } = Y, we = new Map(W.map((pe) => [pe.key, pe])), X = [];
        return me.forEach((pe, Me) => {
          const F = we.get(pe);
          F && (X.push({
            key: F.key,
            label: F.label,
            visible: he.includes(pe),
            order: Me,
            fixed: (Te == null ? void 0 : Te[pe]) || F.fixed
            // Use saved fixed state, fallback to column's fixed
          }), we.delete(pe));
        }), we.forEach((pe) => {
          X.push({
            key: pe.key,
            label: pe.label,
            visible: !0,
            order: X.length,
            fixed: pe.fixed
          });
        }), X;
      }
      const K = (de = t.config) == null ? void 0 : de.initialVisible;
      return W.map((he, me) => ({
        key: he.key,
        label: he.label,
        // If initialVisible is provided, check if column is in the list
        // If not provided, all columns are visible by default
        visible: K ? K.includes(he.key) : !0,
        order: me,
        fixed: he.fixed
      }));
    }, o = J(i()), u = J(JSON.parse(JSON.stringify(i())));
    s().then((Y) => {
      if (Y) {
        const W = i(Y);
        o.value = W, u.value = JSON.parse(JSON.stringify(W));
      }
    });
    const c = S(() => JSON.stringify(o.value) !== JSON.stringify(u.value)), d = () => {
      const Y = r(t.columns), K = o.value.filter((de) => de.visible).sort((de, he) => de.order - he.order).map((de) => {
        const he = Y.find((me) => me.key === de.key);
        return he ? {
          ...he,
          fixed: de.fixed
        } : null;
      }).filter(Boolean);
      a("update:visible-columns", K);
    };
    Ne(
      o,
      () => {
      },
      { deep: !0 }
    );
    const p = () => {
      l(o.value), d(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    }, f = S(() => o.value.every((Y) => Y.visible)), w = S(() => o.value.every((Y) => !Y.visible)), m = S(() => !f.value && !w.value), k = S(() => o.value.filter((Y) => Y.visible).length), y = J(null), h = J(null), g = J(null), x = J(null), $ = (Y) => {
      if (!g.value) return;
      const W = g.value.getBoundingClientRect(), K = Y.clientY, de = 50, he = 10;
      K < W.top + de && K > W.top ? x.value || (x.value = window.setInterval(() => {
        g.value && g.value.scrollTop > 0 && (g.value.scrollTop -= he);
      }, 16)) : K > W.bottom - de && K < W.bottom ? x.value || (x.value = window.setInterval(() => {
        if (g.value) {
          const me = g.value.scrollHeight - g.value.clientHeight;
          g.value.scrollTop < me && (g.value.scrollTop += he);
        }
      }, 16)) : C();
    }, C = () => {
      x.value && (clearInterval(x.value), x.value = null);
    }, O = (Y, W) => {
      var K;
      ((K = t.config) == null ? void 0 : K.allowReorder) !== !1 && (y.value = Y, W.dataTransfer && (W.dataTransfer.effectAllowed = "move", W.dataTransfer.setData("text/html", "")));
    }, _ = (Y, W) => {
      var K;
      ((K = t.config) == null ? void 0 : K.allowReorder) !== !1 && (W.preventDefault(), W.dataTransfer && (W.dataTransfer.dropEffect = "move"), h.value = Y, $(W));
    }, I = () => {
      h.value = null;
    }, D = (Y, W) => {
      var he;
      if (((he = t.config) == null ? void 0 : he.allowReorder) === !1) return;
      if (W.preventDefault(), C(), y.value === null || y.value === Y) {
        y.value = null, h.value = null;
        return;
      }
      const K = [...o.value], [de] = K.splice(y.value, 1);
      K.splice(Y, 0, de), K.forEach((me, Te) => {
        me.order = Te;
      }), o.value = K, L(), y.value = null, h.value = null;
    }, z = () => {
      y.value = null, h.value = null, C();
    }, H = (Y) => {
      const W = o.value.find((K) => K.key === Y);
      W && (W.visible = !W.visible);
    }, ne = () => {
      const Y = !f.value;
      o.value.forEach((W) => {
        W.visible = Y;
      });
    }, te = (Y) => Y === 0 || Y === 1, q = (Y) => Y.fixed === "left", ie = (Y) => {
      if (!te(Y)) return;
      const W = o.value[Y];
      W && (W.fixed === "left" ? W.fixed = void 0 : W.fixed = "left");
    }, L = () => {
      o.value.forEach((Y, W) => {
        Y.fixed === "left" && !te(W) && (Y.fixed = void 0);
      });
    }, ae = async () => {
      var Y;
      if ((Y = t.config) != null && Y.key)
        try {
          await as.deleteTableConfig(t.config.key);
        } catch (W) {
          console.error("Failed to clear storage:", W);
        }
      o.value = i(), d(), u.value = JSON.parse(JSON.stringify(o.value)), a("close");
    };
    return (Y, W) => {
      var K;
      return b(), T("div", DC, [
        E("div", { class: "column-setup-header" }, [
          W[1] || (W[1] = E("span", { class: "column-setup-title" }, "Column Settings", -1)),
          E("button", {
            class: "column-setup-reset-btn",
            title: "Reset to default",
            onClick: ae
          }, [...W[0] || (W[0] = [
            E("svg", {
              fill: "none",
              height: "13",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2.3",
              viewBox: "0 0 24 24",
              width: "13"
            }, [
              E("polyline", { points: "1 4 1 10 7 10" }),
              E("path", { d: "M3.51 15a9 9 0 1 0 .49-4.5" })
            ], -1)
          ])])
        ]),
        E("div", {
          class: "column-setup-toggle-all",
          onClick: ne
        }, [
          E("div", {
            class: j([{
              "column-setup-toggle-eye--none": w.value
            }, "column-setup-toggle-eye"])
          }, [
            f.value ? (b(), T("svg", _C, [...W[2] || (W[2] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }, null, -1)
            ])])) : m.value ? (b(), T("svg", OC, [...W[3] || (W[3] = [
              E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
              E("line", {
                x1: "9",
                x2: "15",
                y1: "12",
                y2: "12"
              }, null, -1)
            ])])) : (b(), T("svg", EC, [
              E("path", { d: $u }),
              W[4] || (W[4] = E("line", {
                x1: "1",
                x2: "23",
                y1: "1",
                y2: "23"
              }, null, -1))
            ]))
          ], 2),
          W[5] || (W[5] = E("span", { class: "column-setup-toggle-label" }, "Show all columns", -1)),
          E("span", IC, le(k.value) + " / " + le(o.value.length), 1)
        ]),
        E("div", {
          ref_key: "listRef",
          ref: g,
          class: "column-setup-list"
        }, [
          (b(!0), T($e, null, Oe(o.value, (de, he) => {
            var me, Te, we;
            return b(), T("div", {
              key: de.key,
              class: j([{
                "column-setup-item--dragging": y.value === he,
                "column-setup-item--drag-over": h.value === he,
                "column-setup-item--no-reorder": ((me = e.config) == null ? void 0 : me.allowReorder) === !1
              }, "column-setup-item"]),
              draggable: ((Te = e.config) == null ? void 0 : Te.allowReorder) !== !1,
              onDragend: z,
              onDragleave: I,
              onDragover: (X) => _(he, X),
              onDragstart: (X) => O(he, X),
              onDrop: (X) => D(he, X)
            }, [
              ((we = e.config) == null ? void 0 : we.allowReorder) !== !1 ? (b(), T("div", PC, [
                se(v(ye), {
                  size: 16,
                  icon: "lucide:grip-vertical"
                })
              ])) : P("", !0),
              E("button", {
                class: j([de.visible ? "column-setup-item-eye--visible" : "column-setup-item-eye--hidden", "column-setup-item-eye"]),
                title: de.visible ? "Hide column" : "Show column",
                onClick: Ve((X) => H(de.key), ["stop"])
              }, [
                de.visible ? (b(), T("svg", VC, [...W[6] || (W[6] = [
                  E("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }, null, -1),
                  E("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                  }, null, -1)
                ])])) : (b(), T("svg", FC, [
                  E("path", { d: $u }),
                  W[7] || (W[7] = E("line", {
                    x1: "1",
                    x2: "23",
                    y1: "1",
                    y2: "23"
                  }, null, -1))
                ]))
              ], 10, RC),
              E("div", {
                class: j([{ "column-setup-item-label--hidden": !de.visible }, "column-setup-item-label"])
              }, le(de.label), 3),
              te(he) ? (b(), T("button", {
                key: 1,
                class: j([{ "column-setup-item-fixed-btn--active": q(de) }, "column-setup-item-fixed-btn"]),
                title: q(de) ? "Unpin column" : "Pin column to left",
                onClick: Ve((X) => ie(he), ["stop"])
              }, [
                se(v(ye), {
                  icon: q(de) ? "lucide:pin" : "lucide:pin-off",
                  size: 16
                }, null, 8, ["icon"])
              ], 10, LC)) : P("", !0),
              de.fixed && !te(he) ? (b(), T("div", NC, [
                se(v(ye), {
                  size: 16,
                  icon: "lucide:triangle-alert"
                })
              ])) : P("", !0)
            ], 42, AC);
          }), 128))
        ], 512),
        E("div", zC, [
          ((K = e.config) == null ? void 0 : K.allowReorder) !== !1 ? (b(), T("span", BC, [
            se(v(ye), {
              size: 11,
              icon: "lucide:grip-vertical"
            }),
            W[8] || (W[8] = He(" Drag to reorder ", -1))
          ])) : P("", !0),
          se(v(vt), {
            disabled: !c.value,
            text: "Apply",
            variant: "primary",
            class: "h-[30px]",
            onClick: p
          }, null, 8, ["disabled"])
        ])
      ]);
    };
  }
}), YC = /* @__PURE__ */ Le(WC, [["__scopeId", "data-v-72a05d03"]]), HC = { class: "v-table-empty-state-content" }, UC = {
  key: 0,
  class: "v-table-empty-state-icon"
}, qC = {
  key: 1,
  class: "v-table-empty-state-title"
}, jC = {
  key: 2,
  class: "v-table-empty-state-description"
}, GC = /* @__PURE__ */ ke({
  __name: "TableEmptyState",
  props: {
    title: {},
    description: {},
    icon: {}
  },
  setup(e) {
    const n = Oa(), t = bn("tableSlots", {}), a = (s, { slots: l }) => U({ default: t.emptyState }, "default", {}, l.default);
    return (s, l) => (b(), T("div", {
      class: j([{ "v-table-empty-state--modern": v(n) }, "v-table-empty-state"])
    }, [
      E("div", HC, [
        se(a, null, {
          default: ue(() => [
            e.icon ? (b(), T("div", UC, [
              se(v(ye), {
                icon: e.icon,
                size: v(n) ? 40 : 48
              }, null, 8, ["icon", "size"])
            ])) : P("", !0),
            e.title ? (b(), T("h3", qC, le(e.title), 1)) : P("", !0),
            e.description ? (b(), T("p", jC, le(e.description), 1)) : P("", !0)
          ]),
          _: 1
        })
      ])
    ], 2));
  }
}), KC = /* @__PURE__ */ Le(GC, [["__scopeId", "data-v-57210eab"]]), ZC = ["aria-label", "title"], XC = /* @__PURE__ */ ke({
  __name: "TableFullscreenToggle",
  props: {
    isFullscreen: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = S(() => e.isFullscreen ? "Collapse table" : "Expand table"), s = S(() => e.isFullscreen ? "lucide:minimize-2" : "lucide:maximize-2");
    return (l, r) => (b(), T("button", {
      "aria-label": a.value,
      class: j([{ "v-table-fullscreen-toggle--active": e.isFullscreen }, "v-table-fullscreen-toggle"]),
      title: a.value,
      type: "button",
      onClick: r[0] || (r[0] = (i) => t("toggle"))
    }, [
      se(v(ye), {
        icon: s.value,
        size: 15
      }, null, 8, ["icon"])
    ], 10, ZC));
  }
}), JC = /* @__PURE__ */ ke({
  __name: "TableHeaderCheckbox",
  props: {
    state: {},
    disabled: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = () => {
      t.disabled || a("toggle");
    };
    return (l, r) => (b(), T("div", {
      class: "v-table-header-checkbox-cell",
      onClick: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      se(v(ad), {
        disabled: e.disabled,
        indeterminate: e.state === "indeterminate",
        "model-value": e.state === "checked",
        "onUpdate:modelValue": s
      }, null, 8, ["disabled", "indeterminate", "model-value"])
    ]));
  }
}), QC = /* @__PURE__ */ Le(JC, [["__scopeId", "data-v-b48644bb"]]), eM = ["aria-label", "aria-pressed"], df = /* @__PURE__ */ ke({
  __name: "TablePinButton",
  props: {
    pinned: { type: Boolean },
    label: {}
  },
  emits: ["toggle"],
  setup(e, { emit: n }) {
    const t = n, a = S(() => e.pinned ? `Unpin ${e.label}` : `Pin ${e.label}`), s = (l) => {
      l.stopPropagation(), t("toggle");
    };
    return (l, r) => (b(), T("button", {
      "aria-label": a.value,
      "aria-pressed": e.pinned,
      class: j([{ "v-table-pin-button--active": e.pinned }, "v-table-pin-button"]),
      type: "button",
      onClick: s,
      onMousedown: r[0] || (r[0] = Ve(() => {
      }, ["stop"]))
    }, [
      se(v(ye), {
        icon: e.pinned ? "lucide:x" : "lucide:pin",
        size: 13
      }, null, 8, ["icon"])
    ], 42, eM));
  }
}), tM = { class: "v-table-header-content" }, nM = ["title"], aM = { class: "items-center justify-center flex p-0 w-[16px]" }, sM = ["title"], lM = ["aria-label"], rM = /* @__PURE__ */ ke({
  __name: "TableHeader",
  props: {
    column: {},
    label: {},
    align: { default: "left" },
    columnKey: {},
    resizable: { type: Boolean, default: !0 },
    isSorted: { type: Boolean, default: !1 },
    sortOrder: { default: null },
    sortIndex: { default: -1 }
  },
  emits: ["sort-click", "resize-start", "resize-dblclick"],
  setup(e, { emit: n }) {
    const t = bn("tableSlots", {}), a = Oa(), s = bn("tableHighlight", null), l = e, r = n, i = S(() => !l.isSorted || !l.sortOrder ? "lucide:arrow-up-down" : l.sortOrder === "asc" ? "lucide:arrow-up" : "lucide:arrow-down"), o = S(() => l.isSorted ? "v-sort-icon v-sort-icon--active" : "v-sort-icon"), u = (w) => {
      l.column.sortable && (w.stopPropagation(), r("sort-click"));
    }, c = (w) => {
      l.column.onHeaderClick && (w.stopPropagation(), l.column.onHeaderClick({
        column: l.column,
        columnKey: l.columnKey,
        event: w
      }));
    }, d = (w) => {
      r("resize-start", l.columnKey, w);
    }, p = () => {
      r("resize-dblclick", l.columnKey);
    }, f = (w) => {
      l.column.sortable && (w.key === "Enter" || w.key === " ") && (w.preventDefault(), r("sort-click"));
    };
    return (w, m) => {
      var k;
      return b(), T("div", {
        class: j([{
          "v-table-header-cell--left": e.align === "left",
          "v-table-header-cell--center": e.align === "center",
          "v-table-header-cell--right": e.align === "right",
          "v-table-header-cell--sortable": e.column.sortable,
          "v-table-header-cell--clickable": e.column.onHeaderClick
        }, "v-table-header-cell"])
      }, [
        E("div", tM, [
          E("div", {
            class: j([{ "v-table-header-label-wrapper--clickable": e.column.onHeaderClick }, "v-table-header-label-wrapper"]),
            onClick: c
          }, [
            U(w.$slots, "default", {
              column: e.column,
              isSorted: e.isSorted,
              sortOrder: e.sortOrder
            }, () => [
              E("span", {
                title: e.label,
                class: "v-table-header-label"
              }, le(e.label), 9, nM)
            ], !0),
            U(w.$slots, "icon", { column: e.column }, void 0, !0),
            e.column.tooltip ? (b(), ce(v(xa), {
              key: 0,
              text: e.column.tooltip,
              placement: "top",
              "tooltip-class": "bg-cardBg opacity-1 w-[300px]"
            }, {
              default: ue(() => [
                E("div", aM, [
                  se(v(ye), {
                    size: v(a) ? 12 : 14,
                    class: "v-table-header-info-icon",
                    icon: "lucide:info"
                  }, null, 8, ["size"])
                ])
              ]),
              _: 1
            }, 8, ["text"])) : P("", !0),
            e.column.onHeaderClick ? (b(), T("div", {
              key: 1,
              title: `Click to interact with ${e.label}`,
              class: "v-table-header-click-indicator"
            }, [
              se(v(ye), {
                size: v(a) ? 12 : 14,
                class: "click-indicator-icon",
                icon: "lucide:mouse-pointer-click"
              }, null, 8, ["size"])
            ], 8, sM)) : P("", !0)
          ], 2),
          e.column.sortable ? (b(), T("div", {
            key: 0,
            "aria-label": `Sort by ${e.label}`,
            tabindex: 0,
            class: "v-table-header-sort",
            role: "button",
            onClick: u,
            onKeydown: f
          }, [
            se(v(ye), {
              class: j(o.value),
              icon: i.value,
              size: v(a) ? 14 : 16
            }, null, 8, ["class", "icon", "size"])
          ], 40, lM)) : P("", !0),
          v(t).headerCellCustomAction ? (b(), ce(mt(v(t).headerCellCustomAction), {
            key: 1,
            column: e.column
          }, null, 8, ["column"])) : P("", !0),
          (k = v(s)) != null && k.columnEnabled.value ? (b(), ce(df, {
            key: 2,
            label: e.label,
            pinned: v(s).isColumnPinned(e.columnKey),
            onToggle: m[0] || (m[0] = (y) => v(s).toggleColumn(e.columnKey))
          }, null, 8, ["label", "pinned"])) : P("", !0)
        ]),
        e.resizable ? (b(), T("div", {
          key: 0,
          class: "v-table-resize-handle",
          onMousedown: Ve(d, ["stop"]),
          onDblclick: Ve(p, ["stop"])
        }, [...m[1] || (m[1] = [
          E("div", { class: "v-table-resize-indicator" }, [
            E("div", { class: "v-table-resize-line" }),
            E("div", { class: "v-table-resize-line" })
          ], -1),
          E("div", { class: "v-table-resize-divider" }, null, -1)
        ])], 32)) : P("", !0)
      ], 2);
    };
  }
}), ff = /* @__PURE__ */ Le(rM, [["__scopeId", "data-v-f522bebd"]]), iM = { class: "v-table-header-group-label" }, oM = /* @__PURE__ */ ke({
  __name: "TableHeaderGroup",
  props: {
    cell: {},
    groupWidth: {}
  },
  setup(e) {
    return (n, t) => (b(), T("div", {
      class: j([{
        "v-table-header-group--left": e.cell.column.align === "left",
        "v-table-header-group--center": e.cell.column.align === "center",
        "v-table-header-group--right": e.cell.column.align === "right"
      }, "v-table-header-group"])
    }, [
      E("span", iM, le(e.cell.label), 1)
    ], 2));
  }
}), uM = /* @__PURE__ */ ke({
  __name: "TableHeaderGrouped",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getGroupWidth: { type: Function },
    getGroupFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, l = (i) => {
      a("resize-dblclick", i);
    }, r = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (b(!0), T($e, null, Oe(e.columns, (u, c) => (b(), T("div", {
      key: `header-level-${c}`,
      class: j([`v-table-header-row-level-${c}`, "v-table-header-row"])
    }, [
      c === 0 ? U(i.$slots, "checkbox-header", { key: 0 }) : P("", !0),
      (b(!0), T($e, null, Oe(u, (d) => (b(), T($e, {
        key: d.key
      }, [
        d.isGroup ? (b(), ce(oM, {
          key: 0,
          cell: d,
          class: j(e.getColumnClasses(d.column)),
          "group-width": e.getGroupWidth(d.column),
          style: Fe({
            gridColumn: `span ${d.colspan}`,
            gridRow: d.rowspan > 1 ? `span ${d.rowspan}` : void 0,
            ...e.getGroupFixedStyles(d.column)
          })
        }, null, 8, ["cell", "class", "group-width", "style"])) : (b(), ce(ff, {
          key: 1,
          align: d.column.align,
          class: j([
            e.getColumnClasses(d.column),
            {
              "v-table-header-cell--grouped": c > 0,
              "v-table-header-cell--rowspan": d.rowspan > 1
            }
          ]),
          column: d.column,
          "column-key": d.column.key,
          "is-sorted": e.getSortState(d.column.key).isSorted,
          label: d.label,
          resizable: t.isColumnResizable(d.column),
          "sort-index": e.getSortState(d.column.key).index,
          "sort-order": e.getSortState(d.column.key).order,
          style: Fe({
            gridRow: d.rowspan > 1 ? `span ${d.rowspan}` : void 0,
            ...e.getFixedStyles(d.column)
          }),
          onSortClick: (p) => r(d.column),
          onResizeStart: s,
          onResizeDblclick: l
        }, dt({ _: 2 }, [
          i.$slots[`header-icon-${d.column.key}`] ? {
            name: "icon",
            fn: ue((p) => [
              U(i.$slots, `header-icon-${d.column.key}`, lt({ ref_for: !0 }, p))
            ]),
            key: "0"
          } : void 0,
          i.$slots[`header-${d.column.key}`] ? {
            name: "default",
            fn: ue((p) => [
              U(i.$slots, `header-${d.column.key}`, lt({ ref_for: !0 }, p))
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))
      ], 64))), 128))
    ], 2))), 128));
  }
}), cM = { class: "v-table-header-row" }, dM = /* @__PURE__ */ ke({
  __name: "TableHeaderSimple",
  props: {
    columns: {},
    getColumnClasses: { type: Function },
    getFixedStyles: { type: Function },
    getSortState: { type: Function },
    isColumnResizable: { type: Function }
  },
  emits: ["resize-start", "resize-dblclick", "sort-click"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = (i, o) => {
      a("resize-start", i, o);
    }, l = (i) => {
      a("resize-dblclick", i);
    }, r = (i) => {
      a("sort-click", i);
    };
    return (i, o) => (b(), T("div", cM, [
      U(i.$slots, "checkbox-header"),
      (b(!0), T($e, null, Oe(e.columns, (u) => (b(), ce(ff, {
        key: u.key,
        align: u.align,
        class: j(e.getColumnClasses(u)),
        column: u,
        "column-key": u.key,
        "is-sorted": e.getSortState(u.key).isSorted,
        label: u.label,
        resizable: t.isColumnResizable(u),
        "sort-index": e.getSortState(u.key).index,
        "sort-order": e.getSortState(u.key).order,
        style: Fe(e.getFixedStyles(u)),
        onSortClick: (c) => r(u),
        onResizeStart: s,
        onResizeDblclick: l
      }, dt({ _: 2 }, [
        i.$slots[`header-icon-${u.key}`] ? {
          name: "icon",
          fn: ue((c) => [
            U(i.$slots, `header-icon-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "0"
        } : void 0,
        i.$slots[`header-${u.key}`] ? {
          name: "default",
          fn: ue((c) => [
            U(i.$slots, `header-${u.key}`, lt({ ref_for: !0 }, c))
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["align", "class", "column", "column-key", "is-sorted", "label", "resizable", "sort-index", "sort-order", "style", "onSortClick"]))), 128))
    ]));
  }
}), fM = {
  key: 0,
  class: "v-table-loading-overlay"
}, hM = { class: "v-table-loading-spinner" }, mM = /* @__PURE__ */ ke({
  __name: "TableLoadingOverlay",
  props: {
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (b(), ce(ht, { name: "fade" }, {
      default: ue(() => [
        e.loading ? (b(), T("div", fM, [
          t[0] || (t[0] = E("div", { class: "v-table-loading-backdrop" }, null, -1)),
          E("div", hM, [
            se(v(Xs), {
              size: "large",
              variant: "primary"
            })
          ])
        ])) : P("", !0)
      ]),
      _: 1
    }));
  }
}), vM = { class: "v-table-pagination" }, pM = { class: "v-table-pagination-info" }, gM = { class: "v-table-pagination-info-highlight" }, yM = { class: "v-table-pagination-info-highlight" }, bM = { class: "v-table-pagination-controls" }, wM = ["disabled"], kM = ["disabled", "onClick"], xM = {
  key: 1,
  class: "v-table-pagination-ellipsis"
}, SM = ["disabled"], $M = {
  key: 0,
  class: "v-table-pagination-size"
}, TM = ["disabled", "value"], CM = ["value"], MM = /* @__PURE__ */ ke({
  __name: "TablePagination",
  props: {
    page: {},
    pageSize: {},
    total: {},
    pageSizeOptions: { default: () => [10, 25, 50, 100] },
    showSizeChanger: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["page-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, s = Oa(), l = S(() => Math.ceil(t.total / t.pageSize)), r = S(() => t.total === 0 ? 0 : aa((t.page - 1) * t.pageSize + 1)), i = S(() => {
      const m = t.page * t.pageSize;
      return aa(Math.min(m, t.total));
    }), o = S(() => {
      const m = [], k = l.value, y = t.page;
      if (k <= 7) {
        for (let h = 1; h <= k; h++)
          m.push(h);
        return m;
      }
      return m.push(1), y <= 3 ? (m.push(2, 3, 4), m.push("ellipsis"), m.push(k)) : y >= k - 2 ? (m.push("ellipsis"), m.push(k - 3, k - 2, k - 1, k)) : (m.push("ellipsis"), m.push(y - 1, y, y + 1), m.push("ellipsis"), m.push(k)), m;
    }), u = (m) => {
      t.loading || m !== t.page && (m < 1 || m > l.value || a("page-change", { page: m, pageSize: t.pageSize }));
    }, c = () => {
      t.page > 1 && u(t.page - 1);
    }, d = () => {
      t.page < l.value && u(t.page + 1);
    }, p = (m) => {
      t.loading || m !== t.pageSize && a("page-change", { page: 1, pageSize: m });
    }, f = S(() => t.loading || t.page <= 1), w = S(() => t.loading || t.page >= l.value);
    return (m, k) => (b(), T("div", vM, [
      E("div", pM, [
        k[1] || (k[1] = He(" Showing ", -1)),
        E("span", gM, le(r.value) + "–" + le(i.value), 1),
        k[2] || (k[2] = He(" of ", -1)),
        E("span", yM, le(v(aa)(e.total)), 1)
      ]),
      E("div", bM, [
        E("button", {
          disabled: f.value,
          "aria-label": "Previous page",
          class: "v-table-pagination-btn",
          onClick: c
        }, [
          se(v(ye), {
            size: v(s) ? 15 : 18,
            icon: "lucide:chevron-left"
          }, null, 8, ["size"])
        ], 8, wM),
        (b(!0), T($e, null, Oe(o.value, (y, h) => (b(), T($e, { key: h }, [
          y !== "ellipsis" ? (b(), T("button", {
            key: 0,
            class: j([{ "v-table-pagination-btn--active": y === e.page }, "v-table-pagination-btn"]),
            disabled: e.loading,
            onClick: (g) => u(y)
          }, le(y), 11, kM)) : (b(), T("span", xM, " ... "))
        ], 64))), 128)),
        E("button", {
          disabled: w.value,
          "aria-label": "Next page",
          class: "v-table-pagination-btn",
          onClick: d
        }, [
          se(v(ye), {
            size: v(s) ? 15 : 18,
            icon: "lucide:chevron-right"
          }, null, 8, ["size"])
        ], 8, SM)
      ]),
      e.showSizeChanger ? (b(), T("div", $M, [
        k[3] || (k[3] = E("label", { for: "pagination-size" }, "Rows:", -1)),
        E("select", {
          id: "pagination-size",
          disabled: e.loading,
          value: e.pageSize,
          onChange: k[0] || (k[0] = (y) => p(Number(y.target.value)))
        }, [
          (b(!0), T($e, null, Oe(e.pageSizeOptions, (y) => (b(), T("option", {
            key: y,
            value: y
          }, le(y), 9, CM))), 128))
        ], 40, TM)
      ])) : P("", !0)
    ]));
  }
}), DM = /* @__PURE__ */ Le(MM, [["__scopeId", "data-v-b2d204b5"]]), _M = { class: "v-toolbar v-toolbar--split" }, OM = { class: "v-toolbar-split-left" }, EM = { key: 0 }, IM = { class: "v-toolbar-title" }, AM = {
  key: 0,
  class: "v-toolbar-subtitle"
}, PM = {
  key: 0,
  class: "v-toolbar-search-split flex h-full items-center"
}, RM = { class: "v-toolbar-split-right" }, VM = /* @__PURE__ */ ke({
  __name: "TableToolbar",
  props: {
    config: { default: void 0 },
    search: { default: "" }
  },
  emits: ["update:search", "refresh", "reset-sort", "export"],
  setup(e, { emit: n }) {
    const t = Oa(), a = bn("tableSlots", {}), s = e, l = n, r = S({
      get: () => s.search,
      set: (g) => l("update:search", g)
    }), i = S(() => {
      var g;
      return (g = s.config) != null && g.search ? typeof s.config.search == "boolean" ? { placeholder: "Search..." } : s.config.search : null;
    }), o = S(() => {
      var x, $;
      const g = ($ = (x = s.config) == null ? void 0 : x.actions) == null ? void 0 : $.refresh;
      return g ? typeof g == "object" ? { loading: g.loading ?? !1 } : { loading: !1 } : null;
    }), u = S(() => {
      var x, $;
      const g = ($ = (x = s.config) == null ? void 0 : x.actions) == null ? void 0 : $.export;
      return !g || !g ? null : typeof g == "object" ? {
        mode: g.mode,
        formats: g.formats || [],
        selectedOnly: g.selectedOnly ?? !1,
        loading: g.loading ?? !1
      } : {
        mode: g,
        formats: [],
        selectedOnly: !1,
        loading: !1
      };
    }), c = S(() => u.value !== null), d = S(() => {
      var g;
      return ((g = u.value) == null ? void 0 : g.loading) || !1;
    }), p = S(() => {
      var g;
      return ((g = u.value) == null ? void 0 : g.formats) || [];
    }), f = S(() => p.value.some((g) => g.loading)), w = S(() => {
      var g;
      return (g = u.value) == null ? void 0 : g.mode;
    }), m = () => {
      l("refresh");
    }, k = () => {
      l("reset-sort");
    }, y = (g) => {
      var x;
      l("export", String(g), (x = u.value) == null ? void 0 : x.selectedOnly);
    }, h = () => {
      var g;
      l("export", "csv", (g = u.value) == null ? void 0 : g.selectedOnly);
    };
    return (g, x) => {
      var $, C, O, _, I, D;
      return b(), T("div", _M, [
        E("div", OM, [
          v(a).toolbarTitle ? (b(), ce(mt(v(a).toolbarTitle), { key: 0 })) : U(g.$slots, "title", { key: 1 }, () => {
            var z;
            return [
              (z = e.config) != null && z.title ? (b(), T("div", EM, [
                E("h3", IM, le(e.config.title), 1),
                e.config.subtitle ? (b(), T("p", AM, le(e.config.subtitle), 1)) : P("", !0)
              ])) : P("", !0)
            ];
          }),
          v(a).toolbarSearch ? (b(), ce(mt(v(a).toolbarSearch), { key: 2 })) : U(g.$slots, "search", { key: 3 }, () => [
            i.value ? (b(), T("div", PM, [
              x[1] || (x[1] = E("span", { class: "w-px h-5 bg-base-300 ml-[1px] mr-4" }, null, -1)),
              se(v(Fs), {
                modelValue: r.value,
                "onUpdate:modelValue": x[0] || (x[0] = (z) => r.value = z),
                modern: v(t),
                name: i.value.placeholder,
                placeholder: i.value.placeholder,
                class: "max-w-[280px]",
                debounce: "",
                type: "search"
              }, null, 8, ["modelValue", "modern", "name", "placeholder"])
            ])) : P("", !0)
          ]),
          v(a).toolbarFilters ? (b(), ce(mt(v(a).toolbarFilters), { key: 4 })) : U(g.$slots, "filters", { key: 5 })
        ]),
        E("div", RM, [
          v(a).toolbarActions ? (b(), ce(mt(v(a).toolbarActions), { key: 0 })) : U(g.$slots, "actions", { key: 1 }),
          o.value ? (b(), ce(v(vt), {
            key: 2,
            loading: o.value.loading,
            modern: v(t),
            icon: "lucide:refresh-cw",
            variant: "default",
            onClick: m
          }, null, 8, ["loading", "modern"])) : P("", !0),
          (C = ($ = e.config) == null ? void 0 : $.actions) != null && C.resetSort ? (b(), ce(v(vt), {
            key: 3,
            modern: v(t),
            icon: "lucide:arrow-up-down",
            text: "Reset Sort",
            variant: "default",
            onClick: k
          }, null, 8, ["modern"])) : P("", !0),
          c.value && w.value === "single" ? (b(), ce(v(vt), {
            key: 4,
            disabled: d.value,
            loading: d.value,
            modern: v(t),
            icon: "lucide:file-down",
            text: "Export",
            variant: "primary",
            onClick: h
          }, null, 8, ["disabled", "loading", "modern"])) : P("", !0),
          c.value && w.value === "multi" ? (b(), ce(v(Ta), {
            key: 5,
            items: p.value,
            placement: "bottom-right",
            onSelect: y
          }, {
            trigger: ue(() => [
              se(v(vt), {
                loading: f.value,
                modern: v(t),
                icon: "lucide:file-down",
                text: "Export",
                variant: "primary"
              }, null, 8, ["loading", "modern"])
            ]),
            _: 1
          }, 8, ["items"])) : P("", !0),
          v(a).toolbarColumnActions ? (b(), ce(mt(v(a).toolbarColumnActions), { key: 6 })) : P("", !0),
          (_ = (O = e.config) == null ? void 0 : O.actions) != null && _.columnSetup || (D = (I = e.config) == null ? void 0 : I.actions) != null && D.columnPicker ? U(g.$slots, "column-setup", { key: 7 }) : P("", !0)
        ])
      ]);
    };
  }
}), rt = {
  SM: 640,
  // Tailwind sm
  MD: 768,
  // Tailwind md
  LG: 1024,
  // Tailwind lg
  XL: 1280,
  // Tailwind xl
  "2XL": 1536,
  // Tailwind 2xl
  "3XL": 1920,
  // custom 3xl
  ULTRA: 2560,
  // custom ultra
  "4K": 3440
  // custom 4k
}, zi = typeof window < "u" ? window.innerWidth : 1920;
function hf(e = zi) {
  return e < rt.SM || e < rt.MD ? "sm" : e < rt.LG ? "md" : e < rt.XL ? "lg" : e < rt["2XL"] ? "xl" : e < rt["3XL"] ? "2xl" : e < rt.ULTRA ? "3xl" : e < rt["4K"] ? "ultra" : "4k";
}
function Or(e, n = zi) {
  const t = hf(n), a = ["4k", "ultra", "3xl", "2xl", "xl", "lg", "md", "sm"], s = a.indexOf(t);
  for (let l = s; l < a.length; l++) {
    const r = e[a[l]];
    if (r !== void 0) return r;
  }
  return e.default;
}
function v_(e, n = 1920, t, a, s = zi) {
  const l = s / n;
  let r = Math.round(e * l);
  return t !== void 0 && (r = Math.max(r, t)), a !== void 0 && (r = Math.min(r, a)), r;
}
const ia = hf(), Bi = ia === "sm", Wi = ia === "md", mf = ia === "lg", vf = ia === "xl", pf = ia === "2xl", Yi = ia === "3xl", Ql = ia === "ultra", er = ia === "4k", FM = Bi || Wi, p_ = Bi || Wi || mf, LM = vf || pf || Yi || Ql || er, NM = Yi || Ql || er, zM = Ql || er, g_ = {
  sm: Bi,
  md: Wi,
  lg: mf,
  xl: vf,
  "2xl": pf,
  "3xl": Yi,
  ultra: Ql,
  "4k": er,
  // Grouped checks
  isMobileOrTablet: FM,
  isDesktopOrLarger: LM,
  isLargeOrBigger: NM,
  isUltraOrBigger: zM
}, y_ = {
  sm: `(max-width: ${rt.SM - 1}px)`,
  md: `(min-width: ${rt.SM}px) and (max-width: ${rt.MD - 1}px)`,
  lg: `(min-width: ${rt.MD}px) and (max-width: ${rt.LG - 1}px)`,
  xl: `(min-width: ${rt.LG}px) and (max-width: ${rt.XL - 1}px)`,
  "2xl": `(min-width: ${rt.XL}px) and (max-width: ${rt["2XL"] - 1}px)`,
  "3xl": `(min-width: ${rt["2XL"]}px) and (max-width: ${rt["3XL"] - 1}px)`,
  ultra: `(min-width: ${rt["3XL"]}px) and (max-width: ${rt.ULTRA - 1}px)`,
  "4k": `(min-width: ${rt.ULTRA}px)`,
  // Range queries (min-width)
  minMd: `(min-width: ${rt.SM}px)`,
  minLg: `(min-width: ${rt.MD}px)`,
  minXl: `(min-width: ${rt.LG}px)`,
  min2Xl: `(min-width: ${rt.XL}px)`,
  min3Xl: `(min-width: ${rt["2XL"]}px)`,
  minUltra: `(min-width: ${rt["3XL"]}px)`,
  min4K: `(min-width: ${rt.ULTRA}px)`
}, gf = {
  MIN_COLUMN_WIDTH: Or({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 110,
    ultra: 120,
    default: 100
  }),
  DEFAULT_MIN_WIDTH: Or({
    sm: 60,
    md: 80,
    lg: 90,
    xl: 100,
    "3xl": 120,
    ultra: 190,
    default: 100
  }),
  DEFAULT_COLUMN_WIDTH: Or({
    sm: 100,
    md: 120,
    lg: 140,
    xl: 150,
    "3xl": 180,
    ultra: 270,
    default: 150
  })
}, {
  MIN_COLUMN_WIDTH: BM,
  DEFAULT_MIN_WIDTH: Tu,
  DEFAULT_COLUMN_WIDTH: Ss
} = gf;
function WM(e) {
  const n = J(/* @__PURE__ */ new Map()), t = J({
    isResizing: !1,
    columnKey: null,
    startX: 0,
    startWidth: 0
  });
  let a = null, s = null, l = 0;
  const r = (y) => y.width !== "flex", i = (y) => {
    const h = n.value.get(y.key);
    return h !== void 0 ? `${h}px` : y.width === "flex" ? `minmax(${Tu}px, 1fr)` : y.width ? y.width : `${Ss}px`;
  }, o = S(() => e.value.map((y) => i(y)).join(" ")), u = (y = 50) => `${y}px ${o.value}`, c = (y, h) => {
    h.preventDefault(), h.stopPropagation();
    const g = e.value.find((C) => C.key === y);
    if (!g || !r(g))
      return;
    let x;
    const $ = n.value.get(y);
    if ($ !== void 0)
      x = $;
    else if (g.width && g.width !== "flex" && g.width.endsWith("px"))
      x = parseInt(g.width, 10);
    else if (!g.width)
      x = Ss;
    else {
      const C = h.target.closest('[role="columnheader"]');
      x = C ? C.offsetWidth : Ss;
    }
    t.value = {
      isResizing: !0,
      columnKey: y,
      startX: h.clientX,
      startWidth: x
    }, document.addEventListener("mousemove", p), document.addEventListener("mouseup", f), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }, d = () => {
    if (a = null, s === null) return;
    const y = new Map(n.value);
    y.set(s, l), n.value = y;
  }, p = (y) => {
    if (!t.value.isResizing || !t.value.columnKey)
      return;
    const h = y.clientX - t.value.startX, g = Math.max(
      BM,
      t.value.startWidth + h
    );
    s = t.value.columnKey, l = g, a === null && (a = requestAnimationFrame(d));
  }, f = () => {
    a !== null && (cancelAnimationFrame(a), a = null), d(), s = null, t.value = {
      isResizing: !1,
      columnKey: null,
      startX: 0,
      startWidth: 0
    }, document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", f), document.body.style.cursor = "", document.body.style.userSelect = "";
  }, w = (y) => {
    const h = new Map(n.value);
    h.delete(y), n.value = h;
  }, m = () => {
    n.value = /* @__PURE__ */ new Map();
  }, k = (y) => {
    const h = n.value.get(y);
    if (h !== void 0)
      return h;
    const g = e.value.find((x) => x.key === y);
    return g ? g.width === "flex" ? `minmax(${Tu}px, 1fr)` : g.width ? g.width : Ss : Ss;
  };
  return {
    gridTemplateColumns: o,
    getGridTemplateWithCheckbox: u,
    resizedWidths: n,
    isResizing: S(() => t.value.isResizing),
    isColumnResizable: r,
    startResize: c,
    autoFitColumn: w,
    getColumnWidth: k,
    resetWidths: m
  };
}
function YM(e) {
  const n = J(/* @__PURE__ */ new Set());
  return {
    flattenedData: S(() => {
      const i = [], o = (u, c = 0, d) => {
        u.forEach((p) => {
          var m, k;
          const f = !!((m = p.children) != null && m.length || p.expandable && p.expandedContent), w = n.value.has(p.id);
          i.push({
            ...p,
            depth: c,
            parentId: d,
            hasChildren: f,
            isExpanded: w
          }), w && ((k = p.children) != null && k.length) && o(p.children, c + 1, p.id);
        });
      };
      return o(e.value), i;
    }),
    // For passing to virtualizer
    expandedRows: n,
    // For UI indicators
    toggleRow: (i) => {
      n.value.has(i) ? n.value.delete(i) : n.value.add(i), n.value = new Set(n.value);
    },
    // For click handlers
    expandAll: () => {
      const i = (o) => {
        const u = [];
        return o.forEach((c) => {
          var d;
          ((d = c.children) != null && d.length || c.expandable) && (u.push(c.id), c.children && u.push(...i(c.children)));
        }), u;
      };
      n.value = new Set(i(e.value));
    },
    collapseAll: () => {
      n.value.clear(), n.value = /* @__PURE__ */ new Set();
    },
    isExpandable: (i) => {
      var o;
      return !!((o = i.children) != null && o.length || i.expandable);
    }
  };
}
const { DEFAULT_COLUMN_WIDTH: Na } = gf;
function HM(e, n) {
  const t = S(
    () => e.value.filter((m) => m.fixed === "left")
  ), a = S(
    () => e.value.filter((m) => m.fixed === "right")
  ), s = S(
    () => e.value.filter((m) => !m.fixed)
  ), l = S(() => {
    const m = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map();
    let y = 0;
    for (const h of e.value)
      if (h.fixed === "left") {
        k.set(h.key, y);
        let g = Na;
        if (m) {
          const x = m.get(h.key);
          x !== void 0 ? g = x : g = hl(h.width) || Na;
        } else
          g = hl(h.width) || Na;
        y += g;
      }
    return k;
  }), r = S(() => {
    const m = n == null ? void 0 : n.value, k = /* @__PURE__ */ new Map(), y = e.value.filter((g) => g.fixed === "right");
    let h = 0;
    for (let g = y.length - 1; g >= 0; g--) {
      const x = y[g];
      k.set(x.key, h);
      let $ = Na;
      if (m) {
        const C = m.get(x.key);
        C !== void 0 ? $ = C : $ = hl(x.width) || Na;
      } else
        $ = hl(x.width) || Na;
      h += $;
    }
    return k;
  }), i = (m, k) => {
    if (k.fixed === "left") {
      const h = e.value.findIndex((x) => x.key === m);
      let g = 0;
      for (let x = 0; x < h; x++)
        e.value[x].fixed === "left" && g++;
      return 50 + (t.value.length - g);
    }
    if (k.fixed === "right") {
      const h = e.value.findIndex((x) => x.key === m);
      let g = 0;
      for (let x = h + 1; x < e.value.length; x++)
        e.value[x].fixed === "right" && g++;
      return 50 + g + 1;
    }
    return 1;
  }, o = S(() => {
    const m = /* @__PURE__ */ new Map();
    return e.value.forEach((k) => {
      if (!k.fixed) {
        m.set(k.key, {});
        return;
      }
      const y = {
        // position: sticky added through CSS classes!
        // zIndex also controlled through CSS for proper hierarchy
      };
      if (k.fixed === "left") {
        const h = l.value.get(k.key) || 0;
        y.left = `${h}px`;
      } else if (k.fixed === "right") {
        const h = r.value.get(k.key) || 0;
        y.right = `${h}px`;
      }
      m.set(k.key, y);
    }), m;
  }), u = (m) => o.value.get(m.key) || {}, c = (m) => !!m.fixed, d = S(() => {
    let m = null;
    for (const k of e.value)
      k.fixed === "left" && (m = k.key);
    return m;
  }), p = S(() => {
    for (const m of e.value)
      if (m.fixed === "right")
        return m.key;
    return null;
  });
  return {
    leftFixedColumns: t,
    rightFixedColumns: a,
    normalColumns: s,
    getFixedStyles: u,
    isFixed: c,
    isLastLeftFixed: (m) => d.value === m,
    isFirstRightFixed: (m) => p.value === m,
    getZIndex: i
  };
}
function hl(e) {
  return e && e.endsWith("px") ? Number.parseInt(e, 10) : null;
}
function UM(e, n) {
  const a = S(() => ((w) => w.some((m) => !!(m.children && m.children.length > 0)))(e.value)), s = (f, w = 1) => {
    let m = w;
    return f.forEach((k) => {
      if (k.children && k.children.length > 0) {
        const y = s(k.children, w + 1);
        m = Math.max(m, y);
      }
    }), m;
  }, l = S(() => {
    const f = [], w = (m) => {
      m.forEach((k) => {
        k.children && k.children.length > 0 ? w(k.children) : f.push(k);
      });
    };
    return w(e.value), f;
  }), r = (f) => !f.children || f.children.length === 0 ? 1 : f.children.reduce((w, m) => w + r(m), 0), i = (f) => f && f.endsWith("px") ? parseInt(f, 10) : 150, o = (f) => {
    const w = n.value.get(f.key);
    return w !== void 0 ? w : i(f.width);
  }, u = (f) => !f.children || f.children.length === 0 ? o(f) : f.children.reduce((w, m) => w + u(m), 0), c = (f, w, m = 0, k = 1) => {
    const y = [];
    return f.forEach((h) => {
      if (!!(h.children && h.children.length > 0))
        m === w && y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: r(h),
          rowspan: 1,
          isGroup: !0,
          level: m
        }), m < w && y.push(...c(h.children, w, m + 1, k));
      else if (m === w) {
        const x = m === 0;
        y.push({
          key: h.key,
          label: h.label,
          column: h,
          colspan: 1,
          rowspan: x ? k : 1,
          // Root level spans all, others just 1
          isGroup: !1,
          level: m
        });
      }
    }), y;
  }, d = S(() => {
    if (!a.value)
      return [
        e.value.map((m) => ({
          key: m.key,
          label: m.label,
          column: m,
          colspan: 1,
          rowspan: 1,
          isGroup: !1,
          level: 0
        }))
      ];
    const f = s(e.value), w = [];
    for (let m = 0; m < f; m++)
      w.push(c(e.value, m, 0, f));
    return w;
  });
  return {
    hasGroups: a,
    // Boolean - do we have grouped headers?
    flatColumns: l,
    // Flat list of leaf columns for data rows
    headerLevels: d,
    // Array of header rows (one per level)
    getGroupWidth: u,
    // Calculate width of group dynamically
    getColspan: r,
    // Get colspan for any column
    isGroupFixed: (f) => {
      if (!f.children || f.children.length === 0)
        return f.fixed || null;
      const w = (h) => !h.children || h.children.length === 0 ? [h.fixed] : h.children.flatMap((g) => w(g)), m = w(f), k = m.every((h) => h === "left"), y = m.every((h) => h === "right");
      return k ? "left" : y ? "right" : null;
    }
    // Check if group should be sticky
  };
}
const qM = (e, n, t) => {
  if (!n.format)
    return e;
  const a = n.format;
  if (a.formatter)
    return a.formatter(e, t);
  if (a.currency !== void 0 && a.currency !== !1) {
    const s = a.currency === !0 ? "USD" : a.currency;
    return Is(e, s);
  }
  return a.percentage !== void 0 ? Ni(e, a.percentage) : a.number ? aa(e, a.number) : a.date ? Xd(e, a.date) : a.boolean ? Zd(e, a.boolean) : a.fileSize !== void 0 ? Jd(e, a.fileSize) : e;
}, jM = () => ({
  formatCellValue: qM,
  // Export individual formatters for custom use
  formatCurrency: Is,
  formatPercentage: Ni,
  formatNumber: aa,
  formatDate: Xd,
  formatBoolean: Zd,
  formatFileSize: Jd
}), GM = (e) => {
  const { isExpandable: n, isRowExpandable: t } = e, { formatCellValue: a } = jM(), s = (o, u, c) => {
    if (!u.format)
      return o;
    const d = a(o, u, c);
    return d && typeof d == "object" && !Array.isArray(d) && "text" in d && typeof d.text < "u" ? d.text : d;
  }, l = (o, u, c) => {
    if (!u.format)
      return;
    const d = a(o, u, c);
    if (d && typeof d == "object" && !Array.isArray(d) && "class" in d && typeof d.class == "string")
      return d.class;
  }, r = /* @__PURE__ */ new WeakMap();
  return { getCellValue: s, getCellClass: l, getCellMetadata: (o, u, c, d) => {
    let p = r.get(o);
    p || (p = /* @__PURE__ */ new WeakMap(), r.set(o, p));
    const f = p.get(u);
    if (f) return f;
    const w = u.format ? a(o[u.key], u, o) : o[u.key];
    let m = w, k;
    if (w && typeof w == "object" && !Array.isArray(w) && "text" in w && (m = w.text, k = w.class), u.cellClass) {
      const C = u.cellClass({ value: o[u.key], row: o, rowIndex: d });
      C && (k = k ? `${k} ${C}` : C);
    }
    const y = u.cellStyle ? u.cellStyle({ value: o[u.key], row: o, rowIndex: d }) : void 0, h = o.depth || 0, g = c === 0 && h ? { paddingLeft: `${h * 24 + 16}px` } : null, x = c === 0 && Qe(n) ? t(o) : !1, $ = {
      formattedValue: m,
      cssClass: k,
      indentStyle: g,
      customStyle: y,
      isExpandable: x
    };
    return p.set(u, $), $;
  } };
}, KM = (e) => {
  const n = S(() => Qe(e.columns)), t = S(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" || typeof k == "object";
  }), a = S(() => {
    const k = Qe(e.columnSetup);
    return typeof k == "string" ? {
      key: k,
      type: "indexedDB",
      allowReorder: !0
    } : typeof k == "object" ? {
      ...k,
      type: k.type || "indexedDB"
      // Default to indexedDB
    } : {};
  }), s = (k, y, h) => {
    const g = (_) => _.flatMap((I) => I.children && I.children.length ? g(I.children) : [I]), x = new Map(g(n.value).map((_) => [_.key, _])), $ = [], C = k.fixed, O = (_) => {
      var H;
      if (!k.visible.includes(_)) return;
      const I = x.get(_);
      if (I) {
        $.push({ ...I, fixed: (C == null ? void 0 : C[_]) || I.fixed });
        return;
      }
      const D = y == null ? void 0 : y.get(_);
      if (D) {
        $.push({
          key: D.key,
          label: D.label,
          fixed: C == null ? void 0 : C[_],
          sortable: D.sortable ?? h
        });
        return;
      }
      const z = (H = k.labels) == null ? void 0 : H[_];
      z && $.push({
        key: _,
        label: z,
        fixed: C == null ? void 0 : C[_],
        sortable: h
      });
    };
    return k.order.forEach(O), !$.length && k.visible.length && k.visible.forEach(O), $.length ? $ : null;
  }, l = async () => {
    const k = t.value, y = Qe(e.columnPicker), h = !!y && typeof y == "object";
    if (!k && !h) return null;
    if (k) {
      const g = a.value;
      if (g.key)
        try {
          const $ = await Il(g.key, g.type);
          if ($) return s($);
        } catch ($) {
          console.warn("[VTable] Failed to load stored column setup", $);
        }
      const x = Array.isArray(g.initialVisible) ? g.initialVisible : null;
      if (x) {
        const $ = n.value.filter((C) => x.includes(C.key));
        return x.length === 0 ? [] : $.length ? $ : null;
      }
    }
    if (h && typeof y == "object") {
      const g = y.key, x = y.type;
      if (g)
        try {
          const $ = await Il(g, x);
          if ($) {
            const C = /* @__PURE__ */ new Map();
            return y.groups.forEach((O) => O.items.forEach((_) => C.set(_.key, _))), s($, C, y.defaultSortable);
          }
        } catch ($) {
          console.warn("[VTable] Failed to load stored column picker state", $);
        }
    }
    return null;
  }, r = J(null), i = J(null), o = J(null);
  l().then((k) => {
    k !== null && (r.value = k);
  });
  const u = (k) => {
    r.value = [...k];
  }, c = () => {
    var k;
    (k = i.value) == null || k.close();
  }, d = () => {
    var k;
    (k = o.value) == null || k.close();
  }, p = S(() => {
    const k = Qe(e.columnPicker);
    return !!k && typeof k == "object";
  }), f = S(() => {
    const k = Qe(e.columnPicker);
    return !k || typeof k != "object" ? null : k;
  }), w = (k) => {
    const y = k.filter((x) => x.fixed === "left"), h = k.filter((x) => !x.fixed), g = k.filter((x) => x.fixed === "right");
    return !y.length && !g.length ? k : [...y, ...h, ...g];
  }, m = S(() => !t.value && !p.value ? w(n.value) : w(r.value ?? n.value));
  return {
    columnSetupEnabledBasic: t,
    columnSetupConfig: a,
    columnSetupPopoverRef: i,
    columnPickerPopoverRef: o,
    handleVisibleColumnsUpdate: u,
    handleColumnSetupClose: c,
    handleColumnPickerClose: d,
    columnPickerEnabled: p,
    columnPickerConfig: f,
    effectiveColumns: m
  };
}, ZM = (e) => e ? e === !0 ? { enabled: !0, row: !0, column: !0 } : {
  enabled: !0,
  row: e.row ?? !0,
  column: e.column ?? !0
} : { enabled: !1, row: !1, column: !1 }, XM = (e) => {
  const n = J(null), t = J(null), a = () => Qe(e.config), s = S(() => n.value !== null || t.value !== null), l = (m) => n.value === null ? !1 : m !== void 0 && n.value === m, r = (m) => t.value === null ? !1 : t.value === m, i = () => {
    var m;
    (m = e.onChange) == null || m.call(e, {
      rowId: n.value,
      columnKey: t.value
    });
  };
  return {
    pinnedRowId: n,
    pinnedColumnKey: t,
    hasPin: s,
    isRowPinned: l,
    isColumnPinned: r,
    toggleRow: (m) => {
      const { enabled: k, row: y } = a();
      !k || !y || (n.value = n.value === m ? null : m, i());
    },
    toggleColumn: (m) => {
      const { enabled: k, column: y } = a();
      !k || !y || (t.value = t.value === m ? null : m, i());
    },
    unpinRow: () => {
      n.value !== null && (n.value = null, i());
    },
    unpinColumn: () => {
      t.value !== null && (t.value = null, i());
    },
    clear: () => {
      s.value && (n.value = null, t.value = null, i());
    },
    applyRemote: (m) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? m.rowId : null, t.value = h ? m.columnKey : null);
    },
    setPin: (m) => {
      const { enabled: k, row: y, column: h } = a();
      k && (n.value = y ? m.rowId : null, t.value = h ? m.columnKey : null, i());
    }
  };
}, yf = Symbol("tablePageKey");
function b_(e = []) {
  const n = J(1);
  return e.length && Ne(e, () => {
    n.value === 1 ? Ir(n) : n.value = 1;
  }, { flush: "pre", deep: !0 }), ea(yf, n), n;
}
function JM(e) {
  const { config: n, flattenedData: t, selectedRows: a, onSelectionChange: s } = e, l = J(/* @__PURE__ */ new Set()), r = ($) => $.id;
  Ne(
    a,
    ($) => {
      l.value = new Set($.map((C) => r(C)));
    },
    { immediate: !0 }
  );
  const i = S(() => {
    var $;
    return (($ = n.value) == null ? void 0 : $.enabled) ?? !1;
  }), o = S(
    () => {
      var $;
      return (($ = n.value) == null ? void 0 : $.selectionMode) === "dependent";
    }
  ), u = ($) => l.value.has($), c = ($) => {
    var C;
    return (C = n.value) != null && C.isRowSelectable ? n.value.isRowSelectable($) : !0;
  }, d = ($) => {
    if (!$.children || $.children.length === 0) return [];
    const C = [], O = (_) => {
      _.forEach((I) => {
        C.push(r(I)), I.children && O(I.children);
      });
    };
    return O($.children), C;
  }, p = ($) => {
    if (!$.children || $.children.length === 0) return [];
    const C = [], O = t.value.filter((D) => D.isExpanded), _ = new Set(O.map((D) => r(D))), I = (D, z) => {
      D.forEach((H) => {
        if (z) {
          C.push(r(H));
          const ne = _.has(r(H));
          H.children && I(H.children, ne);
        }
      });
    };
    return I($.children, !0), C;
  }, f = ($) => t.value.find(
    (C) => {
      var O;
      return (O = C.children) == null ? void 0 : O.some((_) => _.id === $);
    }
  ), w = ($) => {
    var _;
    if (!$.children || $.children.length === 0)
      return u(r($)) ? "checked" : "unchecked";
    const C = (_ = n.value) != null && _.selectOnlyVisible ? p($) : d($);
    if (C.length === 0)
      return u(r($)) ? "checked" : "unchecked";
    const O = C.filter(
      (I) => l.value.has(I)
    ).length;
    return O === 0 && !u(r($)) ? "unchecked" : O === C.length && u(r($)) ? "checked" : "indeterminate";
  }, m = ($) => {
    var I, D, z, H, ne, te;
    if (!i.value || !c($)) return;
    const C = r($), O = u(C), _ = new Set(l.value);
    if (O ? (_.delete(C), o.value && ((I = n.value) != null && I.selectChildren) && ((D = n.value) != null && D.selectOnlyVisible ? p($) : d($)).forEach((ie) => _.delete(ie))) : (_.add(C), o.value && ((z = n.value) != null && z.selectChildren) && ((H = n.value) != null && H.selectOnlyVisible ? p($) : d($)).forEach((ie) => _.add(ie))), o.value && ((ne = n.value) != null && ne.selectParent)) {
      const q = f(C);
      q && ((((te = q.children) == null ? void 0 : te.map((ae) => r(ae))) || []).every(
        (ae) => _.has(ae)
      ) ? _.add(r(q)) : _.delete(r(q)));
    }
    l.value = _, h();
  }, k = () => {
    const $ = t.value.filter(
      (O) => c(O)
    );
    if ($.length === 0) return "unchecked";
    const C = $.filter(
      (O) => u(r(O))
    ).length;
    return C === 0 ? "unchecked" : C === $.length ? "checked" : "indeterminate";
  }, y = () => {
    if (!i.value) return;
    const $ = k(), C = new Set(l.value), O = t.value.filter(
      (I) => c(I)
    ), _ = (I) => {
      var D;
      return !o.value || !((D = n.value) != null && D.selectChildren) ? [] : n.value.selectOnlyVisible ? p(I) : d(I);
    };
    $ === "checked" ? O.forEach((I) => {
      C.delete(r(I)), _(I).forEach((D) => C.delete(D));
    }) : O.forEach((I) => {
      C.add(r(I)), _(I).forEach((D) => C.add(D));
    }), l.value = C, h();
  }, h = () => {
    const $ = (_, I) => {
      for (const D of I) {
        if (D.id === _) return D;
        if (D.children) {
          const z = $(_, D.children);
          if (z) return z;
        }
      }
    }, C = t.value.map((_) => {
      const { depth: I, parentId: D, hasChildren: z, isExpanded: H, ...ne } = _;
      return ne;
    }), O = Array.from(l.value).map((_) => $(_, C)).filter((_) => _ !== void 0);
    s(O);
  };
  return {
    // State
    isEnabled: i,
    isDependentMode: o,
    selectedIds: l,
    // Methods
    isRowSelected: u,
    isRowSelectable: c,
    toggleRow: m,
    toggleAllRows: y,
    getParentCheckboxState: w,
    getHeaderCheckboxState: k,
    clearSelection: () => {
      l.value = /* @__PURE__ */ new Set(), h();
    },
    selectRows: ($) => {
      l.value = new Set($), h();
    }
  };
}
const QM = (e) => {
  const {
    sort: n = {},
    sortState: t,
    columns: a,
    page: s,
    pageSize: l,
    data: r,
    onRequest: i,
    onSort: o,
    onUpdateSortState: u
  } = e, c = S(() => ({
    type: n.type || "server",
    multiple: n.multiple !== void 0 ? n.multiple : !0
  })), d = J((t == null ? void 0 : t.value) || []);
  t && Ne(t, ($) => {
    d.value = $ || [];
  });
  const p = ($, C) => {
    const O = a.value.find((D) => D.key === C);
    if (O != null && O.sortValue)
      return O.sortValue($, C);
    const _ = C.split(".");
    let I = $;
    for (const D of _) {
      if (I == null) return null;
      I = I[D];
    }
    return I;
  }, f = ($, C, O) => {
    if ($ == null && C == null) return 0;
    if ($ == null) return 1;
    if (C == null) return -1;
    const _ = typeof $ == "string" ? parseFloat($) : $, I = typeof C == "string" ? parseFloat(C) : C;
    if (typeof _ == "number" && typeof I == "number" && !Number.isNaN(_) && !Number.isNaN(I))
      return O === "asc" ? _ - I : I - _;
    const D = String($).toLowerCase(), z = String(C).toLowerCase();
    return O === "asc" ? D.localeCompare(z, void 0, { numeric: !0 }) : z.localeCompare(D, void 0, { numeric: !0 });
  }, w = ($, C) => C.length === 0 ? [...$] : [...$].sort((O, _) => {
    for (const I of C) {
      const D = p(O, I.field), z = p(_, I.field), H = f(D, z, I.order);
      if (H !== 0)
        return H;
    }
    return 0;
  }), m = S(() => c.value.type !== "front" || !r ? (r == null ? void 0 : r.value) || [] : w(r.value, d.value)), k = ($) => {
    const C = d.value.find((O) => O.field === $);
    return {
      isSorted: !!C,
      order: (C == null ? void 0 : C.order) || null,
      index: C ? d.value.indexOf(C) : -1
      // For multi-sort indicator
    };
  }, y = ($) => $ ? $ === "asc" ? "desc" : null : "asc", h = ($) => {
    if (!$.sortable) return;
    const C = $.key, O = k(C), _ = y(O.order);
    let I;
    if (c.value.multiple ? _ === null ? I = d.value.filter((D) => D.field !== C) : O.isSorted ? I = d.value.map(
      (D) => D.field === C ? { field: C, order: _ } : D
    ) : I = [...d.value, { field: C, order: _ }] : _ === null ? I = [] : I = [{ field: C, order: _ }], d.value = I, u == null || u(I), c.value.type === "front") {
      if (I.length > 0) {
        const D = I.find((z) => z.field === C);
        D && (o == null || o({
          field: C,
          order: D.order,
          sortState: I
        }));
      }
    } else {
      const D = {
        // page: page?.value ?? 1,
        page: 1,
        pageSize: (l == null ? void 0 : l.value) ?? 10,
        sort: I
      };
      i == null || i(D);
    }
  }, g = S(() => d.value.length > 0);
  return {
    sortState: d,
    sortConfig: c,
    getSortState: k,
    handleSortClick: h,
    hasSortedColumns: g,
    resetSort: () => {
      if (d.value = [], u == null || u([]), c.value.type === "server") {
        const $ = {
          page: (s == null ? void 0 : s.value) ?? 1,
          pageSize: (l == null ? void 0 : l.value) ?? 10,
          sort: []
        };
        i == null || i($);
      }
    },
    // Frontend sorting
    sortedData: m
    // Reactive sorted data for frontend sorting
  };
};
function za(e, n, t) {
  let a = t.initialDeps ?? [], s, l = !0;
  function r() {
    var i, o, u;
    let c;
    t.key && ((i = t.debug) != null && i.call(t)) && (c = Date.now());
    const d = e();
    if (!(d.length !== a.length || d.some((w, m) => a[m] !== w)))
      return s;
    a = d;
    let f;
    if (t.key && ((o = t.debug) != null && o.call(t)) && (f = Date.now()), s = n(...d), t.key && ((u = t.debug) != null && u.call(t))) {
      const w = Math.round((Date.now() - c) * 100) / 100, m = Math.round((Date.now() - f) * 100) / 100, k = m / 16, y = (h, g) => {
        for (h = String(h); h.length < g; )
          h = " " + h;
        return h;
      };
      console.info(
        `%c⏱ ${y(m, 5)} /${y(w, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * k, 120)
        )}deg 100% 31%);`,
        t == null ? void 0 : t.key
      );
    }
    return t != null && t.onChange && !(l && t.skipInitialOnChange) && t.onChange(s), l = !1, s;
  }
  return r.updateDeps = (i) => {
    a = i;
  }, r;
}
function Cu(e, n) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const e2 = (e, n) => Math.abs(e - n) < 1.01, t2 = (e, n, t) => {
  let a;
  return function(...s) {
    e.clearTimeout(a), a = e.setTimeout(() => n.apply(this, s), t);
  };
}, Mu = (e) => {
  const { offsetWidth: n, offsetHeight: t } = e;
  return { width: n, height: t };
}, n2 = (e) => e, a2 = (e) => {
  const n = Math.max(e.startIndex - e.overscan, 0), t = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let s = n; s <= t; s++)
    a.push(s);
  return a;
}, s2 = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  const s = (r) => {
    const { width: i, height: o } = r;
    n({ width: Math.round(i), height: Math.round(o) });
  };
  if (s(Mu(t)), !a.ResizeObserver)
    return () => {
    };
  const l = new a.ResizeObserver((r) => {
    const i = () => {
      const o = r[0];
      if (o != null && o.borderBoxSize) {
        const u = o.borderBoxSize[0];
        if (u) {
          s({ width: u.inlineSize, height: u.blockSize });
          return;
        }
      }
      s(Mu(t));
    };
    e.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(i) : i();
  });
  return l.observe(t, { box: "border-box" }), () => {
    l.unobserve(t);
  };
}, Du = {
  passive: !0
}, _u = typeof window > "u" ? !0 : "onscrollend" in window, l2 = (e, n) => {
  const t = e.scrollElement;
  if (!t)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  let s = 0;
  const l = e.options.useScrollendEvent && _u ? () => {
  } : t2(
    a,
    () => {
      n(s, !1);
    },
    e.options.isScrollingResetDelay
  ), r = (c) => () => {
    const { horizontal: d, isRtl: p } = e.options;
    s = d ? t.scrollLeft * (p && -1 || 1) : t.scrollTop, l(), n(s, c);
  }, i = r(!0), o = r(!1);
  t.addEventListener("scroll", i, Du);
  const u = e.options.useScrollendEvent && _u;
  return u && t.addEventListener("scrollend", o, Du), () => {
    t.removeEventListener("scroll", i), u && t.removeEventListener("scrollend", o);
  };
}, r2 = (e, n, t) => {
  if (n != null && n.borderBoxSize) {
    const a = n.borderBoxSize[0];
    if (a)
      return Math.round(
        a[t.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return e[t.options.horizontal ? "offsetWidth" : "offsetHeight"];
}, i2 = (e, {
  adjustments: n = 0,
  behavior: t
}, a) => {
  var s, l;
  const r = e + n;
  (l = (s = a.scrollElement) == null ? void 0 : s.scrollTo) == null || l.call(s, {
    [a.options.horizontal ? "left" : "top"]: r,
    behavior: t
  });
};
class o2 {
  constructor(n) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.currentScrollToIndex = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.prevLanes = void 0, this.lanesChangedFlag = !1, this.lanesSettling = !1, this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let t = null;
      const a = () => t || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : t = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((l) => {
          const r = () => {
            this._measureElement(l.target, l);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(r) : r();
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = a()) == null || s.disconnect(), t = null;
        },
        observe: (s) => {
          var l;
          return (l = a()) == null ? void 0 : l.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var l;
          return (l = a()) == null ? void 0 : l.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (t) => {
      Object.entries(t).forEach(([a, s]) => {
        typeof s > "u" && delete t[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: n2,
        rangeExtractor: a2,
        onChange: () => {
        },
        measureElement: r2,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...t
      };
    }, this.notify = (t) => {
      var a, s;
      (s = (a = this.options).onChange) == null || s.call(a, this, t);
    }, this.maybeNotify = za(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (t) => {
        this.notify(t);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((t) => t()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var t;
      const a = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== a) {
        if (this.cleanup(), !a) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = a, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((t = this.scrollElement) == null ? void 0 : t.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, l) => {
            this.scrollAdjustments = 0, this.scrollDirection = l ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = l, this.maybeNotify();
          })
        ), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        });
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (t, a) => {
      const s = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
      for (let r = a - 1; r >= 0; r--) {
        const i = t[r];
        if (s.has(i.lane))
          continue;
        const o = l.get(
          i.lane
        );
        if (o == null || i.end > o.end ? l.set(i.lane, i) : i.end < o.end && s.set(i.lane, !0), s.size === this.options.lanes)
          break;
      }
      return l.size === this.options.lanes ? Array.from(l.values()).sort((r, i) => r.end === i.end ? r.index - i.index : r.end - i.end)[0] : void 0;
    }, this.getMeasurementOptions = za(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled,
        this.options.lanes
      ],
      (t, a, s, l, r, i) => (this.prevLanes !== void 0 && this.prevLanes !== i && (this.lanesChangedFlag = !0), this.prevLanes = i, this.pendingMeasuredCacheIndexes = [], {
        count: t,
        paddingStart: a,
        scrollMargin: s,
        getItemKey: l,
        enabled: r,
        lanes: i
      }),
      {
        key: !1
      }
    ), this.getMeasurements = za(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: t, paddingStart: a, scrollMargin: s, getItemKey: l, enabled: r, lanes: i }, o) => {
        if (!r)
          return this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), [];
        if (this.laneAssignments.size > t)
          for (const p of this.laneAssignments.keys())
            p >= t && this.laneAssignments.delete(p);
        this.lanesChangedFlag && (this.lanesChangedFlag = !1, this.lanesSettling = !0, this.measurementsCache = [], this.itemSizeCache.clear(), this.laneAssignments.clear(), this.pendingMeasuredCacheIndexes = []), this.measurementsCache.length === 0 && !this.lanesSettling && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((p) => {
          this.itemSizeCache.set(p.key, p.size);
        }));
        const u = this.lanesSettling ? 0 : this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [], this.lanesSettling && this.measurementsCache.length === t && (this.lanesSettling = !1);
        const c = this.measurementsCache.slice(0, u), d = new Array(i).fill(
          void 0
        );
        for (let p = 0; p < u; p++) {
          const f = c[p];
          f && (d[f.lane] = p);
        }
        for (let p = u; p < t; p++) {
          const f = l(p), w = this.laneAssignments.get(p);
          let m, k;
          if (w !== void 0 && this.options.lanes > 1) {
            m = w;
            const x = d[m], $ = x !== void 0 ? c[x] : void 0;
            k = $ ? $.end + this.options.gap : a + s;
          } else {
            const x = this.options.lanes === 1 ? c[p - 1] : this.getFurthestMeasurement(c, p);
            k = x ? x.end + this.options.gap : a + s, m = x ? x.lane : p % this.options.lanes, this.options.lanes > 1 && this.laneAssignments.set(p, m);
          }
          const y = o.get(f), h = typeof y == "number" ? y : this.options.estimateSize(p), g = k + h;
          c[p] = {
            index: p,
            start: k,
            size: h,
            end: g,
            key: f,
            lane: m
          }, d[m] = p;
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = za(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (t, a, s, l) => this.range = t.length > 0 && a > 0 ? u2({
        measurements: t,
        outerSize: a,
        scrollOffset: s,
        lanes: l
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = za(
      () => {
        let t = null, a = null;
        const s = this.calculateRange();
        return s && (t = s.startIndex, a = s.endIndex), this.maybeNotify.updateDeps([this.isScrolling, t, a]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          t,
          a
        ];
      },
      (t, a, s, l, r) => l === null || r === null ? [] : t({
        startIndex: l,
        endIndex: r,
        overscan: a,
        count: s
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (t) => {
      const a = this.options.indexAttribute, s = t.getAttribute(a);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (t, a) => {
      const s = this.indexFromElement(t), l = this.measurementsCache[s];
      if (!l)
        return;
      const r = l.key, i = this.elementsCache.get(r);
      i !== t && (i && this.observer.unobserve(i), this.observer.observe(t), this.elementsCache.set(r, t)), t.isConnected && this.resizeItem(s, this.options.measureElement(t, a, this));
    }, this.resizeItem = (t, a) => {
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const l = this.itemSizeCache.get(s.key) ?? s.size, r = a - l;
      r !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, r, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", r), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += r,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, a)), this.notify(!1));
    }, this.measureElement = (t) => {
      if (!t) {
        this.elementsCache.forEach((a, s) => {
          a.isConnected || (this.observer.unobserve(a), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(t, void 0);
    }, this.getVirtualItems = za(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (t, a) => {
        const s = [];
        for (let l = 0, r = t.length; l < r; l++) {
          const i = t[l], o = a[i];
          s.push(o);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (t) => {
      const a = this.getMeasurements();
      if (a.length !== 0)
        return Cu(
          a[bf(
            0,
            a.length - 1,
            (s) => Cu(a[s]).start,
            t
          )]
        );
    }, this.getMaxScrollOffset = () => {
      if (!this.scrollElement) return 0;
      if ("scrollHeight" in this.scrollElement)
        return this.options.horizontal ? this.scrollElement.scrollWidth - this.scrollElement.clientWidth : this.scrollElement.scrollHeight - this.scrollElement.clientHeight;
      {
        const t = this.scrollElement.document.documentElement;
        return this.options.horizontal ? t.scrollWidth - this.scrollElement.innerWidth : t.scrollHeight - this.scrollElement.innerHeight;
      }
    }, this.getOffsetForAlignment = (t, a, s = 0) => {
      if (!this.scrollElement) return 0;
      const l = this.getSize(), r = this.getScrollOffset();
      a === "auto" && (a = t >= r + l ? "end" : "start"), a === "center" ? t += (s - l) / 2 : a === "end" && (t -= l);
      const i = this.getMaxScrollOffset();
      return Math.max(Math.min(i, t), 0);
    }, this.getOffsetForIndex = (t, a = "auto") => {
      t = Math.max(0, Math.min(t, this.options.count - 1));
      const s = this.measurementsCache[t];
      if (!s)
        return;
      const l = this.getSize(), r = this.getScrollOffset();
      if (a === "auto")
        if (s.end >= r + l - this.options.scrollPaddingEnd)
          a = "end";
        else if (s.start <= r + this.options.scrollPaddingStart)
          a = "start";
        else
          return [r, a];
      if (a === "end" && t === this.options.count - 1)
        return [this.getMaxScrollOffset(), a];
      const i = a === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(i, a, s.size),
        a
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.scrollToOffset = (t, { align: a = "start", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(t, a), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (t, { align: a = "auto", behavior: s } = {}) => {
      s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), t = Math.max(0, Math.min(t, this.options.count - 1)), this.currentScrollToIndex = t;
      let l = 0;
      const r = 10, i = (u) => {
        if (!this.targetWindow) return;
        const c = this.getOffsetForIndex(t, u);
        if (!c) {
          console.warn("Failed to get offset for index:", t);
          return;
        }
        const [d, p] = c;
        this._scrollToOffset(d, { adjustments: void 0, behavior: s }), this.targetWindow.requestAnimationFrame(() => {
          const f = () => {
            if (this.currentScrollToIndex !== t) return;
            const w = this.getScrollOffset(), m = this.getOffsetForIndex(t, p);
            if (!m) {
              console.warn("Failed to get offset for index:", t);
              return;
            }
            e2(m[0], w) || o(p);
          };
          this.isDynamicMode() ? this.targetWindow.requestAnimationFrame(f) : f();
        });
      }, o = (u) => {
        this.targetWindow && this.currentScrollToIndex === t && (l++, l < r ? (process.env.NODE_ENV !== "production" && this.options.debug && console.info("Schedule retry", l, r), this.targetWindow.requestAnimationFrame(() => i(u))) : console.warn(
          `Failed to scroll to index ${t} after ${r} attempts.`
        ));
      };
      i(a);
    }, this.scrollBy = (t, { behavior: a } = {}) => {
      a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + t, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var t;
      const a = this.getMeasurements();
      let s;
      if (a.length === 0)
        s = this.options.paddingStart;
      else if (this.options.lanes === 1)
        s = ((t = a[a.length - 1]) == null ? void 0 : t.end) ?? 0;
      else {
        const l = Array(this.options.lanes).fill(null);
        let r = a.length - 1;
        for (; r >= 0 && l.some((i) => i === null); ) {
          const i = a[r];
          l[i.lane] === null && (l[i.lane] = i.end), r--;
        }
        s = Math.max(...l.filter((i) => i !== null));
      }
      return Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (t, {
      adjustments: a,
      behavior: s
    }) => {
      this.options.scrollToFn(t, { behavior: s, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.laneAssignments = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(n);
  }
}
const bf = (e, n, t, a) => {
  for (; e <= n; ) {
    const s = (e + n) / 2 | 0, l = t(s);
    if (l < a)
      e = s + 1;
    else if (l > a)
      n = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function u2({
  measurements: e,
  outerSize: n,
  scrollOffset: t,
  lanes: a
}) {
  const s = e.length - 1, l = (o) => e[o].start;
  if (e.length <= a)
    return {
      startIndex: 0,
      endIndex: s
    };
  let r = bf(
    0,
    s,
    l,
    t
  ), i = r;
  if (a === 1)
    for (; i < s && e[i].end < t + n; )
      i++;
  else if (a > 1) {
    const o = Array(a).fill(0);
    for (; i < s && o.some((c) => c < t + n); ) {
      const c = e[i];
      o[c.lane] = c.end, i++;
    }
    const u = Array(a).fill(t + n);
    for (; r >= 0 && u.some((c) => c >= t); ) {
      const c = e[r];
      u[c.lane] = c.start, r--;
    }
    r = Math.max(0, r - r % a), i = Math.min(s, i + (a - 1 - i % a));
  }
  return { startIndex: r, endIndex: i };
}
function c2(e) {
  const n = new o2(v(e)), t = Et(n), a = n._didMount();
  return Ne(
    () => v(e).getScrollElement(),
    (s) => {
      s && n._willUpdate();
    },
    {
      immediate: !0
    }
  ), Ne(
    () => v(e),
    (s) => {
      n.setOptions({
        ...s,
        onChange: (l, r) => {
          var i;
          Ir(t), (i = s.onChange) == null || i.call(s, l, r);
        }
      }), n._willUpdate(), Ir(t);
    },
    {
      immediate: !0
    }
  ), Al(a), t;
}
function d2(e) {
  return c2(
    S(() => ({
      observeElementRect: s2,
      observeElementOffset: l2,
      scrollToFn: i2,
      ...v(e)
    }))
  );
}
function f2(e, n, t = {}) {
  const {
    estimateSize: a = 50,
    overscan: s = 3,
    measureElement: l = !1
  } = t, r = Et(!1);
  let i = null, o = !1;
  const u = {
    get count() {
      return n.value.length;
    },
    getScrollElement: () => e.value,
    estimateSize: () => a,
    overscan: s,
    scrollingDelay: 150
  };
  l && (u.measureElement = (h) => !h || r.value ? a : h.getBoundingClientRect().height || a);
  const c = d2(u), d = S(() => c.value.getVirtualItems()), p = S(() => c.value.getTotalSize()), f = () => {
    r.value = !0, i && clearTimeout(i), i = setTimeout(() => {
      r.value = !1;
    }, 150);
  }, w = () => {
    const h = e.value;
    !h || !c.value || (c.value.measure(), h.dispatchEvent(new Event("scroll", { bubbles: !0 })));
  }, m = () => {
    const h = e.value;
    h && !o && (h.addEventListener("scroll", f, { passive: !0 }), o = !0);
  }, k = () => {
    const h = e.value;
    h && o && (h.removeEventListener("scroll", f), o = !1);
  }, y = () => {
    i && (clearTimeout(i), i = null);
  };
  return et(() => {
    requestAnimationFrame(() => {
      m();
    });
  }), Vu(() => {
    requestAnimationFrame(() => {
      w(), m();
    });
  }), Ru(() => {
    y();
  }), Jt(() => {
    k(), y();
  }), {
    virtualizer: c,
    virtualItems: d,
    totalSize: p,
    remeasure: w
  };
}
const h2 = {
  key: 1,
  ref: "toolbarSlot",
  class: "v-table-toolbar-slot"
}, m2 = { class: "v-table-container-wrapper" }, v2 = {
  key: 1,
  class: "v-table-header-checkbox-cell v-table-header-checkbox-cell--empty"
}, p2 = ["onClick"], g2 = {
  key: 0,
  class: "v-table-total-cell v-table-checkbox-cell"
}, y2 = { class: "v-table-total-content" }, b2 = {
  key: 0,
  class: "v-table-total-spacer"
}, w2 = 36, k2 = 40, w_ = /* @__PURE__ */ ke({
  inheritAttrs: !1,
  __name: "VTable",
  props: /* @__PURE__ */ Ft({
    columns: {},
    data: {},
    loading: { type: Boolean, default: !1 },
    virtualized: { type: Boolean, default: !0 },
    rowHeight: { default: void 0 },
    modern: { type: Boolean, default: !1 },
    height: {},
    totalRow: {},
    selectedRows: {},
    multiSelect: {},
    expandMode: { default: "auto" },
    sort: { default: () => ({ type: "server", multiple: !0 }) },
    sortState: {},
    pagination: {},
    page: {},
    pageSize: {},
    toolbar: { default: void 0 },
    search: { default: "" },
    rowClassName: {},
    scrollSync: {},
    highlight: { type: [Boolean, Object] },
    highlightState: {},
    highlightSync: {}
  }, {
    search: {},
    searchModifiers: {}
  }),
  emits: /* @__PURE__ */ Ft(["row-click", "update:selected-rows", "expand-click", "update:sort-state", "update:highlight-state", "update:page", "update:pageSize", "request", "sort", "update:search", "toolbar:refresh", "toolbar:reset-sort", "toolbar:export"], ["update:search"]),
  setup(e, { expose: n, emit: t }) {
    const a = e, s = t, l = S(() => a.rowHeight ?? (a.modern ? 40 : 50));
    ea(of, S(() => a.modern));
    const r = Ht(), i = Pl(), o = Ge("wrapper"), u = Ge("fullscreenPlaceholder"), c = Ge("toolbarSlot"), d = Ge("pagination");
    ea("tableSlots", {
      headerCellCustomAction: r["header-cell-custom-action"],
      toolbarTitle: r["toolbar-title"],
      toolbarSearch: r["toolbar-search"],
      toolbarFilters: r["toolbar-filters"],
      toolbarActions: r["toolbar-actions"],
      toolbarColumnActions: r["toolbar-column-actions"],
      emptyState: r["empty-state"]
    });
    const p = rn(e, "search"), f = S(() => {
      var re;
      return ((re = a.toolbar) == null ? void 0 : re.enabled) || r.toolbar;
    }), w = S(() => {
      var re, Se;
      return !!f.value && ((Se = (re = a.toolbar) == null ? void 0 : re.actions) == null ? void 0 : Se.fullscreen) !== !1;
    }), {
      isFullscreen: m,
      zIndex: k,
      placeholderStyle: y,
      panelStyle: h,
      contentHeight: g,
      toggle: x
    } = qx({
      wrapperRef: o,
      placeholderRef: u,
      // The toolbar/pagination chrome is already rendered and is the same size in
      // both fullscreen and normal mode — the composable measures it before the
      // fullscreen flag flips (see useTableFullScreen's enter()) so
      // fullscreenContentHeight is a final px value on the very first fullscreen
      // render (see scrollContainerStyle below).
      chromeRefs: [c, d],
      isEnabled: w,
      // The scroll container's own height changed the instant the fullscreen class
      // applied — the virtualizer's cached scroll element rect is now stale. We
      // don't preserve scroll position across the toggle, so reset to top and
      // force a remeasure (delegated to useVirtualTable's own remeasure()) instead
      // of waiting for the user's next real scroll to reveal any rows.
      onToggle: () => {
        const re = kt.value;
        re && (re.scrollTop = 0, re.scrollLeft = 0), Dt();
      }
    }), $ = S(() => i.class), C = S(() => {
      const re = i.style, Se = typeof re == "object" && re !== null ? re : {};
      if (y.value)
        return { ...Se, ...y.value };
    }), O = () => {
      var qe, Pe;
      s("toolbar:refresh");
      const re = (Pe = (qe = a.toolbar) == null ? void 0 : qe.actions) == null ? void 0 : Pe.refresh;
      (typeof re == "object" ? re.mode ?? "default" : re) !== "custom" && (Q.value = [], fe.value = 1, It.collapseAll(), xt.clear(), s("request", {
        page: fe.value,
        pageSize: Re.value,
        sort: []
      }));
    }, _ = () => {
      var Se, qe;
      s("toolbar:reset-sort"), ((qe = (Se = a.toolbar) == null ? void 0 : Se.actions) == null ? void 0 : qe.resetSort) !== "custom" && (Q.value = [], fe.value = 1, It.collapseAll(), xt.clear(), s("request", {
        page: fe.value,
        pageSize: Re.value,
        sort: []
      }));
    }, I = (re, Se) => {
      s("toolbar:export", re, Se);
    }, {
      columnSetupEnabledBasic: D,
      columnSetupConfig: z,
      columnSetupPopoverRef: H,
      columnPickerPopoverRef: ne,
      handleVisibleColumnsUpdate: te,
      handleColumnSetupClose: q,
      handleColumnPickerClose: ie,
      columnPickerEnabled: L,
      columnPickerConfig: ae,
      effectiveColumns: Y
    } = KM({
      columns: () => a.columns,
      columnSetup: () => {
        var re, Se;
        return (Se = (re = a.toolbar) == null ? void 0 : re.actions) == null ? void 0 : Se.columnSetup;
      },
      columnPicker: () => {
        var re, Se;
        return (Se = (re = a.toolbar) == null ? void 0 : re.actions) == null ? void 0 : Se.columnPicker;
      }
    }), W = S(() => a.totalRow !== void 0), K = J(/* @__PURE__ */ new Map()), {
      hasGroups: de,
      flatColumns: he,
      headerLevels: me,
      getGroupWidth: Te,
      isGroupFixed: we
    } = UM(Y, K), X = S(() => D.value ? de.value ? (console.warn("Column Setup is not supported with grouped headers yet"), !1) : !0 : !1), pe = S(() => de.value ? he.value : Y.value), {
      gridTemplateColumns: Me,
      getGridTemplateWithCheckbox: F,
      startResize: Z,
      autoFitColumn: ve,
      isResizing: G,
      resizedWidths: oe,
      isColumnResizable: be
    } = WM(pe);
    Ne(oe, () => {
      const re = /* @__PURE__ */ new Map();
      pe.value.forEach((Se) => {
        var Pe;
        const qe = oe.value.get(Se.key);
        qe !== void 0 ? re.set(Se.key, qe) : (Pe = Se.width) != null && Pe.endsWith("px") && re.set(Se.key, parseInt(Se.width, 10));
      }), K.value = re;
    }, { immediate: !0 });
    const {
      getFixedStyles: A,
      isLastLeftFixed: B,
      isFirstRightFixed: M
    } = HM(pe, K), V = S(() => a.height ? typeof a.height == "number" ? `${a.height}px` : a.height : "600px"), R = S(() => m.value ? {
      height: `${g.value}px`,
      overscrollBehavior: "contain"
    } : { height: V.value, overscrollBehavior: "contain" }), Q = S({
      get: () => a.sortState || [],
      set: (re) => s("update:sort-state", re)
    }), N = bn(yf, null), fe = S({
      get: () => {
        var re;
        return a.page ?? (N == null ? void 0 : N.value) ?? ((re = a.pagination) == null ? void 0 : re.page) ?? 1;
      },
      set: (re) => {
        a.page !== void 0 ? s("update:page", re) : N && (N.value = re);
      }
    }), Ce = S(() => {
      var re, Se;
      return ((re = a.pagination) == null ? void 0 : re.showSizeChanger) ?? ((Se = a.pagination) == null ? void 0 : Se.pageSizeOptions) !== void 0;
    }), Re = S({
      get: () => {
        var re;
        return a.pageSize ?? ((re = a.pagination) == null ? void 0 : re.pageSize) ?? 10;
      },
      set: (re) => {
        a.pageSize !== void 0 && s("update:pageSize", re);
      }
    }), {
      getSortState: Ee,
      handleSortClick: Ye,
      sortedData: At
    } = QM({
      sort: a.sort,
      sortState: Q,
      columns: Y,
      page: S(() => {
        var re;
        return (re = a.pagination) == null ? void 0 : re.page;
      }),
      pageSize: S(() => {
        var re;
        return (re = a.pagination) == null ? void 0 : re.pageSize;
      }),
      data: S(() => a.data),
      // Pass data for frontend sorting
      onRequest: (re) => {
        fe.value = re.page, It.collapseAll(), xt.clear(), s("request", re);
      },
      onSort: (re) => s("sort", re),
      onUpdateSortState: (re) => s("update:sort-state", re)
    }), Vn = (re) => {
      Ye(re);
    }, Sn = S(() => {
      var qe;
      const re = ((qe = a.sort) == null ? void 0 : qe.type) === "front" ? At.value : a.data, Se = (Pe, ft = "") => Pe.map((Ot, Ln) => {
        var nl;
        const hs = Ot.id ?? `${ft}row-${Ln}`, jn = (nl = Ot.children) != null && nl.length ? Se(Ot.children, `${hs}-`) : Ot.children;
        return Ot.id !== void 0 && jn === Ot.children ? Ot : { ...Ot, id: hs, children: jn };
      });
      return Se(re);
    }), Qt = S(
      () => Sn.value.some((re) => re.children && re.children.length > 0)
    ), Un = S(() => Sn.value), It = YM(Un), Wt = S(() => Qt.value ? It.flattenedData.value : Sn.value), cn = S(() => a.multiSelect), $n = S({
      get: () => a.selectedRows || [],
      set: (re) => s("update:selected-rows", re)
    }), wt = JM({
      config: cn,
      flattenedData: Wt,
      selectedRows: $n,
      onSelectionChange: (re) => {
        s("update:selected-rows", re);
      }
    }), kt = J(null), {
      virtualItems: De,
      totalSize: ut,
      remeasure: Dt
    } = f2(
      kt,
      Wt,
      {
        // Read once: `rowHeight` and `modern` are fixed for the life of a table, so the virtualiser
        // never needs to re-estimate.
        estimateSize: l.value,
        overscan: 2,
        // Reduced from 5 for better performance
        // PERFORMANCE: Disable measureElement to prevent memory leaks
        // Using fixed height improves performance dramatically for large datasets
        // Trade-off: scroll bar may be slightly inaccurate with expanded rows
        measureElement: !1
      }
    ), Tn = S(() => {
      const re = wt.isEnabled.value ? F(a.modern ? k2 : 50) : Me.value;
      return {
        // Sizing plumbing for the SCSS. The header is 48px legacy, 36px modern — never the row height.
        // Legacy cells keep their literal 50px min-height and ignore --v-table-row-h.
        "--v-table-row-h": `${l.value}px`,
        "--v-table-header-h": a.modern ? `${w2}px` : "48px",
        display: "grid",
        gridTemplateColumns: re,
        gridAutoRows: "auto"
        // All rows auto-sized (headers get height from CSS)
      };
    }), Fn = (re) => {
      s("row-click", re);
    }, Ea = ({ page: re, pageSize: Se }) => {
      !a.pagination || a.loading || (kt.value && kt.value.scrollTop > 0 && kt.value.scrollTo({
        top: 0,
        behavior: "smooth"
      }), fe.value = re, Re.value = Se, It.collapseAll(), xt.clear(), s("request", {
        page: re,
        pageSize: Se,
        sort: Q.value
      }));
    }, fs = (re) => {
      const Se = re.target;
      a.scrollSync && a.scrollSync.onScroll(Se.scrollLeft, Se.scrollTop);
    }, tr = (re, Se, qe) => {
      Qt.value && (a.expandMode === "controlled" ? s("expand-click", {
        row: Se,
        column: qe,
        callback: () => It.toggleRow(re),
        expanded: Qs(Se)
      }) : (It.toggleRow(re), s("expand-click", {
        row: Se,
        column: qe,
        callback: () => {
        },
        // Already toggled, callback is no-op
        expanded: !Qs(Se)
        // New state after toggle
      })));
    }, Qs = (re) => re.isExpanded || !1, nr = (re) => re.hasChildren || !1, { getCellValue: ar, getCellClass: sr, getCellMetadata: el } = GM({
      isExpandable: Qt,
      isRowExpandable: (re) => It.isExpandable(re)
    });
    ea("tableCellMetadata", el);
    const qn = S(() => ZM(a.highlight)), tl = () => {
      const re = xt.pinnedRowId.value, Se = xt.pinnedColumnKey.value;
      if (re === null && Se === null) return null;
      const qe = re === null ? -1 : Wt.value.findIndex((jn) => jn.id === re), Pe = qe >= 0 ? Wt.value[qe] : void 0, ft = Se === null ? void 0 : pe.value.find((jn) => jn.key === Se), Ot = Pe && re !== null ? { rowId: re, rowIndex: qe, row: Pe } : null, Ln = ft && Se !== null ? { columnKey: Se, column: ft } : null;
      let hs = null;
      if (Ot && Ln) {
        const jn = pe.value.indexOf(Ln.column), nl = el(Ot.row, Ln.column, jn, Ot.rowIndex);
        hs = {
          value: Ot.row[Ln.columnKey],
          formattedValue: String(nl.formattedValue ?? "")
        };
      }
      return { row: Ot, column: Ln, cell: hs };
    }, xt = XM({
      config: qn,
      onChange: (re) => {
        var Se;
        s("update:highlight-state", tl()), (Se = a.highlightSync) == null || Se.broadcast(re);
      }
    }), ee = (re) => {
      xt.applyRemote(re), s("update:highlight-state", tl());
    }, ge = (re) => xt.isRowPinned(re);
    ea("tableHighlight", {
      columnEnabled: S(() => qn.value.column),
      isColumnPinned: xt.isColumnPinned,
      toggleColumn: xt.toggleColumn
    });
    const Ae = (re, Se) => a.rowClassName ? typeof a.rowClassName == "string" ? a.rowClassName : typeof a.rowClassName == "function" ? a.rowClassName(re, Se) : "" : "", Ue = S(() => a.virtualized ? kt.value ? De.value.length === 0 ? [] : De.value.map((re) => {
      const Se = Wt.value[re.index], qe = Se ? Ae(Se, re.index) : "";
      return {
        row: Se,
        index: re.index,
        // CRITICAL: Use row.id as key, not index! Index causes memory leaks
        // because Vue reuses components for different data at same index
        key: (Se == null ? void 0 : Se.id) || `row-${re.index}`,
        isVirtual: !0,
        virtualRow: re,
        rowClass: qe,
        isCustomRow: !!qe
      };
    }) : [] : Wt.value.map((re, Se) => {
      const qe = Ae(re, Se);
      return {
        row: re,
        index: Se,
        key: re.id || Se,
        isVirtual: !1,
        rowClass: qe,
        isCustomRow: !!qe
      };
    })), tt = (re) => {
      const Se = [], qe = re.fixed || (de.value ? we(re) : null);
      return qe && (Se.push("v-table-fixed-column"), qe === "left" ? Se.push("v-table-fixed-left") : qe === "right" && Se.push("v-table-fixed-right"), B(re.key) && Se.push("v-table-fixed-left-last"), M(re.key) && Se.push("v-table-fixed-right-first")), xt.isColumnPinned(re.key) && Se.push("v-table-cell--pinned-col"), Se;
    }, Ut = S(() => {
      const re = /* @__PURE__ */ new Map();
      return pe.value.forEach((Se) => {
        re.set(Se.key, tt(Se));
      }), de.value && me.value.forEach((Se) => {
        Se.forEach((qe) => {
          re.has(qe.column.key) || re.set(qe.column.key, tt(qe.column));
        });
      }), re;
    }), qt = (re) => Ut.value.get(re.key) ?? [], oa = (re) => we(re) ? A(re) : {}, Ia = S(() => de.value ? uM : dM), ua = S(() => de.value ? me.value : pe.value);
    return Jt(() => {
      var re, Se;
      It && It.collapseAll(), kt.value = null, (re = a.scrollSync) == null || re.unregister(), (Se = a.highlightSync) == null || Se.unregister();
    }), et(() => {
      var re;
      (re = a.highlightSync) == null || re.register(ee), a.scrollSync && kt.value && a.scrollSync.register(kt.value);
    }), qn.value.enabled && (Ne(() => a.highlightState, (re) => {
      var Pe, ft;
      const Se = ((Pe = re == null ? void 0 : re.row) == null ? void 0 : Pe.rowId) ?? null, qe = ((ft = re == null ? void 0 : re.column) == null ? void 0 : ft.columnKey) ?? null;
      Se === xt.pinnedRowId.value && qe === xt.pinnedColumnKey.value || xt.setPin({ rowId: Se, columnKey: qe });
    }), Ne(qn, (re) => {
      if (!re.enabled) {
        xt.clear();
        return;
      }
      re.row || xt.unpinRow(), re.column || xt.unpinColumn();
    })), n({ visibleColumns: Y }), (re, Se) => {
      var qe;
      return b(), T($e, null, [
        (b(), ce(Pn, {
          disabled: !v(m),
          to: "body"
        }, [
          E("div", lt({
            ref: "wrapper",
            class: [{
              "v-table-wrapper--modern": e.modern,
              "v-table-wrapper--virtualized": e.virtualized,
              "v-table-wrapper--with-toolbar": f.value,
              "v-table-wrapper--fullscreen": v(m)
            }, "v-table-wrapper"],
            style: v(m) ? { ...v(h), zIndex: v(k) + 1 } : void 0
          }, v(i)), [
            w.value ? (b(), ce(XC, {
              key: 0,
              "is-fullscreen": v(m),
              onToggle: v(x)
            }, null, 8, ["is-fullscreen", "onToggle"])) : P("", !0),
            f.value ? (b(), T("div", h2, [
              v(r).toolbar ? U(re.$slots, "toolbar", { key: 0 }) : (qe = e.toolbar) != null && qe.enabled ? (b(), ce(VM, {
                key: 1,
                search: p.value,
                "onUpdate:search": Se[0] || (Se[0] = (Pe) => p.value = Pe),
                config: e.toolbar,
                onExport: I,
                onRefresh: O,
                onResetSort: _
              }, dt({ _: 2 }, [
                X.value || v(L) ? {
                  name: "column-setup",
                  fn: ue(() => [
                    v(L) ? (b(), ce(v(Ta), {
                      key: 0,
                      ref_key: "columnPickerPopoverRef",
                      ref: ne,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: ue(() => [
                        se(v(vt), {
                          modern: e.modern,
                          icon: "lucide:columns",
                          variant: "default"
                        }, null, 8, ["modern"])
                      ]),
                      content: ue(() => [
                        se(MC, {
                          columns: v(Y),
                          groups: v(ae).groups,
                          loading: v(ae).loading,
                          "original-columns": a.columns,
                          "storage-key": v(ae).key,
                          "storage-type": v(ae).type,
                          types: v(ae).types,
                          onClose: v(ie),
                          "onUpdate:visibleColumns": v(te)
                        }, null, 8, ["columns", "groups", "loading", "original-columns", "storage-key", "storage-type", "types", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : P("", !0),
                    X.value ? (b(), ce(v(Ta), {
                      key: 1,
                      ref_key: "columnSetupPopoverRef",
                      ref: H,
                      offset: 8,
                      "content-class": "rounded-lg",
                      placement: "bottom-right",
                      unstyled: ""
                    }, {
                      trigger: ue(() => [
                        se(v(vt), {
                          modern: e.modern,
                          icon: "lucide:table-2",
                          variant: "default"
                        }, null, 8, ["modern"])
                      ]),
                      content: ue(() => [
                        se(YC, {
                          columns: e.columns,
                          config: v(z),
                          onClose: v(q),
                          "onUpdate:visibleColumns": v(te)
                        }, null, 8, ["columns", "config", "onClose", "onUpdate:visibleColumns"])
                      ]),
                      _: 1
                    }, 512)) : P("", !0)
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["search", "config"])) : P("", !0)
            ], 512)) : P("", !0),
            E("div", m2, [
              Wt.value.length === 0 ? (b(), ce(KC, {
                key: 0,
                description: "Try adjusting your filters or search criteria",
                icon: "lucide:inbox",
                title: "No data to display"
              })) : P("", !0),
              se(mM, { loading: e.loading }, null, 8, ["loading"]),
              E("div", {
                ref_key: "scrollContainerRef",
                ref: kt,
                class: j([{ "v-table-scroll-container--loading": e.loading }, "v-table-scroll-container v-table-scrollbar-styled"]),
                style: Fe(R.value),
                onScrollPassive: fs
              }, [
                E("div", {
                  class: j([{
                    "v-is-resizing": v(G),
                    "v-table-grid--highlight": v(xt).hasPin.value
                  }, "v-table-grid"]),
                  style: Fe(Tn.value)
                }, [
                  (b(), ce(mt(Ia.value), {
                    columns: ua.value,
                    "get-column-classes": qt,
                    "get-fixed-styles": v(A),
                    "get-group-fixed-styles": oa,
                    "get-group-width": v(Te),
                    "get-sort-state": v(Ee),
                    "is-column-resizable": v(be),
                    onResizeStart: v(Z),
                    onResizeDblclick: v(ve),
                    onSortClick: Vn
                  }, dt({ _: 2 }, [
                    v(wt).isEnabled.value ? {
                      name: "checkbox-header",
                      fn: ue(() => {
                        var Pe;
                        return [
                          ((Pe = cn.value) == null ? void 0 : Pe.showHeaderCheckbox) !== !1 ? (b(), ce(QC, {
                            key: 0,
                            state: v(wt).getHeaderCheckboxState(),
                            onToggle: v(wt).toggleAllRows
                          }, null, 8, ["state", "onToggle"])) : (b(), T("div", v2))
                        ];
                      }),
                      key: "0"
                    } : void 0,
                    Oe(pe.value, (Pe) => ({
                      name: `header-icon-${Pe.key}`,
                      fn: ue((ft) => [
                        U(re.$slots, `header-icon-${Pe.key}`, Mt(zt(ft)))
                      ])
                    })),
                    Oe(pe.value, (Pe) => ({
                      name: `header-${Pe.key}`,
                      fn: ue((ft) => [
                        U(re.$slots, `header-${Pe.key}`, Mt(zt(ft)))
                      ])
                    }))
                  ]), 1064, ["columns", "get-fixed-styles", "get-group-width", "get-sort-state", "is-column-resizable", "onResizeStart", "onResizeDblclick"])),
                  a.virtualized && v(De).length > 0 && v(De)[0] ? (b(), T("div", {
                    key: 0,
                    style: Fe({ height: `${v(De)[0].start}px` }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : P("", !0),
                  (b(!0), T($e, null, Oe(Ue.value, (Pe) => (b(), T("div", {
                    key: Pe.key,
                    class: j([{ "v-table-row-wrapper--pinned": ge(Pe.row.id) }, "v-table-row-wrapper"]),
                    onClick: (ft) => Fn(Pe.row)
                  }, [
                    v(wt).isEnabled.value ? (b(), ce(NT, {
                      key: 0,
                      checked: v(wt).isRowSelected(Pe.row.id),
                      class: j(Pe.rowClass),
                      "data-custom-row": Pe.isCustomRow ? "true" : void 0,
                      disabled: !v(wt).isRowSelectable(Pe.row),
                      indeterminate: v(wt).isDependentMode.value && nr(Pe.row) && v(wt).getParentCheckboxState(Pe.row) === "indeterminate",
                      onToggle: (ft) => v(wt).toggleRow(Pe.row)
                    }, null, 8, ["checked", "class", "data-custom-row", "disabled", "indeterminate", "onToggle"])) : P("", !0),
                    (b(!0), T($e, null, Oe(pe.value, (ft, Ot) => (b(), ce(yu, {
                      key: ft.key,
                      align: ft.align,
                      class: j([
                        qt(ft),
                        Pe.rowClass,
                        { "v-table-cell--pin-host": qn.value.row && Ot === 0 }
                      ]),
                      "col-index": Ot,
                      column: ft,
                      "data-custom-row": Pe.isCustomRow ? "true" : void 0,
                      interactive: ft.interactive,
                      "is-expanded": !!Pe.row.isExpanded,
                      row: Pe.row,
                      "row-index": Pe.index,
                      style: Fe(v(A)(ft)),
                      onToggleExpand: (Ln) => tr(Pe.row.id, Pe.row, ft)
                    }, dt({ _: 2 }, [
                      qn.value.row && Ot === 0 ? {
                        name: "pin",
                        fn: ue(() => [
                          se(df, {
                            pinned: ge(Pe.row.id),
                            label: "row",
                            onToggle: (Ln) => v(xt).toggleRow(Pe.row.id)
                          }, null, 8, ["pinned", "onToggle"])
                        ]),
                        key: "0"
                      } : void 0,
                      v(r)[`cell-${ft.key}`] ? {
                        name: "default",
                        fn: ue(() => [
                          U(re.$slots, `cell-${ft.key}`, {
                            column: ft,
                            depth: Pe.row.depth || 0,
                            index: Pe.index,
                            row: Pe.row,
                            value: Pe.row[ft.key]
                          })
                        ]),
                        key: "1"
                      } : void 0
                    ]), 1032, ["align", "class", "col-index", "column", "data-custom-row", "interactive", "is-expanded", "row", "row-index", "style", "onToggleExpand"]))), 128))
                  ], 10, p2))), 128)),
                  a.virtualized && v(De).length > 0 && v(De)[v(De).length - 1] ? (b(), T("div", {
                    key: 1,
                    style: Fe({
                      height: `${v(ut) - v(De)[v(De).length - 1].end}px`
                    }),
                    class: "v-table-virtual-spacer"
                  }, null, 4)) : P("", !0),
                  W.value && e.totalRow ? (b(), T($e, { key: 2 }, [
                    v(wt).isEnabled.value ? (b(), T("div", g2)) : P("", !0),
                    (b(!0), T($e, null, Oe(pe.value, (Pe, ft) => (b(), ce(yu, {
                      key: Pe.key,
                      align: Pe.align,
                      class: j([qt(Pe), "v-table-total-cell"]),
                      style: Fe(v(A)(Pe))
                    }, {
                      default: ue(() => [
                        E("div", y2, [
                          ft === 0 && Qt.value ? (b(), T("div", b2)) : P("", !0),
                          E("div", {
                            class: j([{ "v-table-total-text--truncate": !Pe.interactive }, "v-table-total-text"])
                          }, [
                            U(re.$slots, `total-cell-${Pe.key}`, {
                              column: Pe,
                              row: e.totalRow,
                              value: e.totalRow[Pe.key]
                            }, () => [
                              se(FT, {
                                class: j(v(sr)(e.totalRow[Pe.key], Pe, e.totalRow)),
                                interactive: Pe.interactive,
                                value: v(ar)(e.totalRow[Pe.key], Pe, e.totalRow)
                              }, null, 8, ["class", "interactive", "value"])
                            ])
                          ], 2)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["align", "class", "style"]))), 128))
                  ], 64)) : P("", !0)
                ], 6)
              ], 38)
            ]),
            e.pagination ? (b(), ce(DM, {
              key: 2,
              ref: "pagination",
              loading: e.loading,
              page: fe.value,
              "page-size": Re.value,
              "page-size-options": e.pagination.pageSizeOptions || [10, 25, 50, 100],
              "show-size-changer": Ce.value,
              total: e.pagination.total,
              onPageChange: Ea
            }, null, 8, ["loading", "page", "page-size", "page-size-options", "show-size-changer", "total"])) : P("", !0)
          ], 16)
        ], 8, ["disabled"])),
        v(y) ? (b(), T("div", {
          key: 0,
          ref: "fullscreenPlaceholder",
          class: j($.value),
          style: Fe(C.value),
          "aria-hidden": "true"
        }, null, 6)) : P("", !0)
      ], 64);
    };
  }
}), x2 = /* @__PURE__ */ ke({
  __name: "DeltaValue",
  props: {
    value: { default: void 0 },
    delta: { default: void 0 },
    format: { default: void 0 },
    deltaFormat: { default: void 0 },
    deltaAsPercentage: { type: Boolean, default: !0 },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showZeroDelta: { type: Boolean, default: !0 },
    modern: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const n = e, t = Oa(), a = S(() => n.modern ?? t.value), s = S(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta < 0 : n.delta > 0), l = S(() => n.delta === null || n.delta === void 0 ? null : n.reverse ? n.delta > 0 : n.delta < 0), r = S(() => n.delta === 0), i = S(() => n.delta === null || n.delta === void 0 ? !1 : n.showZeroDelta || n.delta !== 0), o = S(() => {
      var f;
      if (n.delta === null || n.delta === void 0) return "";
      const d = Math.abs(n.delta);
      if (n.deltaFormat) {
        const { type: w = "number", decimals: m = 0, currencyCode: k = "USD" } = n.deltaFormat;
        switch (w) {
          case "currency":
            return new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: k,
              minimumFractionDigits: m,
              maximumFractionDigits: m
            }).format(d);
          case "percentage":
            return `${new Intl.NumberFormat("en-US", {
              minimumFractionDigits: m,
              maximumFractionDigits: m
            }).format(d)}%`;
          default:
            return new Intl.NumberFormat("en-US", {
              minimumFractionDigits: m,
              maximumFractionDigits: m
            }).format(d);
        }
      }
      const p = d.toFixed(((f = n.format) == null ? void 0 : f.decimals) ?? 0);
      return n.deltaAsPercentage ? `${p}%` : p;
    }), u = S(() => {
      if (n.value === null || n.value === void 0) return null;
      if (typeof n.value == "string") return n.value;
      const { type: d = "number", decimals: p = 0, currencyCode: f = "USD" } = n.format || {};
      switch (d) {
        case "currency":
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: f,
            minimumFractionDigits: p,
            maximumFractionDigits: p
          }).format(n.value);
        case "percentage":
          return `${new Intl.NumberFormat("en-US", {
            minimumFractionDigits: p,
            maximumFractionDigits: p
          }).format(n.value)}%`;
        default:
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: p,
            maximumFractionDigits: p
          }).format(n.value);
      }
    }), c = S(() => {
      if (a.value)
        switch (n.size) {
          case "sm":
            return { value: "delta-value__value--sm", delta: "delta-value__delta--sm", icon: 11 };
          case "lg":
            return { value: "delta-value__value--lg", delta: "delta-value__delta--lg", icon: 14 };
          default:
            return { value: "", delta: "", icon: 12 };
        }
      switch (n.size) {
        case "sm":
          return {
            value: "text-sm",
            delta: "text-xs",
            icon: 14
          };
        case "lg":
          return {
            value: "text-lg font-semibold",
            delta: "text-sm",
            icon: 20
          };
        default:
          return {
            value: "text-base",
            delta: "text-sm",
            icon: 16
          };
      }
    });
    return (d, p) => (b(), T("div", {
      class: j(["delta-value flex flex-col", { "delta-value--modern": a.value }])
    }, [
      u.value !== null ? (b(), T("span", {
        key: 0,
        class: j([c.value.value, "text-mainText"])
      }, le(u.value), 3)) : P("", !0),
      i.value ? (b(), T("div", {
        key: 1,
        class: j([c.value.delta, "flex items-center gap-0.5"])
      }, [
        s.value ? (b(), ce(v(ye), {
          key: 0,
          size: c.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : l.value ? (b(), ce(v(ye), {
          key: 1,
          size: c.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : r.value ? (b(), ce(v(ye), {
          key: 2,
          size: c.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : P("", !0),
        E("span", {
          class: j({
            "text-success": s.value,
            "text-negative": l.value,
            "text-secondaryText": r.value
          })
        }, le(o.value), 3)
      ], 2)) : P("", !0)
    ], 2));
  }
}), k_ = /* @__PURE__ */ Le(x2, [["__scopeId", "data-v-8b50e3f4"]]), x_ = /* @__PURE__ */ ke({
  __name: "DeltaIndicator",
  props: {
    value: { default: 0 },
    format: { default: () => {
    } },
    reverse: { type: Boolean, default: !1 },
    size: { default: "default" },
    showIcon: { type: Boolean, default: !0 },
    showZero: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = S(
      () => e.value !== null && e.value !== void 0
    ), t = S(
      () => n.value && (e.showZero || e.value !== 0)
    ), a = S(() => n.value ? e.reverse ? e.value < 0 : e.value > 0 : null), s = S(() => n.value ? e.reverse ? e.value > 0 : e.value < 0 : null), l = S(() => e.value === 0), r = S(() => {
      if (!n.value) return "";
      const o = e.format;
      if (!o) return String(e.value);
      if (o.currency !== void 0) {
        if (typeof o.currency == "object") {
          const { code: u, decimals: c } = o.currency;
          return Is(e.value, { code: u, decimals: c });
        }
        return typeof o.currency == "string" ? Is(e.value, o.currency) : Is(e.value);
      }
      return o.percentage !== void 0 ? Ni(e.value, o.percentage === !0 ? void 0 : o.percentage) : o.number !== void 0 ? aa(e.value, o.number) : String(e.value);
    }), i = S(() => {
      switch (e.size) {
        case "sm":
          return { text: "text-xs", icon: 12 };
        case "lg":
          return { text: "text-sm font-semibold", icon: 18 };
        default:
          return { text: "text-sm", icon: 14 };
      }
    });
    return (o, u) => t.value ? (b(), T("div", {
      key: 0,
      class: j([i.value.text, "flex items-center gap-0.5"])
    }, [
      e.showIcon ? (b(), T($e, { key: 0 }, [
        a.value ? (b(), ce(v(ye), {
          key: 0,
          size: i.value.icon,
          color: "text-success",
          icon: "lucide:arrow-up"
        }, null, 8, ["size"])) : s.value ? (b(), ce(v(ye), {
          key: 1,
          size: i.value.icon,
          color: "text-negative",
          icon: "lucide:arrow-down"
        }, null, 8, ["size"])) : l.value ? (b(), ce(v(ye), {
          key: 2,
          size: i.value.icon,
          color: "text-secondaryText",
          icon: "lucide:minus"
        }, null, 8, ["size"])) : P("", !0)
      ], 64)) : P("", !0),
      E("span", {
        class: j({
          "text-success": a.value,
          "text-negative": s.value,
          "text-secondaryText": l.value
        })
      }, le(r.value), 3)
    ], 2)) : P("", !0);
  }
}), S2 = { class: "v-table-title-block" }, $2 = { class: "v-table-title-block__title-section" }, T2 = {
  key: 1,
  class: "v-table-title-block__title"
}, C2 = {
  key: 2,
  class: "v-table-title-block__separator"
}, M2 = {
  key: 0,
  class: "v-table-title-block__actions"
}, D2 = /* @__PURE__ */ ke({
  __name: "TableTitleBlock",
  props: {
    title: { default: "" },
    icon: { default: "" }
  },
  setup(e) {
    return (n, t) => (b(), T("div", S2, [
      E("div", $2, [
        e.icon ? (b(), ce(v(ye), {
          key: 0,
          icon: e.icon,
          size: 20,
          class: "v-table-title-block__icon"
        }, null, 8, ["icon"])) : P("", !0),
        e.title ? (b(), T("h3", T2, le(e.title), 1)) : P("", !0),
        e.title && n.$slots.default ? (b(), T("span", C2)) : P("", !0)
      ]),
      n.$slots.default ? (b(), T("div", M2, [
        U(n.$slots, "default", {}, void 0, !0)
      ])) : P("", !0)
    ]));
  }
}), S_ = /* @__PURE__ */ Le(D2, [["__scopeId", "data-v-c3a3c2e6"]]);
function _2(e) {
  const {
    granularity: n,
    dateRange: t,
    includeSummary: a = !1,
    onPeriodChange: s
  } = e, l = J(null), r = J(!0), i = S(() => {
    const m = n.value, k = [], y = m === "MONTH" ? "All Months" : m === "WEEK" ? "All Weeks" : "All Days";
    return k.push({ label: y, value: "all" }), a && k.push({ label: "Summary", value: "summary" }), m === "MONTH" ? k.push(...u()) : m === "WEEK" ? k.push(...c()) : m === "DAY" && k.push(...d()), k;
  }), o = S(() => i.value[0]);
  function u() {
    const { since: m, until: k } = t.value, y = Ie.fromISO(m, { zone: "utc" }), h = Ie.fromISO(k, { zone: "utc" }), g = [];
    let x = y.startOf("month");
    for (; x <= h; )
      g.push({
        label: x.toFormat("MMMM yyyy"),
        value: x.toISODate()
      }), x = x.plus({ months: 1 });
    return g.sort(
      ($, C) => Ie.fromISO(C.value).toMillis() - Ie.fromISO($.value).toMillis()
    );
  }
  function c() {
    const { since: m, until: k } = t.value, y = Ie.fromISO(m, { zone: "utc" }), h = Ie.fromISO(k, { zone: "utc" }), g = Ie.utc().startOf("day"), x = [];
    let $ = y.startOf("week").plus({ days: 6 });
    for (; $ <= h && $ < g; )
      x.push({
        label: $.toFormat("MM/dd/yyyy"),
        value: $.toISODate()
      }), $ = $.plus({ weeks: 1 });
    return x.sort(
      (C, O) => Ie.fromISO(O.value).toMillis() - Ie.fromISO(C.value).toMillis()
    );
  }
  function d() {
    const { since: m, until: k } = t.value, y = Ie.fromISO(m, { zone: "utc" }), h = Ie.fromISO(k, { zone: "utc" }), g = Ie.utc().startOf("day"), x = [];
    let $ = y;
    for (; $ <= h && $ < g; )
      x.push({
        label: $.toFormat("MM/dd/yyyy"),
        value: $.toISODate()
      }), $ = $.plus({ days: 1 });
    return x.sort(
      (C, O) => Ie.fromISO(O.value).toMillis() - Ie.fromISO(C.value).toMillis()
    );
  }
  const p = S(() => {
    var y;
    const m = (y = l.value) == null ? void 0 : y.value;
    if (!m || m === "all" || m === "summary")
      return {};
    const k = n.value;
    if (k === "MONTH") {
      const g = Ie.fromISO(m, { zone: "utc" }).endOf("month");
      return {
        period: {
          since: m,
          until: g.toISODate()
        }
      };
    }
    if (k === "WEEK") {
      const h = Ie.fromISO(m, { zone: "utc" });
      return {
        period: {
          since: m,
          until: h.plus({ days: 6 }).toISODate()
        }
      };
    }
    return k === "DAY" ? {
      period: {
        since: m,
        until: m
      }
    } : {};
  }), f = (m) => {
    l.value = m, r.value = m.value !== "summary", s && s(p.value, r.value);
  }, w = async () => {
    l.value = o.value, r.value = !0, s && s(p.value, r.value);
  };
  return Ne(
    () => [n.value, t.value],
    () => {
      w();
    },
    { flush: "pre", deep: !0 }
  ), l.value || (l.value = o.value), {
    /** Currently selected period */
    selectedPeriod: l,
    /** Available period options for dropdown */
    periodOptions: i,
    /** Default period option */
    defaultPeriod: o,
    /** Request params to spread into API call */
    periodRequestParams: p,
    /** Whether to group by date (false when "Summary" is selected) */
    isGroupByDate: r,
    /** Handle period selection change */
    handlePeriodChange: f,
    /** Reset to default period */
    resetPeriod: w
  };
}
const O2 = { class: "w-[160px]" }, $_ = /* @__PURE__ */ ke({
  __name: "TablePeriodSelect",
  props: {
    granularity: {},
    dateRange: {},
    includeSummary: { type: Boolean, default: !1 },
    widthClass: { default: "w-40" },
    placeholder: { default: "Select period" },
    modern: { type: Boolean, default: void 0 }
  },
  emits: ["change"],
  setup(e, { expose: n, emit: t }) {
    const a = e, s = Oa(), l = S(() => a.modern ?? s.value), r = t, {
      selectedPeriod: i,
      periodOptions: o,
      periodRequestParams: u,
      isGroupByDate: c,
      handlePeriodChange: d
    } = _2({
      granularity: kl(a, "granularity"),
      dateRange: kl(a, "dateRange"),
      includeSummary: a.includeSummary,
      onPeriodChange: () => {
        p();
      }
    }), p = () => {
      r("change", {
        selected: i.value,
        requestParams: u.value,
        isGroupByDate: c.value
      });
    }, f = (w) => {
      d(w);
    };
    return n({
      selectedPeriod: i,
      periodRequestParams: u,
      isGroupByDate: c
    }), (w, m) => (b(), T("div", O2, [
      se(v(Nx), lt({
        modelValue: v(i),
        "onUpdate:modelValue": m[0] || (m[0] = (k) => Fu(i) ? i.value = k : null),
        class: e.widthClass,
        "close-on-select": !0,
        modern: l.value,
        options: v(o),
        placeholder: e.placeholder,
        searchable: !1
      }, w.$attrs, { onSelect: f }), null, 16, ["modelValue", "class", "modern", "options", "placeholder"])
    ]));
  }
}), E2 = /* @__PURE__ */ ke({
  __name: "TableExpandAdditionalHeadersButton",
  props: {
    isExpanded: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n;
    return (a, s) => (b(), T("button", {
      class: j([{ "is-expanded": e.isExpanded }, "expand-button"]),
      type: "button",
      onClick: s[0] || (s[0] = Ve((l) => t("click"), ["stop"]))
    }, [
      se(v(ye), {
        size: 16,
        class: "expand-icon",
        icon: "lucide:chevron-right"
      })
    ], 2));
  }
}), T_ = /* @__PURE__ */ Le(E2, [["__scopeId", "data-v-41dc3668"]]), ha = /* @__PURE__ */ new Map(), C_ = (e, n, t) => {
  const a = (t == null ? void 0 : t.paginationMode) === "sync" ? t.totalPages : void 0, s = (t == null ? void 0 : t.paginationMode) ?? "independent", l = (t == null ? void 0 : t.initialPage) ?? 1, r = t == null ? void 0 : t.namespace, i = r ? `${r}:${e}` : e, o = n.filter((h) => h !== e), u = J(l), c = J(null), d = {
    scrollEl: null,
    scrollPosition: c,
    isReceivingScroll: !1,
    pendingScrollX: 0,
    pendingScrollY: 0,
    scrollRafId: null,
    page: u,
    paginationMode: s,
    totalPages: a,
    receiveHighlight: null,
    isReceivingHighlight: !1
  };
  ha.set(i, d);
  const p = (h) => r ? `${r}:${h}` : h, f = {
    register: (h) => {
      d.scrollEl = h;
      for (const g of o) {
        const x = ha.get(p(g));
        if (x != null && x.scrollEl) {
          h.scrollLeft = x.scrollEl.scrollLeft, h.scrollTop = x.scrollEl.scrollTop;
          break;
        }
      }
    },
    unregister: () => {
      d.scrollEl = null;
    },
    onScroll: (h, g) => {
      d.isReceivingScroll || o.forEach((x) => {
        const $ = ha.get(p(x));
        !$ || !$.scrollEl || $.scrollEl.scrollLeft === h && $.scrollEl.scrollTop === g || ($.pendingScrollX = h, $.pendingScrollY = g, $.scrollRafId === null && ($.scrollRafId = requestAnimationFrame(() => {
          $.scrollRafId = null, $.scrollEl && ($.isReceivingScroll = !0, $.scrollEl.scrollLeft = $.pendingScrollX, $.scrollEl.scrollTop = $.pendingScrollY, requestAnimationFrame(() => {
            $.isReceivingScroll = !1;
          }));
        })));
      });
    },
    scrollPosition: c
  }, w = {
    register: (h) => {
      d.receiveHighlight = h;
    },
    unregister: () => {
      d.receiveHighlight = null;
    },
    // No rAF throttling here, unlike onScroll: this fires once per click.
    broadcast: (h) => {
      d.isReceivingHighlight || o.forEach((g) => {
        const x = ha.get(p(g));
        x != null && x.receiveHighlight && (x.isReceivingHighlight = !0, x.receiveHighlight(h), x.isReceivingHighlight = !1);
      });
    }
  }, m = (h) => {
    u.value = h, o.forEach((g) => {
      const x = ha.get(p(g));
      if (!(!x || x.paginationMode === "independent")) {
        if (x.paginationMode === "reset") {
          x.page.value = 1;
          return;
        }
        x.totalPages && (x.page.value = Math.min(h, x.totalPages.value));
      }
    });
  }, k = (h = 1) => {
    var g;
    d.page.value = h, d.scrollPosition.value = null, (g = d.receiveHighlight) == null || g.call(d, { rowId: null, columnKey: null }), d.scrollEl && (d.scrollEl.scrollLeft = 0, d.scrollEl.scrollTop = 0), o.forEach((x) => {
      var C;
      const $ = ha.get(p(x));
      $ && ($.page.value = h, $.scrollPosition.value = null, (C = $.receiveHighlight) == null || C.call($, { rowId: null, columnKey: null }), $.scrollEl && ($.scrollEl.scrollLeft = 0, $.scrollEl.scrollTop = 0));
    });
  }, y = t == null ? void 0 : t.resetOn;
  return y !== void 0 && Ne(() => Qe(y), () => k()), Al(() => {
    ha.delete(i);
  }), {
    // markRaw prevents reactive() from deep-wrapping the controllers
    link: ka({
      scrollSync: Ui(f),
      highlightSync: Ui(w),
      page: u,
      "onUpdate:page": m
    }),
    resetState: k
  };
};
function M_(e, n = 100, t = !1) {
  const a = Math.max(0, Math.min(1, e / n)), s = Math.round(t ? 255 * a : 255 * (1 - a)), l = Math.round(t ? 255 * (1 - a) : 255 * a);
  return `rgba(${s}, ${l}, 0, 0.4)`;
}
function D_(e) {
  const n = Math.max(0, Math.min(100, e)), t = Math.round(255 * (100 - n) / 100), a = Math.round(255 * n / 100);
  return `bg-[rgb(${t},${a},0)]`;
}
const __ = () => ({
  success: (i, o) => {
    fa.success(i, {
      description: o,
      duration: 4e3
    });
  },
  error: (i, o) => {
    fa.error(i, {
      description: o,
      duration: 5e3
    });
  },
  warning: (i, o) => {
    fa.warning(i, {
      description: o,
      duration: 4e3
    });
  },
  info: (i, o) => {
    fa.info(i, {
      description: o,
      duration: 4e3
    });
  },
  promise: (i, o) => fa.promise(i, o),
  custom: (i, o) => fa(i, o),
  dismiss: (i) => {
    fa.dismiss(i);
  }
}), wf = Symbol("SidebarState");
function I2(e) {
  const n = S(
    () => Fu(e.items) ? e.items.value : e.items
  ), t = () => {
    e.isCollapsed.value = !e.isCollapsed.value;
  }, a = (u) => {
    const c = e.expandedItems.value;
    c.has(u) ? c.delete(u) : c.add(u), e.expandedItems.value = new Set(c);
  }, s = (u) => {
    if (!u.length) return;
    const c = new Set(e.expandedItems.value);
    u.forEach((d) => c.add(d)), e.expandedItems.value = c;
  }, l = (u) => e.expandedItems.value.has(u), r = () => {
    e.isMobileOpen.value = !0;
  }, i = () => {
    e.isMobileOpen.value = !1;
  }, o = () => {
    e.isMobileOpen.value = !e.isMobileOpen.value;
  };
  return {
    isCollapsed: e.isCollapsed,
    isMobileOpen: e.isMobileOpen,
    expandedItems: e.expandedItems,
    resolvedItems: n,
    options: e.options,
    toggleCollapse: t,
    toggleExpanded: a,
    expandMany: s,
    isExpanded: l,
    openMobile: r,
    closeMobile: i,
    toggleMobile: o
  };
}
function ds() {
  const e = bn(wf);
  if (!e)
    throw new Error(
      '[NavigationSidebar] useSidebarState() called outside of <NavigationSidebar>. Make sure the component is wrapped in <NavigationSidebar :sidebar="...">.'
    );
  return e;
}
function kf(e, n = []) {
  const t = ui();
  return { resolvedTo: S(() => {
    const s = e.to;
    if (!s) return;
    if (!n.length) return s;
    const l = {};
    for (const r of n) {
      const i = t.query[r];
      i != null && (l[r] = Array.isArray(i) ? i[0] ?? "" : i);
    }
    return Object.keys(l).length ? typeof s == "string" ? { path: s, query: l } : {
      ...s,
      query: {
        ...l,
        ...s.query ?? {}
      }
    } : s;
  }) };
}
const A2 = { class: "sidebar-flyout__item-label" }, P2 = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, R2 = /* @__PURE__ */ ke({
  __name: "SidebarMenuFlyoutItem",
  props: {
    item: {}
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, { isActive: a, onPrefetch: s, options: l } = ds(), { resolvedTo: r } = kf(e.item, l.persistentQueryParams), i = S(() => a(e.item.id)), o = S(() => ({
      "sidebar-flyout__item--active": i.value,
      "sidebar-flyout__item--disabled": e.item.disabled
    })), u = () => {
      e.item.disabled || !r.value || s(r.value);
    }, c = () => {
      e.item.disabled || t("click", e.item);
    };
    return (d, p) => {
      const f = Lu("router-link");
      return e.item.to ? (b(), ce(f, {
        key: 0,
        "aria-current": i.value ? "page" : void 0,
        class: j([o.value, "sidebar-flyout__item"]),
        style: Fe(`--depth: ${e.item.level}`),
        to: v(r),
        onClick: c,
        onMouseenter: u
      }, {
        default: ue(() => [
          e.item.icon ? (b(), ce(ye, {
            key: 0,
            icon: e.item.icon,
            size: 15,
            class: "sidebar-flyout__item-icon"
          }, null, 8, ["icon"])) : P("", !0),
          E("span", A2, le(e.item.label), 1),
          e.item.badge ? (b(), T("span", P2, le(e.item.badge), 1)) : P("", !0)
        ]),
        _: 1
      }, 8, ["aria-current", "class", "style", "to"])) : P("", !0);
    };
  }
}), V2 = { class: "sidebar-flyout__item-label" }, F2 = {
  key: 1,
  class: "sidebar-flyout__item-badge"
}, L2 = /* @__PURE__ */ ke({
  __name: "SidebarMenuFlyoutParent",
  props: {
    item: {}
  },
  setup(e) {
    return (n, t) => (b(), T("div", {
      style: Fe(`--depth: ${e.item.level}`),
      class: "sidebar-flyout__item sidebar-flyout__item--parent"
    }, [
      e.item.icon ? (b(), ce(ye, {
        key: 0,
        icon: e.item.icon,
        size: 15,
        class: "sidebar-flyout__item-icon"
      }, null, 8, ["icon"])) : P("", !0),
      E("span", V2, le(e.item.label), 1),
      e.item.badge ? (b(), T("span", F2, le(e.item.badge), 1)) : P("", !0)
    ], 4));
  }
}), N2 = { class: "sidebar-flyout" }, z2 = { class: "sidebar-flyout__title" }, B2 = { class: "sidebar-flyout__list" }, Ou = 16, W2 = /* @__PURE__ */ ke({
  __name: "SidebarMenuFlyout",
  props: {
    item: {}
  },
  setup(e) {
    const { closeMobile: n } = ds(), t = J(!1), a = J(null), s = J(null), l = J({ top: 0, left: 0, right: 0 }), r = J(!1), { width: i, height: o } = hm(), u = () => {
      if (!a.value || !s.value) return;
      const h = a.value.getBoundingClientRect(), g = s.value.getBoundingClientRect(), x = h.right + 8, $ = s.value.offsetHeight, C = Math.max(
        Ou,
        Math.min(h.top, o.value - Ou - $)
      );
      x + g.width > i.value - 20 ? (r.value = !0, l.value = {
        top: C,
        right: i.value - h.left + 8,
        left: 0
      }) : (r.value = !1, l.value = { top: C, left: x, right: 0 });
    };
    Ne([i, o], () => {
      t.value && u();
    });
    const { start: c, stop: d } = Fr(async () => {
      t.value = !0, await Ke(), requestAnimationFrame(u);
    }, 150, { immediate: !1 }), { start: p, stop: f } = Fr(() => {
      t.value = !1;
    }, 100, { immediate: !1 }), w = () => {
      if (f(), !t.value) {
        if (a.value) {
          const h = a.value.getBoundingClientRect();
          l.value = { top: h.top, left: h.right + 8, right: 0 };
        }
        c();
      }
    }, m = () => {
      d(), p();
    }, k = S(() => {
      const h = (g, x = 0) => {
        var C;
        const $ = [];
        for (const O of g)
          $.push({ ...O, level: x }), (C = O.children) != null && C.length && $.push(...h(O.children, x + 1));
        return $;
      };
      return e.item.children ? h(e.item.children) : [];
    }), y = (h) => {
      h.disabled || (n(), t.value = !1);
    };
    return (h, g) => (b(), T("div", {
      ref_key: "buttonRef",
      ref: a,
      class: "sidebar-flyout-trigger",
      onMouseenter: w,
      onMouseleave: m
    }, [
      U(h.$slots, "default", {}, void 0, !0),
      (b(), ce(Pn, { to: "body" }, [
        se(ht, {
          "enter-active-class": "sidebar-flyout-enter-active",
          "enter-from-class": "sidebar-flyout-enter-from",
          "enter-to-class": "sidebar-flyout-enter-to",
          "leave-active-class": "sidebar-flyout-leave-active",
          "leave-from-class": "sidebar-flyout-leave-from",
          "leave-to-class": "sidebar-flyout-leave-to"
        }, {
          default: ue(() => {
            var x;
            return [
              t.value && ((x = e.item.children) != null && x.length) ? (b(), T("div", {
                key: 0,
                style: Fe({
                  top: `${l.value.top}px`,
                  ...r.value ? { right: `${l.value.right - 8}px` } : { left: `${l.value.left - 8}px` }
                }),
                class: j([{ "sidebar-flyout-portal--left": r.value }, "sidebar-flyout-portal"]),
                onMouseenter: w,
                onMouseleave: m
              }, [
                E("div", {
                  class: j([r.value ? "sidebar-flyout-bridge--left" : "sidebar-flyout-bridge--right", "sidebar-flyout-bridge"])
                }, null, 2),
                E("div", {
                  ref_key: "flyoutRef",
                  ref: s,
                  class: "sidebar-flyout-content"
                }, [
                  E("div", N2, [
                    E("div", z2, le(e.item.label), 1),
                    E("div", B2, [
                      (b(!0), T($e, null, Oe(k.value, ($) => (b(), T($e, {
                        key: $.id
                      }, [
                        $.to ? (b(), ce(R2, {
                          key: 0,
                          item: $,
                          onClick: y
                        }, null, 8, ["item"])) : (b(), ce(L2, {
                          key: 1,
                          item: $
                        }, null, 8, ["item"]))
                      ], 64))), 128))
                    ])
                  ])
                ], 512)
              ], 38)) : P("", !0)
            ];
          }),
          _: 1
        })
      ]))
    ], 544));
  }
}), Y2 = /* @__PURE__ */ Le(W2, [["__scopeId", "data-v-224b195a"]]), H2 = ["aria-label"], U2 = ["title"], q2 = {
  key: 1,
  class: "sidebar-item__badge"
}, j2 = { class: "sidebar-item-children__inner" }, G2 = /* @__PURE__ */ ke({
  __name: "SidebarNavItem",
  props: {
    item: {},
    level: { default: 0 }
  },
  setup(e) {
    const {
      isCollapsed: n,
      isExpanded: t,
      toggleExpanded: a,
      closeMobile: s,
      isActive: l,
      isOnActivePath: r,
      onPrefetch: i,
      options: o
    } = ds(), { resolvedTo: u } = kf(e.item, o.persistentQueryParams), c = Ge("label"), d = J(!1), p = S(() => {
      var $;
      return !!(($ = e.item.children) != null && $.length);
    }), f = S(() => p.value && t(e.item.id)), w = S(() => l(e.item.id)), m = S(
      () => !w.value && p.value && r(e.item.id)
    ), k = () => {
      p.value || e.item.disabled || !u.value || i(u.value);
    }, y = () => {
      const $ = c.value;
      $ && (d.value = $.scrollWidth > $.clientWidth);
    }, h = () => {
      if (!e.item.disabled) {
        if (e.item.onClick) {
          e.item.onClick(), s();
          return;
        }
        p.value ? a(e.item.id) : s();
      }
    }, g = S(() => e.item.icon ?? null), x = S(() => ({
      "sidebar-item--active": w.value,
      "sidebar-item--has-active-child": m.value,
      "sidebar-item--disabled": e.item.disabled,
      "sidebar-item--collapsed": n.value,
      "sidebar-item--nested": e.level > 0,
      "sidebar-item--no-icon": !g.value
    }));
    return ($, C) => {
      const O = Lu("SidebarNavItem", !0);
      return b(), T("div", {
        style: Fe(`--depth: ${e.level}`),
        class: "sidebar-item-wrapper"
      }, [
        v(n) && p.value && !e.item.disabled ? (b(), ce(Y2, {
          key: 0,
          item: e.item
        }, {
          default: ue(() => [
            E("button", {
              "aria-label": e.item.label,
              class: j([{
                "sidebar-item--active": w.value,
                "sidebar-item--has-active-child": m.value
              }, "sidebar-item sidebar-item--collapsed"]),
              type: "button",
              onClick: h
            }, [
              e.item.icon ? (b(), ce(ye, {
                key: 0,
                icon: e.item.icon,
                size: 15,
                class: "sidebar-item__icon"
              }, null, 8, ["icon"])) : P("", !0)
            ], 10, H2)
          ]),
          _: 1
        }, 8, ["item"])) : v(n) && !e.item.disabled ? (b(), ce(xa, {
          key: 1,
          delay: 200,
          text: e.item.label,
          placement: "right"
        }, {
          default: ue(() => [
            (b(), ce(mt(e.item.to ? "router-link" : "button"), {
              "aria-label": e.item.label,
              class: j([{ "sidebar-item--active": w.value }, "sidebar-item sidebar-item--collapsed"]),
              disabled: e.item.disabled || void 0,
              to: e.item.to ? v(u) : void 0,
              type: e.item.to ? void 0 : "button",
              onClick: h,
              onMouseenter: k
            }, {
              default: ue(() => [
                e.item.icon ? (b(), ce(ye, {
                  key: 0,
                  icon: e.item.icon,
                  size: 15,
                  class: "sidebar-item__icon"
                }, null, 8, ["icon"])) : P("", !0)
              ]),
              _: 1
            }, 40, ["aria-label", "class", "disabled", "to", "type"]))
          ]),
          _: 1
        }, 8, ["text"])) : (b(), ce(mt(p.value || !e.item.to ? "button" : "router-link"), {
          key: 2,
          "aria-current": w.value ? "page" : void 0,
          "aria-expanded": p.value ? f.value : void 0,
          "aria-label": e.item.label,
          class: j([x.value, "sidebar-item"]),
          disabled: e.item.disabled || void 0,
          to: !p.value && e.item.to ? v(u) : void 0,
          type: p.value || !e.item.to ? "button" : void 0,
          onClick: h,
          onMouseenter: k
        }, {
          default: ue(() => [
            g.value ? (b(), ce(ye, {
              key: 0,
              icon: g.value,
              size: 15,
              class: "sidebar-item__icon"
            }, null, 8, ["icon"])) : P("", !0),
            se(ht, {
              "enter-active-class": "sidebar-label-enter-active",
              "enter-from-class": "sidebar-label-enter-from",
              "enter-to-class": "sidebar-label-enter-to",
              "leave-active-class": "sidebar-label-leave-active",
              "leave-from-class": "sidebar-label-leave-from",
              "leave-to-class": "sidebar-label-leave-to"
            }, {
              default: ue(() => [
                v(n) ? P("", !0) : (b(), T("span", {
                  key: 0,
                  ref: "label",
                  title: d.value ? e.item.label : void 0,
                  class: "sidebar-item__label",
                  onMouseenter: y
                }, le(e.item.label), 41, U2))
              ]),
              _: 1
            }),
            e.item.badge && !v(n) ? (b(), T("span", q2, le(e.item.badge), 1)) : P("", !0),
            p.value && !v(n) ? (b(), ce(ye, {
              key: 2,
              class: j([{ "sidebar-item__chevron--expanded": f.value }, "sidebar-item__chevron"]),
              size: 14,
              icon: "lucide:chevron-right"
            }, null, 8, ["class"])) : P("", !0)
          ]),
          _: 1
        }, 40, ["aria-current", "aria-expanded", "aria-label", "class", "disabled", "to", "type"])),
        p.value && !v(n) ? (b(), T("div", {
          key: 3,
          class: j([{ "sidebar-item-children--expanded": f.value }, "sidebar-item-children"])
        }, [
          E("div", j2, [
            (b(!0), T($e, null, Oe(e.item.children, (_) => (b(), ce(O, {
              key: _.id,
              item: _,
              level: e.level + 1
            }, null, 8, ["item", "level"]))), 128))
          ])
        ], 2)) : P("", !0)
      ], 4);
    };
  }
}), xf = /* @__PURE__ */ Le(G2, [["__scopeId", "data-v-0acaee3e"]]), K2 = {
  key: 0,
  class: "v-sidebar-footer__slot"
}, Z2 = {
  key: 1,
  class: "v-sidebar-footer__nav"
}, X2 = {
  key: 2,
  class: "v-sidebar-footer__slot"
}, J2 = /* @__PURE__ */ ke({
  __name: "SidebarFooter",
  props: {
    items: { default: () => [] }
  },
  setup(e) {
    const { isCollapsed: n } = ds();
    return (t, a) => (b(), T("div", {
      class: j([{ "v-sidebar-footer--collapsed": v(n) }, "v-sidebar-footer"])
    }, [
      t.$slots.start ? (b(), T("div", K2, [
        U(t.$slots, "start")
      ])) : P("", !0),
      e.items.length ? (b(), T("nav", Z2, [
        (b(!0), T($e, null, Oe(e.items, (s) => (b(), ce(xf, {
          key: s.id,
          item: s,
          level: 0
        }, null, 8, ["item"]))), 128))
      ])) : P("", !0),
      t.$slots.end ? (b(), T("div", X2, [
        U(t.$slots, "end")
      ])) : P("", !0)
    ], 2));
  }
}), Q2 = {
  key: 0,
  class: "sidebar-header__brand"
}, eD = {
  key: 0,
  class: "sidebar-header__logo"
}, tD = ["alt", "src"], nD = {
  key: 1,
  "aria-hidden": "true",
  class: "sidebar-header__mark"
}, aD = { class: "sidebar-header__name" }, sD = { class: "sidebar-header__controls" }, lD = ["aria-label"], rD = { class: "sidebar-header__toggle-icons" }, iD = /* @__PURE__ */ ke({
  __name: "SidebarHeader",
  setup(e) {
    var l;
    const { isCollapsed: n, toggleCollapse: t, options: a } = ds(), s = ((l = a.brandName) == null ? void 0 : l.trim().charAt(0).toUpperCase()) ?? "";
    return (r, i) => (b(), T("div", {
      class: j([{ "sidebar-header--collapsed": v(n) }, "sidebar-header"])
    }, [
      se(ht, {
        "enter-active-class": "sidebar-label-enter-active",
        "enter-from-class": "sidebar-label-enter-from",
        "enter-to-class": "sidebar-label-enter-to",
        "leave-active-class": "sidebar-label-leave-active",
        "leave-from-class": "sidebar-label-leave-from",
        "leave-to-class": "sidebar-label-leave-to"
      }, {
        default: ue(() => [
          v(n) ? P("", !0) : (b(), T("div", Q2, [
            U(r.$slots, "start", {}, () => [
              v(a).logoUrl ? (b(), T("div", eD, [
                E("img", {
                  alt: v(a).brandName,
                  src: v(a).logoUrl
                }, null, 8, tD)
              ])) : v(s) ? (b(), T("span", nD, le(v(s)), 1)) : P("", !0),
              E("span", aD, le(v(a).brandName), 1)
            ], !0)
          ]))
        ]),
        _: 3
      }),
      E("div", sD, [
        U(r.$slots, "end", {}, void 0, !0),
        E("button", {
          "aria-label": v(n) ? "Expand sidebar" : "Collapse sidebar",
          class: j([{ "sidebar-header__toggle--collapsed": v(n) }, "sidebar-header__toggle"]),
          type: "button",
          onClick: i[0] || (i[0] = //@ts-ignore
          (...o) => v(t) && v(t)(...o))
        }, [
          E("span", rD, [
            se(ye, {
              size: 15,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--close",
              icon: "lucide:panel-left-close"
            }),
            se(ye, {
              size: 15,
              class: "sidebar-header__toggle-icon sidebar-header__toggle-icon--open",
              icon: "lucide:panel-left-open"
            })
          ])
        ], 10, lD)
      ])
    ], 2));
  }
}), oD = /* @__PURE__ */ Le(iD, [["__scopeId", "data-v-14b770dc"]]), uD = { class: "sidebar-nav__list" }, cD = /* @__PURE__ */ ke({
  __name: "SidebarNav",
  setup(e) {
    const {
      resolvedItems: n,
      isCollapsed: t,
      expandedItems: a,
      activeItemId: s
    } = ds();
    return (l, r) => (b(), T("nav", {
      class: j([{ "sidebar-nav--collapsed": v(t) }, "sidebar-nav"])
    }, [
      E("div", uD, [
        (b(!0), T($e, null, Oe(v(n), (i, o, u, c) => {
          const d = [v(s), v(a), v(t), i.id];
          if (c && c.key === i.id && Of(c, d)) return c;
          const p = (b(), ce(xf, {
            key: i.id,
            item: i,
            level: 0
          }, null, 8, ["item"]));
          return p.memo = d, p;
        }, r, 0), 128))
      ])
    ], 2));
  }
});
function Sf(e, n = []) {
  var a;
  const t = [];
  for (const s of e) {
    const l = [...n, s.id];
    if (s.to) {
      const r = {
        itemId: s.id,
        ancestorIds: l,
        matchNested: s.matchNested,
        activeOn: s.activeOn
      };
      typeof s.to == "string" ? r.path = s.to : typeof s.to == "object" && "name" in s.to && s.to.name ? r.routeName = s.to.name : typeof s.to == "object" && "path" in s.to && s.to.path && (r.path = s.to.path), t.push(r);
    }
    (a = s.children) != null && a.length && t.push(...Sf(s.children, l));
  }
  return t;
}
function dD(e) {
  const n = ui(), t = S(() => Sf(e.value)), a = Et(null), s = Et(/* @__PURE__ */ new Set());
  Ne(
    () => ({ path: n.path, name: n.name, matchedNames: n.matched.map((u) => u.name) }),
    ({ path: u, name: c, matchedNames: d }) => {
      let p;
      for (const f of t.value) {
        if (f.path && f.path === u) {
          p = f;
          break;
        }
        if (f.routeName && f.routeName === c) {
          p = f;
          break;
        }
      }
      p ?? (p = t.value.find((f) => f.matchNested && f.routeName !== void 0 && d.includes(f.routeName))), p ?? (p = t.value.find((f) => {
        var w;
        return (w = f.activeOn) == null ? void 0 : w.some((m) => d.includes(m));
      })), p ? (a.value = p.itemId, s.value = new Set(p.ancestorIds)) : (a.value = null, s.value = /* @__PURE__ */ new Set());
    },
    { immediate: !0 }
  );
  const l = S(() => a.value), r = S(() => s.value);
  return { activeItemId: l, activePathIds: r, isActive: (u) => a.value === u, isOnActivePath: (u) => s.value.has(u) };
}
const O_ = /* @__PURE__ */ ke({
  __name: "NavigationSidebar",
  props: {
    sidebar: {}
  },
  emits: ["prefetch", "collapse", "item-click"],
  setup(e, { emit: n }) {
    const t = n, a = Ef(
      () => import("./NavigationSidebarMobile-kR3VqNnE.js")
    ), s = I2(e.sidebar), { activeItemId: l, activePathIds: r, isActive: i, isOnActivePath: o } = dD(
      s.resolvedItems
    );
    ea(wf, {
      ...s,
      activeItemId: l,
      activePathIds: r,
      isActive: i,
      isOnActivePath: o,
      onPrefetch: (c) => t("prefetch", c)
    });
    const u = S(() => e.sidebar.isCollapsed.value);
    return Ne(
      r,
      (c) => {
        s.expandMany([...c]);
      },
      { immediate: !0 }
    ), (c, d) => (b(), T("div", null, [
      E("aside", {
        class: j([{ "sidebar--collapsed": u.value }, "sidebar sidebar--flat"]),
        "aria-label": "Main navigation"
      }, [
        se(oD, null, dt({ _: 2 }, [
          c.$slots["header-title"] ? {
            name: "start",
            fn: ue(() => [
              U(c.$slots, "header-title")
            ]),
            key: "0"
          } : void 0,
          c.$slots["header-end"] ? {
            name: "end",
            fn: ue(() => [
              U(c.$slots, "header-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024),
        U(c.$slots, "subtitle-block"),
        se(cD),
        se(J2, null, dt({ _: 2 }, [
          c.$slots["footer-start"] ? {
            name: "start",
            fn: ue(() => [
              U(c.$slots, "footer-start")
            ]),
            key: "0"
          } : void 0,
          c.$slots["footer-end"] ? {
            name: "end",
            fn: ue(() => [
              U(c.$slots, "footer-end")
            ]),
            key: "1"
          } : void 0
        ]), 1024)
      ], 2),
      se(v(a), null, dt({ _: 2 }, [
        c.$slots["footer-start"] ? {
          name: "start",
          fn: ue(() => [
            U(c.$slots, "footer-start")
          ]),
          key: "0"
        } : void 0,
        c.$slots["footer-end"] ? {
          name: "end",
          fn: ue(() => [
            U(c.$slots, "footer-end")
          ]),
          key: "1"
        } : void 0
      ]), 1024)
    ]));
  }
}), fD = "ui-sidebar";
function hD(e) {
  try {
    return localStorage.getItem(`${e}:collapsed`) === "true";
  } catch {
    return !1;
  }
}
function mD(e, n) {
  try {
    localStorage.setItem(`${e}:collapsed`, String(n));
  } catch {
  }
}
function vD(e) {
  try {
    const n = localStorage.getItem(`${e}:expanded`);
    if (!n) return /* @__PURE__ */ new Set();
    const t = JSON.parse(n);
    return Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function pD(e, n) {
  try {
    localStorage.setItem(`${e}:expanded`, JSON.stringify([...n]));
  } catch {
  }
}
function E_(e) {
  const n = {
    brandName: e.brandName ?? "",
    logoUrl: e.logoUrl ?? "",
    storageKey: e.storageKey ?? fD,
    persistCollapse: e.persistCollapse ?? !0,
    persistentQueryParams: e.persistentQueryParams ?? []
  }, t = J(!1), a = J(!1), s = J(/* @__PURE__ */ new Set());
  return n.persistCollapse && typeof window < "u" && (t.value = hD(n.storageKey), s.value = vD(n.storageKey), jt(() => {
    mD(n.storageKey, t.value);
  }), jt(() => {
    pD(n.storageKey, s.value);
  })), {
    items: e.items,
    isCollapsed: t,
    isMobileOpen: a,
    expandedItems: s,
    options: n,
    toggleCollapse: () => {
      t.value = !t.value;
    },
    toggleMobile: () => {
      a.value = !a.value;
    }
  };
}
function gD(e, n, t, a, s) {
  let l = e.find((r) => r.id === n);
  return l || (l = { id: n, label: t, icon: a, order: s ?? 999, children: [] }, e.push(l)), l;
}
function yD(e, n, t) {
  if (!t.menuGroup) {
    e.push(n);
    return;
  }
  const a = t.menuGroup.split("/");
  let s = e;
  a.forEach((l, r) => {
    var c;
    const i = `group:${a.slice(0, r + 1).join("/")}`, o = (c = t.menuGroupMeta) == null ? void 0 : c[l];
    s = gD(
      s,
      i,
      l,
      (o == null ? void 0 : o.icon) ?? (r === 0 ? t.menuGroupIcon : void 0),
      (o == null ? void 0 : o.order) ?? (r === 0 ? t.menuGroupOrder : void 0)
    ).children;
  }), s.push(n);
}
function $f(e) {
  return e.sort((n, t) => (n.order ?? 999) - (t.order ?? 999)).map((n) => {
    var t;
    return {
      ...n,
      children: (t = n.children) != null && t.length ? $f(n.children) : void 0
    };
  });
}
function I_(e) {
  const n = [];
  for (const { item: t, meta: a } of e)
    yD(n, t, a);
  return $f(n);
}
const bD = ["aria-expanded", "title"], wD = {
  key: 0,
  class: "workspace-trigger__text"
}, kD = { class: "workspace-trigger__label" }, xD = {
  key: 0,
  class: "workspace-trigger__user"
}, SD = { class: "workspace-menu__text" }, $D = { class: "workspace-menu__title" }, TD = { class: "workspace-menu__caption" }, CD = { class: "workspace-menu__heading" }, MD = ["aria-current", "disabled", "onClick"], DD = { class: "workspace-menu__label" }, _D = { class: "workspace-menu__section" }, OD = ["onClick"], ED = { class: "workspace-menu__text" }, ID = { class: "workspace-menu__title" }, AD = {
  key: 0,
  class: "workspace-menu__caption"
}, PD = ["onClick"], RD = /* @__PURE__ */ ke({
  __name: "VWorkspaceContext",
  props: {
    items: { default: () => {
    } },
    activeId: { default: null },
    activeLabel: { default: () => {
    } },
    caption: {},
    switchHeading: { default: "" },
    sections: { default: () => {
    } },
    canAccess: { type: Function, default: void 0 },
    user: {},
    collapsed: { type: Boolean, default: !1 },
    placement: { default: "bottom-left" },
    switching: { type: Boolean, default: !1 },
    headClickable: { type: Boolean, default: !1 }
  },
  emits: ["switch", "select", "profile", "head-click", "logout"],
  setup(e, { emit: n }) {
    const t = [
      "from-primary-600 to-primary",
      "from-success-600 to-success",
      "from-warning-600 to-warning"
    ], a = n, s = S(() => e.sections !== void 0), l = (y) => {
      var h;
      return y === void 0 || ((h = e.canAccess) == null ? void 0 : h.call(e, y)) === !0;
    }, r = S(() => {
      if (e.sections === void 0) {
        const g = e.items ?? [];
        return g.length < 2 ? [] : [{
          id: "",
          heading: e.switchHeading,
          variant: "switch",
          caption: void 0,
          primary: !0,
          entries: g.map((x, $) => ({
            id: x.id,
            label: x.label,
            tile: $,
            active: x.id === e.activeId
          }))
        }];
      }
      let y = 0;
      const h = [];
      for (const g of e.sections) {
        if (!l(g.permission)) continue;
        const x = g.items.filter((C) => l(C.permission));
        if (x.length === 0) continue;
        const $ = g.activeId !== void 0 ? g.activeId : e.activeId;
        h.push({
          id: g.id,
          heading: g.heading,
          variant: g.variant,
          caption: g.caption,
          primary: g.primary === !0,
          entries: x.map((C) => ({
            id: C.id,
            label: C.label,
            tile: y++,
            active: C.id === $
          }))
        });
      }
      return h;
    }), i = S(() => {
      var x;
      if (e.sections === void 0) {
        const $ = e.items ?? [], C = $.findIndex((_) => _.id === e.activeId), O = C >= 0 ? C : 0;
        return { label: ((x = $[O]) == null ? void 0 : x.label) ?? "", tile: O, caption: e.caption };
      }
      const y = e.activeId === null ? void 0 : r.value.map(($) => ({ group: $, entry: $.entries.find((C) => C.id === e.activeId) })).find(($) => $.entry !== void 0);
      if (y != null && y.entry)
        return {
          label: y.entry.label,
          tile: y.entry.tile,
          caption: y.group.caption ?? e.caption
        };
      const h = r.value.find(($) => $.primary) ?? r.value[0], g = h == null ? void 0 : h.entries.find(($) => $.active);
      return {
        label: (g == null ? void 0 : g.label) ?? "",
        tile: (g == null ? void 0 : g.tile) ?? 0,
        caption: (h == null ? void 0 : h.caption) ?? e.caption
      };
    }), o = S(() => e.activeLabel ?? i.value.label), u = S(() => {
      if (!e.user) return "";
      const y = e.user.displayName ?? e.user.name;
      return e.user.role ? `${y} · ${e.user.role}` : y;
    }), c = S(() => e.placement.startsWith("top")), d = S(() => e.placement.endsWith("right")), p = (y) => t[y % t.length], f = (y) => y.split(" ").filter(Boolean).slice(0, 2).map((h) => h[0]).join("").toUpperCase(), w = S(
      () => {
        var y, h;
        return f(o.value) || f(((y = e.user) == null ? void 0 : y.displayName) ?? ((h = e.user) == null ? void 0 : h.name) ?? "") || "?";
      }
    ), m = (y, h) => {
      s.value ? a("select", y.id, h.id) : a("switch", h.id);
    }, k = (y, h) => {
      y(), h();
    };
    return Ne(
      [() => e.sections, () => e.items, r],
      () => {
      },
      { immediate: !0 }
    ), (y, h) => (b(), T("div", {
      class: j([{ "workspace-context--collapsed": e.collapsed }, "workspace-context"])
    }, [
      se(Ta, {
        class: j([{ "workspace-floating--collapsed": e.collapsed }, "workspace-floating"]),
        placement: e.placement,
        unstyled: ""
      }, {
        trigger: ue(({ isOpen: g }) => [
          E("button", {
            "aria-expanded": g,
            class: j([{
              "workspace-trigger--open": g,
              "workspace-trigger--collapsed": e.collapsed
            }, "workspace-trigger"]),
            title: e.collapsed ? o.value : void 0,
            "aria-haspopup": "menu",
            type: "button"
          }, [
            E("span", {
              class: j([p(i.value.tile), "workspace-tile text-white"])
            }, le(w.value), 3),
            se(ht, { name: "context-info-fade" }, {
              default: ue(() => [
                e.collapsed ? P("", !0) : (b(), T("span", wD, [
                  E("span", kD, le(o.value), 1),
                  e.user ? (b(), T("span", xD, le(u.value), 1)) : P("", !0)
                ]))
              ]),
              _: 1
            }),
            se(ht, { name: "context-info-fade" }, {
              default: ue(() => [
                !e.collapsed && e.user ? (b(), ce(qi, {
                  key: 0,
                  avatar: e.user.avatar ?? void 0,
                  "custom-size": 24,
                  name: e.user.name,
                  modern: "",
                  shape: "square"
                }, null, 8, ["avatar", "name"])) : P("", !0)
              ]),
              _: 1
            }),
            se(ht, { name: "context-info-fade" }, {
              default: ue(() => [
                e.collapsed ? P("", !0) : (b(), ce(ye, {
                  key: 0,
                  loading: e.switching,
                  size: 14,
                  class: "workspace-trigger__chevron",
                  icon: "lucide:chevron-down"
                }, null, 8, ["loading"]))
              ]),
              _: 1
            })
          ], 10, bD)
        ]),
        content: ue(({ close: g }) => [
          E("div", {
            class: j([{ "workspace-menu--up": c.value, "workspace-menu--right": d.value }, "workspace-menu"])
          }, [
            (b(), ce(mt(e.headClickable ? "button" : "div"), {
              class: j([{ "workspace-menu__head--button": e.headClickable }, "workspace-menu__head"]),
              type: e.headClickable ? "button" : void 0,
              onClick: (x) => e.headClickable && k(g, () => a("head-click"))
            }, {
              default: ue(() => [
                E("span", {
                  class: j([p(i.value.tile), "workspace-tile workspace-tile--lg text-white"])
                }, le(w.value), 3),
                E("span", SD, [
                  E("span", $D, le(o.value), 1),
                  E("span", TD, le(i.value.caption), 1)
                ]),
                e.headClickable ? (b(), ce(ye, {
                  key: 0,
                  size: 14,
                  class: "workspace-menu__arrow",
                  icon: "lucide:chevron-right"
                })) : P("", !0)
              ]),
              _: 1
            }, 8, ["class", "type", "onClick"])),
            (b(!0), T($e, null, Oe(r.value, (x) => (b(), T("div", {
              key: x.id,
              class: "workspace-menu__section"
            }, [
              E("p", CD, le(x.heading), 1),
              (b(!0), T($e, null, Oe(x.entries, ($) => (b(), T("button", {
                key: $.id,
                "aria-current": $.active ? "true" : void 0,
                disabled: x.variant === "switch" && $.active || e.switching,
                class: "workspace-menu__item",
                type: "button",
                onClick: (C) => k(g, () => m(x, $))
              }, [
                E("span", {
                  class: j([p($.tile), "workspace-tile workspace-tile--sm text-white"])
                }, le(f($.label) || "?"), 3),
                E("span", DD, le($.label), 1),
                x.variant === "switch" && $.active ? (b(), ce(ye, {
                  key: 0,
                  size: 15,
                  class: "workspace-menu__check",
                  icon: "lucide:check"
                })) : x.variant === "link" ? (b(), ce(ye, {
                  key: 1,
                  size: 14,
                  class: "workspace-menu__arrow",
                  icon: "lucide:chevron-right"
                })) : P("", !0)
              ], 8, MD))), 128))
            ]))), 128)),
            E("div", _D, [
              e.user ? (b(), T("button", {
                key: 0,
                class: "workspace-menu__item workspace-menu__item--user",
                type: "button",
                onClick: (x) => k(g, () => a("profile"))
              }, [
                se(qi, {
                  avatar: e.user.avatar ?? void 0,
                  "custom-size": 32,
                  name: e.user.name,
                  modern: "",
                  shape: "square"
                }, null, 8, ["avatar", "name"]),
                E("span", ED, [
                  E("span", ID, le(e.user.name), 1),
                  e.user.email ? (b(), T("span", AD, le(e.user.email), 1)) : P("", !0)
                ]),
                se(ye, {
                  size: 14,
                  class: "workspace-menu__arrow",
                  icon: "lucide:chevron-right"
                })
              ], 8, OD)) : P("", !0),
              E("button", {
                class: "workspace-menu__item workspace-menu__item--danger",
                type: "button",
                onClick: (x) => k(g, () => a("logout"))
              }, [
                se(ye, {
                  size: 15,
                  icon: "lucide:log-out"
                }),
                h[0] || (h[0] = E("span", { class: "workspace-menu__label" }, "Log out", -1))
              ], 8, PD)
            ]),
            U(y.$slots, "menu-footer", {}, void 0, !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["class", "placement"])
    ], 2));
  }
}), A_ = /* @__PURE__ */ Le(RD, [["__scopeId", "data-v-e80d0a61"]]);
export {
  Ju as $,
  YD as A,
  rt as B,
  zT as C,
  I1 as D,
  n_ as E,
  jD as F,
  QD as G,
  Ta as H,
  d_ as I,
  Fs as J,
  ZD as K,
  Xs as L,
  y_ as M,
  l_ as N,
  a_ as O,
  r_ as P,
  f_ as Q,
  gf as R,
  sx as S,
  KC as T,
  Nx as U,
  ye as V,
  e_ as W,
  w_ as X,
  DM as Y,
  h_ as Z,
  Le as _,
  kf as a,
  i_ as a0,
  o_ as a1,
  d1 as a2,
  xa as a3,
  $S as a4,
  A_ as a5,
  I_ as a6,
  E_ as a7,
  ia as a8,
  m_ as a9,
  FM as aA,
  Zs as aB,
  Bi as aC,
  Ql as aD,
  zM as aE,
  g_ as aF,
  vf as aG,
  o1 as aH,
  wl as aI,
  R1 as aJ,
  as as aK,
  KD as aL,
  Gd as aM,
  C_ as aN,
  Xl as aO,
  dD as aP,
  mS as aQ,
  jM as aR,
  b_ as aS,
  _2 as aT,
  jd as aU,
  __ as aV,
  zi as aW,
  F1 as aa,
  Zd as ab,
  Es as ac,
  qM as ad,
  Is as ae,
  Xd as af,
  Jd as ag,
  UD as ah,
  aa as ai,
  Ni as aj,
  hf as ak,
  Kd as al,
  M_ as am,
  D_ as an,
  Or as ao,
  v_ as ap,
  XD as aq,
  pf as ar,
  Yi as as,
  er as at,
  LM as au,
  HD as av,
  p_ as aw,
  NM as ax,
  mf as ay,
  Wi as az,
  Ps as b,
  sk as c,
  x_ as d,
  k_ as e,
  qD as f,
  s_ as g,
  O_ as h,
  T_ as i,
  $_ as j,
  S_ as k,
  u_ as l,
  c_ as m,
  qi as n,
  t_ as o,
  JD as p,
  vt as q,
  zD as r,
  X$ as s,
  ad as t,
  ds as u,
  Qu as v,
  Gk as w,
  GD as x,
  BD as y,
  WD as z
};
//# sourceMappingURL=index-Bb1wrqFw.js.map
